import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  ArrayList3it5z8td81qkl as ArrayList,
  Unit_instance104q5opgivhr8 as Unit_instance,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  lazy2hsh8ze7j6ikd as lazy,
  toString30pk9tzaqopn as toString_0,
  emptyList1g2z5xcrvp2zy as emptyList,
  until1jbpn0z3f8lbg as until,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  zipfdxxupzuj2p9 as zip,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  Error3ofk6owajcepa as Error_0,
  numberToLong1a4cndvg6c52s as numberToLong,
  listOfvhqybd2zx248 as listOf,
  plus310ted5e4i90h as plus,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  toLongw1zpgk99d84b as toLong,
  toLongArray23ixicpzp5r3w as toLongArray,
  Enum3alwj03lh1n41 as Enum,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isInterface3d6p8outrmvmk as isInterface,
  plus17rl43at52ays as plus_0,
  toString1h6jjoch8cjt8 as toString_1,
  repeat2w4c6j8zoq09o as repeat,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  joinToString1cxrrlmo0chqs as joinToString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  numberToChar93r9buh19yek as numberToChar,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  StringCompanionObject_instance2odz3s3zbrixa as StringCompanionObject_instance,
  Char__toInt_impl_vasixd1g1ubcha2b2yr as Char__toInt_impl_vasixd,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  HashMap1a0ld5kgwhmhv as HashMap,
  println2shhhgwwt4c61 as println,
  printStackTrace18lnx7a39cni as printStackTrace,
  KtMap140uvy3s5zad8 as KtMap,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toShort36kaw0zjdq3ex as toShort,
  _UShort___init__impl__jigrne3hvr35xwb2tau as _UShort___init__impl__jigrne,
  sort15ai02l4kxbfa as sort,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  createThis2j2avj17cvnv2 as createThis,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  indexOfwa4w6635jewi as indexOf,
  StringBuildermazzzhj6kkai as StringBuilder,
  protoOf180f3jzyo7rfj as protoOf,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Long2qws0ah9gnpki as Long,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  toByte4i43936u611k as toByte,
  FloatCompanionObject_instance29smzmmxq0czz as FloatCompanionObject_instance,
  floatFromBits1n9d03e2m5i5s as floatFromBits,
  DoubleCompanionObject_instance2yqrcskeqd1tm as DoubleCompanionObject_instance,
  doubleFromBits153kwgwnt8ety as doubleFromBits,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  round2mrvepag8eey0 as round,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  booleanArray2jdug9b51huk7 as booleanArray,
  toList383f556t1dixk as toList,
  fill1t21qnvy6b48o as fill,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  DurationUnit_MICROSECONDS_getInstance2dy62s6vvg5md as DurationUnit_MICROSECONDS_getInstance,
  Duration__minus_impl_q5cfm7ntz6q4kzlr5l as Duration__minus_impl_q5cfm7,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  Duration__plus_impl_yu9v8f1x7qwk17prwx4 as Duration__plus_impl_yu9v8f,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  EmptyCoroutineContext_getInstance2bxophqwsfm9n as EmptyCoroutineContext_getInstance,
  CancellationException3b36o9qz53rgr as CancellationException,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3idov4hy0gkwd as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  toList3jhuyej2anx2q as toList_0,
  numberToDouble210hrknaofnhf as numberToDouble,
  Collection1k04j3hzsbod0 as Collection,
  HashSet2dzve9y63nf0v as HashSet,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  fill3hcjvebk42tyx as fill_0,
  toInt2q8uldh7sc951 as toInt,
  startsWith26w8qjqapeeq6 as startsWith,
  emptySetcxexqki71qfa as emptySet,
  sorted354mfsiv4s7x5 as sorted,
  putAlliz90jhzb8z23 as putAll,
  toIntArray2d4xwvtjb01mq as toIntArray,
  sliceArray2hu2ljigibgmi as sliceArray,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  addAll1k27qatfgp3k5 as addAll,
} from './kotlin-kotlin-stdlib.mjs';
import {
  openSync2m3qn99fqytu0 as openSync,
  get_eofaukbsoaf5jcj as get_eof,
  readU82o15i0epsnmc5 as readU8,
  readU16LE24dnvocwt4zgx as readU16LE,
  readBytes3l26albs0coyl as readBytes,
  readString20u8kjncp0xlx as readString,
  readF64BEb6rie7pu3y5f as readF64BE,
  readF64LEtuen41849f3m as readF64LE,
  readStringz3jxaogr49n5ys as readStringz,
  readS81kx01977bwzhe as readS8,
  readS32LE3aqh95gxznf4n as readS32LE,
  readS24LEt6r5k1f3n0k8 as readS24LE,
  readStringzhw4hjo42cfdw as readStringz_0,
  MemorySyncStreamBase3aid16odb3j0i as MemorySyncStreamBase,
  SyncStreamce10l9wq5tt7 as SyncStream,
  writeBytes3aje3m4oawkwy as writeBytes,
  readS16BEajefcznk5l4b as readS16BE,
  readS16LE375f28fer5dhk as readS16LE,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  readS64BEb4xwz284o9f2 as readS64BE,
  readS64LE1ebpo9xwj4186 as readS64LE,
  write81fg3kayjaelgo as write8,
  write32BE32zetfyrv09xq as write32BE,
  write32LEi7tyrlzcgsc3 as write32LE,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-korlibs-io-stream.mjs';
import { invalidOp1stebxh2m3n07 as invalidOp } from './korlibs-korlibs-platform.mjs';
import {
  Companion_getInstance3moaeo8p2fvjj as Companion_getInstance_0,
  DateTime2gld4ho36azq9 as DateTime,
  DateTime__toString_impl_cnuejeub59104j2jjn as DateTime__toString_impl_cnueje,
  min27i0e7o9bo03e as min,
} from './korlibs-korlibs-time-core.mjs';
import {
  Xmlepssdknidwxh as Xml,
  Companion_getInstance1ijxhf2kvgag6 as Companion_getInstance_1,
  get_isNode17sq12d5k4oq6 as get_isNode,
  get_isComment2ks3g310vik1w as get_isComment,
  get_isText26l7ptq9ktzap as get_isText,
} from './korlibs-korlibs-serialization.mjs';
import {
  fromIntArray2gxq3jb1ug201 as fromIntArray,
  format1w6w3fsj4lh0e as format,
  get_UTF82geyfhi1l22xl as get_UTF8,
  toString2x583ovdqfjci as toString_2,
  substr2jonrcqd8qwvx as substr,
} from './korlibs-korlibs-string.mjs';
import {
  Mixin3lmkm5hum2vdj as Mixin,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
} from './korlibs-korlibs-datastructure-core.mjs';
import { Companion_instance3l8wldvwuxoxv as Companion_instance } from './korlibs-korlibs-number.mjs';
import {
  Companion_getInstance266qhgy61dybo as Companion_getInstance_2,
  MMatrix1y71lv7vv6y8t as MMatrix,
  MPoint2sx5s6wh6byii as MPoint,
  LineScaleMode_NORMAL_getInstance349p0dssy4fun as LineScaleMode_NORMAL_getInstance,
  LineScaleMode_VERTICAL_getInstance1y4ujr6379lzf as LineScaleMode_VERTICAL_getInstance,
  LineScaleMode_HORIZONTAL_getInstance3elygu0hslt3a as LineScaleMode_HORIZONTAL_getInstance,
  LineScaleMode_NONE_getInstance2502q1le8nox0 as LineScaleMode_NONE_getInstance,
  MBoundsBuilder153gzhei3ukb0 as MBoundsBuilder,
  get_mutable10c8ws0x48eez as get_mutable,
  Companion_getInstance2iuza9dwssjbj as Companion_getInstance_3,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  LineJoin_MITER_getInstance3doesgezxmixn as LineJoin_MITER_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  LineCap_ROUND_getInstance29bkl1dpat5pj as LineCap_ROUND_getInstance,
  LineCap_BUTT_getInstanceb57ygh36gdst as LineCap_BUTT_getInstance,
  LineCap_SQUARE_getInstancemqgc8h2k247o as LineCap_SQUARE_getInstance,
  bounds3w4bgsrpsjcra as bounds,
} from './korlibs-korlibs-math.mjs';
import {
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  binarySearch2l7jc6a3nco69 as binarySearch,
  _BSearchResult___get_raw__impl__uyuhf33e2ricm0z1amr as _BSearchResult___get_raw__impl__uyuhf3,
  memoize7smufkpxqzwy as memoize,
  BitSetdjtyjyvg0eod as BitSet,
  Computed3myh0u4qvtp8f as Computed,
  toIntMapp1jij98esrcm as toIntMap,
} from './korlibs-korlibs-datastructure.mjs';
import {
  Colors_getInstance1qvds1isfbag2 as Colors_getInstance,
  Bitmaps_instancebct336c8d0m7 as Bitmaps_instance,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  EmptyShape_instance7pcf1jiur1zr as EmptyShape_instance,
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Companion_instance28pvop2a7cl7d as Companion_instance_0,
  ColorAdd_pack3r2zgiosu4kvu as ColorAdd_pack,
  _ColorAdd___init__impl__q78um5gky0ff72uk7r as _ColorAdd___init__impl__q78um5,
  _RGBA___get_rf__impl__kvz75k3pk03bu2ddet as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1u2gy3h5k9nkx as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg3ni93gubw9yz3 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3iv1uv3wd82oh as _RGBA___get_af__impl__vu36qv,
  _ColorAdd___get_r__impl__j9xkne17vuqwxy9emvi as _ColorAdd___get_r__impl__j9xkne,
  _ColorAdd___get_g__impl__itrhk12ga6a629kamfn as _ColorAdd___get_g__impl__itrhk1,
  _ColorAdd___get_b__impl__grv87amaxn3ehj16vp as _ColorAdd___get_b__impl__grv87a,
  _ColorAdd___get_a__impl__c1r8ux3viqig9khweua as _ColorAdd___get_a__impl__c1r8ux,
  ColorTransform3dmo0aeuiflxt as ColorTransform,
  get_ColorAdd_NEUTRAL1xv2kr8lpc2tn as get_ColorAdd_NEUTRAL,
  slice2pfxfvku0ybgy as slice,
  AtlasPacker_instance3njp6qtlzeo8x as AtlasPacker_instance,
  _RGBA___get_r__impl__duz7mo1b9m6cls2dem1 as _RGBA___get_r__impl__duz7mo,
  _RGBA___get_g__impl__o8pukr1ulyqj17gj1s1 as _RGBA___get_g__impl__o8pukr,
  _RGBA___get_b__impl__m6tl80172fwst9o63y as _RGBA___get_b__impl__m6tl80,
  BitmapVector1i7qp6908cg6h as BitmapVector,
  Companion_getInstanceocd6ti8e4l21 as Companion_getInstance_4,
  _RGBA___get_value__impl__hhco8v1fb2bqjo5n70o as _RGBA___get_value__impl__hhco8v,
  GradientInterpolationMethod_NORMAL_getInstance25j9adkqotkam as GradientInterpolationMethod_NORMAL_getInstance,
  GradientInterpolationMethod_LINEAR_getInstance3o4xsg00vfgv6 as GradientInterpolationMethod_LINEAR_getInstance,
  GradientKind_LINEAR_getInstance2913i2r9znmz6 as GradientKind_LINEAR_getInstance,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  GradientKind_RADIAL_getInstance1ck78a4imhrkm as GradientKind_RADIAL_getInstance,
  FillShape13c5zk3dmjgcf as FillShape,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  NonePaint_instancek3yy5o7n1y50 as NonePaint_instance,
  RGBA34obx2i62wcl3 as RGBA,
  CycleMethod_NO_CYCLE_getInstancebe2q8ehvdorv as CycleMethod_NO_CYCLE_getInstance,
  CycleMethod_REFLECT_getInstancejnj3c4t5urcx as CycleMethod_REFLECT_getInstance,
  CycleMethod_REPEAT_getInstance5g0up2ih5p7m as CycleMethod_REPEAT_getInstance,
  Bitmap321klycakvwgb5w as Bitmap32,
  Companion_getInstance2idzw3eipflw0 as Companion_getInstance_5,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  ShapeRasterizerMethod_X4_getInstance2a78eqls9c7ts as ShapeRasterizerMethod_X4_getInstance,
  values3n9ql9zpv12og as values,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  _RgbaArray___init__impl__oib4y43cjeodgxd0rus as _RgbaArray___init__impl__oib4y4,
  BGRA_5551_getInstance2mf7chkayi3uu as BGRA_5551_getInstance,
  decode23c6atnc2eonu as decode,
  BGRA_getInstance1jlz9n65lstj1 as BGRA_getInstance,
  _RGBA___get_rgb__impl__tijaqt1opkd4mw5vm2z as _RGBA___get_rgb__impl__tijaqt,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1xlsnvr8f9icc as readBitmap,
  BitmapChannel_ALPHA_getInstance2af1cve68aq1s as BitmapChannel_ALPHA_getInstance,
  GlyphMetrics287h9a5nacttn as GlyphMetrics,
  Companion_getInstance2fl1toxz5lf8a as Companion_getInstance_6,
  SystemFont1o0xb03tghhtk as SystemFont,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Companion_getInstance1p5o3grjloafn as Companion_getInstance_7,
  Companion_instancevwyx2uq9kvqe as Companion_instance_1,
  RGBA__hashCode_impl_h59qf63jsbsnnrny7w3 as RGBA__hashCode_impl_h59qf6,
  PNG_getInstance2phopdctkwslg as PNG_getInstance,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  _RGBA___get_a__impl__6msvu72gkofe1pz7ypd as _RGBA___get_a__impl__6msvu7,
} from './korlibs-korlibs-image.mjs';
import {
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_8,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_9,
} from './korlibs-korlibs-math-vector.mjs';
import {
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__toDouble_impl_o7epze3e3zsci3ipwe7 as Ratio__toDouble_impl_o7epze,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance_10,
  interpolate2g7wzskc23f1q as interpolate,
  Ratio__toString_impl_mfgt3e2hpoo0nu4cwhr as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v7lufr2urxbhm as Ratio__hashCode_impl_quhc2v,
  clamp31lhm66c28ic8 as clamp,
  insert8f3zk23r8x9da as insert8,
  toIntCeil3h286vm49zgwd as toIntCeil,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
} from './korlibs-korlibs-math-core.mjs';
import {
  Companion_getInstance1ybjf5xfi0it8 as Companion_getInstance_11,
  Companion_getInstance27y7ak0p8xjnv as Companion_getInstance_12,
  get_Deflate2a0lyute7oxjd as get_Deflate,
  Lzma_instance2qi6ni3wowut9 as Lzma_instance,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-korlibs-compression.mjs';
import {
  replaceWith20ov7o46kyfqm as replaceWith,
  Container7486fjmip554 as Container,
  DummyView1mkji6wt5kruk as DummyView,
  View11ybmmoof9vue as View,
  addUpdater1la23qj9g2d42 as addUpdater,
  Graphics2q0lx93a2j4b2 as Graphics,
  addTo25e29vq105prw as addTo,
  GraphicsRenderer_GPU_getInstance2y97iviksol8a as GraphicsRenderer_GPU_getInstance,
  set_filter36wgvpm5cukpc as set_filter,
  GraphicsRenderer_CPU_getInstance1ncsup8rv6gza as GraphicsRenderer_CPU_getInstance,
  GraphicsRenderer_SYSTEM_getInstance1vcvjxz5tx3ul as GraphicsRenderer_SYSTEM_getInstance,
  values367gftm1eq5yt as values_0,
  Companion_getInstance2ae29zia1q3bi as Companion_getInstance_13,
  DropshadowFilter3mmze965vo4ad as DropshadowFilter,
  Companion_instance3d7ruxdq0a083 as Companion_instance_2,
  BlurFilter1o7ok9bw0jdji as BlurFilter,
  ComposedFilter2v12lgfcjpd5f as ComposedFilter,
  composedOrNull2kh1bl8tczqtf as composedOrNull,
} from './korge-root-korge.mjs';
import {
  launchImmediatelylnv8lnistpdy as launchImmediately,
  printStackTrace297j5gt7hfz21 as printStackTrace_0,
  AsyncOnce2iqg7qjwjlt3t as AsyncOnce,
} from './korlibs-korlibs-io.mjs';
import { Signal3nnez3346azzf as Signal } from './korlibs-korlibs-concurrent.mjs';
import {
  Companion_getInstance3jgth1v8sehkm as Companion_getInstance_14,
  AGStencilReference__withReferenceValue$default_impl_2trj0v232x7ttx8ekye as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  Companion_getInstancey5u5n7g62xvk as Companion_getInstance_15,
  Companion_getInstancer6z1nlxalqx7 as Companion_getInstance_16,
  AGStencilOpFunc__withEnabled_impl_mpcwmrtmo0h8rbfy7w as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  _AGColorMask___init__impl__j38ai814mo4mz42teo7 as _AGColorMask___init__impl__j38ai8,
  AGStencilReference__withReadMask$default_impl_7mdffx1g2sfp701cvyr as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGStencilReference__withWriteMask$default_impl_b7j7b43mm4w8krkt3ep as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance2v5l7b83xykmk as Companion_getInstance_17,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv5p5tszphd23r as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance19lgm19ipf6do as Companion_getInstance_18,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo33l2pvqtfq9yj as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd2tf3sk32uhtv1 as AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd,
  AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw2amtefs1nlpor as AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw,
  TextureWithBitmapSlice1c4x879lwy0ns as TextureWithBitmapSlice,
  drawText1tnl009j4blt0 as drawText,
} from './korge-root-korge-core.mjs';
import { Uint16Buffer__set_impl_g0kliu1yamftxrkicc6 as Uint16Buffer__set_impl_g0kliu } from './korlibs-korlibs-memory.mjs';
import {
  get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider,
  Companion_getInstance3vx36q4sbftih as Companion_getInstance_19,
} from './korlibs-korlibs-audio.mjs';
import {
  get_hexLower32nr02qmg5e1t as get_hexLower,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-korlibs-encoding.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_3 = this;
    this.ulv_1 = 8;
    this.vlv_1 = 22;
    this.wlv_1 = 23;
    this.xlv_1 = 24;
    this.ylv_1 = 25;
    this.zlv_1 = 26;
    this.alw_1 = 5;
    this.blw_1 = new Namespace(0, '');
  }
}
class Namespace {
  constructor(kind, name) {
    Companion_getInstance_20();
    this.nlw_1 = kind;
    this.olw_1 = name;
  }
  toString() {
    return this.olw_1;
  }
  hashCode() {
    var result = this.nlw_1;
    result = imul(result, 31) + getStringHashCode(this.olw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Namespace))
      return false;
    var tmp0_other_with_cast = other instanceof Namespace ? other : THROW_CCE();
    if (!(this.nlw_1 === tmp0_other_with_cast.nlw_1))
      return false;
    if (!(this.olw_1 === tmp0_other_with_cast.olw_1))
      return false;
    return true;
  }
}
class EmptyMultiname {
  constructor() {
    this.plw_1 = '';
  }
  xf() {
    return this.plw_1;
  }
}
class ABCQName {
  constructor(namespace, name) {
    this.qlw_1 = namespace;
    this.rlw_1 = name;
    this.slw_1 = this.rlw_1;
  }
  toString() {
    return this.qlw_1.toString() + '.' + this.rlw_1;
  }
  xf() {
    return this.slw_1;
  }
  hashCode() {
    var result = this.qlw_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.rlw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ABCQName))
      return false;
    var tmp0_other_with_cast = other instanceof ABCQName ? other : THROW_CCE();
    if (!this.qlw_1.equals(tmp0_other_with_cast.qlw_1))
      return false;
    if (!(this.rlw_1 === tmp0_other_with_cast.rlw_1))
      return false;
    return true;
  }
}
class QNameA {
  constructor(namespace, name) {
    this.tlw_1 = namespace;
    this.ulw_1 = name;
    this.vlw_1 = this.ulw_1;
  }
  xf() {
    return this.vlw_1;
  }
  toString() {
    return 'QNameA(namespace=' + this.tlw_1.toString() + ', name=' + this.ulw_1 + ')';
  }
  hashCode() {
    var result = this.tlw_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ulw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof QNameA))
      return false;
    var tmp0_other_with_cast = other instanceof QNameA ? other : THROW_CCE();
    if (!this.tlw_1.equals(tmp0_other_with_cast.tlw_1))
      return false;
    if (!(this.ulw_1 === tmp0_other_with_cast.ulw_1))
      return false;
    return true;
  }
}
class RTQName {
  constructor(name) {
    this.wlw_1 = name;
    this.xlw_1 = this.wlw_1;
  }
  xf() {
    return this.xlw_1;
  }
  toString() {
    return 'RTQName(name=' + this.wlw_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.wlw_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RTQName))
      return false;
    var tmp0_other_with_cast = other instanceof RTQName ? other : THROW_CCE();
    if (!(this.wlw_1 === tmp0_other_with_cast.wlw_1))
      return false;
    return true;
  }
}
class RTQNameA {
  constructor(name) {
    this.ylw_1 = name;
    this.zlw_1 = this.ylw_1;
  }
  xf() {
    return this.zlw_1;
  }
  toString() {
    return 'RTQNameA(name=' + this.ylw_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.ylw_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RTQNameA))
      return false;
    var tmp0_other_with_cast = other instanceof RTQNameA ? other : THROW_CCE();
    if (!(this.ylw_1 === tmp0_other_with_cast.ylw_1))
      return false;
    return true;
  }
}
class RTQNameL {
  constructor() {
    this.alx_1 = '';
  }
  xf() {
    return this.alx_1;
  }
}
class RTQNameLA {
  constructor() {
    this.blx_1 = '';
  }
  xf() {
    return this.blx_1;
  }
}
class Multiname {
  constructor(name, namespaceSet) {
    this.clx_1 = name;
    this.dlx_1 = namespaceSet;
    this.elx_1 = this.clx_1;
  }
  xf() {
    return this.elx_1;
  }
  toString() {
    return 'Multiname(name=' + this.clx_1 + ', namespaceSet=' + toString(this.dlx_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.clx_1);
    result = imul(result, 31) + hashCode(this.dlx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Multiname))
      return false;
    var tmp0_other_with_cast = other instanceof Multiname ? other : THROW_CCE();
    if (!(this.clx_1 === tmp0_other_with_cast.clx_1))
      return false;
    if (!equals(this.dlx_1, tmp0_other_with_cast.dlx_1))
      return false;
    return true;
  }
}
class MultinameA {
  constructor(name, namespaceSet) {
    this.flx_1 = name;
    this.glx_1 = namespaceSet;
    this.hlx_1 = this.flx_1;
  }
  xf() {
    return this.hlx_1;
  }
  toString() {
    return 'MultinameA(name=' + this.flx_1 + ', namespaceSet=' + toString(this.glx_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.flx_1);
    result = imul(result, 31) + hashCode(this.glx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MultinameA))
      return false;
    var tmp0_other_with_cast = other instanceof MultinameA ? other : THROW_CCE();
    if (!(this.flx_1 === tmp0_other_with_cast.flx_1))
      return false;
    if (!equals(this.glx_1, tmp0_other_with_cast.glx_1))
      return false;
    return true;
  }
}
class MultinameL {
  constructor(namespaceSet) {
    this.ilx_1 = namespaceSet;
    this.jlx_1 = '';
  }
  xf() {
    return this.jlx_1;
  }
  toString() {
    return 'MultinameL(namespaceSet=' + toString(this.ilx_1) + ')';
  }
  hashCode() {
    return hashCode(this.ilx_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MultinameL))
      return false;
    var tmp0_other_with_cast = other instanceof MultinameL ? other : THROW_CCE();
    if (!equals(this.ilx_1, tmp0_other_with_cast.ilx_1))
      return false;
    return true;
  }
}
class MultinameLA {
  constructor(namespaceSet) {
    this.klx_1 = namespaceSet;
    this.llx_1 = '';
  }
  xf() {
    return this.llx_1;
  }
  toString() {
    return 'MultinameLA(namespaceSet=' + toString(this.klx_1) + ')';
  }
  hashCode() {
    return hashCode(this.klx_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MultinameLA))
      return false;
    var tmp0_other_with_cast = other instanceof MultinameLA ? other : THROW_CCE();
    if (!equals(this.klx_1, tmp0_other_with_cast.klx_1))
      return false;
    return true;
  }
}
class TypeName {
  constructor(qname, parameters) {
    this.mlx_1 = qname;
    this.nlx_1 = parameters;
    this.olx_1 = 'TypeName(' + this.mlx_1 + ')';
  }
  xf() {
    return this.olx_1;
  }
  toString() {
    return 'TypeName(qname=' + this.mlx_1 + ', parameters=' + toString(this.nlx_1) + ')';
  }
  hashCode() {
    var result = this.mlx_1;
    result = imul(result, 31) + hashCode(this.nlx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TypeName))
      return false;
    var tmp0_other_with_cast = other instanceof TypeName ? other : THROW_CCE();
    if (!(this.mlx_1 === tmp0_other_with_cast.mlx_1))
      return false;
    if (!equals(this.nlx_1, tmp0_other_with_cast.nlx_1))
      return false;
    return true;
  }
}
class Metadata {
  constructor(name, values) {
    this.plx_1 = name;
    this.qlx_1 = values;
  }
  toString() {
    return 'Metadata(name=' + this.plx_1 + ', values=' + toString(this.qlx_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.plx_1);
    result = imul(result, 31) + hashCode(this.qlx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Metadata))
      return false;
    var tmp0_other_with_cast = other instanceof Metadata ? other : THROW_CCE();
    if (!(this.plx_1 === tmp0_other_with_cast.plx_1))
      return false;
    if (!equals(this.qlx_1, tmp0_other_with_cast.qlx_1))
      return false;
    return true;
  }
}
class MethodBody {
  constructor(method, maxStack, localCount, initScopeDepth, maxScopeDepth, opcodes, cpool, exceptions, traits) {
    this.clw_1 = method;
    this.dlw_1 = maxStack;
    this.elw_1 = localCount;
    this.flw_1 = initScopeDepth;
    this.glw_1 = maxScopeDepth;
    this.hlw_1 = opcodes;
    this.ilw_1 = cpool;
    this.jlw_1 = exceptions;
    this.klw_1 = traits;
    var tmp = this;
    tmp.llw_1 = lazy(ABC$MethodBody$ops$delegate$lambda(this));
    this.clw_1.slx_1 = this;
  }
  p9n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.llw_1;
    ops$factory();
    return this_0.b2();
  }
}
class ExceptionInfo {
  constructor(from, to, target, type, variableName) {
    this.tlx_1 = from;
    this.ulx_1 = to;
    this.vlx_1 = target;
    this.wlx_1 = type;
    this.xlx_1 = variableName;
  }
  toString() {
    return 'ExceptionInfo(from=' + this.tlx_1 + ', to=' + this.ulx_1 + ', target=' + this.vlx_1 + ', type=' + toString(this.wlx_1) + ', variableName=' + toString(this.xlx_1) + ')';
  }
  hashCode() {
    var result = this.tlx_1;
    result = imul(result, 31) + this.ulx_1 | 0;
    result = imul(result, 31) + this.vlx_1 | 0;
    result = imul(result, 31) + hashCode(this.wlx_1) | 0;
    result = imul(result, 31) + hashCode(this.xlx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExceptionInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ExceptionInfo ? other : THROW_CCE();
    if (!(this.tlx_1 === tmp0_other_with_cast.tlx_1))
      return false;
    if (!(this.ulx_1 === tmp0_other_with_cast.ulx_1))
      return false;
    if (!(this.vlx_1 === tmp0_other_with_cast.vlx_1))
      return false;
    if (!equals(this.wlx_1, tmp0_other_with_cast.wlx_1))
      return false;
    if (!equals(this.xlx_1, tmp0_other_with_cast.xlx_1))
      return false;
    return true;
  }
}
class TraitSlot {
  constructor(name, slotIndex, type, value) {
    this.ylx_1 = name;
    this.zlx_1 = slotIndex;
    this.aly_1 = type;
    this.bly_1 = value;
  }
  w3() {
    return this.ylx_1;
  }
  toString() {
    return 'TraitSlot(name=' + toString(this.ylx_1) + ', slotIndex=' + this.zlx_1 + ', type=' + toString(this.aly_1) + ', value=' + toString_0(this.bly_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.ylx_1);
    result = imul(result, 31) + this.zlx_1 | 0;
    result = imul(result, 31) + hashCode(this.aly_1) | 0;
    result = imul(result, 31) + (this.bly_1 == null ? 0 : hashCode(this.bly_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TraitSlot))
      return false;
    var tmp0_other_with_cast = other instanceof TraitSlot ? other : THROW_CCE();
    if (!equals(this.ylx_1, tmp0_other_with_cast.ylx_1))
      return false;
    if (!(this.zlx_1 === tmp0_other_with_cast.zlx_1))
      return false;
    if (!equals(this.aly_1, tmp0_other_with_cast.aly_1))
      return false;
    if (!equals(this.bly_1, tmp0_other_with_cast.bly_1))
      return false;
    return true;
  }
}
class TraitMethod {
  constructor(name, dispIndex, methodIndex) {
    this.cly_1 = name;
    this.dly_1 = dispIndex;
    this.ely_1 = methodIndex;
  }
  w3() {
    return this.cly_1;
  }
  toString() {
    return 'TraitMethod(name=' + toString(this.cly_1) + ', dispIndex=' + this.dly_1 + ', methodIndex=' + this.ely_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.cly_1);
    result = imul(result, 31) + this.dly_1 | 0;
    result = imul(result, 31) + this.ely_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TraitMethod))
      return false;
    var tmp0_other_with_cast = other instanceof TraitMethod ? other : THROW_CCE();
    if (!equals(this.cly_1, tmp0_other_with_cast.cly_1))
      return false;
    if (!(this.dly_1 === tmp0_other_with_cast.dly_1))
      return false;
    if (!(this.ely_1 === tmp0_other_with_cast.ely_1))
      return false;
    return true;
  }
}
class TraitClass {
  constructor(name, slotIndex, classIndex) {
    this.fly_1 = name;
    this.gly_1 = slotIndex;
    this.hly_1 = classIndex;
  }
  w3() {
    return this.fly_1;
  }
  toString() {
    return 'TraitClass(name=' + toString(this.fly_1) + ', slotIndex=' + this.gly_1 + ', classIndex=' + this.hly_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.fly_1);
    result = imul(result, 31) + this.gly_1 | 0;
    result = imul(result, 31) + this.hly_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TraitClass))
      return false;
    var tmp0_other_with_cast = other instanceof TraitClass ? other : THROW_CCE();
    if (!equals(this.fly_1, tmp0_other_with_cast.fly_1))
      return false;
    if (!(this.gly_1 === tmp0_other_with_cast.gly_1))
      return false;
    if (!(this.hly_1 === tmp0_other_with_cast.hly_1))
      return false;
    return true;
  }
}
class TraitFunction {
  constructor(name, slotIndex, functionIndex) {
    this.ily_1 = name;
    this.jly_1 = slotIndex;
    this.kly_1 = functionIndex;
  }
  w3() {
    return this.ily_1;
  }
  toString() {
    return 'TraitFunction(name=' + toString(this.ily_1) + ', slotIndex=' + this.jly_1 + ', functionIndex=' + this.kly_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.ily_1);
    result = imul(result, 31) + this.jly_1 | 0;
    result = imul(result, 31) + this.kly_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TraitFunction))
      return false;
    var tmp0_other_with_cast = other instanceof TraitFunction ? other : THROW_CCE();
    if (!equals(this.ily_1, tmp0_other_with_cast.ily_1))
      return false;
    if (!(this.jly_1 === tmp0_other_with_cast.jly_1))
      return false;
    if (!(this.kly_1 === tmp0_other_with_cast.kly_1))
      return false;
    return true;
  }
}
class InstanceInfo {
  constructor(name, base, interfaces, instanceInitializer, traits) {
    this.lly_1 = name;
    this.mly_1 = base;
    this.nly_1 = interfaces;
    this.oly_1 = instanceInitializer;
    this.ply_1 = traits;
  }
  toString() {
    return 'InstanceInfo(name=' + this.lly_1.toString() + ', base=' + toString(this.mly_1) + ', interfaces=' + toString(this.nly_1) + ', instanceInitializer=' + this.oly_1.toString() + ', traits=' + toString(this.ply_1) + ')';
  }
  hashCode() {
    var result = this.lly_1.hashCode();
    result = imul(result, 31) + hashCode(this.mly_1) | 0;
    result = imul(result, 31) + hashCode(this.nly_1) | 0;
    result = imul(result, 31) + this.oly_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ply_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InstanceInfo))
      return false;
    var tmp0_other_with_cast = other instanceof InstanceInfo ? other : THROW_CCE();
    if (!this.lly_1.equals(tmp0_other_with_cast.lly_1))
      return false;
    if (!equals(this.mly_1, tmp0_other_with_cast.mly_1))
      return false;
    if (!equals(this.nly_1, tmp0_other_with_cast.nly_1))
      return false;
    if (!this.oly_1.equals(tmp0_other_with_cast.oly_1))
      return false;
    if (!equals(this.ply_1, tmp0_other_with_cast.ply_1))
      return false;
    return true;
  }
}
class ClassInfo {
  constructor(initializer, traits) {
    this.qly_1 = initializer;
    this.rly_1 = traits;
  }
  toString() {
    return 'ClassInfo(initializer=' + this.qly_1.toString() + ', traits=' + toString(this.rly_1) + ')';
  }
  hashCode() {
    var result = this.qly_1.hashCode();
    result = imul(result, 31) + hashCode(this.rly_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClassInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ClassInfo ? other : THROW_CCE();
    if (!this.qly_1.equals(tmp0_other_with_cast.qly_1))
      return false;
    if (!equals(this.rly_1, tmp0_other_with_cast.rly_1))
      return false;
    return true;
  }
}
class TypeInfo {
  constructor(abc, instanceInfo, classInfo) {
    this.sly_1 = abc;
    this.tly_1 = instanceInfo;
    this.uly_1 = classInfo;
  }
  w3() {
    return this.tly_1.lly_1;
  }
  vly() {
    return this.tly_1.ply_1;
  }
}
class ScriptInfo {
  constructor(initializer, traits) {
    this.wly_1 = initializer;
    this.xly_1 = traits;
  }
  toString() {
    return 'ScriptInfo(initializer=' + this.wly_1.toString() + ', traits=' + toString(this.xly_1) + ')';
  }
  hashCode() {
    var result = this.wly_1.hashCode();
    result = imul(result, 31) + hashCode(this.xly_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScriptInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ScriptInfo ? other : THROW_CCE();
    if (!this.wly_1.equals(tmp0_other_with_cast.wly_1))
      return false;
    if (!equals(this.xly_1, tmp0_other_with_cast.xly_1))
      return false;
    return true;
  }
}
class MethodDesc {
  constructor(name) {
    this.rlx_1 = name;
    this.slx_1 = null;
  }
  toString() {
    return 'MethodDesc(name=' + this.rlx_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.rlx_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MethodDesc))
      return false;
    var tmp0_other_with_cast = other instanceof MethodDesc ? other : THROW_CCE();
    if (!(this.rlx_1 === tmp0_other_with_cast.rlx_1))
      return false;
    return true;
  }
}
class ABC {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp.yly_1 = emptyList();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_0.zly_1 = emptyList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_1.alz_1 = emptyList();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.blz_1 = emptyList();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_3.clz_1 = emptyList();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.dlz_1 = emptyList();
    var tmp_5 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_5.elz_1 = emptyList();
    this.flz_1 = new AbcConstantPool();
  }
  ilz() {
    return this.flz_1.jlz_1;
  }
  qlz() {
    return this.flz_1.klz_1;
  }
  rlz() {
    return this.flz_1.llz_1;
  }
  slz() {
    return this.flz_1.mlz_1;
  }
  tlz() {
    return this.flz_1.nlz_1;
  }
  glz() {
    return this.flz_1.plz_1;
  }
  ulz(s) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>' call
    var minor = readU16LE(s);
    var major = readU16LE(s);
    this.flz_1.vlz(s);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var tmp$ret$0 = this.wlz(s);
      destination.f(tmp$ret$0);
    }
    tmp.yly_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = until(0, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var item_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var name = this.slz().i1(readU30(s));
      // Inline function 'kotlin.collections.map' call
      var this_2 = until(0, readU30(s));
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_1 = this_2.f1();
      while (tmp0_iterator_1.g1()) {
        var item_1 = tmp0_iterator_1.h1();
        // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$3 = to(this.slz().i1(readU30(s)), this.slz().i1(readU30(s)));
        destination_1.f(tmp$ret$3);
      }
      var items = destination_1;
      var tmp$ret$6 = new Metadata(name, toMap(items));
      destination_0.f(tmp$ret$6);
    }
    tmp_0.elz_1 = destination_0;
    var typeCount = readU30(s);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = until(0, typeCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.f1();
    while (tmp0_iterator_2.g1()) {
      var item_2 = tmp0_iterator_2.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var tmp$ret$9 = this.xlz(s);
      destination_2.f(tmp$ret$9);
    }
    tmp_1.zly_1 = destination_2;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_4 = until(0, typeCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.w(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator_3 = this_4.f1();
    while (tmp0_iterator_3.g1()) {
      var item_3 = tmp0_iterator_3.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var tmp$ret$12 = this.ylz(s);
      destination_3.f(tmp$ret$12);
    }
    tmp_2.alz_1 = destination_3;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.map' call
    var this_5 = zip(this.zly_1, this.alz_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_4 = this_5.f1();
    while (tmp0_iterator_4.g1()) {
      var item_4 = tmp0_iterator_4.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var tmp$ret$15 = new TypeInfo(this, item_4.im_1, item_4.jm_1);
      destination_4.f(tmp$ret$15);
    }
    tmp_3.blz_1 = destination_4;
    var tmp_4 = this;
    // Inline function 'kotlin.collections.map' call
    var this_6 = until(0, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList.w(collectionSizeOrDefault(this_6, 10));
    var tmp0_iterator_5 = this_6.f1();
    while (tmp0_iterator_5.g1()) {
      var item_5 = tmp0_iterator_5.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var tmp$ret$18 = new ScriptInfo(this.yly_1.i1(readU30(s)), this.zlz(s));
      destination_5.f(tmp$ret$18);
    }
    tmp_4.clz_1 = destination_5;
    var tmp_5 = this;
    // Inline function 'kotlin.collections.map' call
    var this_7 = until(0, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_6 = ArrayList.w(collectionSizeOrDefault(this_7, 10));
    var tmp0_iterator_6 = this_7.f1();
    while (tmp0_iterator_6.g1()) {
      var item_6 = tmp0_iterator_6.h1();
      // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>' call
      var method = this.yly_1.i1(readU30(s));
      var maxStack = readU30(s);
      var localCount = readU30(s);
      var initScopeDepth = readU30(s);
      var maxScopeDepth = readU30(s);
      var opcodes = readBytes(s, readU30(s));
      // Inline function 'kotlin.collections.map' call
      var this_8 = until(0, readU30(s));
      // Inline function 'kotlin.collections.mapTo' call
      var destination_7 = ArrayList.w(collectionSizeOrDefault(this_8, 10));
      var tmp0_iterator_7 = this_8.f1();
      while (tmp0_iterator_7.g1()) {
        var item_7 = tmp0_iterator_7.h1();
        // Inline function 'korlibs.korfl.ABC.readFile.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$21 = new ExceptionInfo(readU30(s), readU30(s), readU30(s), this.glz().i1(readU30(s)), this.glz().i1(readU30(s)));
        destination_7.f(tmp$ret$21);
      }
      var exceptions = destination_7;
      var traits = this.zlz(s);
      var tmp$ret$24 = new MethodBody(method, maxStack, localCount, initScopeDepth, maxScopeDepth, opcodes, this.flz_1, exceptions, traits);
      destination_6.f(tmp$ret$24);
    }
    tmp_5.dlz_1 = destination_6;
    return this;
  }
  ylz(s) {
    return new ClassInfo(this.yly_1.i1(readU30(s)), this.zlz(s));
  }
  xlz(s) {
    var tmp = this.glz().i1(readU30(s));
    var name = tmp instanceof ABCQName ? tmp : THROW_CCE();
    var base = this.glz().i1(readU30(s));
    var flags = readU8(s);
    var isSealed = !((flags & 1) === 0);
    var isFinal = !((flags & 2) === 0);
    var isInterface = !((flags & 4) === 0);
    if (!((flags & 8) === 0)) {
      var protectedNamespace = this.tlz().i1(readU30(s));
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korfl.ABC.readInstance.<anonymous>' call
      var tmp$ret$0 = this.glz().i1(readU30(s));
      destination.f(tmp$ret$0);
    }
    var interfaces = destination;
    var instanceInitializerIndex = readU30(s);
    var traits = this.zlz(s);
    return new InstanceInfo(name, base, interfaces, this.yly_1.i1(instanceInitializerIndex), traits);
  }
  hlz(type, index) {
    var tmp;
    switch (type) {
      case 3:
        tmp = this.ilz().i1(index);
        break;
      case 4:
        tmp = this.qlz().i1(index);
        break;
      case 6:
        tmp = this.rlz().i1(index);
        break;
      case 1:
        tmp = this.slz().i1(index);
        break;
      case 11:
        tmp = true;
        break;
      case 10:
        tmp = false;
        break;
      case 12:
      case 0:
        tmp = null;
        break;
      case 8:
      case 22:
      case 23:
      case 24:
      case 25:
      case 26:
      case 5:
        tmp = this.tlz().i1(index);
        break;
      default:
        invalidOp('Unknown parameter type.');
        break;
    }
    return tmp;
  }
  zlz(s) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korfl.ABC.readTraits.<anonymous>' call
      var name = this.glz().i1(readU30(s));
      var kind = readU8(s);
      var info = kind >>> 4 | 0;
      var hasMetadata = !((info & 4) === 0);
      var traitKind = kind & 15;
      var tmp;
      switch (traitKind) {
        case 0:
          tmp = readTraits$_anonymous_$handleTraitSlot_f8v1zw(s, this, name);
          break;
        case 6:
          tmp = readTraits$_anonymous_$handleTraitSlot_f8v1zw(s, this, name);
          break;
        case 1:
          tmp = readTraits$_anonymous_$handleTraitMethod_m5u9vd(s, info, name);
          break;
        case 2:
          tmp = readTraits$_anonymous_$handleTraitMethod_m5u9vd(s, info, name);
          break;
        case 3:
          tmp = readTraits$_anonymous_$handleTraitMethod_m5u9vd(s, info, name);
          break;
        case 4:
          tmp = new TraitClass(name, readU30(s), readU30(s));
          break;
        case 5:
          tmp = new TraitFunction(name, readU30(s), readU30(s));
          break;
        default:
          invalidOp('Unknown trait kind ' + traitKind);
          break;
      }
      var trait = tmp;
      if (hasMetadata) {
        // Inline function 'kotlin.collections.map' call
        var this_1 = until(0, readU30(s));
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
        var tmp0_iterator_0 = this_1.f1();
        while (tmp0_iterator_0.g1()) {
          var item_0 = tmp0_iterator_0.h1();
          // Inline function 'korlibs.korfl.ABC.readTraits.<anonymous>.<anonymous>' call
          var tmp$ret$0 = this.elz_1.i1(readU30(s));
          destination_0.f(tmp$ret$0);
        }
        var metadatas = destination_0;
      }
      destination.f(trait);
    }
    return destination;
  }
  wlz(s) {
    var parameterCount = readU30(s);
    var returnType = this.glz().i1(readU30(s));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, parameterCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korfl.ABC.readMethod.<anonymous>' call
      var tmp$ret$0 = this.glz().i1(readU30(s));
      destination.f(tmp$ret$0);
    }
    var parameters = destination;
    var name = this.slz().i1(readU30(s));
    var flags = readU8(s);
    var needsArguments = !((flags & 1) === 0);
    var needsActivation = !((flags & 2) === 0);
    var needsRest = !((flags & 4) === 0);
    var hasOptionalParameters = !((flags & 8) === 0);
    var setsDXNS = !((flags & 64) === 0);
    var hasParameterNames = !((flags & 128) === 0);
    if (hasOptionalParameters) {
      var optionalCount = readU8(s);
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, optionalCount);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.f1();
      while (tmp0_iterator_0.g1()) {
        var item_0 = tmp0_iterator_0.h1();
        var valueIndex = readU30(s);
        var optionalType = readU8(s);
        var value = this.hlz(optionalType, valueIndex);
        destination_0.f(Unit_instance);
      }
      var optionalValues = destination_0;
    }
    if (hasParameterNames) {
      // Inline function 'kotlin.collections.map' call
      var this_2 = until(0, parameterCount);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_1 = this_2.f1();
      while (tmp0_iterator_1.g1()) {
        var item_1 = tmp0_iterator_1.h1();
        // Inline function 'korlibs.korfl.ABC.readMethod.<anonymous>' call
        var tmp$ret$5 = this.slz().i1(readU30(s));
        destination_1.f(tmp$ret$5);
      }
      var parameterNames = destination_1;
    }
    return new MethodDesc(name);
  }
}
class Reader {
  constructor(i) {
    this.am0_1 = i;
  }
  bm0() {
    var len = this.cm0();
    var dyn = ((len >>> 3 | 0) & 1) === 1;
    len = len >>> 4 | 0;
    readU8(this.am0_1);
    // Inline function 'kotlin.collections.linkedMapOf' call
    var h = LinkedHashMap.vc();
    if (dyn) {
      $l$loop: while (true) {
        var s = this.dm0();
        if (s === '')
          break $l$loop;
        // Inline function 'kotlin.collections.set' call
        var value = this.p1v();
        h.r3(s, value);
      }
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, len);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.korfl.Reader.readObject.<anonymous>' call
        var tmp$ret$1 = this.dm0();
        destination.f(tmp$ret$1);
      }
      var keys = destination;
      var inductionVariable = 0;
      var last = len;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.set' call
          var key = keys.i1(n);
          var value_0 = this.p1v();
          h.r3(key, value_0);
        }
         while (inductionVariable < last);
    }
    return h;
  }
  em0(len) {
    // Inline function 'kotlin.collections.linkedMapOf' call
    var h = LinkedHashMap.vc();
    readU8(this.am0_1);
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = this.p1v();
        var value = this.p1v();
        h.r3(key, value);
      }
       while (inductionVariable < len);
    return h;
  }
  fm0(n) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var a = ArrayList.m1();
    this.p1v();
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        a.f(this.p1v());
      }
       while (inductionVariable < n);
    return a;
  }
  h1r(size) {
    return readBytes(this.am0_1, size);
  }
  gm0(preShift) {
    var ret = 0;
    var c = readU8(this.am0_1);
    if (c > 191)
      ret = 896;
    var n = 0;
    $l$loop: while (true) {
      var tmp;
      n = n + 1 | 0;
      if (n < 4) {
        tmp = c > 127;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      ret = ret | c & 127;
      ret = ret << 7;
      c = readU8(this.am0_1);
    }
    if (n > 3)
      ret = ret << 1;
    ret = ret | c;
    return ret >>> preShift | 0;
  }
  cm0(preShift, $super) {
    preShift = preShift === VOID ? 0 : preShift;
    return $super === VOID ? this.gm0(preShift) : $super.gm0.call(this, preShift);
  }
  dm0() {
    return readString(this.am0_1, this.gm0(1));
  }
  hm0(id) {
    var tmp;
    switch (id) {
      case 0:
        tmp = Undefined_instance;
        break;
      case 1:
        tmp = null;
        break;
      case 2:
        tmp = false;
        break;
      case 3:
        tmp = true;
        break;
      case 4:
        tmp = this.cm0();
        break;
      case 5:
        tmp = readF64BE(this.am0_1);
        break;
      case 6:
        tmp = this.dm0();
        break;
      case 7:
        throw Error_0.cf('XMLDocument unsupported');
      case 8:
        // Inline function 'kotlin.run' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korfl.Reader.readWithCode.<anonymous>' call

        readU8(this.am0_1);
        var tmp$ret$1 = Companion_getInstance_0().e1w(numberToLong(readF64BE(this.am0_1)));
        tmp = new DateTime(tmp$ret$1);
        break;
      case 9:
        tmp = this.fm0(this.gm0(1));
        break;
      case 10:
        tmp = this.bm0();
        break;
      case 11:
        tmp = Xml(this.dm0());
        break;
      case 12:
        tmp = this.h1r(this.gm0(1));
        break;
      case 13:
      case 14:
      case 15:
        tmp = this.fm0(this.gm0(1));
        break;
      case 16:
        // Inline function 'kotlin.run' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korfl.Reader.readWithCode.<anonymous>' call

        var len = this.gm0(1);
        this.dm0();
        tmp = this.fm0(len);
        break;
      case 17:
        tmp = this.em0(this.gm0(1));
        break;
      default:
        throw Error_0.cf('Unknown AMF ' + id);
    }
    return tmp;
  }
  p1v() {
    return this.hm0(readU8(this.am0_1));
  }
}
class AMF3 {
  im0(s) {
    var out = (new Reader(s)).p1v();
    return out;
  }
}
class AbcConstantPool {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp.jlz_1 = emptyList();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_0.klz_1 = emptyList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_1.llz_1 = emptyList();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.mlz_1 = emptyList();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_3.nlz_1 = emptyList();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.olz_1 = emptyList();
    var tmp_5 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_5.plz_1 = emptyList();
  }
  vlz(s) {
    var intCount = readU30(s);
    var tmp = this;
    var tmp_0 = listOf(0);
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(1, intCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      var tmp$ret$0 = readU30(s);
      destination.f(tmp$ret$0);
    }
    tmp.jlz_1 = plus(tmp_0, destination);
    var uintCount = readU30(s);
    var tmp_1 = this;
    var tmp_2 = listOf(0);
    // Inline function 'kotlin.collections.map' call
    var this_1 = until(1, uintCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var item_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      var tmp$ret$3 = readU30(s);
      destination_0.f(tmp$ret$3);
    }
    tmp_1.klz_1 = plus(tmp_2, destination_0);
    var doubleCount = readU30(s);
    var tmp_3 = this;
    var tmp_4 = listOf(0.0);
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(1, doubleCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.f1();
    while (tmp0_iterator_1.g1()) {
      var item_1 = tmp0_iterator_1.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      var tmp$ret$6 = readF64LE(s);
      destination_1.f(tmp$ret$6);
    }
    tmp_3.llz_1 = plus(tmp_4, destination_1);
    var stringCount = readU30(s);
    var tmp_5 = this;
    var tmp_6 = listOf('');
    // Inline function 'kotlin.collections.map' call
    var this_3 = until(1, stringCount);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.f1();
    while (tmp0_iterator_2.g1()) {
      var item_2 = tmp0_iterator_2.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      var tmp$ret$9 = readStringz(s, readU30(s));
      destination_2.f(tmp$ret$9);
    }
    tmp_5.mlz_1 = plus(tmp_6, destination_2);
    var tmp_7 = this;
    var tmp_8 = listOf(Companion_getInstance_20().blw_1);
    // Inline function 'kotlin.collections.map' call
    var this_4 = until(1, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.w(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator_3 = this_4.f1();
    while (tmp0_iterator_3.g1()) {
      var item_3 = tmp0_iterator_3.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      var kind = readU8(s);
      var name = this.mlz_1.i1(readU30(s));
      var tmp$ret$12 = new Namespace(kind, name);
      destination_3.f(tmp$ret$12);
    }
    tmp_7.nlz_1 = plus(tmp_8, destination_3);
    var tmp_9 = this;
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$15 = emptyList();
    var tmp_10 = listOf(tmp$ret$15);
    // Inline function 'kotlin.collections.map' call
    var this_5 = until(1, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_4 = this_5.f1();
    while (tmp0_iterator_4.g1()) {
      var item_4 = tmp0_iterator_4.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_6 = until(0, readU30(s));
      // Inline function 'kotlin.collections.mapTo' call
      var destination_5 = ArrayList.w(collectionSizeOrDefault(this_6, 10));
      var tmp0_iterator_5 = this_6.f1();
      while (tmp0_iterator_5.g1()) {
        var item_5 = tmp0_iterator_5.h1();
        // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>.<anonymous>' call
        var tmp$ret$16 = this.nlz_1.i1(readU30(s));
        destination_5.f(tmp$ret$16);
      }
      destination_4.f(destination_5);
    }
    tmp_9.olz_1 = plus(tmp_10, destination_4);
    var tmp_11 = this;
    var tmp_12 = listOf(EmptyMultiname_instance);
    // Inline function 'kotlin.collections.map' call
    var this_7 = until(1, readU30(s));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_6 = ArrayList.w(collectionSizeOrDefault(this_7, 10));
    var tmp0_iterator_6 = this_7.f1();
    while (tmp0_iterator_6.g1()) {
      var item_6 = tmp0_iterator_6.h1();
      // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>' call
      var kind_0 = readU8(s);
      var tmp_13;
      switch (kind_0) {
        case 7:
          tmp_13 = new ABCQName(this.nlz_1.i1(readU30(s)), this.mlz_1.i1(readU30(s)));
          break;
        case 13:
          tmp_13 = new QNameA(this.nlz_1.i1(readU30(s)), this.mlz_1.i1(readU30(s)));
          break;
        case 15:
          tmp_13 = new RTQName(this.mlz_1.i1(readU30(s)));
          break;
        case 16:
          tmp_13 = new RTQNameA(this.mlz_1.i1(readU30(s)));
          break;
        case 17:
          tmp_13 = RTQNameL_instance;
          break;
        case 18:
          tmp_13 = RTQNameLA_instance;
          break;
        case 9:
          tmp_13 = new Multiname(this.mlz_1.i1(readU30(s)), this.olz_1.i1(readU30(s)));
          break;
        case 14:
          tmp_13 = new MultinameA(this.mlz_1.i1(readU30(s)), this.olz_1.i1(readU30(s)));
          break;
        case 27:
          tmp_13 = new MultinameL(this.olz_1.i1(readU30(s)));
          break;
        case 28:
          tmp_13 = new MultinameLA(this.olz_1.i1(readU30(s)));
          break;
        case 29:
          var tmp_14 = readU30(s);
          // Inline function 'kotlin.collections.map' call

          var this_8 = until(0, readU30(s));
          // Inline function 'kotlin.collections.mapTo' call

          var destination_7 = ArrayList.w(collectionSizeOrDefault(this_8, 10));
          var tmp0_iterator_7 = this_8.f1();
          while (tmp0_iterator_7.g1()) {
            var item_7 = tmp0_iterator_7.h1();
            // Inline function 'korlibs.korfl.AbcConstantPool.readConstantPool.<anonymous>.<anonymous>' call
            var tmp$ret$22 = readU30(s);
            destination_7.f(tmp$ret$22);
          }

          tmp_13 = new TypeName(tmp_14, destination_7);
          break;
        default:
          invalidOp('Unsupported ' + kind_0);
          break;
      }
      var tmp$ret$25 = tmp_13;
      destination_6.f(tmp$ret$25);
    }
    tmp_11.plz_1 = plus(tmp_12, destination_6);
  }
}
class Companion_0 {
  mlw(cpool, s) {
    var iop = readU8(s);
    var op = Companion_getInstance_22().jm0_1.k3(iop);
    return ensureNotNull(op).qm0_1.mm0_1(new KindContext(op, cpool, s));
  }
}
class KindContext {
  constructor(op, cpool, s) {
    this.rm0_1 = op;
    this.sm0_1 = cpool;
    this.tm0_1 = s;
  }
  qlz() {
    return this.sm0_1.klz_1;
  }
  rlz() {
    return this.sm0_1.llz_1;
  }
  slz() {
    return this.sm0_1.mlz_1;
  }
  tlz() {
    return this.sm0_1.nlz_1;
  }
  glz() {
    return this.sm0_1.plz_1;
  }
}
class Kind extends Enum {
  constructor(name, ordinal, read) {
    var tmp;
    if (read === VOID) {
      tmp = AbcOpcode$Kind$_init_$lambda_lyqwcd;
    } else {
      tmp = read;
    }
    read = tmp;
    super(name, ordinal);
    this.mm0_1 = read;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values_1();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korfl.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.pm0_1, item);
      destination.f(tmp$ret$0);
    }
    tmp.jm0_1 = toMap(destination);
  }
}
class AbcOpcode extends Enum {
  constructor(name, ordinal, id, type) {
    super(name, ordinal);
    this.pm0_1 = id;
    this.qm0_1 = type;
  }
}
class AbcBasicOperation {
  constructor(opcode) {
    this.um0_1 = opcode;
  }
  vm0() {
    return this.um0_1;
  }
  toString() {
    return 'AbcBasicOperation(opcode=' + this.um0_1.toString() + ')';
  }
  hashCode() {
    return this.um0_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcBasicOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcBasicOperation ? other : THROW_CCE();
    if (!this.um0_1.equals(tmp0_other_with_cast.um0_1))
      return false;
    return true;
  }
}
class AbcLabelOperation {
  constructor(opcode, position) {
    this.wm0_1 = opcode;
    this.xm0_1 = position;
  }
  vm0() {
    return this.wm0_1;
  }
  toString() {
    return 'AbcLabelOperation(opcode=' + this.wm0_1.toString() + ', position=' + this.xm0_1.toString() + ')';
  }
  hashCode() {
    var result = this.wm0_1.hashCode();
    result = imul(result, 31) + this.xm0_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcLabelOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcLabelOperation ? other : THROW_CCE();
    if (!this.wm0_1.equals(tmp0_other_with_cast.wm0_1))
      return false;
    if (!this.xm0_1.equals(tmp0_other_with_cast.xm0_1))
      return false;
    return true;
  }
}
class AbcIntOperation {
  constructor(opcode, value) {
    this.ym0_1 = opcode;
    this.zm0_1 = value;
  }
  vm0() {
    return this.ym0_1;
  }
  toString() {
    return 'AbcIntOperation(opcode=' + this.ym0_1.toString() + ', value=' + this.zm0_1 + ')';
  }
  hashCode() {
    var result = this.ym0_1.hashCode();
    result = imul(result, 31) + this.zm0_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcIntOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcIntOperation ? other : THROW_CCE();
    if (!this.ym0_1.equals(tmp0_other_with_cast.ym0_1))
      return false;
    if (!(this.zm0_1 === tmp0_other_with_cast.zm0_1))
      return false;
    return true;
  }
}
class AbcDoubleOperation {
  constructor(opcode, value) {
    this.am1_1 = opcode;
    this.bm1_1 = value;
  }
  vm0() {
    return this.am1_1;
  }
  toString() {
    return 'AbcDoubleOperation(opcode=' + this.am1_1.toString() + ', value=' + this.bm1_1 + ')';
  }
  hashCode() {
    var result = this.am1_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.bm1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcDoubleOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcDoubleOperation ? other : THROW_CCE();
    if (!this.am1_1.equals(tmp0_other_with_cast.am1_1))
      return false;
    if (!equals(this.bm1_1, tmp0_other_with_cast.bm1_1))
      return false;
    return true;
  }
}
class AbcIntIntOperation {
  constructor(opcode, value1, value2) {
    this.cm1_1 = opcode;
    this.dm1_1 = value1;
    this.em1_1 = value2;
  }
  vm0() {
    return this.cm1_1;
  }
  toString() {
    return 'AbcIntIntOperation(opcode=' + this.cm1_1.toString() + ', value1=' + this.dm1_1 + ', value2=' + this.em1_1 + ')';
  }
  hashCode() {
    var result = this.cm1_1.hashCode();
    result = imul(result, 31) + this.dm1_1 | 0;
    result = imul(result, 31) + this.em1_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcIntIntOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcIntIntOperation ? other : THROW_CCE();
    if (!this.cm1_1.equals(tmp0_other_with_cast.cm1_1))
      return false;
    if (!(this.dm1_1 === tmp0_other_with_cast.dm1_1))
      return false;
    if (!(this.em1_1 === tmp0_other_with_cast.em1_1))
      return false;
    return true;
  }
}
class AbcIntStringIntIntOperation {
  constructor(opcode, int1, string, int2, int3) {
    this.fm1_1 = opcode;
    this.gm1_1 = int1;
    this.hm1_1 = string;
    this.im1_1 = int2;
    this.jm1_1 = int3;
  }
  vm0() {
    return this.fm1_1;
  }
  toString() {
    return 'AbcIntStringIntIntOperation(opcode=' + this.fm1_1.toString() + ', int1=' + this.gm1_1 + ', string=' + this.hm1_1 + ', int2=' + this.im1_1 + ', int3=' + this.jm1_1 + ')';
  }
  hashCode() {
    var result = this.fm1_1.hashCode();
    result = imul(result, 31) + this.gm1_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.hm1_1) | 0;
    result = imul(result, 31) + this.im1_1 | 0;
    result = imul(result, 31) + this.jm1_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcIntStringIntIntOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcIntStringIntIntOperation ? other : THROW_CCE();
    if (!this.fm1_1.equals(tmp0_other_with_cast.fm1_1))
      return false;
    if (!(this.gm1_1 === tmp0_other_with_cast.gm1_1))
      return false;
    if (!(this.hm1_1 === tmp0_other_with_cast.hm1_1))
      return false;
    if (!(this.im1_1 === tmp0_other_with_cast.im1_1))
      return false;
    if (!(this.jm1_1 === tmp0_other_with_cast.jm1_1))
      return false;
    return true;
  }
}
class AbcStringOperation {
  constructor(opcode, value) {
    this.km1_1 = opcode;
    this.lm1_1 = value;
  }
  vm0() {
    return this.km1_1;
  }
  toString() {
    return 'AbcStringOperation(opcode=' + this.km1_1.toString() + ', value=' + this.lm1_1 + ')';
  }
  hashCode() {
    var result = this.km1_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.lm1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcStringOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcStringOperation ? other : THROW_CCE();
    if (!this.km1_1.equals(tmp0_other_with_cast.km1_1))
      return false;
    if (!(this.lm1_1 === tmp0_other_with_cast.lm1_1))
      return false;
    return true;
  }
}
class AbcMultinameOperation {
  constructor(opcode, multiname) {
    this.mm1_1 = opcode;
    this.nm1_1 = multiname;
  }
  vm0() {
    return this.mm1_1;
  }
  toString() {
    return 'AbcMultinameOperation(opcode=' + this.mm1_1.toString() + ', multiname=' + toString(this.nm1_1) + ')';
  }
  hashCode() {
    var result = this.mm1_1.hashCode();
    result = imul(result, 31) + hashCode(this.nm1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcMultinameOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcMultinameOperation ? other : THROW_CCE();
    if (!this.mm1_1.equals(tmp0_other_with_cast.mm1_1))
      return false;
    if (!equals(this.nm1_1, tmp0_other_with_cast.nm1_1))
      return false;
    return true;
  }
}
class AbcMultinameIntOperation {
  constructor(opcode, multiname, value) {
    this.om1_1 = opcode;
    this.pm1_1 = multiname;
    this.qm1_1 = value;
  }
  vm0() {
    return this.om1_1;
  }
  toString() {
    return 'AbcMultinameIntOperation(opcode=' + this.om1_1.toString() + ', multiname=' + toString(this.pm1_1) + ', value=' + this.qm1_1 + ')';
  }
  hashCode() {
    var result = this.om1_1.hashCode();
    result = imul(result, 31) + hashCode(this.pm1_1) | 0;
    result = imul(result, 31) + this.qm1_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcMultinameIntOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcMultinameIntOperation ? other : THROW_CCE();
    if (!this.om1_1.equals(tmp0_other_with_cast.om1_1))
      return false;
    if (!equals(this.pm1_1, tmp0_other_with_cast.pm1_1))
      return false;
    if (!(this.qm1_1 === tmp0_other_with_cast.qm1_1))
      return false;
    return true;
  }
}
class AbcJumpOperation {
  constructor(opcode, position) {
    this.rm1_1 = opcode;
    this.sm1_1 = position;
  }
  vm0() {
    return this.rm1_1;
  }
  toString() {
    return 'AbcJumpOperation(opcode=' + this.rm1_1.toString() + ', position=' + this.sm1_1.toString() + ')';
  }
  hashCode() {
    var result = this.rm1_1.hashCode();
    result = imul(result, 31) + this.sm1_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcJumpOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcJumpOperation ? other : THROW_CCE();
    if (!this.rm1_1.equals(tmp0_other_with_cast.rm1_1))
      return false;
    if (!this.sm1_1.equals(tmp0_other_with_cast.sm1_1))
      return false;
    return true;
  }
}
class AbcNewClassOperation {
  constructor(opcode, value) {
    this.tm1_1 = opcode;
    this.um1_1 = value;
  }
  vm0() {
    return this.tm1_1;
  }
  toString() {
    return 'AbcNewClassOperation(opcode=' + this.tm1_1.toString() + ', value=' + this.um1_1 + ')';
  }
  hashCode() {
    var result = this.tm1_1.hashCode();
    result = imul(result, 31) + this.um1_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcNewClassOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcNewClassOperation ? other : THROW_CCE();
    if (!this.tm1_1.equals(tmp0_other_with_cast.tm1_1))
      return false;
    if (!(this.um1_1 === tmp0_other_with_cast.um1_1))
      return false;
    return true;
  }
}
class AbcLookupSwitchOperation {
  constructor(opcode, defaultMarker, markers) {
    this.vm1_1 = opcode;
    this.wm1_1 = defaultMarker;
    this.xm1_1 = markers;
  }
  vm0() {
    return this.vm1_1;
  }
  toString() {
    return 'AbcLookupSwitchOperation(opcode=' + this.vm1_1.toString() + ', defaultMarker=' + this.wm1_1.toString() + ', markers=' + toString(this.xm1_1) + ')';
  }
  hashCode() {
    var result = this.vm1_1.hashCode();
    result = imul(result, 31) + this.wm1_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.xm1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcLookupSwitchOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcLookupSwitchOperation ? other : THROW_CCE();
    if (!this.vm1_1.equals(tmp0_other_with_cast.vm1_1))
      return false;
    if (!this.wm1_1.equals(tmp0_other_with_cast.wm1_1))
      return false;
    if (!equals(this.xm1_1, tmp0_other_with_cast.xm1_1))
      return false;
    return true;
  }
}
class AbcNamespaceOperation {
  constructor(opcode, namespace) {
    this.ym1_1 = opcode;
    this.zm1_1 = namespace;
  }
  vm0() {
    return this.ym1_1;
  }
  toString() {
    return 'AbcNamespaceOperation(opcode=' + this.ym1_1.toString() + ', namespace=' + this.zm1_1.toString() + ')';
  }
  hashCode() {
    var result = this.ym1_1.hashCode();
    result = imul(result, 31) + this.zm1_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AbcNamespaceOperation))
      return false;
    var tmp0_other_with_cast = other instanceof AbcNamespaceOperation ? other : THROW_CCE();
    if (!this.ym1_1.equals(tmp0_other_with_cast.ym1_1))
      return false;
    if (!this.zm1_1.equals(tmp0_other_with_cast.zm1_1))
      return false;
    return true;
  }
}
class Undefined {}
class Companion_2 {
  am2(actions) {
    var labelNr = 1;
    var labelCount = 0;
    var action;
    var n = actions.j1();
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        action = actions.i1(i);
        if (isInterface(action, IActionBranch)) {
          var j = 0;
          var found = false;
          var actionBranch = action;
          var targetPos = (actionBranch.lz() + actionBranch.bm2() | 0) + actionBranch.cm2() | 0;
          if (targetPos <= actionBranch.lz()) {
            var inductionVariable_0 = 0;
            if (inductionVariable_0 <= i)
              $l$loop: do {
                var _j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                j = i - _j | 0;
                if (targetPos === actions.i1(j).lz()) {
                  labelCount = labelCount + 1 | 0;
                  found = true;
                  break $l$loop;
                }
              }
               while (!(_j === i));
          } else {
            var inductionVariable_1 = i + 1 | 0;
            if (inductionVariable_1 < n)
              $l$loop_0: do {
                var _j_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                j = _j_0;
                if (targetPos === actions.i1(j).lz()) {
                  labelCount = labelCount + 1 | 0;
                  found = true;
                  break $l$loop_0;
                }
              }
               while (inductionVariable_1 < n);
            if (!found) {
              action = actions.i1(j - 1 | 0);
              if (targetPos === (action.lz() + action.bm2() | 0)) {
                j = -1;
                found = true;
              }
            }
          }
          if (found) {
            actionBranch.dm2(j);
            if (j >= 0) {
              action = actions.i1(j);
              action.em2('L');
            }
          } else {
            actionBranch.dm2(-2);
          }
        }
      }
       while (inductionVariable < n);
    var inductionVariable_2 = 0;
    if (inductionVariable_2 < n)
      do {
        var i_0 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        action = actions.i1(i_0);
        if (!(action.fm2() == null)) {
          var _receiver__tnumb7 = action;
          var tmp = _receiver__tnumb7.fm2();
          var _unary__edvuaz = labelNr;
          labelNr = _unary__edvuaz + 1 | 0;
          _receiver__tnumb7.em2(plus_0(tmp, _unary__edvuaz));
        }
      }
       while (inductionVariable_2 < n);
    return labelCount;
  }
}
class Action {
  constructor(code, length, pos) {
    this.gm2_1 = code;
    this.hm2_1 = length;
    this.im2_1 = pos;
    this.jm2_1 = null;
  }
  km2() {
    return this.gm2_1;
  }
  a() {
    return this.hm2_1;
  }
  lz() {
    return this.im2_1;
  }
  em2(_set____db54di) {
    this.jm2_1 = _set____db54di;
  }
  fm2() {
    return this.jm2_1;
  }
  bm2() {
    return this.a() + (this.km2() >= 128 ? 3 : 1) | 0;
  }
  lm2(data) {
  }
  mm2(indent) {
    return '[Action] Code: ' + toString_1(this.km2(), 16) + ', Length: ' + this.a();
  }
  nm2(indent, context) {
    return this.om2(indent) + 'unknown (0x' + toString_1(this.km2(), 16) + ')';
  }
  om2(indent) {
    return !(this.fm2() == null) ? '' + this.fm2() + ':\n' + repeat(' ', indent + 2 | 0) : repeat(' ', 2);
  }
}
class ActionExecutionContext {
  constructor(actions, cpool, labelCount) {
    this.pm2_1 = actions;
    this.qm2_1 = cpool;
    this.rm2_1 = labelCount;
    var tmp = this;
    var tmp_0;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.pm2_1.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.korfl.as3swf.ActionExecutionContext.endLabel.<anonymous>' call
        var tmp_1;
        if (!(element == null) ? isInterface(element, IActionBranch) : false) {
          tmp_1 = element.tm2() === -1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    if (!(tmp$ret$1 == null)) {
      tmp_0 = 'L' + (this.rm2_1 + 1 | 0);
    } else {
      tmp_0 = null;
    }
    tmp.sm2_1 = tmp_0;
  }
}
class ActionNextFrame extends Action {
  mm2(indent) {
    return '[ActionNextFrame]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'nextFrame';
  }
}
class ActionPreviousFrame extends Action {
  mm2(indent) {
    return '[ActionPreviousFrame]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'previousFrame';
  }
}
class ActionPlay extends Action {
  mm2(indent) {
    return '[ActionPlay]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'play';
  }
}
class ActionStop extends Action {
  mm2(indent) {
    return '[ActionStop]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stop';
  }
}
class ActionToggleQuality extends Action {
  mm2(indent) {
    return '[ActionToggleQuality]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'toggleQuality';
  }
}
class ActionStopSounds extends Action {
  mm2(indent) {
    return '[ActionStopSounds]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stopSounds';
  }
}
class ActionAdd extends Action {
  mm2(indent) {
    return '[ActionAdd]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'add';
  }
}
class ActionSubtract extends Action {
  mm2(indent) {
    return '[ActionSubtract]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'subtract';
  }
}
class ActionMultiply extends Action {
  mm2(indent) {
    return '[ActionMultiply]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'multiply';
  }
}
class ActionDivide extends Action {
  mm2(indent) {
    return '[ActionDivide]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'divide';
  }
}
class ActionEquals extends Action {
  mm2(indent) {
    return '[ActionEquals]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'equals';
  }
}
class ActionLess extends Action {
  mm2(indent) {
    return '[ActionLess]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'less';
  }
}
class ActionAnd extends Action {
  mm2(indent) {
    return '[ActionAnd]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'and';
  }
}
class ActionOr extends Action {
  mm2(indent) {
    return '[ActionOr]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'or';
  }
}
class ActionNot extends Action {
  mm2(indent) {
    return '[ActionNot]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'not';
  }
}
class ActionStringEquals extends Action {
  mm2(indent) {
    return '[ActionStringEquals]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stringEquals';
  }
}
class ActionStringLength extends Action {
  mm2(indent) {
    return '[ActionStringLength]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stringLength';
  }
}
class ActionStringExtract extends Action {
  mm2(indent) {
    return '[ActionStringExtract]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stringExtract';
  }
}
class ActionPop extends Action {
  mm2(indent) {
    return '[ActionPop]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'pop';
  }
}
class ActionToInteger extends Action {
  mm2(indent) {
    return '[ActionToInteger]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'toInteger';
  }
}
class ActionGetVariable extends Action {
  mm2(indent) {
    return '[ActionGetVariable]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'getVariable';
  }
}
class ActionSetVariable extends Action {
  mm2(indent) {
    return '[ActionSetVariable]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'setVariable';
  }
}
class ActionSetTarget2 extends Action {
  mm2(indent) {
    return '[ActionSetTarget2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'setTarget2';
  }
}
class ActionStringAdd extends Action {
  mm2(indent) {
    return '[ActionStringAdd]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stringAdd';
  }
}
class ActionGetProperty extends Action {
  mm2(indent) {
    return '[ActionGetProperty]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'getProperty';
  }
}
class ActionSetProperty extends Action {
  mm2(indent) {
    return '[ActionSetProperty]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'setProperty';
  }
}
class ActionCloneSprite extends Action {
  mm2(indent) {
    return '[ActionCloneSprite]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'cloneSprite';
  }
}
class ActionRemoveSprite extends Action {
  mm2(indent) {
    return '[ActionRemoveSprite]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'removeSprite';
  }
}
class ActionTrace extends Action {
  mm2(indent) {
    return '[ActionTrace]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'trace';
  }
}
class ActionStartDrag extends Action {
  mm2(indent) {
    return '[ActionStartDrag]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'startDrag';
  }
}
class ActionEndDrag extends Action {
  mm2(indent) {
    return '[ActionEndDrag]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'endDrag';
  }
}
class ActionStringLess extends Action {
  mm2(indent) {
    return '[ActionStringLess]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stringLess';
  }
}
class ActionThrow extends Action {
  mm2(indent) {
    return '[ActionThrow]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'throw';
  }
}
class ActionCastOp extends Action {
  mm2(indent) {
    return '[ActionCastOp]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'castOp';
  }
}
class ActionImplementsOp extends Action {
  mm2(indent) {
    return '[ActionImplementsOp]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'implementsOp';
  }
}
class ActionRandomNumber extends Action {
  mm2(indent) {
    return '[ActionRandomNumber]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'randomNumber';
  }
}
class ActionMBStringLength extends Action {
  mm2(indent) {
    return '[ActionMBStringLength]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'mbStringLength';
  }
}
class ActionCharToAscii extends Action {
  mm2(indent) {
    return '[ActionCharToAscii]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'charToAscii';
  }
}
class ActionAsciiToChar extends Action {
  mm2(indent) {
    return '[ActionAsciiToChar]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'asciiToChar';
  }
}
class ActionGetTime extends Action {
  mm2(indent) {
    return '[ActionGetTime]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'getTime';
  }
}
class ActionMBStringExtract extends Action {
  mm2(indent) {
    return '[ActionMBStringExtract]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'mbStringExtract';
  }
}
class ActionMBCharToAscii extends Action {
  mm2(indent) {
    return '[ActionMBCharToAscii]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'mbCharToAscii';
  }
}
class ActionMBAsciiToChar extends Action {
  mm2(indent) {
    return '[ActionMBAsciiToChar]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'mbAsciiToChar';
  }
}
class ActionDelete extends Action {
  mm2(indent) {
    return '[ActionDelete]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'delete';
  }
}
class ActionDelete2 extends Action {
  mm2(indent) {
    return '[ActionDelete2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'delete2';
  }
}
class ActionDefineLocal extends Action {
  mm2(indent) {
    return '[ActionDefineLocal]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'defineLocal';
  }
}
class ActionCallFunction extends Action {
  mm2(indent) {
    return '[ActionCallFunction]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'callFunction';
  }
}
class ActionReturn extends Action {
  mm2(indent) {
    return '[ActionReturn]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'return';
  }
}
class ActionModulo extends Action {
  mm2(indent) {
    return '[ActionModulo]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'modulo';
  }
}
class ActionNewObject extends Action {
  mm2(indent) {
    return '[ActionNewObject]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'newObject';
  }
}
class ActionDefineLocal2 extends Action {
  mm2(indent) {
    return '[ActionDefineLocal2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'defineLocal2';
  }
}
class ActionInitArray extends Action {
  mm2(indent) {
    return '[ActionInitArray]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'initArray';
  }
}
class ActionInitObject extends Action {
  mm2(indent) {
    return '[ActionInitObject]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'initObject';
  }
}
class ActionTypeOf extends Action {
  mm2(indent) {
    return '[ActionTypeOf]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'typeOf';
  }
}
class ActionTargetPath extends Action {
  mm2(indent) {
    return '[ActionTargetPath]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'targetPath';
  }
}
class ActionEnumerate extends Action {
  mm2(indent) {
    return '[ActionEnumerate]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'enumerate';
  }
}
class ActionAdd2 extends Action {
  mm2(indent) {
    return '[ActionAdd2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'add2';
  }
}
class ActionLess2 extends Action {
  mm2(indent) {
    return '[ActionLess2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'less2';
  }
}
class ActionEquals2 extends Action {
  mm2(indent) {
    return '[ActionEquals2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'equals2';
  }
}
class ActionToNumber extends Action {
  mm2(indent) {
    return '[ActionToNumber]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'toNumber';
  }
}
class ActionToString extends Action {
  mm2(indent) {
    return '[ActionToString]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'toString';
  }
}
class ActionPushDuplicate extends Action {
  mm2(indent) {
    return '[ActionPushDuplicate]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'pushDuplicate';
  }
}
class ActionStackSwap extends Action {
  mm2(indent) {
    return '[ActionStackSwap]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stackSwap';
  }
}
class ActionGetMember extends Action {
  mm2(indent) {
    return '[ActionGetMember]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'getMember';
  }
}
class ActionSetMember extends Action {
  mm2(indent) {
    return '[ActionSetMember]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'setMember';
  }
}
class ActionIncrement extends Action {
  mm2(indent) {
    return '[ActionIncrement]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'increment';
  }
}
class ActionDecrement extends Action {
  mm2(indent) {
    return '[ActionDecrement]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'decrement';
  }
}
class ActionCallMethod extends Action {
  mm2(indent) {
    return '[ActionCallMethod]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'callMethod';
  }
}
class ActionNewMethod extends Action {
  mm2(indent) {
    return '[ActionNewMethod]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'newMethod';
  }
}
class ActionInstanceOf extends Action {
  mm2(indent) {
    return '[ActionInstanceOf]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'instanceOf';
  }
}
class ActionEnumerate2 extends Action {
  mm2(indent) {
    return '[ActionEnumerate2]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'enumerate2';
  }
}
class ActionBitAnd extends Action {
  mm2(indent) {
    return '[ActionBitAnd]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'bitAnd';
  }
}
class ActionBitOr extends Action {
  mm2(indent) {
    return '[ActionBitOr]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'bitOr';
  }
}
class ActionBitXor extends Action {
  mm2(indent) {
    return '[ActionBitXor]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'bitXor';
  }
}
class ActionBitLShift extends Action {
  mm2(indent) {
    return '[ActionBitLShift]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'bitLShift';
  }
}
class ActionBitRShift extends Action {
  mm2(indent) {
    return '[ActionBitRShift]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'bitRShift';
  }
}
class ActionBitURShift extends Action {
  mm2(indent) {
    return '[ActionBitURShift]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'bitURShift';
  }
}
class ActionStrictEquals extends Action {
  mm2(indent) {
    return '[ActionStrictEquals]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'strictEquals';
  }
}
class ActionGreater extends Action {
  mm2(indent) {
    return '[ActionGreater]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'greater';
  }
}
class ActionStringGreater extends Action {
  mm2(indent) {
    return '[ActionStringGreater]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'stringGreater';
  }
}
class ActionExtends extends Action {
  mm2(indent) {
    return '[ActionExtends]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'extends';
  }
}
class ActionGotoFrame extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.kmf_1 = 0;
  }
  lm2(data) {
    this.kmf_1 = data.pmf();
  }
  mm2(indent) {
    return '[ActionGotoFrame] Frame: ' + this.kmf_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'gotoFrame ' + this.kmf_1;
  }
}
class ActionGetURL extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.umf_1 = null;
    this.vmf_1 = null;
  }
  lm2(data) {
    this.umf_1 = data.dm0();
    this.vmf_1 = data.dm0();
  }
  mm2(indent) {
    return '[ActionGetURL] URL: ' + this.umf_1 + ', Target: ' + this.vmf_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'getURL "' + this.umf_1 + '", "' + this.vmf_1 + '"';
  }
}
class ActionStoreRegister extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.amg_1 = 0;
  }
  lm2(data) {
    this.amg_1 = data.bmg();
  }
  mm2(indent) {
    return '[ActionStoreRegister] RegisterNumber: ' + this.amg_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'store $' + this.amg_1;
  }
}
class ActionConstantPool extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.gmg_1 = ArrayList.m1();
  }
  lm2(data) {
    var count = data.pmf();
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.gmg_1.f(data.dm0());
      }
       while (inductionVariable < count);
  }
  mm2(indent) {
    var str = '[ActionConstantPool] Values: ' + this.gmg_1.j1();
    var inductionVariable = 0;
    var last = this.gmg_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + i + ': ' + this.gmg_1.i1(i));
      }
       while (inductionVariable < last);
    return str;
  }
  nm2(indent, context) {
    var str = this.om2(indent) + 'constantPool';
    context.qm2_1.o3();
    var inductionVariable = 0;
    var last = this.gmg_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + i + ': ' + this.gmg_1.i1(i));
        context.qm2_1.f(this.gmg_1.i1(i));
      }
       while (inductionVariable < last);
    return str;
  }
}
class ActionWaitForFrame extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.lmg_1 = 0;
    this.mmg_1 = 0;
  }
  lm2(data) {
    this.lmg_1 = data.pmf();
    this.mmg_1 = data.bmg();
  }
  mm2(indent) {
    return '[ActionWaitForFrame] Frame: ' + this.lmg_1 + ', SkipCount: ' + this.mmg_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'waitForFrame ' + this.lmg_1 + (this.mmg_1 > 0 ? ', ' + this.mmg_1 : '');
  }
}
class ActionSetTarget extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.rmg_1 = null;
  }
  lm2(data) {
    this.rmg_1 = data.dm0();
  }
  mm2(indent) {
    return '[ActionSetTarget] TargetName: ' + this.rmg_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'setTarget "' + this.rmg_1 + '"';
  }
}
class ActionGotoLabel extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.wmg_1 = null;
  }
  lm2(data) {
    this.wmg_1 = data.dm0();
  }
  mm2(indent) {
    return '[ActionGotoLabel] Label: ' + this.wmg_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'gotoLabel "' + this.wmg_1 + '"';
  }
}
class ActionWaitForFrame2 extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.bmh_1 = 0;
  }
  lm2(data) {
    this.bmh_1 = data.bmg();
  }
  mm2(indent) {
    return '[ActionWaitForFrame2] SkipCount: ' + this.bmh_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'waitForFrame2 (' + this.bmh_1 + ')';
  }
}
class ActionDefineFunction2 extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.gmh_1 = null;
    this.hmh_1 = ArrayList.m1();
    this.imh_1 = ArrayList.m1();
    this.jmh_1 = 0;
    this.kmh_1 = 0;
    this.lmh_1 = false;
    this.mmh_1 = false;
    this.nmh_1 = false;
    this.omh_1 = false;
    this.pmh_1 = false;
    this.qmh_1 = false;
    this.rmh_1 = false;
    this.smh_1 = false;
    this.tmh_1 = false;
  }
  lm2(data) {
    this.gmh_1 = data.dm0();
    var numParams = data.pmf();
    this.kmh_1 = data.bmg();
    var flags1 = data.bmg();
    this.lmh_1 = !((flags1 & 128) === 0);
    this.mmh_1 = !((flags1 & 64) === 0);
    this.rmh_1 = !((flags1 & 32) === 0);
    this.nmh_1 = !((flags1 & 16) === 0);
    this.smh_1 = !((flags1 & 8) === 0);
    this.omh_1 = !((flags1 & 4) === 0);
    this.tmh_1 = !((flags1 & 2) === 0);
    this.pmh_1 = !((flags1 & 1) === 0);
    var flags2 = data.bmg();
    this.qmh_1 = !((flags2 & 1) === 0);
    var inductionVariable = 0;
    if (inductionVariable < numParams)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.hmh_1.f(data.umh());
      }
       while (inductionVariable < numParams);
    var codeSize = data.pmf();
    var bodyEndPosition = data.q1q() + codeSize | 0;
    while (data.q1q() < bodyEndPosition) {
      this.imh_1.f(ensureNotNull(data.ymh()));
    }
    this.jmh_1 = Companion_instance_6.am2(this.imh_1);
  }
  mm2(indent) {
    var tmp;
    var tmp_0;
    if (this.gmh_1 == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = ensureNotNull(this.gmh_1);
      tmp_0 = charSequenceLength(this_0) === 0;
    }
    if (tmp_0) {
      tmp = '<anonymous>';
    } else {
      tmp = this.gmh_1;
    }
    var str = '[ActionDefineFunction2] ' + tmp + '(' + joinToString(this.hmh_1, ', ') + '), ';
    // Inline function 'kotlin.collections.arrayListOf' call
    var a = ArrayList.m1();
    if (this.lmh_1) {
      a.f('preloadParent');
    }
    if (this.mmh_1) {
      a.f('preloadRoot');
    }
    if (this.nmh_1) {
      a.f('preloadSuper');
    }
    if (this.omh_1) {
      a.f('preloadArguments');
    }
    if (this.pmh_1) {
      a.f('preloadThis');
    }
    if (this.qmh_1) {
      a.f('preloadGlobal');
    }
    if (this.rmh_1) {
      a.f('suppressSuper');
    }
    if (this.smh_1) {
      a.f('suppressArguments');
    }
    if (this.tmh_1) {
      a.f('suppressThis');
    }
    if (a.j1() === 0) {
      a.f('none');
    }
    str = str + ('Flags: ' + joinToString(a, ','));
    var inductionVariable = 0;
    var last = this.imh_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.imh_1.i1(i).mm2(indent + 4 | 0));
      }
       while (inductionVariable < last);
    return str;
  }
  nm2(indent, context) {
    var tmp = this.om2(indent) + 'defineFunction2 ';
    var tmp_0;
    var tmp_1;
    if (this.gmh_1 == null) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = ensureNotNull(this.gmh_1);
      tmp_1 = charSequenceLength(this_0) === 0;
    }
    if (tmp_1) {
      tmp_0 = '';
    } else {
      tmp_0 = this.gmh_1;
    }
    var str = tmp + tmp_0 + '(' + joinToString(this.hmh_1, ', ') + ') {';
    // Inline function 'kotlin.collections.arrayListOf' call
    var preload = ArrayList.m1();
    // Inline function 'kotlin.collections.arrayListOf' call
    var suppress = ArrayList.m1();
    if (this.lmh_1) {
      preload.f('parent');
    }
    if (this.mmh_1) {
      preload.f('root');
    }
    if (this.nmh_1) {
      preload.f('super');
    }
    if (this.omh_1) {
      preload.f('arguments');
    }
    if (this.pmh_1) {
      preload.f('this');
    }
    if (this.qmh_1) {
      preload.f('global');
    }
    if (this.rmh_1) {
      suppress.f('super');
    }
    if (this.smh_1) {
      suppress.f('arguments');
    }
    if (this.tmh_1) {
      suppress.f('this');
    }
    if (preload.j1() > 0)
      str = str + ('\n' + repeat(' ', indent + 4 | 0) + '// preload: ' + joinToString(preload, ', '));
    if (suppress.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent + 4 | 0) + '// suppress: ' + joinToString(suppress, ', '));
    }
    var ctx = new ActionExecutionContext(this.imh_1, ArrayList.v(context.qm2_1), this.jmh_1);
    var inductionVariable = 0;
    var last = this.imh_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.imh_1.i1(i).nm2(indent + 4 | 0, ctx));
      }
       while (inductionVariable < last);
    if (!(ctx.sm2_1 == null))
      str = str + ('\n' + repeat(' ', indent + 4 | 0) + ctx.sm2_1 + ':');
    str = str + ('\n' + repeat(' ', indent + 2 | 0) + '}');
    return str;
  }
}
class ActionTry extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.dmi_1 = false;
    this.emi_1 = false;
    this.fmi_1 = false;
    this.gmi_1 = null;
    this.hmi_1 = 0;
    this.imi_1 = ArrayList.m1();
    this.jmi_1 = ArrayList.m1();
    this.kmi_1 = ArrayList.m1();
    this.lmi_1 = 0;
    this.mmi_1 = 0;
    this.nmi_1 = 0;
  }
  lm2(data) {
    var flags = data.bmg();
    this.dmi_1 = !((flags & 4) === 0);
    this.emi_1 = !((flags & 2) === 0);
    this.fmi_1 = !((flags & 1) === 0);
    var trySize = data.pmf();
    var catchSize = data.pmf();
    var finallySize = data.pmf();
    if (this.dmi_1) {
      this.hmi_1 = data.bmg();
    } else {
      this.gmi_1 = data.dm0();
    }
    var tryEndPosition = data.q1q() + trySize | 0;
    while (data.q1q() < tryEndPosition) {
      this.imi_1.f(ensureNotNull(data.ymh()));
    }
    var catchEndPosition = data.q1q() + catchSize | 0;
    while (data.q1q() < catchEndPosition) {
      this.jmi_1.f(ensureNotNull(data.ymh()));
    }
    var finallyEndPosition = data.q1q() + finallySize | 0;
    while (data.q1q() < finallyEndPosition) {
      this.kmi_1.f(ensureNotNull(data.ymh()));
    }
    this.lmi_1 = Companion_instance_6.am2(this.imi_1);
    this.mmi_1 = Companion_instance_6.am2(this.jmi_1);
    this.nmi_1 = Companion_instance_6.am2(this.kmi_1);
  }
  mm2(indent) {
    var str = '[ActionTry] ';
    str = str + (this.dmi_1 ? 'Register: ' + this.hmi_1 : 'Name: ' + this.gmi_1);
    if (!(this.imi_1.j1() === 0)) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Try:');
      var inductionVariable = 0;
      var last = this.imi_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.imi_1.i1(i).mm2(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    if (!(this.jmi_1.j1() === 0)) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Catch:');
      var inductionVariable_0 = 0;
      var last_0 = this.jmi_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i_0 + '] ' + this.jmi_1.i1(i_0).mm2(indent + 4 | 0));
        }
         while (inductionVariable_0 < last_0);
    }
    if (!(this.kmi_1.j1() === 0)) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Finally:');
      var inductionVariable_1 = 0;
      var last_1 = this.kmi_1.j1();
      if (inductionVariable_1 < last_1)
        do {
          var i_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i_1 + '] ' + this.kmi_1.i1(i_1).mm2(indent + 4 | 0));
        }
         while (inductionVariable_1 < last_1);
    }
    return str;
  }
  nm2(indent, context) {
    var str = !(this.fm2() == null) ? plus_0(this.fm2(), ':\n') : '';
    var lf = '';
    if (!(this.imi_1.j1() === 0)) {
      str = str + (lf + repeat(' ', indent + 2 | 0) + 'try {');
      var contextTry = new ActionExecutionContext(this.imi_1, ArrayList.v(context.qm2_1), this.lmi_1);
      var inductionVariable = 0;
      var last = this.imi_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.imi_1.i1(i).nm2(indent + 4 | 0, contextTry));
        }
         while (inductionVariable < last);
      if (!(contextTry.sm2_1 == null))
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + contextTry.sm2_1 + ':');
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + '}');
      lf = '\n';
    }
    if (!(this.jmi_1.j1() === 0)) {
      str = str + (lf + repeat(' ', indent + 2 | 0) + 'catch(' + (this.dmi_1 ? '$' + this.hmi_1 : this.gmi_1) + ') {');
      var contextCatch = new ActionExecutionContext(this.jmi_1, ArrayList.v(context.qm2_1), this.mmi_1);
      var inductionVariable_0 = 0;
      var last_0 = this.jmi_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.jmi_1.i1(i_0).nm2(indent + 4 | 0, contextCatch));
        }
         while (inductionVariable_0 < last_0);
      if (!(contextCatch.sm2_1 == null))
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + contextCatch.sm2_1 + ':');
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + '}');
      lf = '\n';
    }
    if (!(this.kmi_1.j1() === 0)) {
      str = str + (lf + repeat(' ', indent + 2 | 0) + 'finally {');
      var contextFinally = new ActionExecutionContext(this.kmi_1, ArrayList.v(context.qm2_1), this.nmi_1);
      var inductionVariable_1 = 0;
      var last_1 = this.kmi_1.j1();
      if (inductionVariable_1 < last_1)
        do {
          var i_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.kmi_1.i1(i_1).nm2(indent + 4 | 0, contextFinally));
        }
         while (inductionVariable_1 < last_1);
      if (!(contextFinally.sm2_1 == null))
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + contextFinally.sm2_1 + ':');
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + '}');
    }
    return str;
  }
}
class ActionWith extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.smi_1 = ArrayList.m1();
    this.tmi_1 = 0;
  }
  lm2(data) {
    var codeSize = data.pmf();
    var bodyEndPosition = data.q1q() + codeSize | 0;
    while (data.q1q() < bodyEndPosition) {
      this.smi_1.f(ensureNotNull(data.ymh()));
    }
    this.tmi_1 = Companion_instance_6.am2(this.smi_1);
  }
  mm2(indent) {
    var str = '[ActionWith]';
    var inductionVariable = 0;
    var last = this.smi_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.smi_1.i1(i).mm2(indent + 4 | 0));
      }
       while (inductionVariable < last);
    return str;
  }
  nm2(indent, context) {
    var str = this.om2(indent) + 'with {';
    var ctx = new ActionExecutionContext(this.smi_1, ArrayList.v(context.qm2_1), this.tmi_1);
    var inductionVariable = 0;
    var last = this.smi_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.smi_1.i1(i).nm2(indent + 4 | 0, ctx));
      }
       while (inductionVariable < last);
    if (!(ctx.sm2_1 == null))
      str = str + ('\n' + repeat(' ', indent + 4 | 0) + ctx.sm2_1 + ':');
    str = str + ('\n' + repeat(' ', indent + 2 | 0) + '}');
    return str;
  }
}
class ActionPush extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.ymi_1 = ArrayList.m1();
  }
  lm2(data) {
    var endPosition = data.q1q() + this.a() | 0;
    while (!(data.q1q() === endPosition)) {
      this.ymi_1.f(data.zmi());
    }
  }
  mm2(indent) {
    return '[ActionPush] ' + joinToString(this.ymi_1, ', ');
  }
  nm2(indent, context) {
    var str = this.om2(indent);
    var inductionVariable = 0;
    var last = this.ymi_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (i > 0)
          str = str + ('\n' + repeat(' ', indent + 2 | 0));
        str = str + ('push ' + this.ymi_1.i1(i).hmj(context.qm2_1));
      }
       while (inductionVariable < last);
    return str;
  }
}
class IActionBranch {}
class ActionJump extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.mmj_1 = 0;
    this.nmj_1 = -2;
  }
  cm2() {
    return this.mmj_1;
  }
  dm2(_set____db54di) {
    this.nmj_1 = _set____db54di;
  }
  tm2() {
    return this.nmj_1;
  }
  lm2(data) {
    this.mmj_1 = data.omj();
  }
  mm2(indent) {
    var bi = ' [' + (this.nmj_1 >= 0 ? this.nmj_1.toString() : this.nmj_1 === -1 ? 'EOB' : '???') + ']';
    return '[ActionJump] BranchOffset: ' + this.mmj_1 + bi;
  }
  nm2(indent, context) {
    var tmp;
    if (this.nmj_1 >= 0) {
      var tmp9_safe_receiver = context.pm2_1.i1(this.nmj_1);
      tmp = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.fm2();
    } else if (this.nmj_1 === -1) {
      tmp = 'L' + (context.rm2_1 + 1 | 0);
    } else {
      tmp = 'ILLEGAL BRANCH';
    }
    var ls = tmp;
    return this.om2(indent) + 'jump ' + ls;
  }
}
class ActionGetURL2 extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.tmj_1 = 0;
    this.umj_1 = 0;
    this.vmj_1 = false;
    this.wmj_1 = false;
  }
  lm2(data) {
    this.tmj_1 = data.xmj(2);
    this.umj_1 = data.xmj(4);
    this.vmj_1 = data.xmj(1) === 1;
    this.wmj_1 = data.xmj(1) === 1;
  }
  mm2(indent) {
    return '[ActionGetURL2] SendVarsMethod: ' + this.tmj_1 + ' (' + this.ymj() + '), Reserved: ' + this.umj_1 + ', LoadTargetFlag: ' + this.vmj_1 + ', LoadVariablesFlag: ' + this.wmj_1;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'getUrl2 (method: ' + this.ymj() + ', target: ' + (!this.vmj_1 ? 'window' : 'sprite') + ', variables: ' + (!this.wmj_1 ? 'no' : 'yes') + ')';
  }
  ymj() {
    var tmp;
    switch (this.tmj_1) {
      case 0:
        tmp = 'None';
        break;
      case 1:
        tmp = 'GET';
        break;
      case 2:
        tmp = 'POST';
        break;
      default:
        var message = 'sendVarsMethod is only defined for values of 0, 1, and 2.';
        throw IllegalStateException.m5(toString(message));
    }
    return tmp;
  }
}
class ActionDefineFunction extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.dmk_1 = null;
    this.emk_1 = ArrayList.m1();
    this.fmk_1 = ArrayList.m1();
    this.gmk_1 = 0;
  }
  lm2(data) {
    this.dmk_1 = data.dm0();
    var count = data.pmf();
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.emk_1.f(data.dm0());
      }
       while (inductionVariable < count);
    var codeSize = data.pmf();
    var bodyEndPosition = data.q1q() + codeSize | 0;
    while (data.q1q() < bodyEndPosition) {
      this.fmk_1.f(ensureNotNull(data.ymh()));
    }
    this.gmk_1 = Companion_instance_6.am2(this.fmk_1);
  }
  mm2(indent) {
    var tmp;
    var tmp_0;
    if (this.dmk_1 == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = ensureNotNull(this.dmk_1);
      tmp_0 = charSequenceLength(this_0) === 0;
    }
    if (tmp_0) {
      tmp = '<anonymous>';
    } else {
      tmp = this.dmk_1;
    }
    var str = '[ActionDefineFunction] ' + tmp + '(' + joinToString(this.emk_1, ', ') + ')';
    var inductionVariable = 0;
    var last = this.fmk_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.fmk_1.i1(i).mm2(indent + 4 | 0));
      }
       while (inductionVariable < last);
    return str;
  }
  nm2(indent, context) {
    var tmp = this.om2(indent) + 'defineFunction ';
    var tmp_0;
    var tmp_1;
    if (this.dmk_1 == null) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = ensureNotNull(this.dmk_1);
      tmp_1 = charSequenceLength(this_0) === 0;
    }
    if (tmp_1) {
      tmp_0 = '';
    } else {
      tmp_0 = this.dmk_1;
    }
    var str = tmp + tmp_0 + '(' + joinToString(this.emk_1, ', ') + ') {';
    var ctx = new ActionExecutionContext(this.fmk_1, ArrayList.v(context.qm2_1), this.gmk_1);
    var inductionVariable = 0;
    var last = this.fmk_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.fmk_1.i1(i).nm2(indent + 4 | 0, ctx));
      }
       while (inductionVariable < last);
    if (!(ctx.sm2_1 == null)) {
      str = str + ('\n' + repeat(' ', indent + 4 | 0) + ctx.sm2_1 + ':');
    }
    str = str + ('\n' + repeat(' ', indent + 2 | 0) + '}');
    return str;
  }
}
class ActionIf extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.lmk_1 = 0;
    this.mmk_1 = -2;
  }
  cm2() {
    return this.lmk_1;
  }
  dm2(_set____db54di) {
    this.mmk_1 = _set____db54di;
  }
  tm2() {
    return this.mmk_1;
  }
  lm2(data) {
    this.lmk_1 = data.omj();
  }
  mm2(indent) {
    var bi = '[' + (this.mmk_1 >= 0 ? this.mmk_1.toString() : this.mmk_1 === -1 ? 'EOB' : '???') + ']';
    return '[ActionIf] BranchOffset: ' + this.lmk_1 + bi;
  }
  nm2(indent, context) {
    var tmp;
    if (this.mmk_1 >= 0) {
      var tmp8_safe_receiver = context.pm2_1.i1(this.mmk_1);
      tmp = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.fm2();
    } else if (this.mmk_1 === -1) {
      tmp = 'L' + (context.rm2_1 + 1 | 0);
    } else {
      tmp = 'ILLEGAL BRANCH';
    }
    var ls = tmp;
    return this.om2(indent) + 'if ' + ls;
  }
}
class ActionCall extends Action {
  mm2(indent) {
    return '[ActionCall]';
  }
  nm2(indent, context) {
    return this.om2(indent) + 'call';
  }
}
class ActionGotoFrame2 extends Action {
  constructor(code, length, pos) {
    super(code, length, pos);
    this.vmk_1 = false;
    this.wmk_1 = false;
    this.xmk_1 = 0;
  }
  lm2(data) {
    var flags = data.bmg();
    this.vmk_1 = !((flags & 2) === 0);
    this.wmk_1 = !((flags & 1) === 0);
    if (this.vmk_1) {
      this.xmk_1 = data.pmf();
    }
  }
  mm2(indent) {
    var str = '[ActionGotoFrame2] PlayFlag: ' + this.wmk_1 + ', SceneBiasFlag: ' + this.vmk_1;
    if (this.vmk_1)
      str = str + (', ' + this.xmk_1);
    return str;
  }
  nm2(indent, context) {
    return this.om2(indent) + 'gotoFrame2 (' + (!this.wmk_1 ? 'gotoAndStop' : 'gotoAndPlay') + (this.vmk_1 ? ', sceneBias: ' + this.xmk_1 : '') + ')';
  }
}
class ActionUnknown extends Action {
  lm2(data) {
    if (this.a() > 0) {
      data.cml(this.a());
    }
  }
  mm2(indent) {
    return '[????] Code: ' + toString_1(this.km2(), 16) + ', Length: ' + this.a();
  }
}
class Companion_3 {
  constructor() {
    this.dml_1 = 'zlib';
    this.eml_1 = 'lzma';
    this.fml_1 = 1;
    this.gml_1 = 2;
    this.hml_1 = 4;
    this.iml_1 = 8;
  }
}
class SWFTimelineContainer {
  constructor() {
    this.qmm_1 = ArrayList.m1();
    this.rmm_1 = ArrayList.m1();
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.smm_1 = HashMap.c9();
    this.tmm_1 = ArrayList.m1();
    this.umm_1 = ArrayList.m1();
    this.vmm_1 = ArrayList.m1();
    this.wmm_1 = null;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.ymm_1 = HashMap.c9();
    this.zmm_1 = false;
    this.amn_1 = false;
    this.bmn_1 = null;
    this.cmn_1 = 0;
    this.dmn_1 = 0;
    this.emn_1 = new SWFTagFactory();
    this.fmn_1 = this;
    this.gmn_1 = 16777215;
    this.hmn_1 = null;
  }
  wmn() {
    var tmp = this.xmm_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('currentFrame');
    }
  }
  imn(data, version, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parseTags__eki1u0(this, data, version, $completion), $completion);
  }
  xmn(data, async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parseTag__51w741(this, data, async, $completion), $completion);
  }
  ymn(tag, currentTagIndex) {
    this.gmn_1 = tag.vmq_1;
  }
  zmn(tag, currentTagIndex) {
    this.hmn_1 = tag;
  }
  pmn(indent, flags) {
    var str = '';
    if (this.qmm_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Tags:');
      var inductionVariable = 0;
      var last = this.qmm_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + this.qmm_1.i1(i).wmq(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    if (!((flags & 1) === 0)) {
      if (this.tmm_1.j1() > 0) {
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Scenes:');
        var inductionVariable_0 = 0;
        var last_0 = this.tmm_1.j1();
        if (inductionVariable_0 < last_0)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            str = str + ('\n' + this.tmm_1.i1(i_0).mm2(indent + 4 | 0));
          }
           while (inductionVariable_0 < last_0);
      }
      if (this.umm_1.j1() > 0) {
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Frames:');
        var inductionVariable_1 = 0;
        var last_1 = this.umm_1.j1();
        if (inductionVariable_1 < last_1)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            str = str + ('\n' + this.umm_1.i1(i_1).mm2(indent + 4 | 0));
          }
           while (inductionVariable_1 < last_1);
      }
      if (this.vmm_1.j1() > 0) {
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Layers:');
        var inductionVariable_2 = 0;
        var last_2 = this.vmm_1.j1();
        if (inductionVariable_2 < last_2)
          do {
            var i_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i_2 + '] ' + this.vmm_1.i1(i_2).mm2(indent + 4 | 0));
          }
           while (inductionVariable_2 < last_2);
      }
    }
    return str;
  }
  dmr(indent, flags, $super) {
    indent = indent === VOID ? 0 : indent;
    flags = flags === VOID ? 0 : flags;
    return $super === VOID ? this.pmn(indent, flags) : $super.pmn.call(this, indent, flags);
  }
  toString() {
    return this.pmn(0, 0);
  }
}
class SWF extends SWFTimelineContainer {
  constructor() {
    super();
    this.bmm_1 = new Mixin();
    this.cmm_1 = SWFData.nmn();
    this.dmm_1 = null;
    this.emm_1 = 0;
    this.fmm_1 = 0;
    this.gmm_1 = 0;
    this.hmm_1 = new SWFRectangle();
    this.imm_1 = 0.0;
    this.jmm_1 = 0;
    this.kmm_1 = false;
    this.lmm_1 = 'zlib';
    this.emm_1 = 10;
    this.fmm_1 = 0;
    this.gmm_1 = 0;
    this.hmm_1 = new SWFRectangle();
    this.imm_1 = 50.0;
    this.jmm_1 = 1;
    this.kmm_1 = true;
    this.lmm_1 = 'zlib';
  }
  n13(_set____db54di) {
    this.bmm_1.n13(_set____db54di);
  }
  o13() {
    return this.bmm_1.o13();
  }
  omn(bytes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadBytes__jf9vlb(this, bytes, $completion), $completion);
  }
  omm(data, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5(this, data, $completion), $completion);
  }
  pmm($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parseHeader__o3854c(this, $completion), $completion);
  }
  pmn(indent, flags) {
    var indent0 = repeat(' ', indent);
    var indent2 = repeat(' ', indent + 2 | 0);
    var indent4 = repeat(' ', indent + 4 | 0);
    var s = indent0 + '[SWF]\n' + indent2 + 'Header:\n' + indent4 + 'Version: ' + this.emm_1 + '\n' + indent4 + 'Compression: ';
    var tmp = s;
    var tmp_0;
    if (this.kmm_1) {
      switch (this.lmm_1) {
        case 'zlib':
          tmp_0 = 'ZLIB';
          break;
        case 'lzma':
          tmp_0 = 'LZMA';
          break;
        default:
          tmp_0 = 'Unknown';
          break;
      }
    } else {
      tmp_0 = 'None';
    }
    s = tmp + tmp_0;
    return s + '\n' + indent4 + 'FileLength: ' + this.fmm_1 + '\n' + indent4 + 'FileLengthCompressed: ' + this.gmm_1 + '\n' + indent4 + 'FrameSize: ' + this.hmm_1.vmn() + '\n' + indent4 + 'FrameRate: ' + this.imm_1 + '\n' + indent4 + 'FrameCount: ' + this.jmm_1 + super.pmn(indent, 0);
  }
}
class Companion_4 {
  constructor() {
    this.amo_1 = true;
  }
}
class Companion_5 {}
class FlashByteArray {
  static emr() {
    var $this = createThis(this);
    $this.vmh_1 = MemorySyncStreamBase.n1v();
    $this.wmh_1 = new SyncStream($this.vmh_1);
    $this.xmh_1 = Endian_BIG_ENDIAN_getInstance();
    return $this;
  }
  static tnl(data) {
    var $this = this.emr();
    writeBytes($this.wmh_1, data);
    $this.mmm($this.wmh_1.a().q2());
    return $this;
  }
  p1q(value) {
    this.wmh_1.r1v(toLong(value));
  }
  q1q() {
    return this.wmh_1.q1q().q2();
  }
  mmm(value) {
    this.wmh_1.i1v(toLong(value));
  }
  a() {
    return this.wmh_1.a().q2();
  }
  i1(index) {
    return ensureIndex(this, index).vmh_1.c1s_1.iv_1[index] & 255;
  }
  l38(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.FlashByteArray.set.<anonymous>' call
    ensureIndex(this, index).vmh_1.c1s_1.iv_1[index] = toByte(value);
    return value;
  }
  xn3() {
    return this.xmh_1.equals(Endian_LITTLE_ENDIAN_getInstance());
  }
  y12() {
    return readU8(this.wmh_1);
  }
  cmq() {
    return this.xn3() ? readS16LE(this.wmh_1) : readS16BE(this.wmh_1);
  }
  rmr() {
    return this.xn3() ? readS32LE(this.wmh_1) : readS32BE(this.wmh_1);
  }
  yn3() {
    return this.xn3() ? readS64LE(this.wmh_1) : readS64BE(this.wmh_1);
  }
  smr() {
    return this.y12() & 255;
  }
  bmq() {
    return this.cmq() & 65535;
  }
  tmr() {
    return this.rmr();
  }
  wmr() {
    // Inline function 'korlibs.memory.reinterpretAsFloat' call
    // Inline function 'kotlin.fromBits' call
    var bits = this.rmr();
    return floatFromBits(bits);
  }
  zn3() {
    // Inline function 'korlibs.memory.reinterpretAsDouble' call
    // Inline function 'kotlin.fromBits' call
    var bits = this.yn3();
    return doubleFromBits(bits);
  }
  an4(len) {
    var dd = copyOfRange(this.vmh_1.c1s_1.rv(), this.q1q(), this.q1q() + len | 0);
    // Inline function 'kotlin.apply' call
    var this_0 = toString_2(dd, get_UTF8());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.FlashByteArray.readUTFBytes.<anonymous>' call
    this.p1q(this.q1q() + len | 0);
    return this_0;
  }
  gmr(i) {
    return write8(this.wmh_1, i);
  }
  bn4(i) {
    var tmp;
    if (this.xn3()) {
      write32LE(this.wmh_1, i);
      tmp = Unit_instance;
    } else {
      write32BE(this.wmh_1, i);
      tmp = Unit_instance;
    }
    return tmp;
  }
  hmr(i) {
    return this.bn4(i);
  }
  imr(bytes) {
    writeBytes(this.wmh_1, bytes);
  }
  cn4(bytes, offset, length) {
    var len = length >= 0 ? length : bytes.a();
    bytes.p1q(offset);
    writeBytes(this.wmh_1, readBytes(bytes.wmh_1, len));
  }
  dmq(bytes, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? -1 : length;
    var tmp;
    if ($super === VOID) {
      this.cn4(bytes, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.cn4.call(this, bytes, offset, length);
    }
    return tmp;
  }
  dn4(content) {
    this.wmh_1.r1v(new Long(0, 0));
    this.wmh_1.i1v(new Long(0, 0));
    writeBytes(this.wmh_1, content);
    this.p1q(0);
  }
  jmr(method, $completion) {
    this.dn4(_uncompress(this, this.hn4(), method));
    return Unit_instance;
  }
  fmr(method, $completion, $super) {
    method = method === VOID ? 'zlib' : method;
    return $super === VOID ? this.jmr(method, $completion) : $super.jmr.call(this, method, $completion);
  }
  h1r(len) {
    return readBytes(this.wmh_1, len);
  }
  nmm(bytes) {
    return this.en4(bytes, bytes.q1q(), this.bmo());
  }
  en4(bytes, position, length) {
    var len = length >= 0 ? length : this.bmo();
    bytes.p1q(position);
    writeBytes(bytes.wmh_1, readBytes(this.wmh_1, len));
    bytes.p1q(position);
  }
  fn4() {
    throw NotImplementedError.oe();
  }
  bmo() {
    return this.a() - this.q1q() | 0;
  }
  pmr() {
    return this;
  }
  bm0() {
    this.pmr();
    return AMF3_instance.im0(this.wmh_1);
  }
  gn4() {
    return toFlash(this.hn4());
  }
  hn4() {
    return this.vmh_1.c1s_1.rv();
  }
}
class BitArray extends FlashByteArray {
  static omr() {
    var $this = this.emr();
    $this.nmr_1 = 0;
    return $this;
  }
  wn3(_bits, _bitBuffer) {
    var bits = _bits;
    var bitBuffer = _bitBuffer;
    if (bits === 0) {
      return bitBuffer;
    }
    var partial;
    var bitsConsumed;
    if (this.nmr_1 > 0) {
      var byte = this.i1(this.q1q() - 1 | 0) & (255 >>> (8 - this.nmr_1 | 0) | 0);
      // Inline function 'kotlin.math.min' call
      var a = this.nmr_1;
      var b = bits;
      bitsConsumed = Math.min(a, b);
      this.nmr_1 = this.nmr_1 - bitsConsumed | 0;
      partial = byte >>> this.nmr_1 | 0;
    } else {
      // Inline function 'kotlin.math.min' call
      var b_0 = bits;
      bitsConsumed = Math.min(8, b_0);
      this.nmr_1 = 8 - bitsConsumed | 0;
      partial = this.smr() >>> this.nmr_1 | 0;
    }
    bits = bits - bitsConsumed | 0;
    bitBuffer = bitBuffer << bitsConsumed | partial;
    return bits > 0 ? this.wn3(bits, bitBuffer) : bitBuffer;
  }
  zmr(_bits, _bitBuffer, $super) {
    _bitBuffer = _bitBuffer === VOID ? 0 : _bitBuffer;
    return $super === VOID ? this.wn3(_bits, _bitBuffer) : $super.wn3.call(this, _bits, _bitBuffer);
  }
  pmr() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.BitArray.resetBitsPending.<anonymous>' call
    this.nmr_1 = 0;
    return this;
  }
}
class SWFData extends BitArray {
  static nmn() {
    var $this = this.omr();
    $this.xmh_1 = Endian_LITTLE_ENDIAN_getInstance();
    return $this;
  }
  omj() {
    return this.pmr().cmq();
  }
  qmr() {
    return this.pmr().rmr();
  }
  bmg() {
    return this.pmr().smr();
  }
  pmf() {
    return this.pmr().bmq();
  }
  jmn() {
    return this.pmr().tmr();
  }
  umr() {
    return this.pmr().rmr() / 65536;
  }
  mmn() {
    return this.pmr().cmq() / 256.0;
  }
  vmr() {
    return this.pmr().wmr();
  }
  xmr() {
    var tmp = Companion_instance;
    // Inline function 'kotlin.toUShort' call
    var this_0 = this.pmr().bmq();
    var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
    return tmp.d3h(tmp$ret$0);
  }
  ymr() {
    this.pmr();
    var result = this.smr();
    if (!((result & 128) === 0)) {
      result = result & 127 | this.smr() << 7;
      if (!((result & 16384) === 0)) {
        result = result & 16383 | this.smr() << 14;
        if (!((result & 2097152) === 0)) {
          result = result & 2097151 | this.smr() << 21;
          if (!((result & 268435456) === 0)) {
            result = result & 268435455 | this.smr() << 28;
          }
        }
      }
    }
    return result;
  }
  xmj(bits) {
    return this.zmr(bits);
  }
  ams(bits) {
    var shift = 32 - bits | 0;
    return this.zmr(bits) << shift >> shift;
  }
  bms(bits) {
    return this.ams(bits) / 65536;
  }
  dm0() {
    this.pmr();
    return readStringz_0(this.wmh_1);
  }
  cms() {
    this.pmr();
    return this.smr();
  }
  dms() {
    this.pmr();
    var r = this.smr();
    var g = this.smr();
    var b = this.smr();
    return -16777216 | r << 16 | g << 8 | b;
  }
  ems() {
    this.pmr();
    var rgb = this.dms() & 16777215;
    var a = this.smr();
    return a << 24 | rgb;
  }
  lmn() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFRectangle();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readRECT.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  fms() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMatrix();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMATRIX.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  pms() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFColorTransform();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readCXFORM.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  amt() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFColorTransformWithAlpha();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readCXFORMWITHALPHA.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  lmt(unitDivisor) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFShape(unitDivisor);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readSHAPE.<anonymous>' call
    this_0.ymt(this);
    return this_0;
  }
  zmt(unitDivisor, $super) {
    unitDivisor = unitDivisor === VOID ? 20.0 : unitDivisor;
    return $super === VOID ? this.lmt(unitDivisor) : $super.lmt.call(this, unitDivisor);
  }
  amu(level, unitDivisor) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFShapeWithStyle(unitDivisor);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readSHAPEWITHSTYLE.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  qmu(level, unitDivisor, $super) {
    level = level === VOID ? 1 : level;
    unitDivisor = unitDivisor === VOID ? 20.0 : unitDivisor;
    return $super === VOID ? this.amu(level, unitDivisor) : $super.amu.call(this, level, unitDivisor);
  }
  rmu(numBits) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFShapeRecordStraightEdge(numBits);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readSTRAIGHTEDGERECORD.<anonymous>' call
    this_0.tmu(this);
    return this_0;
  }
  umu(numBits) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFShapeRecordCurvedEdge(numBits);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readCURVEDEDGERECORD.<anonymous>' call
    this_0.tmu(this);
    return this_0;
  }
  vmu(states, fillBits, lineBits, level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFShapeRecordStyleChange(states, fillBits, lineBits);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readSTYLECHANGERECORD.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  imv(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFFillStyle();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readFILLSTYLE.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  qmv(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFLineStyle();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readLINESTYLE.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  emw(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFLineStyle2();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readLINESTYLE2.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  smw(level) {
    if (this.bmg() === 0) {
      return null;
    } else {
      var _unary__edvuaz = this.q1q();
      this.p1q(_unary__edvuaz - 1 | 0);
      // Inline function 'kotlin.apply' call
      var this_0 = new SWFButtonRecord();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korfl.as3swf.SWFData.readBUTTONRECORD.<anonymous>' call
      this_0.pmu(this, level);
      return this_0;
    }
  }
  fmx(level, $super) {
    level = level === VOID ? 1 : level;
    return $super === VOID ? this.smw(level) : $super.smw.call(this, level);
  }
  gmx() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFButtonCondAction();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readBUTTONCONDACTION.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  umx() {
    var filterId = this.bmg();
    var filter = SWFFilterFactory_instance.kmo(filterId);
    filter.lm2(this);
    return filter;
  }
  vmx(glyphBits, advanceBits, previousRecord, level) {
    if (this.bmg() === 0) {
      return null;
    } else {
      var _unary__edvuaz = this.q1q();
      this.p1q(_unary__edvuaz - 1 | 0);
      // Inline function 'kotlin.apply' call
      var this_0 = new SWFTextRecord();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korfl.as3swf.SWFData.readTEXTRECORD.<anonymous>' call
      this_0.imy(this, glyphBits, advanceBits, previousRecord, level);
      return this_0;
    }
  }
  jmy(glyphBits, advanceBits) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFGlyphEntry();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readGLYPHENTRY.<anonymous>' call
    this_0.mmy(this, glyphBits, advanceBits);
    return this_0;
  }
  nmy() {
    return SWFZoneRecord.qmy(this);
  }
  rmy() {
    return SWFZoneData.umy(this);
  }
  vmy(wideCodes) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFKerningRecord();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readKERNINGRECORD.<anonymous>' call
    this_0.zmy(this, wideCodes);
    return this_0;
  }
  amz(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFGradient();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readGRADIENT.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  fmz(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFFocalGradient();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readFOCALGRADIENT.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  kmz(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFGradientRecord();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readGRADIENTRECORD.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  omz(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMorphFillStyle();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMORPHFILLSTYLE.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  ymz(level, $super) {
    level = level === VOID ? 1 : level;
    return $super === VOID ? this.omz(level) : $super.omz.call(this, level);
  }
  zmz(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMorphLineStyle();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMORPHLINESTYLE.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  on0(level, $super) {
    level = level === VOID ? 1 : level;
    return $super === VOID ? this.zmz(level) : $super.zmz.call(this, level);
  }
  pn0(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMorphLineStyle2();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMORPHLINESTYLE2.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  en1(level, $super) {
    level = level === VOID ? 1 : level;
    return $super === VOID ? this.pn0(level) : $super.pn0.call(this, level);
  }
  fn1(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMorphGradient();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMORPHGRADIENT.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  ln1(level) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMorphFocalGradient();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMORPHFOCALGRADIENT.<anonymous>' call
    this_0.pmu(this, level);
    return this_0;
  }
  rn1() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFMorphGradientRecord();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readMORPHGRADIENTRECORD.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  ymh() {
    var pos = this.q1q();
    var action = null;
    var actionCode = this.bmg();
    if (!(actionCode === 0)) {
      var actionLength = actionCode >= 128 ? this.pmf() : 0;
      action = SWFActionFactory_instance.wn1(actionCode, actionLength, pos);
      action.lm2(this);
    }
    return action;
  }
  zmi() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFActionValue();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readACTIONVALUE.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  umh() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFRegisterParam();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readREGISTERPARAM.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  zn1() {
    return SWFSymbol.cn2(this);
  }
  dn2() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFSoundInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readSOUNDINFO.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  on2() {
    return SWFSoundEnvelope.sn2(this);
  }
  tn2(version) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFClipActions();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readCLIPACTIONS.<anonymous>' call
    this_0.pmu(this, version);
    return this_0;
  }
  wn2(version) {
    var pos = this.q1q();
    var flags = version >= 6 ? this.jmn() : this.pmf();
    if (flags === 0) {
      return null;
    } else {
      this.p1q(pos);
      // Inline function 'kotlin.apply' call
      var this_0 = new SWFClipActionRecord();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korfl.as3swf.SWFData.readCLIPACTIONRECORD.<anonymous>' call
      this_0.pmu(this, version);
      return this_0;
    }
  }
  bn3(version) {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFClipEventFlags();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readCLIPEVENTFLAGS.<anonymous>' call
    this_0.pmu(this, version);
    return this_0;
  }
  vn3() {
    var pos = this.q1q();
    var tagTypeAndLength = this.pmf();
    var tagLength = tagTypeAndLength & 63;
    if (tagLength === 63) {
      tagLength = this.qmr();
    }
    return new SWFRecordHeader(tagTypeAndLength >>> 6 | 0, tagLength, this.q1q() - pos | 0);
  }
  kmn(compressionMethod, uncompressedLength, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_swfUncompress__isrgon(this, compressionMethod, uncompressedLength, $completion), $completion);
  }
  dmo() {
    // Inline function 'kotlin.apply' call
    var this_0 = new SWFRawTag();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFData.readRawTag.<anonymous>' call
    this_0.lm2(this);
    return this_0;
  }
  cml(length) {
    this.p1q(this.q1q() + length | 0);
  }
}
class SoundCompression {
  constructor() {
    this.in4_1 = 0;
    this.jn4_1 = 1;
    this.kn4_1 = 2;
    this.ln4_1 = 3;
    this.mn4_1 = 4;
    this.nn4_1 = 5;
    this.on4_1 = 6;
    this.pn4_1 = 11;
  }
  mm2(soundCompression) {
    var tmp;
    switch (soundCompression) {
      case 0:
        tmp = 'Uncompressed Native Endian';
        break;
      case 1:
        tmp = 'ADPCM';
        break;
      case 2:
        tmp = 'MP3';
        break;
      case 3:
        tmp = 'Uncompressed Little Endian';
        break;
      case 4:
        tmp = 'Nellymoser 16kHz';
        break;
      case 5:
        tmp = 'Nellymoser 8kHz';
        break;
      case 6:
        tmp = 'Nellymoser';
        break;
      case 11:
        tmp = 'Speex';
        break;
      default:
        return 'unknown';
    }
    return tmp;
  }
}
class SoundRate {
  constructor() {
    this.qn4_1 = 0;
    this.rn4_1 = 1;
    this.sn4_1 = 2;
    this.tn4_1 = 3;
  }
  mm2(soundRate) {
    switch (soundRate) {
      case 0:
        return '5.5kHz';
      case 1:
        return '11kHz';
      case 2:
        return '22kHz';
      case 3:
        return '44kHz';
      default:
        return 'unknown';
    }
  }
}
class SoundSize {
  constructor() {
    this.un4_1 = 0;
    this.vn4_1 = 1;
  }
  mm2(soundSize) {
    switch (soundSize) {
      case 0:
        return '8bit';
      case 1:
        return '16bit';
      default:
        return 'unknown';
    }
  }
}
class SoundType {
  constructor() {
    this.wn4_1 = 0;
    this.xn4_1 = 1;
  }
  mm2(soundType) {
    switch (soundType) {
      case 0:
        return 'mono';
      case 1:
        return 'stereo';
      default:
        return 'unknown';
    }
  }
}
class BlendMode {
  constructor() {
    this.yn4_1 = 0;
    this.zn4_1 = 1;
    this.an5_1 = 2;
    this.bn5_1 = 3;
    this.cn5_1 = 4;
    this.dn5_1 = 5;
    this.en5_1 = 6;
    this.fn5_1 = 7;
    this.gn5_1 = 8;
    this.hn5_1 = 9;
    this.in5_1 = 10;
    this.jn5_1 = 11;
    this.kn5_1 = 12;
    this.ln5_1 = 13;
    this.mn5_1 = 14;
  }
  mm2(blendMode) {
    switch (blendMode) {
      case 0:
      case 1:
        return 'normal';
      case 2:
        return 'layer';
      case 3:
        return 'multiply';
      case 4:
        return 'screen';
      case 5:
        return 'lighten';
      case 6:
        return 'darken';
      case 7:
        return 'difference';
      case 8:
        return 'add';
      case 9:
        return 'subtract';
      case 10:
        return 'invert';
      case 11:
        return 'alpha';
      case 12:
        return 'erase';
      case 13:
        return 'overlay';
      case 14:
        return 'hardlight';
      default:
        return 'unknown';
    }
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values_2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korfl.as3swf.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.pn5_1, item);
      destination.f(tmp$ret$0);
    }
    tmp.qn5_1 = toMap(destination);
  }
  i1(index) {
    var tmp0_elvis_lhs = this.qn5_1.k3(index);
    return tmp0_elvis_lhs == null ? GradientSpreadMode_PAD_getInstance() : tmp0_elvis_lhs;
  }
}
class GradientSpreadMode extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.pn5_1 = id;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values_3();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korfl.as3swf.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.tn5_1, item);
      destination.f(tmp$ret$0);
    }
    tmp.un5_1 = toMap(destination);
  }
  i1(index) {
    var tmp0_elvis_lhs = this.un5_1.k3(index);
    return tmp0_elvis_lhs == null ? GradientInterpolationMode_NORMAL_getInstance() : tmp0_elvis_lhs;
  }
}
class GradientInterpolationMode extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.tn5_1 = id;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values_4();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korfl.as3swf.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.xn5_1, item);
      destination.f(tmp$ret$0);
    }
    tmp.yn5_1 = toMap(destination);
  }
  i1(index) {
    var tmp0_elvis_lhs = this.yn5_1.k3(index);
    return tmp0_elvis_lhs == null ? LineCapsStyle_ROUND_getInstance() : tmp0_elvis_lhs;
  }
}
class LineCapsStyle extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.xn5_1 = id;
  }
}
class LineJointStyle {
  constructor() {
    this.zn5_1 = 0;
    this.an6_1 = 1;
    this.bn6_1 = 2;
  }
  mm2(lineJointStyle) {
    switch (lineJointStyle) {
      case 0:
        return 'round';
      case 1:
        return 'bevel';
      case 2:
        return 'miter';
      default:
        return 'null';
    }
  }
}
class ActionValueType {
  constructor() {
    this.cn6_1 = 0;
    this.dn6_1 = 1;
    this.en6_1 = 2;
    this.fn6_1 = 3;
    this.gn6_1 = 4;
    this.hn6_1 = 5;
    this.in6_1 = 6;
    this.jn6_1 = 7;
    this.kn6_1 = 8;
    this.ln6_1 = 9;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values_5();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korfl.as3swf.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.on6_1, item);
      destination.f(tmp$ret$0);
    }
    tmp.pn6_1 = toMap(destination);
  }
  i1(index) {
    var tmp0_elvis_lhs = this.pn6_1.k3(index);
    return tmp0_elvis_lhs == null ? BitmapFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class BitmapFormat extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.on6_1 = id;
  }
}
class BitmapType {
  constructor() {
    this.qn6_1 = 1;
    this.rn6_1 = 2;
    this.sn6_1 = 3;
  }
  mm2(bitmapFormat) {
    switch (bitmapFormat) {
      case 1:
        return 'JPEG';
      case 2:
        return 'GIF89a';
      case 3:
        return 'PNG';
      default:
        return 'unknown';
    }
  }
}
class VideoDeblockingType {
  constructor() {
    this.tn6_1 = 0;
    this.un6_1 = 1;
    this.vn6_1 = 2;
    this.wn6_1 = 3;
    this.xn6_1 = 4;
    this.yn6_1 = 5;
  }
  mm2(deblockingType) {
    switch (deblockingType) {
      case 0:
        return 'videopacket';
      case 1:
        return 'off';
      case 2:
        return 'level 1';
      case 3:
        return 'level 2';
      case 4:
        return 'level 3';
      case 5:
        return 'level 4';
      default:
        return 'unknown';
    }
  }
}
class VideoCodecID {
  constructor() {
    this.zn6_1 = 2;
    this.an7_1 = 3;
    this.bn7_1 = 4;
    this.cn7_1 = 5;
    this.dn7_1 = 6;
  }
  mm2(codecId) {
    switch (codecId) {
      case 2:
        return 'H.263';
      case 3:
        return 'Screen Video';
      case 4:
        return 'VP6';
      case 5:
        return 'VP6 With Alpha';
      case 6:
        return 'Screen Video V2';
      default:
        return 'unknown';
    }
  }
}
class CSMTableHint {
  constructor() {
    this.en7_1 = 0;
    this.fn7_1 = 1;
    this.gn7_1 = 2;
  }
  mm2(csmTableHint) {
    switch (csmTableHint) {
      case 0:
        return 'thin';
      case 1:
        return 'medium';
      case 2:
        return 'thick';
      default:
        return 'unknown';
    }
  }
}
class SWFRectangle {
  constructor(xmin, xmax, ymin, ymax) {
    xmin = xmin === VOID ? 0 : xmin;
    xmax = xmax === VOID ? 11000 : xmax;
    ymin = ymin === VOID ? 0 : ymin;
    ymax = ymax === VOID ? 8000 : ymax;
    this.qmn_1 = xmin;
    this.rmn_1 = xmax;
    this.smn_1 = ymin;
    this.tmn_1 = ymax;
    this.umn_1 = Companion_getInstance_2().l2m();
  }
  lm2(data) {
    data.pmr();
    var bits = data.xmj(5);
    this.qmn_1 = data.ams(bits);
    this.rmn_1 = data.ams(bits);
    this.smn_1 = data.ams(bits);
    this.tmn_1 = data.ams(bits);
  }
  o42() {
    this.umn_1.o4e(NumberUtils_instance.hn7(this.qmn_1 / 20));
    this.umn_1.q4e(NumberUtils_instance.hn7(this.rmn_1 / 20));
    this.umn_1.p4e(NumberUtils_instance.hn7(this.smn_1 / 20));
    this.umn_1.r4e(NumberUtils_instance.hn7(this.tmn_1 / 20));
    return this.umn_1;
  }
  toString() {
    return '(' + this.qmn_1 + ',' + this.rmn_1 + ',' + this.smn_1 + ',' + this.tmn_1 + ')';
  }
  vmn() {
    return '(' + (this.rmn_1 - this.qmn_1 | 0) / 20 + ',' + (this.tmn_1 - this.smn_1 | 0) / 20 + ')';
  }
}
class SWFRawTag {
  gmo() {
    var tmp = this.emo_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('header');
    }
  }
  u51() {
    var tmp = this.fmo_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('bytes');
    }
  }
  lm2(data) {
    var pos = data.q1q();
    this.emo_1 = data.vn3();
    this.fmo_1 = SWFData.nmn();
    var posContent = data.q1q();
    data.p1q(pos);
    this.u51().imr(data.h1r(this.gmo().mmo()));
    data.p1q(posContent);
  }
}
class SWFRecordHeader {
  constructor(type, contentLength, headerLength) {
    this.hmo_1 = type;
    this.imo_1 = contentLength;
    this.jmo_1 = headerLength;
  }
  mmo() {
    return this.jmo_1 + this.imo_1 | 0;
  }
  toString() {
    return '[SWFRecordHeader] type: ' + this.hmo_1 + ', headerLength: ' + this.jmo_1 + ', contentlength: ' + this.imo_1;
  }
}
class SWFFrameLabel {
  constructor(frameNumber, name) {
    this.smp_1 = frameNumber;
    this.tmp_1 = name;
  }
  toString() {
    return 'Frame: ' + this.smp_1 + ', Name: ' + this.tmp_1;
  }
}
class SWFScene {
  constructor(offset, name) {
    this.ump_1 = offset;
    this.vmp_1 = name;
  }
  toString() {
    return 'Frame: ' + this.ump_1 + ', Name: ' + this.vmp_1;
  }
}
class SWFMatrix {
  constructor() {
    this.gms_1 = 1.0;
    this.hms_1 = 1.0;
    this.ims_1 = 0.0;
    this.jms_1 = 0.0;
    this.kms_1 = 0;
    this.lms_1 = 0;
    this.mms_1 = 0.0;
    this.nms_1 = 0.0;
    this.oms_1 = 0.0;
  }
  gl6() {
    return new MMatrix(this.gms_1, this.ims_1, this.jms_1, this.hms_1, this.kms_1 / 20.0, this.lms_1 / 20.0);
  }
  lm2(data) {
    data.pmr();
    this.gms_1 = 1.0;
    this.hms_1 = 1.0;
    if (data.xmj(1) === 1) {
      var scaleBits = data.xmj(5);
      this.gms_1 = data.bms(scaleBits);
      this.hms_1 = data.bms(scaleBits);
    }
    this.ims_1 = 0.0;
    this.jms_1 = 0.0;
    if (data.xmj(1) === 1) {
      var rotateBits = data.xmj(5);
      this.ims_1 = data.bms(rotateBits);
      this.jms_1 = data.bms(rotateBits);
    }
    var translateBits = data.xmj(5);
    this.kms_1 = data.ams(translateBits);
    this.lms_1 = data.ams(translateBits);
    var px = this.gl6().w4d(MPoint.s4c(0.0, 1.0));
    var tmp = this;
    var tmp_0 = 180 / 3.141592653589793;
    // Inline function 'kotlin.math.atan2' call
    var y = px.q4c_1;
    var x = px.p4c_1;
    tmp.oms_1 = tmp_0 * Math.atan2(y, x) - 90;
    if (this.oms_1 < 0)
      this.oms_1 = this.oms_1 + 360;
    var tmp_1 = this;
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = this.gms_1 * this.gms_1 + this.ims_1 * this.ims_1;
    tmp_1.mms_1 = Math.sqrt(x_0);
    var tmp_2 = this;
    // Inline function 'kotlin.math.sqrt' call
    var x_1 = this.jms_1 * this.jms_1 + this.hms_1 * this.hms_1;
    tmp_2.nms_1 = Math.sqrt(x_1);
  }
  in7() {
    return this.gms_1 === 1.0 && this.hms_1 === 1.0 && this.ims_1 === 0.0 && this.jms_1 === 0.0 && this.kms_1 === 0 && this.lms_1 === 0;
  }
  toString() {
    return '(' + this.gms_1 + ',' + this.ims_1 + ',' + this.jms_1 + ',' + this.hms_1 + ',' + this.kms_1 + ',' + this.lms_1 + ')';
  }
}
class SWFColorTransform {
  constructor() {
    this.qms_1 = 256;
    this.rms_1 = 256;
    this.sms_1 = 256;
    this.tms_1 = 256;
    this.ums_1 = 0;
    this.vms_1 = 0;
    this.wms_1 = 0;
    this.xms_1 = 0;
    this.yms_1 = false;
    this.zms_1 = false;
  }
  jn7() {
    return this.qms_1 / 256;
  }
  kn7() {
    return this.rms_1 / 256;
  }
  ln7() {
    return this.sms_1 / 256;
  }
  mn7() {
    return this.tms_1 / 256;
  }
  nn7() {
    return this.ums_1;
  }
  on7() {
    return this.vms_1;
  }
  pn7() {
    return this.wms_1;
  }
  qn7() {
    return this.xms_1;
  }
  lm2(data) {
    data.pmr();
    this.zms_1 = data.xmj(1) === 1;
    this.yms_1 = data.xmj(1) === 1;
    var bits = data.xmj(4);
    if (this.yms_1) {
      this.qms_1 = data.ams(bits);
      this.rms_1 = data.ams(bits);
      this.sms_1 = data.ams(bits);
    } else {
      this.qms_1 = 256;
      this.rms_1 = 256;
      this.sms_1 = 256;
    }
    if (this.zms_1) {
      this.ums_1 = data.ams(bits);
      this.vms_1 = data.ams(bits);
      this.wms_1 = data.ams(bits);
    } else {
      this.ums_1 = 0;
      this.vms_1 = 0;
      this.wms_1 = 0;
    }
  }
  in7() {
    return !this.yms_1 && !this.zms_1;
  }
  toString() {
    return '(' + this.jn7() + ',' + this.kn7() + ',' + this.ln7() + ',' + this.nn7() + ',' + this.on7() + ',' + this.pn7() + ')';
  }
}
class SWFColorTransformWithAlpha extends SWFColorTransform {
  lm2(data) {
    data.pmr();
    this.zms_1 = data.xmj(1) === 1;
    this.yms_1 = data.xmj(1) === 1;
    var bits = data.xmj(4);
    if (this.yms_1) {
      this.qms_1 = data.ams(bits);
      this.rms_1 = data.ams(bits);
      this.sms_1 = data.ams(bits);
      this.tms_1 = data.ams(bits);
    } else {
      this.qms_1 = 256;
      this.rms_1 = 256;
      this.sms_1 = 256;
      this.tms_1 = 256;
    }
    if (this.zms_1) {
      this.ums_1 = data.ams(bits);
      this.vms_1 = data.ams(bits);
      this.wms_1 = data.ams(bits);
      this.xms_1 = data.ams(bits);
    } else {
      this.ums_1 = 0;
      this.vms_1 = 0;
      this.wms_1 = 0;
      this.xms_1 = 0;
    }
  }
  toString() {
    return '(' + this.jn7() + ',' + this.kn7() + ',' + this.ln7() + ',' + this.mn7() + ',' + this.nn7() + ',' + this.on7() + ',' + this.pn7() + ',' + this.qn7() + ')';
  }
}
class SWFShape {
  constructor(unitDivisor) {
    unitDivisor = unitDivisor === VOID ? 20.0 : unitDivisor;
    this.mmt_1 = unitDivisor;
    this.nmt_1 = FastArrayList.g14();
    this.omt_1 = FastArrayList.g14();
    this.pmt_1 = FastArrayList.g14();
    this.qmt_1 = MPoint.v4c(0, 0);
    this.rmt_1 = FastArrayList.g14();
    this.smt_1 = FastArrayList.g14();
    this.tmt_1 = IntMap.t37();
    this.umt_1 = IntMap.t37();
    this.vmt_1 = 0;
    this.wmt_1 = HashMap.c9();
    this.xmt_1 = false;
  }
  pmu(data, level) {
    data.pmr();
    var numFillBits = data.xmj(4);
    var numLineBits = data.xmj(4);
    this.rn7(data, numFillBits, numLineBits, level);
    this.sn7();
  }
  ymt(data, level, $super) {
    level = level === VOID ? 1 : level;
    var tmp;
    if ($super === VOID) {
      this.pmu(data, level);
      tmp = Unit_instance;
    } else {
      tmp = $super.pmu.call(this, data, level);
    }
    return tmp;
  }
  rn7(data, _fillBits, _lineBits, level) {
    var fillBits = _fillBits;
    var lineBits = _lineBits;
    var shapeRecord = null;
    $l$loop: while (!(shapeRecord instanceof SWFShapeRecordEnd)) {
      var edgeRecord = data.xmj(1) === 1;
      if (edgeRecord) {
        var straightFlag = data.xmj(1) === 1;
        var numBits = data.xmj(4) + 2 | 0;
        if (straightFlag) {
          shapeRecord = data.rmu(numBits);
        } else {
          shapeRecord = data.umu(numBits);
        }
      } else {
        var states = data.xmj(5);
        if (states === 0) {
          shapeRecord = SWFShapeRecordEnd_getInstance();
        } else {
          var styleChangeRecord = data.vmu(states, fillBits, lineBits, level);
          if (styleChangeRecord.tn7()) {
            fillBits = styleChangeRecord.ymu_1;
            lineBits = styleChangeRecord.zmu_1;
          }
          shapeRecord = styleChangeRecord;
        }
      }
      this.nmt_1.f(shapeRecord);
    }
  }
  sn7() {
    var tmp = this.nmt_1.i1(0);
    var styleChangeRecord = tmp instanceof SWFShapeRecordStyleChange ? tmp : null;
    if (!(styleChangeRecord == null) && styleChangeRecord.vn7()) {
      this.qmt_1.p4c_1 = NumberUtils_instance.un7(styleChangeRecord.amv_1 / this.mmt_1);
      this.qmt_1.q4c_1 = NumberUtils_instance.un7(styleChangeRecord.bmv_1 / this.mmt_1);
    }
  }
  wn7(_handler) {
    var handler = _handler;
    this.xmt_1 = false;
    this.xn7();
    handler.yn7();
    var inductionVariable = 0;
    var last = this.vmt_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.zn7(handler, i);
        this.an8(handler, i);
      }
       while (inductionVariable < last);
    handler.bn8();
  }
  xn7() {
    if (this.xmt_1)
      return Unit_instance;
    this.xmt_1 = true;
    var xPos = 0.0;
    var yPos = 0.0;
    var from;
    var to;
    var control;
    var fillStyleIdxOffset = 0;
    var lineStyleIdxOffset = 0;
    var currentFillStyleIdx0 = 0;
    var currentFillStyleIdx1 = 0;
    var currentLineStyleIdx = 0;
    var subPath = FastArrayList.g14();
    this.vmt_1 = 0;
    this.rmt_1 = FastArrayList.g14();
    this.smt_1 = FastArrayList.g14();
    this.tmt_1 = IntMap.t37();
    this.umt_1 = IntMap.t37();
    var inductionVariable = 0;
    var last = this.nmt_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var shapeRecord = this.nmt_1.i1(i);
        switch (shapeRecord.b2n()) {
          case 2:
            var styleChangeRecord = shapeRecord instanceof SWFShapeRecordStyleChange ? shapeRecord : THROW_CCE();
            if (styleChangeRecord.dn8() || styleChangeRecord.en8() || styleChangeRecord.fn8()) {
              this.cn8(subPath, currentLineStyleIdx, currentFillStyleIdx0, currentFillStyleIdx1);
              subPath = FastArrayList.g14();
            }

            if (styleChangeRecord.tn7()) {
              fillStyleIdxOffset = this.omt_1.j1();
              lineStyleIdxOffset = this.pmt_1.j1();
              this.omt_1.k1(styleChangeRecord.fmv_1);
              this.pmt_1.k1(styleChangeRecord.gmv_1);
            }

            if (styleChangeRecord.dn8() && styleChangeRecord.emv_1 === 0 && styleChangeRecord.en8() && styleChangeRecord.cmv_1 === 0 && styleChangeRecord.fn8() && styleChangeRecord.dmv_1 === 0) {
              this.gn8(this.tmt_1);
              this.gn8(this.umt_1);
              this.rmt_1.f(this.tmt_1);
              this.smt_1.f(this.umt_1);
              this.tmt_1 = IntMap.t37();
              this.umt_1 = IntMap.t37();
              currentLineStyleIdx = 0;
              currentFillStyleIdx0 = 0;
              currentFillStyleIdx1 = 0;
              this.vmt_1 = this.vmt_1 + 1 | 0;
            } else {
              if (styleChangeRecord.dn8()) {
                currentLineStyleIdx = styleChangeRecord.emv_1;
                if (currentLineStyleIdx > 0)
                  currentLineStyleIdx = currentLineStyleIdx + lineStyleIdxOffset | 0;
              }
              if (styleChangeRecord.en8()) {
                currentFillStyleIdx0 = styleChangeRecord.cmv_1;
                if (currentFillStyleIdx0 > 0)
                  currentFillStyleIdx0 = currentFillStyleIdx0 + fillStyleIdxOffset | 0;
              }
              if (styleChangeRecord.fn8()) {
                currentFillStyleIdx1 = styleChangeRecord.dmv_1;
                if (currentFillStyleIdx1 > 0)
                  currentFillStyleIdx1 = currentFillStyleIdx1 + fillStyleIdxOffset | 0;
              }
            }

            if (styleChangeRecord.vn7()) {
              xPos = styleChangeRecord.amv_1 / this.mmt_1;
              yPos = styleChangeRecord.bmv_1 / this.mmt_1;
            }

            break;
          case 3:
            var straightEdgeRecord = shapeRecord instanceof SWFShapeRecordStraightEdge ? shapeRecord : THROW_CCE();
            from = MPoint.s4c(NumberUtils_instance.un7(xPos), NumberUtils_instance.un7(yPos));
            if (straightEdgeRecord.jn8_1) {
              xPos = xPos + straightEdgeRecord.mn8_1 / this.mmt_1;
              yPos = yPos + straightEdgeRecord.ln8_1 / this.mmt_1;
            } else {
              if (straightEdgeRecord.kn8_1) {
                yPos = yPos + straightEdgeRecord.ln8_1 / this.mmt_1;
              } else {
                xPos = xPos + straightEdgeRecord.mn8_1 / this.mmt_1;
              }
            }

            to = MPoint.s4c(NumberUtils_instance.un7(xPos), NumberUtils_instance.un7(yPos));
            subPath.f(new StraightEdge(from, to, currentLineStyleIdx, currentFillStyleIdx1));
            break;
          case 4:
            var curvedEdgeRecord = shapeRecord instanceof SWFShapeRecordCurvedEdge ? shapeRecord : THROW_CCE();
            from = MPoint.s4c(NumberUtils_instance.un7(xPos), NumberUtils_instance.un7(yPos));
            var xPosControl = xPos + curvedEdgeRecord.qn8_1 / this.mmt_1;
            var yPosControl = yPos + curvedEdgeRecord.rn8_1 / this.mmt_1;
            xPos = xPosControl + curvedEdgeRecord.sn8_1 / this.mmt_1;
            yPos = yPosControl + curvedEdgeRecord.tn8_1 / this.mmt_1;
            control = MPoint.s4c(xPosControl, yPosControl);
            to = MPoint.s4c(NumberUtils_instance.un7(xPos), NumberUtils_instance.un7(yPos));
            subPath.f(new CurvedEdge(from, control, to, currentLineStyleIdx, currentFillStyleIdx1));
            break;
          case 1:
            this.cn8(subPath, currentLineStyleIdx, currentFillStyleIdx0, currentFillStyleIdx1);
            this.gn8(this.tmt_1);
            this.gn8(this.umt_1);
            this.rmt_1.f(this.tmt_1);
            this.smt_1.f(this.umt_1);
            this.vmt_1 = this.vmt_1 + 1 | 0;
            break;
        }
      }
       while (inductionVariable < last);
  }
  cn8(subPath, lineStyleIdx, fillStyleIdx0, fillStyleIdx1) {
    if (!(fillStyleIdx0 === 0)) {
      var path = this.tmt_1.i1(fillStyleIdx0);
      if (path == null) {
        path = FastArrayList.g14();
        this.tmt_1.n37(fillStyleIdx0, path);
      }
      var inductionVariable = 0;
      var last = subPath.j1();
      if (inductionVariable < last)
        do {
          var _j = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var j = (subPath.j1() - 1 | 0) - _j | 0;
          path.f(subPath.i1(j).vn8(fillStyleIdx0));
        }
         while (inductionVariable < last);
    }
    if (!(fillStyleIdx1 === 0)) {
      var path_0 = this.tmt_1.i1(fillStyleIdx1);
      if (path_0 == null) {
        path_0 = FastArrayList.g14();
        this.tmt_1.n37(fillStyleIdx1, path_0);
      }
      path_0.v14(subPath);
    }
    if (!(lineStyleIdx === 0)) {
      var path_1 = this.umt_1.i1(lineStyleIdx);
      if (path_1 == null) {
        path_1 = FastArrayList.g14();
        this.umt_1.n37(lineStyleIdx, path_1);
      }
      path_1.v14(subPath);
    }
  }
  zn7(handler, groupIndex) {
    var path = this.wn8(this.rmt_1.i1(groupIndex));
    var pos = MPoint.v4c(2147483647, 2147483647);
    var fillStyleIdx = 2147483647;
    if (path.j1() > 0) {
      handler.xn8();
      var inductionVariable = 0;
      var last = path.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = path.i1(i);
          if (!(fillStyleIdx === e.zn8())) {
            if (!(fillStyleIdx === 2147483647)) {
              handler.yn8();
            }
            fillStyleIdx = e.zn8();
            pos = MPoint.v4c(2147483647, 2147483647);
            try {
              var matrix;
              var fillStyle = this.omt_1.i1(fillStyleIdx - 1 | 0);
              switch (fillStyle.jmv_1) {
                case 0:
                  handler.cn9(ColorUtils_instance.an9(fillStyle.kmv_1), ColorUtils_instance.bn9(fillStyle.kmv_1));
                  break;
                case 16:
                case 18:
                case 19:
                  var colors = IntArrayList.f31();
                  var alphas = DoubleArrayList.c32();
                  var ratios = IntArrayList.f31();
                  var gradientMatrix = fillStyle.mmv_1;
                  if (!(gradientMatrix == null)) {
                    matrix = gradientMatrix.gl6().j13();
                    var inductionVariable_0 = 0;
                    var last_0 = ensureNotNull(fillStyle.lmv_1).emz_1.j1();
                    if (inductionVariable_0 < last_0)
                      do {
                        var gri = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        var gradientRecord = ensureNotNull(fillStyle.lmv_1).emz_1.i1(gri);
                        colors.l31(ColorUtils_instance.an9(gradientRecord.mmz_1));
                        alphas.t2d(ColorUtils_instance.bn9(gradientRecord.mmz_1));
                        ratios.l31(gradientRecord.lmz_1);
                      }
                       while (inductionVariable_0 < last_0);
                    handler.dn9(fillStyle.jmv_1 === 16 ? GradientType_LINEAR_getInstance() : GradientType_RADIAL_getInstance(), colors, alphas, ratios, matrix, ensureNotNull(fillStyle.lmv_1).bmz_1, ensureNotNull(fillStyle.lmv_1).cmz_1, ensureNotNull(fillStyle.lmv_1).dmz_1);
                  } else {
                    println('SWF.gradientMatrix=null');
                    handler.cn9(encodeSWFColor(Colors_getInstance().i4t_1), 1.0);
                  }

                  break;
                case 64:
                case 65:
                case 66:
                case 67:
                  var m = ensureNotNull(fillStyle.omv_1);
                  matrix = new MMatrix();
                  createBox(matrix, m.mms_1 / 20, m.nms_1 / 20, m.oms_1, m.kms_1 / 20.0, m.lms_1 / 20.0);
                  handler.en9(fillStyle.nmv_1, matrix, fillStyle.jmv_1 === 64 || fillStyle.jmv_1 === 66, fillStyle.jmv_1 === 64 || fillStyle.jmv_1 === 65);
                  break;
              }
            } catch ($p) {
              if ($p instanceof Error_0) {
                var e_0 = $p;
                handler.fn9(0);
              } else {
                throw $p;
              }
            }
          }
          if (!pos.equals(e.gn9())) {
            handler.b48(e.gn9().p4c_1, e.gn9().q4c_1);
          }
          if (e instanceof CurvedEdge) {
            var c = e;
            handler.rn9(c.mn9_1.p4c_1, c.mn9_1.q4c_1, c.hn9().p4c_1, c.hn9().q4c_1);
          } else {
            handler.c48(e.hn9().p4c_1, e.hn9().q4c_1);
          }
          pos = e.hn9();
        }
         while (inductionVariable < last);
      if (!(fillStyleIdx === 2147483647)) {
        handler.yn8();
      }
      handler.sn9();
    }
  }
  an8(handler, groupIndex) {
    var path = this.wn8(this.smt_1.i1(groupIndex));
    var pos = MPoint.v4c(2147483647, 2147483647);
    var lineStyleIdx = 2147483647;
    if (path.j1() > 0) {
      handler.tn9();
      var basePoint = null;
      var inductionVariable = 0;
      var last = path.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = path.i1(i);
          if (!(lineStyleIdx === e.un9())) {
            lineStyleIdx = e.un9();
            pos = MPoint.v4c(2147483647, 2147483647);
            var tmp;
            try {
              tmp = this.pmt_1.i1(lineStyleIdx - 1 | 0);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Error_0) {
                var e_0 = $p;
                tmp_0 = null;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            var lineStyle = tmp;
            if (!(lineStyle == null)) {
              var scaleMode = lineStyle.ymv_1 && lineStyle.zmv_1 ? LineScaleMode_NONE_getInstance() : lineStyle.ymv_1 ? LineScaleMode_HORIZONTAL_getInstance() : lineStyle.zmv_1 ? LineScaleMode_VERTICAL_getInstance() : LineScaleMode_NORMAL_getInstance();
              handler.wn9(lineStyle.rmv_1 / 20, ColorUtils_instance.an9(lineStyle.smv_1), ColorUtils_instance.bn9(lineStyle.smv_1), lineStyle.amw_1, scaleMode, lineStyle.umv_1, lineStyle.vmv_1, LineJointStyle_instance.mm2(lineStyle.wmv_1), lineStyle.cmw_1);
              if (lineStyle.xmv_1) {
                var fillStyle = ensureNotNull(lineStyle.dmw_1);
                switch (fillStyle.jmv_1) {
                  case 16:
                  case 18:
                  case 19:
                    var colors = IntArrayList.f31();
                    var alphas = DoubleArrayList.c32();
                    var ratios = IntArrayList.f31();
                    var gradientRecord;
                    var matrix = ensureNotNull(fillStyle.mmv_1).gl6().j13();
                    var inductionVariable_0 = 0;
                    var last_0 = ensureNotNull(fillStyle.lmv_1).emz_1.j1();
                    if (inductionVariable_0 < last_0)
                      do {
                        var gri = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        gradientRecord = ensureNotNull(fillStyle.lmv_1).emz_1.i1(gri);
                        colors.l31(ColorUtils_instance.an9(gradientRecord.mmz_1));
                        alphas.t2d(ColorUtils_instance.bn9(gradientRecord.mmz_1));
                        ratios.l31(gradientRecord.lmz_1);
                      }
                       while (inductionVariable_0 < last_0);
                    handler.xn9(fillStyle.jmv_1 === 16 ? GradientType_LINEAR_getInstance() : GradientType_RADIAL_getInstance(), colors, alphas, ratios, matrix, ensureNotNull(fillStyle.lmv_1).bmz_1, ensureNotNull(fillStyle.lmv_1).cmz_1, ensureNotNull(fillStyle.lmv_1).dmz_1);
                    break;
                }
              }
            } else {
              handler.vn9(0.0);
            }
          }
          if (!e.gn9().equals(pos)) {
            basePoint = e.gn9();
            handler.b48(e.gn9().p4c_1, e.gn9().q4c_1);
          }
          if (e instanceof CurvedEdge) {
            handler.rn9(e.mn9_1.p4c_1, e.mn9_1.q4c_1, e.hn9().p4c_1, e.hn9().q4c_1);
          } else {
            handler.c48(e.hn9().p4c_1, e.hn9().q4c_1);
          }
          if (e.hn9().equals(basePoint)) {
            handler.yn9();
          }
          pos = e.hn9();
        }
         while (inductionVariable < last);
      handler.zn9();
    }
  }
  wn8(edgeMap) {
    var newPath = FastArrayList.g14();
    var styleIdxArray = FastArrayList.g14();
    var _iterator__ex2g4s = edgeMap.l3().f1();
    while (_iterator__ex2g4s.g1()) {
      var styleIdx = _iterator__ex2g4s.h1();
      styleIdxArray.f(styleIdx);
    }
    sort(styleIdxArray);
    var inductionVariable = 0;
    var last = styleIdxArray.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        newPath.v14(ensureNotNull(edgeMap.i1(styleIdxArray.i1(i))));
      }
       while (inductionVariable < last);
    return newPath;
  }
  gn8(edgeMap) {
    var _iterator__ex2g4s = edgeMap.l3().f1();
    while (_iterator__ex2g4s.g1()) {
      var styleIdx = _iterator__ex2g4s.h1();
      var subPath = edgeMap.i1(styleIdx);
      if (!(subPath == null) && subPath.j1() > 0) {
        var prevEdge = null;
        var tmpPath = FastArrayList.g14();
        this.ana(subPath);
        while (subPath.j1() > 0) {
          var idx = 0;
          while (idx < subPath.j1()) {
            if (prevEdge == null || prevEdge.hn9().equals(subPath.i1(idx).gn9())) {
              var edge = subPath.q3(idx);
              tmpPath.f(edge);
              this.cna(edge);
              prevEdge = edge;
            } else {
              var edge_0 = this.bna(prevEdge);
              if (!(edge_0 == null)) {
                idx = subPath.q1(edge_0);
              } else {
                idx = 0;
                prevEdge = null;
              }
            }
          }
        }
        edgeMap.n37(styleIdx, tmpPath);
      }
    }
  }
  ana(path) {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.wmt_1 = HashMap.c9();
    var inductionVariable = 0;
    var last = path.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var from = path.i1(i).gn9();
        var key = from;
        var coordMapArray = this.wmt_1.k3(from);
        if (coordMapArray == null) {
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.wmt_1;
          var value = fastArrayListOf([path.i1(i)]);
          this_0.r3(key, value);
        } else {
          coordMapArray.f(path.i1(i));
        }
      }
       while (inductionVariable < last);
  }
  cna(edge) {
    var key = edge.gn9();
    var coordMapArray = this.wmt_1.k3(key);
    if (!(coordMapArray == null)) {
      if (coordMapArray.j1() === 1) {
        this.wmt_1.s3(key);
      } else {
        var i = coordMapArray.q1(edge);
        if (i > -1) {
          coordMapArray.q3(i);
        }
      }
    }
  }
  bna(edge) {
    var coordMapArray = this.wmt_1.k3(edge.hn9());
    var tmp;
    var tmp_0;
    if (!(coordMapArray == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !coordMapArray.a1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = coordMapArray.i1(0);
    } else {
      tmp = null;
    }
    return tmp;
  }
  mm2(indent) {
    var str = '\n' + repeat(' ', indent) + 'ShapeRecords:';
    var inductionVariable = 0;
    var last = this.nmt_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + this.nmt_1.i1(i).toString());
      }
       while (inductionVariable < last);
    return str;
  }
}
class SWFShapeWithStyle extends SWFShape {
  constructor(unitDivisor) {
    unitDivisor = unitDivisor === VOID ? 20.0 : unitDivisor;
    super(unitDivisor);
    this.nmu_1 = ArrayList.m1();
    this.omu_1 = ArrayList.m1();
  }
  pmu(data, level) {
    data.pmr();
    var inductionVariable = 0;
    var last = this.dna(data, level);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nmu_1.f(data.imv(level));
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = this.dna(data, level);
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.omu_1.f(level <= 3 ? data.qmv(level) : data.emw(level));
      }
       while (inductionVariable_0 < last_0);
    data.pmr();
    var numFillBits = data.xmj(4);
    var numLineBits = data.xmj(4);
    this.rn7(data, numFillBits, numLineBits, level);
  }
  wn7(_handler) {
    this.omt_1 = FastArrayList.u14(this.nmu_1);
    this.pmt_1 = FastArrayList.u14(this.omu_1);
    super.wn7(_handler);
  }
  mm2(indent) {
    var str = '';
    if (this.nmu_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent) + 'FillStyles:');
      var inductionVariable = 0;
      var last = this.nmu_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + (i + 1 | 0) + '] ' + this.nmu_1.i1(i).toString());
        }
         while (inductionVariable < last);
    }
    if (this.omu_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent) + 'LineStyles:');
      var inductionVariable_0 = 0;
      var last_0 = this.omu_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + (i_0 + 1 | 0) + '] ' + this.omu_1.i1(i_0).toString());
        }
         while (inductionVariable_0 < last_0);
    }
    return str + super.mm2(indent);
  }
  dna(data, level) {
    var len = data.bmg();
    if (level >= 2 && len === 255)
      len = data.pmf();
    return len;
  }
}
class SWFShapeRecord {
  constructor() {
    this.smu_1 = 0;
  }
  b2n() {
    return this.smu_1;
  }
  pmu(data, level) {
    return Unit_instance;
  }
  tmu(data, level, $super) {
    level = level === VOID ? 1 : level;
    var tmp;
    if ($super === VOID) {
      this.pmu(data, level);
      tmp = Unit_instance;
    } else {
      tmp = $super.pmu.call(this, data, level);
    }
    return tmp;
  }
  toString() {
    return '[SWFShapeRecord]';
  }
  j13() {
    return new SWFShapeRecord();
  }
}
class SWFShapeRecordStraightEdge extends SWFShapeRecord {
  constructor(numBits, generalLineFlag, vertLineFlag, deltaY, deltaX) {
    numBits = numBits === VOID ? 0 : numBits;
    generalLineFlag = generalLineFlag === VOID ? false : generalLineFlag;
    vertLineFlag = vertLineFlag === VOID ? false : vertLineFlag;
    deltaY = deltaY === VOID ? 0 : deltaY;
    deltaX = deltaX === VOID ? 0 : deltaX;
    super();
    this.in8_1 = numBits;
    this.jn8_1 = generalLineFlag;
    this.kn8_1 = vertLineFlag;
    this.ln8_1 = deltaY;
    this.mn8_1 = deltaX;
    this.nn8_1 = 3;
  }
  pmu(data, level) {
    this.jn8_1 = data.xmj(1) === 1;
    this.kn8_1 = !this.jn8_1 ? data.xmj(1) === 1 : false;
    this.mn8_1 = this.jn8_1 || !this.kn8_1 ? data.ams(this.in8_1) : 0;
    this.ln8_1 = this.jn8_1 || this.kn8_1 ? data.ams(this.in8_1) : 0;
  }
  b2n() {
    return this.nn8_1;
  }
  toString() {
    var str = '[SWFShapeRecordStraightEdge] ';
    str = str + (this.jn8_1 ? 'General: ' + this.mn8_1 + ',' + this.ln8_1 : this.kn8_1 ? 'Vertical: ' + this.ln8_1 : 'Horizontal: ' + this.mn8_1);
    return str;
  }
  j13() {
    return this.ena();
  }
  fna(numBits, generalLineFlag, vertLineFlag, deltaY, deltaX) {
    return new SWFShapeRecordStraightEdge(numBits, generalLineFlag, vertLineFlag, deltaY, deltaX);
  }
  ena(numBits, generalLineFlag, vertLineFlag, deltaY, deltaX, $super) {
    numBits = numBits === VOID ? this.in8_1 : numBits;
    generalLineFlag = generalLineFlag === VOID ? this.jn8_1 : generalLineFlag;
    vertLineFlag = vertLineFlag === VOID ? this.kn8_1 : vertLineFlag;
    deltaY = deltaY === VOID ? this.ln8_1 : deltaY;
    deltaX = deltaX === VOID ? this.mn8_1 : deltaX;
    return $super === VOID ? this.fna(numBits, generalLineFlag, vertLineFlag, deltaY, deltaX) : $super.fna.call(this, numBits, generalLineFlag, vertLineFlag, deltaY, deltaX);
  }
  hashCode() {
    var result = this.in8_1;
    result = imul(result, 31) + getBooleanHashCode(this.jn8_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kn8_1) | 0;
    result = imul(result, 31) + this.ln8_1 | 0;
    result = imul(result, 31) + this.mn8_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFShapeRecordStraightEdge))
      return false;
    var tmp0_other_with_cast = other instanceof SWFShapeRecordStraightEdge ? other : THROW_CCE();
    if (!(this.in8_1 === tmp0_other_with_cast.in8_1))
      return false;
    if (!(this.jn8_1 === tmp0_other_with_cast.jn8_1))
      return false;
    if (!(this.kn8_1 === tmp0_other_with_cast.kn8_1))
      return false;
    if (!(this.ln8_1 === tmp0_other_with_cast.ln8_1))
      return false;
    if (!(this.mn8_1 === tmp0_other_with_cast.mn8_1))
      return false;
    return true;
  }
}
class SWFShapeRecordCurvedEdge extends SWFShapeRecord {
  constructor(numBits, controlDeltaX, controlDeltaY, anchorDeltaX, anchorDeltaY) {
    numBits = numBits === VOID ? 0 : numBits;
    controlDeltaX = controlDeltaX === VOID ? 0 : controlDeltaX;
    controlDeltaY = controlDeltaY === VOID ? 0 : controlDeltaY;
    anchorDeltaX = anchorDeltaX === VOID ? 0 : anchorDeltaX;
    anchorDeltaY = anchorDeltaY === VOID ? 0 : anchorDeltaY;
    super();
    this.pn8_1 = numBits;
    this.qn8_1 = controlDeltaX;
    this.rn8_1 = controlDeltaY;
    this.sn8_1 = anchorDeltaX;
    this.tn8_1 = anchorDeltaY;
    this.un8_1 = 4;
  }
  pmu(data, level) {
    this.qn8_1 = data.ams(this.pn8_1);
    this.rn8_1 = data.ams(this.pn8_1);
    this.sn8_1 = data.ams(this.pn8_1);
    this.tn8_1 = data.ams(this.pn8_1);
  }
  b2n() {
    return this.un8_1;
  }
  toString() {
    return '[SWFShapeRecordCurvedEdge] ControlDelta: ' + this.qn8_1 + ',' + this.rn8_1 + ', AnchorDelta: ' + this.sn8_1 + ',' + this.tn8_1;
  }
  j13() {
    return this.gna();
  }
  hna(numBits, controlDeltaX, controlDeltaY, anchorDeltaX, anchorDeltaY) {
    return new SWFShapeRecordCurvedEdge(numBits, controlDeltaX, controlDeltaY, anchorDeltaX, anchorDeltaY);
  }
  gna(numBits, controlDeltaX, controlDeltaY, anchorDeltaX, anchorDeltaY, $super) {
    numBits = numBits === VOID ? this.pn8_1 : numBits;
    controlDeltaX = controlDeltaX === VOID ? this.qn8_1 : controlDeltaX;
    controlDeltaY = controlDeltaY === VOID ? this.rn8_1 : controlDeltaY;
    anchorDeltaX = anchorDeltaX === VOID ? this.sn8_1 : anchorDeltaX;
    anchorDeltaY = anchorDeltaY === VOID ? this.tn8_1 : anchorDeltaY;
    return $super === VOID ? this.hna(numBits, controlDeltaX, controlDeltaY, anchorDeltaX, anchorDeltaY) : $super.hna.call(this, numBits, controlDeltaX, controlDeltaY, anchorDeltaX, anchorDeltaY);
  }
  hashCode() {
    var result = this.pn8_1;
    result = imul(result, 31) + this.qn8_1 | 0;
    result = imul(result, 31) + this.rn8_1 | 0;
    result = imul(result, 31) + this.sn8_1 | 0;
    result = imul(result, 31) + this.tn8_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFShapeRecordCurvedEdge))
      return false;
    var tmp0_other_with_cast = other instanceof SWFShapeRecordCurvedEdge ? other : THROW_CCE();
    if (!(this.pn8_1 === tmp0_other_with_cast.pn8_1))
      return false;
    if (!(this.qn8_1 === tmp0_other_with_cast.qn8_1))
      return false;
    if (!(this.rn8_1 === tmp0_other_with_cast.rn8_1))
      return false;
    if (!(this.sn8_1 === tmp0_other_with_cast.sn8_1))
      return false;
    if (!(this.tn8_1 === tmp0_other_with_cast.tn8_1))
      return false;
    return true;
  }
}
class SWFShapeRecordStyleChange extends SWFShapeRecord {
  constructor(states, numFillBits, numLineBits, moveDeltaX, moveDeltaY, fillStyle0, fillStyle1, lineStyle, fillStyles, lineStyles) {
    states = states === VOID ? 0 : states;
    numFillBits = numFillBits === VOID ? 0 : numFillBits;
    numLineBits = numLineBits === VOID ? 0 : numLineBits;
    moveDeltaX = moveDeltaX === VOID ? 0 : moveDeltaX;
    moveDeltaY = moveDeltaY === VOID ? 0 : moveDeltaY;
    fillStyle0 = fillStyle0 === VOID ? 0 : fillStyle0;
    fillStyle1 = fillStyle1 === VOID ? 0 : fillStyle1;
    lineStyle = lineStyle === VOID ? 0 : lineStyle;
    fillStyles = fillStyles === VOID ? ArrayList.m1() : fillStyles;
    lineStyles = lineStyles === VOID ? ArrayList.m1() : lineStyles;
    super();
    this.xmu_1 = states;
    this.ymu_1 = numFillBits;
    this.zmu_1 = numLineBits;
    this.amv_1 = moveDeltaX;
    this.bmv_1 = moveDeltaY;
    this.cmv_1 = fillStyle0;
    this.dmv_1 = fillStyle1;
    this.emv_1 = lineStyle;
    this.fmv_1 = fillStyles;
    this.gmv_1 = lineStyles;
    this.hmv_1 = 2;
  }
  tn7() {
    return !((this.xmu_1 & 16) === 0);
  }
  dn8() {
    return !((this.xmu_1 & 8) === 0);
  }
  fn8() {
    return !((this.xmu_1 & 4) === 0);
  }
  en8() {
    return !((this.xmu_1 & 2) === 0);
  }
  vn7() {
    return !((this.xmu_1 & 1) === 0);
  }
  b2n() {
    return this.hmv_1;
  }
  pmu(data, level) {
    if (this.vn7()) {
      var moveBits = data.xmj(5);
      this.amv_1 = data.ams(moveBits);
      this.bmv_1 = data.ams(moveBits);
    }
    this.cmv_1 = this.en8() ? data.xmj(this.ymu_1) : 0;
    this.dmv_1 = this.fn8() ? data.xmj(this.ymu_1) : 0;
    this.emv_1 = this.dn8() ? data.xmj(this.zmu_1) : 0;
    if (this.tn7()) {
      data.pmr();
      var fillStylesLen = this.dna(data, level);
      var inductionVariable = 0;
      if (inductionVariable < fillStylesLen)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.fmv_1.f(data.imv(level));
        }
         while (inductionVariable < fillStylesLen);
      var lineStylesLen = this.dna(data, level);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < lineStylesLen)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.gmv_1.f(level <= 3 ? data.qmv(level) : data.emw(level));
        }
         while (inductionVariable_0 < lineStylesLen);
      data.pmr();
      this.ymu_1 = data.xmj(4);
      this.zmu_1 = data.xmj(4);
    }
  }
  dna(data, level) {
    var len = data.bmg();
    if (level >= 2 && len === 255) {
      len = data.pmf();
    }
    return len;
  }
  toString() {
    var indent = 0;
    var str = '[SWFShapeRecordStyleChange] ';
    // Inline function 'kotlin.collections.arrayListOf' call
    var cmds = ArrayList.m1();
    if (this.vn7()) {
      cmds.f('MoveTo: ' + this.amv_1 + ',' + this.bmv_1);
    }
    if (this.en8()) {
      cmds.f('FillStyle0: ' + this.cmv_1);
    }
    if (this.fn8()) {
      cmds.f('FillStyle1: ' + this.dmv_1);
    }
    if (this.dn8()) {
      cmds.f('LineStyle: ' + this.emv_1);
    }
    if (cmds.j1() > 0)
      str = str + joinToString(cmds, ', ');
    if (this.tn7()) {
      if (this.fmv_1.j1() > 0) {
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'New FillStyles:');
        var inductionVariable = 0;
        var last = this.fmv_1.j1();
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + (i + 1 | 0) + '] ' + this.fmv_1.i1(i).toString());
          }
           while (inductionVariable < last);
      }
      if (this.gmv_1.j1() > 0) {
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'New LineStyles:');
        var inductionVariable_0 = 0;
        var last_0 = this.gmv_1.j1();
        if (inductionVariable_0 < last_0)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + (i_0 + 1 | 0) + '] ' + this.gmv_1.i1(i_0).toString());
          }
           while (inductionVariable_0 < last_0);
      }
    }
    return str;
  }
  j13() {
    return this.ina();
  }
  jna(states, numFillBits, numLineBits, moveDeltaX, moveDeltaY, fillStyle0, fillStyle1, lineStyle, fillStyles, lineStyles) {
    return new SWFShapeRecordStyleChange(states, numFillBits, numLineBits, moveDeltaX, moveDeltaY, fillStyle0, fillStyle1, lineStyle, fillStyles, lineStyles);
  }
  ina(states, numFillBits, numLineBits, moveDeltaX, moveDeltaY, fillStyle0, fillStyle1, lineStyle, fillStyles, lineStyles, $super) {
    states = states === VOID ? this.xmu_1 : states;
    numFillBits = numFillBits === VOID ? this.ymu_1 : numFillBits;
    numLineBits = numLineBits === VOID ? this.zmu_1 : numLineBits;
    moveDeltaX = moveDeltaX === VOID ? this.amv_1 : moveDeltaX;
    moveDeltaY = moveDeltaY === VOID ? this.bmv_1 : moveDeltaY;
    fillStyle0 = fillStyle0 === VOID ? this.cmv_1 : fillStyle0;
    fillStyle1 = fillStyle1 === VOID ? this.dmv_1 : fillStyle1;
    lineStyle = lineStyle === VOID ? this.emv_1 : lineStyle;
    fillStyles = fillStyles === VOID ? this.fmv_1 : fillStyles;
    lineStyles = lineStyles === VOID ? this.gmv_1 : lineStyles;
    return $super === VOID ? this.jna(states, numFillBits, numLineBits, moveDeltaX, moveDeltaY, fillStyle0, fillStyle1, lineStyle, fillStyles, lineStyles) : $super.jna.call(this, states, numFillBits, numLineBits, moveDeltaX, moveDeltaY, fillStyle0, fillStyle1, lineStyle, fillStyles, lineStyles);
  }
  hashCode() {
    var result = this.xmu_1;
    result = imul(result, 31) + this.ymu_1 | 0;
    result = imul(result, 31) + this.zmu_1 | 0;
    result = imul(result, 31) + this.amv_1 | 0;
    result = imul(result, 31) + this.bmv_1 | 0;
    result = imul(result, 31) + this.cmv_1 | 0;
    result = imul(result, 31) + this.dmv_1 | 0;
    result = imul(result, 31) + this.emv_1 | 0;
    result = imul(result, 31) + this.fmv_1.hashCode() | 0;
    result = imul(result, 31) + this.gmv_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFShapeRecordStyleChange))
      return false;
    var tmp0_other_with_cast = other instanceof SWFShapeRecordStyleChange ? other : THROW_CCE();
    if (!(this.xmu_1 === tmp0_other_with_cast.xmu_1))
      return false;
    if (!(this.ymu_1 === tmp0_other_with_cast.ymu_1))
      return false;
    if (!(this.zmu_1 === tmp0_other_with_cast.zmu_1))
      return false;
    if (!(this.amv_1 === tmp0_other_with_cast.amv_1))
      return false;
    if (!(this.bmv_1 === tmp0_other_with_cast.bmv_1))
      return false;
    if (!(this.cmv_1 === tmp0_other_with_cast.cmv_1))
      return false;
    if (!(this.dmv_1 === tmp0_other_with_cast.dmv_1))
      return false;
    if (!(this.emv_1 === tmp0_other_with_cast.emv_1))
      return false;
    if (!this.fmv_1.equals(tmp0_other_with_cast.fmv_1))
      return false;
    if (!this.gmv_1.equals(tmp0_other_with_cast.gmv_1))
      return false;
    return true;
  }
}
class SWFFillStyle {
  constructor() {
    this.jmv_1 = 0;
    this.kmv_1 = 0;
    this.lmv_1 = null;
    this.mmv_1 = null;
    this.nmv_1 = 0;
    this.omv_1 = null;
    this.pmv_1 = 0;
  }
  pmu(data, level) {
    this.pmv_1 = level;
    this.jmv_1 = data.bmg();
    switch (this.jmv_1) {
      case 0:
        this.kmv_1 = level <= 2 ? data.dms() : data.ems();
        break;
      case 16:
      case 18:
      case 19:
        this.mmv_1 = data.fms();
        this.lmv_1 = this.jmv_1 === 19 ? data.fmz(level) : data.amz(level);
        break;
      case 64:
      case 65:
      case 66:
      case 67:
        this.nmv_1 = data.pmf();
        this.omv_1 = data.fms();
        break;
      default:
        throw Error_0.cf('Unknown fill style type: 0x' + toString_1(this.jmv_1, 16));
    }
  }
  toString() {
    var str = '[SWFFillStyle] Type: ' + format('%02x', [this.jmv_1]);
    switch (this.jmv_1) {
      case 0:
        str = str + (' (solid), Color: ' + (this.pmv_1 <= 2 ? ColorUtils_instance.lna(this.kmv_1) : ColorUtils_instance.kna(this.kmv_1)));
        break;
      case 16:
        str = str + (' (linear gradient), Gradient: ' + toString_0(this.lmv_1) + ', Matrix: ' + toString_0(this.mmv_1));
        break;
      case 18:
        str = str + (' (radial gradient), Gradient: ' + toString_0(this.lmv_1) + ', Matrix: ' + toString_0(this.mmv_1));
        break;
      case 19:
        var tmp = str;
        var tmp_0 = toString_0(this.lmv_1);
        var tmp_1 = toString_0(this.mmv_1);
        var tmp34_safe_receiver = this.lmv_1;
        str = tmp + (' (focal radial gradient), Gradient: ' + tmp_0 + ', Matrix: ' + tmp_1 + ', FocalPoint: ' + (tmp34_safe_receiver == null ? null : tmp34_safe_receiver.dmz_1));
        break;
      case 64:
        str = str + (' (repeating bitmap), BitmapID: ' + this.nmv_1);
        break;
      case 65:
        str = str + (' (clipped bitmap), BitmapID: ' + this.nmv_1);
        break;
      case 66:
        str = str + (' (non-smoothed repeating bitmap), BitmapID: ' + this.nmv_1);
        break;
      case 67:
        str = str + (' (non-smoothed clipped bitmap), BitmapID: ' + this.nmv_1);
        break;
    }
    return str;
  }
}
class SWFLineStyle {
  constructor() {
    this.rmv_1 = 0;
    this.smv_1 = 0;
    this.tmv_1 = 0;
    this.umv_1 = LineCapsStyle_ROUND_getInstance();
    this.vmv_1 = LineCapsStyle_ROUND_getInstance();
    this.wmv_1 = 0;
    this.xmv_1 = false;
    this.ymv_1 = false;
    this.zmv_1 = false;
    this.amw_1 = false;
    this.bmw_1 = false;
    this.cmw_1 = 3.0;
    this.dmw_1 = null;
  }
  pmu(data, level) {
    this.tmv_1 = level;
    this.rmv_1 = data.pmf();
    this.smv_1 = level <= 2 ? data.dms() : data.ems();
  }
  toString() {
    return '[SWFLineStyle] Width: ' + this.rmv_1 + ' Color: ' + (this.tmv_1 <= 2 ? ColorUtils_instance.lna(this.smv_1) : ColorUtils_instance.kna(this.smv_1));
  }
}
class SWFLineStyle2 extends SWFLineStyle {
  pmu(data, level) {
    this.rmv_1 = data.pmf();
    this.umv_1 = Companion_getInstance_29().i1(data.xmj(2));
    this.wmv_1 = data.xmj(2);
    this.xmv_1 = data.xmj(1) === 1;
    this.ymv_1 = data.xmj(1) === 1;
    this.zmv_1 = data.xmj(1) === 1;
    this.amw_1 = data.xmj(1) === 1;
    data.xmj(5);
    this.bmw_1 = data.xmj(1) === 1;
    this.vmv_1 = Companion_getInstance_29().i1(data.xmj(2));
    if (this.wmv_1 === 2)
      this.cmw_1 = data.mmn();
    if (this.xmv_1) {
      this.dmw_1 = data.imv(level);
    } else {
      this.smv_1 = data.ems();
    }
  }
  toString() {
    var str = '[SWFLineStyle2] Width: ' + this.rmv_1 + ', ' + 'StartCaps: ' + this.umv_1 + ', ' + 'EndCaps: ' + this.vmv_1.toString() + ', ' + 'Joint: ' + LineJointStyle_instance.mm2(this.wmv_1) + ', ';
    if (this.bmw_1)
      str = str + 'NoClose, ';
    if (this.ymv_1)
      str = str + 'NoHScale, ';
    if (this.zmv_1)
      str = str + 'NoVScale, ';
    if (this.amw_1)
      str = str + 'PixelHinting, ';
    if (this.xmv_1) {
      str = str + ('Fill: ' + toString_0(this.dmw_1));
    } else {
      str = str + ('Color: ' + ColorUtils_instance.kna(this.smv_1));
    }
    return str;
  }
}
class SWFButtonRecord {
  constructor() {
    this.tmw_1 = false;
    this.umw_1 = false;
    this.vmw_1 = false;
    this.wmw_1 = false;
    this.xmw_1 = false;
    this.ymw_1 = false;
    this.zmw_1 = 0;
    this.amx_1 = 0;
    this.bmx_1 = null;
    this.cmx_1 = null;
    this.dmx_1 = 0;
    this.emx_1 = ArrayList.m1();
  }
  pmu(data, level) {
    var flags = data.bmg();
    this.vmw_1 = !((flags & 8) === 0);
    this.wmw_1 = !((flags & 4) === 0);
    this.xmw_1 = !((flags & 2) === 0);
    this.ymw_1 = !((flags & 1) === 0);
    this.zmw_1 = data.pmf();
    this.amx_1 = data.pmf();
    this.bmx_1 = data.fms();
    if (level >= 2) {
      this.cmx_1 = data.amt();
      this.umw_1 = !((flags & 16) === 0);
      if (this.umw_1) {
        var numberOfFilters = data.bmg();
        var inductionVariable = 0;
        if (inductionVariable < numberOfFilters)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.emx_1.f(data.umx());
          }
           while (inductionVariable < numberOfFilters);
      }
      this.tmw_1 = !((flags & 32) === 0);
      if (this.tmw_1) {
        this.dmx_1 = data.bmg();
      }
    }
  }
  mm2(indent) {
    var str = 'Depth: ' + this.amx_1 + ', CharacterID: ' + this.zmw_1 + ', States: ';
    // Inline function 'kotlin.collections.arrayListOf' call
    var states = ArrayList.m1();
    if (this.ymw_1) {
      states.f('up');
    }
    if (this.xmw_1) {
      states.f('over');
    }
    if (this.wmw_1) {
      states.f('down');
    }
    if (this.vmw_1) {
      states.f('hit');
    }
    str = str + joinToString(states, ',');
    if (this.tmw_1)
      str = str + (', BlendMode: ' + BlendMode_instance.mm2(this.dmx_1));
    if (!(this.bmx_1 == null) && !ensureNotNull(this.bmx_1).in7())
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Matrix: ' + toString_0(this.bmx_1));
    if (!(this.cmx_1 == null) && !ensureNotNull(this.cmx_1).in7())
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'ColorTransform: ' + toString_0(this.cmx_1));
    if (this.umw_1) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Filters:');
      var inductionVariable = 0;
      var last = this.emx_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.emx_1.i1(i).mm2(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    return str;
  }
}
class SWFButtonCondAction {
  constructor() {
    this.hmx_1 = 0;
    this.imx_1 = false;
    this.jmx_1 = false;
    this.kmx_1 = false;
    this.lmx_1 = false;
    this.mmx_1 = false;
    this.nmx_1 = false;
    this.omx_1 = false;
    this.pmx_1 = false;
    this.qmx_1 = false;
    this.rmx_1 = 0;
    this.smx_1 = ArrayList.m1();
    this.tmx_1 = 0;
  }
  lm2(data) {
    var flags = data.bmg() << 8 | data.bmg();
    this.imx_1 = !((flags & 32768) === 0);
    this.jmx_1 = !((flags & 16384) === 0);
    this.kmx_1 = !((flags & 8192) === 0);
    this.lmx_1 = !((flags & 4096) === 0);
    this.mmx_1 = !((flags & 2048) === 0);
    this.nmx_1 = !((flags & 1024) === 0);
    this.omx_1 = !((flags & 512) === 0);
    this.pmx_1 = !((flags & 256) === 0);
    this.qmx_1 = !((flags & 1) === 0);
    this.rmx_1 = (flags & 255) >>> 1 | 0;
    var action;
    $l$loop: while (true) {
      action = data.ymh();
      if (action == null)
        break $l$loop;
      this.smx_1.f(action);
    }
    this.tmx_1 = Companion_instance_6.am2(this.smx_1);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var a = ArrayList.m1();
    if (this.imx_1) {
      a.f('idleToOverDown');
    }
    if (this.jmx_1) {
      a.f('outDownToIdle');
    }
    if (this.kmx_1) {
      a.f('outDownToOverDown');
    }
    if (this.lmx_1) {
      a.f('overDownToOutDown');
    }
    if (this.mmx_1) {
      a.f('overDownToOverUp');
    }
    if (this.nmx_1) {
      a.f('overUpToOverDown');
    }
    if (this.omx_1) {
      a.f('overUpToIdle');
    }
    if (this.pmx_1) {
      a.f('idleToOverUp');
    }
    if (this.qmx_1) {
      a.f('overDownToIdle');
    }
    var str = 'CondActionRecord (' + joinToString(a, ', ') + ')';
    if (this.rmx_1 > 0)
      str = str + (', KeyPress: ' + this.rmx_1);
    if ((flags & 2) === 0) {
      var inductionVariable = 0;
      var last = this.smx_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + this.smx_1.i1(i).mm2(indent + 2 | 0));
        }
         while (inductionVariable < last);
    } else {
      var tmp = this.smx_1;
      // Inline function 'kotlin.collections.arrayListOf' call
      var tmp$ret$1 = ArrayList.m1();
      var context = new ActionExecutionContext(tmp, tmp$ret$1, this.tmx_1);
      var inductionVariable_0 = 0;
      var last_0 = this.smx_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.smx_1.i1(i_0).nm2(indent + 4 | 0, context));
        }
         while (inductionVariable_0 < last_0);
      if (!(context.sm2_1 == null)) {
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + context.sm2_1 + ':');
      }
    }
    return str;
  }
}
class SWFTextRecord {
  constructor() {
    this.wmx_1 = 0;
    this.xmx_1 = false;
    this.ymx_1 = false;
    this.zmx_1 = false;
    this.amy_1 = false;
    this.bmy_1 = 0;
    this.cmy_1 = 0;
    this.dmy_1 = 0;
    this.emy_1 = 0;
    this.fmy_1 = 0;
    this.gmy_1 = ArrayList.m1();
    this.hmy_1 = 0;
  }
  imy(data, glyphBits, advanceBits, previousRecord, level) {
    this.hmy_1 = level;
    var styles = data.bmg();
    this.wmx_1 = styles >>> 7 | 0;
    this.xmx_1 = !((styles & 8) === 0);
    this.ymx_1 = !((styles & 4) === 0);
    this.amy_1 = !((styles & 2) === 0);
    this.zmx_1 = !((styles & 1) === 0);
    var tmp = this;
    var tmp_0;
    if (this.xmx_1) {
      tmp_0 = data.pmf();
    } else {
      var tmp0_elvis_lhs = previousRecord == null ? null : previousRecord.bmy_1;
      tmp_0 = tmp0_elvis_lhs == null ? this.bmy_1 : tmp0_elvis_lhs;
    }
    tmp.bmy_1 = tmp_0;
    var tmp_1 = this;
    var tmp_2;
    if (this.ymx_1) {
      tmp_2 = level < 2 ? data.dms() : data.ems();
    } else {
      var tmp1_elvis_lhs = previousRecord == null ? null : previousRecord.cmy_1;
      tmp_2 = tmp1_elvis_lhs == null ? this.cmy_1 : tmp1_elvis_lhs;
    }
    tmp_1.cmy_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4;
    if (this.zmx_1) {
      tmp_4 = data.omj();
    } else {
      var tmp2_elvis_lhs = previousRecord == null ? null : previousRecord.emy_1;
      tmp_4 = tmp2_elvis_lhs == null ? this.emy_1 : tmp2_elvis_lhs;
    }
    tmp_3.emy_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6;
    if (this.amy_1) {
      tmp_6 = data.omj();
    } else {
      var tmp3_elvis_lhs = previousRecord == null ? null : previousRecord.fmy_1;
      tmp_6 = tmp3_elvis_lhs == null ? this.fmy_1 : tmp3_elvis_lhs;
    }
    tmp_5.fmy_1 = tmp_6;
    var tmp_7 = this;
    var tmp_8;
    if (this.xmx_1) {
      tmp_8 = data.pmf();
    } else {
      var tmp4_elvis_lhs = previousRecord == null ? null : previousRecord.dmy_1;
      tmp_8 = tmp4_elvis_lhs == null ? this.dmy_1 : tmp4_elvis_lhs;
    }
    tmp_7.dmy_1 = tmp_8;
    var inductionVariable = 0;
    var last = data.bmg();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.gmy_1.f(data.jmy(glyphBits, advanceBits));
      }
       while (inductionVariable < last);
  }
  mm2(indent) {
    var params = arrayListOf(['Glyphs: ' + this.gmy_1.j1().toString()]);
    if (this.xmx_1) {
      params.f('FontID: ' + this.bmy_1);
    }
    params.f('Height: ' + this.dmy_1);
    if (this.ymx_1) {
      params.f('Color: ' + (this.hmy_1 <= 2 ? ColorUtils_instance.lna(this.cmy_1) : ColorUtils_instance.kna(this.cmy_1)));
    }
    if (this.zmx_1) {
      params.f('XOffset: ' + this.emy_1);
    }
    if (this.amy_1) {
      params.f('YOffset: ' + this.fmy_1);
    }
    var str = joinToString(params, ', ');
    var inductionVariable = 0;
    var last = this.gmy_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + this.gmy_1.i1(i).toString());
      }
       while (inductionVariable < last);
    return str;
  }
}
class SWFGlyphEntry {
  constructor() {
    this.kmy_1 = 0;
    this.lmy_1 = 0;
  }
  mmy(data, glyphBits, advanceBits) {
    this.kmy_1 = data.xmj(glyphBits);
    this.lmy_1 = data.ams(advanceBits);
  }
  toString() {
    return '[SWFGlyphEntry] Index: ' + this.kmy_1.toString() + ', Advance: ' + this.lmy_1.toString();
  }
}
class SWFZoneRecord {
  static mna(zoneData, mask) {
    var $this = createThis(this);
    $this.omy_1 = zoneData;
    $this.pmy_1 = mask;
    return $this;
  }
  static qmy(data) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, data.bmg());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korfl.as3swf.SWFZoneRecord.<init>.<anonymous>' call
      var tmp$ret$0 = data.rmy();
      destination.f(tmp$ret$0);
    }
    return this.mna(destination, data.bmg());
  }
}
class SWFZoneData {
  static nna(alignmentCoordinate, range) {
    var $this = createThis(this);
    $this.smy_1 = alignmentCoordinate;
    $this.tmy_1 = range;
    return $this;
  }
  static umy(data) {
    return this.nna(data.xmr(), data.xmr());
  }
  toString() {
    return 'SWFZoneData(alignmentCoordinate=' + this.smy_1 + ', range=' + this.tmy_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.smy_1);
    result = imul(result, 31) + getNumberHashCode(this.tmy_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFZoneData))
      return false;
    var tmp0_other_with_cast = other instanceof SWFZoneData ? other : THROW_CCE();
    if (!equals(this.smy_1, tmp0_other_with_cast.smy_1))
      return false;
    if (!equals(this.tmy_1, tmp0_other_with_cast.tmy_1))
      return false;
    return true;
  }
}
class SWFKerningRecord {
  constructor() {
    this.wmy_1 = 0;
    this.xmy_1 = 0;
    this.ymy_1 = 0;
  }
  zmy(data, wideCodes) {
    this.wmy_1 = wideCodes ? data.pmf() : data.bmg();
    this.xmy_1 = wideCodes ? data.pmf() : data.bmg();
    this.ymy_1 = data.omj();
  }
}
class SWFGradient {
  constructor() {
    this.bmz_1 = GradientSpreadMode_PAD_getInstance();
    this.cmz_1 = GradientInterpolationMode_NORMAL_getInstance();
    this.dmz_1 = 0.0;
    this.emz_1 = ArrayList.m1();
  }
  pmu(data, level) {
    data.pmr();
    this.bmz_1 = Companion_getInstance_27().i1(data.xmj(2));
    this.cmz_1 = Companion_getInstance_28().i1(data.xmj(2));
    var numGradients = data.xmj(4);
    var inductionVariable = 0;
    if (inductionVariable < numGradients)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.emz_1.f(data.kmz(level));
      }
       while (inductionVariable < numGradients);
  }
  toString() {
    return '(' + joinToString(this.emz_1, ',') + '), SpreadMode: ' + this.bmz_1.toString() + ', InterpolationMode: ' + this.cmz_1.toString();
  }
}
class SWFFocalGradient extends SWFGradient {
  pmu(data, level) {
    super.pmu(data, level);
    this.dmz_1 = data.mmn();
  }
  toString() {
    return '(' + joinToString(this.emz_1, ',') + ')';
  }
}
class SWFGradientRecord {
  constructor() {
    this.lmz_1 = 0;
    this.mmz_1 = 0;
    this.nmz_1 = 0;
  }
  pmu(data, level) {
    this.nmz_1 = level;
    this.lmz_1 = data.bmg();
    this.mmz_1 = level <= 2 ? data.dms() : data.ems();
  }
  toString() {
    return '[' + this.lmz_1 + ',' + (this.nmz_1 <= 2 ? ColorUtils_instance.lna(this.mmz_1) : ColorUtils_instance.kna(this.mmz_1)) + ']';
  }
}
class SWFMorphFillStyle {
  constructor() {
    this.pmz_1 = 0;
    this.qmz_1 = 0;
    this.rmz_1 = 0;
    this.umz_1 = null;
    this.vmz_1 = 0;
  }
  ona() {
    var tmp = this.smz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('startGradientMatrix');
    }
  }
  pna() {
    var tmp = this.tmz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('endGradientMatrix');
    }
  }
  qna() {
    var tmp = this.wmz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('startBitmapMatrix');
    }
  }
  rna() {
    var tmp = this.xmz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('endBitmapMatrix');
    }
  }
  pmu(data, level) {
    this.pmz_1 = data.bmg();
    switch (this.pmz_1) {
      case 0:
        this.qmz_1 = data.ems();
        this.rmz_1 = data.ems();
        break;
      case 16:
      case 18:
      case 19:
        this.smz_1 = data.fms();
        this.tmz_1 = data.fms();
        this.umz_1 = this.pmz_1 === 19 ? data.ln1(level) : data.fn1(level);
        break;
      case 64:
      case 65:
      case 66:
      case 67:
        this.vmz_1 = data.pmf();
        this.wmz_1 = data.fms();
        this.xmz_1 = data.fms();
        break;
      default:
        throw Error_0.cf('Unknown fill style type: 0x' + toString_1(this.pmz_1, 16));
    }
  }
  sna(ratio) {
    var fillStyle = new SWFFillStyle();
    fillStyle.jmv_1 = this.pmz_1;
    switch (this.pmz_1) {
      case 0:
        fillStyle.kmv_1 = ColorUtils_instance.tna(this.qmz_1, this.rmz_1, ratio);
        break;
      case 16:
      case 18:
        fillStyle.mmv_1 = MatrixUtils_instance.una(this.ona(), this.pna(), ratio);
        fillStyle.lmv_1 = ensureNotNull(this.umz_1).vna(ratio);
        break;
      case 64:
      case 65:
      case 66:
      case 67:
        fillStyle.nmv_1 = this.vmz_1;
        fillStyle.omv_1 = MatrixUtils_instance.una(this.qna(), this.rna(), ratio);
        break;
    }
    return fillStyle;
  }
  toString() {
    var tmp = '[SWFMorphFillStyle] Type: ' + toString_1(this.pmz_1, 16);
    var tmp37_subject = this.pmz_1;
    return tmp + (tmp37_subject === 0 ? ' (solid), StartColor: ' + ColorUtils_instance.kna(this.qmz_1) + ', EndColor: ' + ColorUtils_instance.kna(this.rmz_1) : tmp37_subject === 16 ? ' (linear gradient), Gradient: ' + toString_0(this.umz_1) : tmp37_subject === 18 ? ' (radial gradient), Gradient: ' + toString_0(this.umz_1) : tmp37_subject === 19 ? ' (focal radial gradient), Gradient: ' + toString_0(this.umz_1) : tmp37_subject === 64 ? ' (repeating bitmap), BitmapID: ' + this.vmz_1 : tmp37_subject === 65 ? ' (clipped bitmap), BitmapID: ' + this.vmz_1 : tmp37_subject === 66 ? ' (non-smoothed repeating bitmap), BitmapID: ' + this.vmz_1 : tmp37_subject === 67 ? ' (non-smoothed clipped bitmap), BitmapID: ' + this.vmz_1 : '');
  }
}
class SWFMorphLineStyle {
  constructor() {
    this.an0_1 = 0;
    this.bn0_1 = 0;
    this.cn0_1 = 0;
    this.dn0_1 = 0;
    this.en0_1 = LineCapsStyle_ROUND_getInstance();
    this.fn0_1 = LineCapsStyle_ROUND_getInstance();
    this.gn0_1 = 0;
    this.hn0_1 = false;
    this.in0_1 = false;
    this.jn0_1 = false;
    this.kn0_1 = false;
    this.ln0_1 = false;
    this.mn0_1 = 3.0;
    this.nn0_1 = null;
  }
  pmu(data, level) {
    this.an0_1 = data.pmf();
    this.bn0_1 = data.pmf();
    this.cn0_1 = data.ems();
    this.dn0_1 = data.ems();
  }
  wna(ratio) {
    var lineStyle = new SWFLineStyle();
    if (this.hn0_1) {
      lineStyle.dmw_1 = ensureNotNull(this.nn0_1).sna(ratio);
    } else {
      lineStyle.smv_1 = ColorUtils_instance.tna(this.cn0_1, this.dn0_1, ratio);
      lineStyle.rmv_1 = numberToInt(this.an0_1 + (this.bn0_1 - this.an0_1 | 0) * ratio);
    }
    lineStyle.umv_1 = this.en0_1;
    lineStyle.vmv_1 = this.fn0_1;
    lineStyle.wmv_1 = this.gn0_1;
    lineStyle.xmv_1 = this.hn0_1;
    lineStyle.ymv_1 = this.in0_1;
    lineStyle.zmv_1 = this.jn0_1;
    lineStyle.amw_1 = this.kn0_1;
    lineStyle.bmw_1 = this.ln0_1;
    lineStyle.cmw_1 = this.mn0_1;
    return lineStyle;
  }
  toString() {
    return '[SWFMorphLineStyle] StartWidth: ' + this.an0_1 + ', EndWidth: ' + this.bn0_1 + ', StartColor: ' + ColorUtils_instance.kna(this.cn0_1) + ', EndColor: ' + ColorUtils_instance.kna(this.dn0_1);
  }
}
class SWFMorphLineStyle2 extends SWFMorphLineStyle {
  pmu(data, level) {
    this.an0_1 = data.pmf();
    this.bn0_1 = data.pmf();
    this.en0_1 = Companion_getInstance_29().i1(data.xmj(2));
    this.gn0_1 = data.xmj(2);
    this.hn0_1 = data.xmj(1) === 1;
    this.in0_1 = data.xmj(1) === 1;
    this.jn0_1 = data.xmj(1) === 1;
    this.kn0_1 = data.xmj(1) === 1;
    var reserved = data.xmj(5);
    this.ln0_1 = data.xmj(1) === 1;
    this.fn0_1 = Companion_getInstance_29().i1(data.xmj(2));
    if (this.gn0_1 === 2)
      this.mn0_1 = data.mmn();
    if (this.hn0_1) {
      this.nn0_1 = data.omz(level);
    } else {
      this.cn0_1 = data.ems();
      this.dn0_1 = data.ems();
    }
  }
  toString() {
    var str = '[SWFMorphLineStyle2] StartWidth: ' + this.an0_1 + ', ' + 'EndWidth: ' + this.bn0_1 + ', ' + 'StartCaps: ' + this.en0_1 + ', ' + 'EndCaps: ' + this.fn0_1.toString() + ', ' + 'Joint: ' + this.gn0_1;
    if (this.hn0_1) {
      str = str + (', Fill: ' + toString_0(this.nn0_1));
    } else {
      str = str + (', StartColor: ' + ColorUtils_instance.kna(this.cn0_1));
      str = str + (', EndColor: ' + ColorUtils_instance.kna(this.dn0_1));
    }
    return str;
  }
}
class SWFMorphGradient {
  constructor() {
    this.gn1_1 = 0;
    this.hn1_1 = 0;
    this.in1_1 = 0.0;
    this.jn1_1 = 0.0;
    this.kn1_1 = ArrayList.m1();
  }
  pmu(data, level) {
    data.pmr();
    this.gn1_1 = data.xmj(2);
    this.hn1_1 = data.xmj(2);
    var numGradients = data.xmj(4);
    var inductionVariable = 0;
    if (inductionVariable < numGradients)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.kn1_1.f(data.rn1());
      }
       while (inductionVariable < numGradients);
  }
  vna(ratio) {
    var gradient = new SWFGradient();
    var inductionVariable = 0;
    var last = this.kn1_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        gradient.emz_1.f(this.kn1_1.i1(i).xna(ratio));
      }
       while (inductionVariable < last);
    return gradient;
  }
  toString() {
    return '(' + joinToString(this.kn1_1, ',') + '), spread:' + this.gn1_1 + ', interpolation:' + this.hn1_1;
  }
}
class SWFMorphFocalGradient extends SWFMorphGradient {
  pmu(data, level) {
    super.pmu(data, level);
    this.in1_1 = data.mmn();
    this.jn1_1 = data.mmn();
  }
  vna(ratio) {
    var gradient = new SWFGradient();
    var inductionVariable = 0;
    var last = this.kn1_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        gradient.emz_1.f(this.kn1_1.i1(i).xna(ratio));
      }
       while (inductionVariable < last);
    return gradient;
  }
  toString() {
    return 'FocalPoint: ' + this.in1_1 + ',' + this.jn1_1 + ' (' + joinToString(this.kn1_1, ',') + ')';
  }
}
class SWFMorphGradientRecord {
  constructor() {
    this.sn1_1 = 0;
    this.tn1_1 = 0;
    this.un1_1 = 0;
    this.vn1_1 = 0;
  }
  lm2(data) {
    this.sn1_1 = data.bmg();
    this.tn1_1 = data.ems();
    this.un1_1 = data.bmg();
    this.vn1_1 = data.ems();
  }
  xna(ratio) {
    var gradientRecord = new SWFGradientRecord();
    gradientRecord.mmz_1 = ColorUtils_instance.tna(this.tn1_1, this.vn1_1, ratio);
    gradientRecord.lmz_1 = numberToInt(this.sn1_1 + (this.un1_1 - this.sn1_1 | 0) * ratio);
    return gradientRecord;
  }
  toString() {
    return '[' + this.sn1_1 + ',' + ColorUtils_instance.kna(this.tn1_1) + ',' + this.un1_1 + ',' + ColorUtils_instance.kna(this.vn1_1) + ']';
  }
}
class Companion_10 {}
class SWFActionValue {
  constructor() {
    this.amj_1 = 0;
    this.bmj_1 = null;
    this.cmj_1 = 0.0;
    this.dmj_1 = 0;
    this.emj_1 = false;
    this.fmj_1 = 0;
    this.gmj_1 = 0;
  }
  lm2(data) {
    this.amj_1 = data.bmg();
    var tmp29_subject = this.amj_1;
    if (tmp29_subject === ActionValueType_instance.cn6_1)
      this.bmj_1 = data.dm0();
    else if (tmp29_subject === ActionValueType_instance.dn6_1)
      this.cmj_1 = data.vmr();
    else if (tmp29_subject !== ActionValueType_instance.en6_1)
      if (tmp29_subject !== ActionValueType_instance.fn6_1)
        if (tmp29_subject === ActionValueType_instance.gn6_1)
          this.dmj_1 = data.bmg();
        else if (tmp29_subject === ActionValueType_instance.hn6_1)
          this.emj_1 = !(data.bmg() === 0);
        else if (tmp29_subject === ActionValueType_instance.in6_1) {
          _get_ba__ndbxv0(Companion_instance_14).p1q(0);
          _get_ba__ndbxv0(Companion_instance_14).l38(4, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(5, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(6, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(7, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(0, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(1, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(2, data.bmg());
          _get_ba__ndbxv0(Companion_instance_14).l38(3, data.bmg());
          this.cmj_1 = _get_ba__ndbxv0(Companion_instance_14).zn3();
        } else if (tmp29_subject === ActionValueType_instance.jn6_1)
          this.fmj_1 = data.jmn();
        else if (tmp29_subject === ActionValueType_instance.kn6_1)
          this.gmj_1 = data.bmg();
        else if (tmp29_subject === ActionValueType_instance.ln6_1)
          this.gmj_1 = data.pmf();
        else
          throw Error_0.cf('Unknown ActionValueType: ' + this.amj_1);
  }
  toString() {
    var tmp30_subject = this.amj_1;
    return tmp30_subject === ActionValueType_instance.cn6_1 ? '' + this.bmj_1 + ' (string)' : tmp30_subject === ActionValueType_instance.dn6_1 ? '' + this.cmj_1 + ' (float)' : tmp30_subject === ActionValueType_instance.en6_1 ? 'null' : tmp30_subject === ActionValueType_instance.fn6_1 ? 'undefined' : tmp30_subject === ActionValueType_instance.gn6_1 ? '' + this.dmj_1 + ' (register)' : tmp30_subject === ActionValueType_instance.hn6_1 ? '' + this.emj_1 + ' (boolean)' : tmp30_subject === ActionValueType_instance.in6_1 ? '' + this.cmj_1 + ' (double)' : tmp30_subject === ActionValueType_instance.jn6_1 ? '' + this.fmj_1 + ' (integer)' : tmp30_subject === ActionValueType_instance.kn6_1 ? '' + this.gmj_1 + ' (constant8)' : tmp30_subject === ActionValueType_instance.ln6_1 ? '' + this.gmj_1 + ' (constant16)' : 'unknown';
  }
  hmj(cpool) {
    var tmp31_subject = this.amj_1;
    var tmp;
    if (tmp31_subject === ActionValueType_instance.cn6_1) {
      tmp = '"' + this.bmj_1 + '"';
    } else if (tmp31_subject === ActionValueType_instance.dn6_1 || tmp31_subject === ActionValueType_instance.in6_1) {
      var str = this.cmj_1.toString();
      var tmp_0;
      if (indexOf(str, '.') === -1) {
        tmp_0 = str + '.0';
      } else {
        tmp_0 = str;
      }
      tmp = tmp_0;
    } else if (tmp31_subject === ActionValueType_instance.en6_1) {
      tmp = 'null';
    } else if (tmp31_subject === ActionValueType_instance.fn6_1) {
      tmp = 'undefined';
    } else if (tmp31_subject === ActionValueType_instance.gn6_1) {
      tmp = '$' + this.dmj_1;
    } else if (tmp31_subject === ActionValueType_instance.hn6_1) {
      tmp = this.emj_1.toString();
    } else if (tmp31_subject === ActionValueType_instance.jn6_1) {
      tmp = this.fmj_1.toString();
    } else if (tmp31_subject === ActionValueType_instance.kn6_1 || tmp31_subject === ActionValueType_instance.ln6_1) {
      tmp = '"' + cpool.i1(this.gmj_1) + '"';
    } else {
      tmp = 'UNKNOWN';
    }
    return tmp;
  }
}
class SWFRegisterParam {
  constructor() {
    this.xn1_1 = 0;
    this.yn1_1 = null;
  }
  lm2(data) {
    this.xn1_1 = data.bmg();
    this.yn1_1 = data.dm0();
  }
  toString() {
    return '$' + this.xn1_1 + ':' + this.yn1_1;
  }
}
class SWFSymbol {
  static yna(tagId, name) {
    tagId = tagId === VOID ? 0 : tagId;
    name = name === VOID ? null : name;
    var $this = createThis(this);
    $this.an2_1 = tagId;
    $this.bn2_1 = name;
    return $this;
  }
  static cn2(data) {
    return this.yna(data.pmf(), data.dm0());
  }
  toString() {
    return 'SWFSymbol(tagId=' + this.an2_1 + ', name=' + this.bn2_1 + ')';
  }
  hashCode() {
    var result = this.an2_1;
    result = imul(result, 31) + (this.bn2_1 == null ? 0 : getStringHashCode(this.bn2_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFSymbol))
      return false;
    var tmp0_other_with_cast = other instanceof SWFSymbol ? other : THROW_CCE();
    if (!(this.an2_1 === tmp0_other_with_cast.an2_1))
      return false;
    if (!(this.bn2_1 == tmp0_other_with_cast.bn2_1))
      return false;
    return true;
  }
}
class SWFSoundInfo {
  constructor() {
    this.en2_1 = false;
    this.fn2_1 = false;
    this.gn2_1 = false;
    this.hn2_1 = false;
    this.in2_1 = false;
    this.jn2_1 = false;
    this.kn2_1 = 0;
    this.ln2_1 = 0;
    this.mn2_1 = 0;
    this.nn2_1 = ArrayList.m1();
  }
  lm2(data) {
    var flags = data.bmg();
    this.en2_1 = !((flags & 32) === 0);
    this.fn2_1 = !((flags & 16) === 0);
    this.gn2_1 = !((flags & 8) === 0);
    this.hn2_1 = !((flags & 4) === 0);
    this.in2_1 = !((flags & 2) === 0);
    this.jn2_1 = !((flags & 1) === 0);
    if (this.jn2_1)
      this.ln2_1 = data.jmn();
    if (this.in2_1)
      this.kn2_1 = data.jmn();
    if (this.hn2_1)
      this.mn2_1 = data.pmf();
    if (this.gn2_1) {
      var envPoints = data.bmg();
      var inductionVariable = 0;
      if (inductionVariable < envPoints)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.nn2_1.f(data.on2());
        }
         while (inductionVariable < envPoints);
    }
  }
  toString() {
    return '[SWFSoundInfo]';
  }
}
class SWFSoundEnvelope {
  static zna(pos44, leftLevel, rightLevel) {
    pos44 = pos44 === VOID ? 0 : pos44;
    leftLevel = leftLevel === VOID ? 0 : leftLevel;
    rightLevel = rightLevel === VOID ? 0 : rightLevel;
    var $this = createThis(this);
    $this.pn2_1 = pos44;
    $this.qn2_1 = leftLevel;
    $this.rn2_1 = rightLevel;
    return $this;
  }
  static sn2(data) {
    return this.zna(data.jmn(), data.pmf(), data.pmf());
  }
  toString() {
    return 'SWFSoundEnvelope(pos44=' + this.pn2_1 + ', leftLevel=' + this.qn2_1 + ', rightLevel=' + this.rn2_1 + ')';
  }
  hashCode() {
    var result = this.pn2_1;
    result = imul(result, 31) + this.qn2_1 | 0;
    result = imul(result, 31) + this.rn2_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFSoundEnvelope))
      return false;
    var tmp0_other_with_cast = other instanceof SWFSoundEnvelope ? other : THROW_CCE();
    if (!(this.pn2_1 === tmp0_other_with_cast.pn2_1))
      return false;
    if (!(this.qn2_1 === tmp0_other_with_cast.qn2_1))
      return false;
    if (!(this.rn2_1 === tmp0_other_with_cast.rn2_1))
      return false;
    return true;
  }
}
class SWFClipActions {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.vn2_1 = ArrayList.m1();
  }
  anb() {
    var tmp = this.un2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('eventFlags');
    }
  }
  pmu(data, version) {
    data.pmf();
    this.un2_1 = data.bn3(version);
    $l$loop: while (true) {
      var tmp = this.vn2_1;
      var tmp0_elvis_lhs = data.wn2(version);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp.f(tmp_0);
    }
  }
  pmn(indent, flags) {
    var str = 'ClipActions (' + this.anb().toString() + '):';
    var inductionVariable = 0;
    var last = this.vn2_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + this.vn2_1.i1(i).pmn(indent + 2 | 0, flags));
      }
       while (inductionVariable < last);
    return str;
  }
  bnb(indent, flags, $super) {
    indent = indent === VOID ? 0 : indent;
    flags = flags === VOID ? 0 : flags;
    return $super === VOID ? this.pmn(indent, flags) : $super.pmn.call(this, indent, flags);
  }
}
class SWFClipActionRecord {
  constructor() {
    this.yn2_1 = 0;
    this.zn2_1 = ArrayList.m1();
    this.an3_1 = 0;
  }
  anb() {
    var tmp = this.xn2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('eventFlags');
    }
  }
  pmu(data, version) {
    this.xn2_1 = data.bn3(version);
    data.jmn();
    if (this.anb().tn3_1) {
      this.yn2_1 = data.bmg();
    }
    $l$loop: while (true) {
      var tmp = this.zn2_1;
      var tmp0_elvis_lhs = data.ymh();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp.f(tmp_0);
    }
    this.an3_1 = Companion_instance_6.am2(this.zn2_1);
  }
  pmn(indent, flags) {
    var str = 'ClipActionRecord (' + this.anb().toString() + ')';
    if (this.yn2_1 > 0) {
      str = str + (', KeyCode: ' + this.yn2_1);
    }
    if ((flags & 2) === 0) {
      var inductionVariable = 0;
      var last = this.zn2_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + this.zn2_1.i1(i).mm2(indent + 2 | 0));
        }
         while (inductionVariable < last);
    } else {
      var tmp = this.zn2_1;
      // Inline function 'kotlin.collections.arrayListOf' call
      var tmp$ret$0 = ArrayList.m1();
      var context = new ActionExecutionContext(tmp, tmp$ret$0, this.an3_1);
      var inductionVariable_0 = 0;
      var last_0 = this.zn2_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + this.zn2_1.i1(i_0).nm2(indent + 4 | 0, context));
        }
         while (inductionVariable_0 < last_0);
      if (!(context.sm2_1 == null)) {
        str = str + ('\n' + repeat(' ', indent + 4 | 0) + context.sm2_1 + ':');
      }
    }
    return str;
  }
}
class SWFClipEventFlags {
  constructor() {
    this.cn3_1 = false;
    this.dn3_1 = false;
    this.en3_1 = false;
    this.fn3_1 = false;
    this.gn3_1 = false;
    this.hn3_1 = false;
    this.in3_1 = false;
    this.jn3_1 = false;
    this.kn3_1 = false;
    this.ln3_1 = false;
    this.mn3_1 = false;
    this.nn3_1 = false;
    this.on3_1 = false;
    this.pn3_1 = false;
    this.qn3_1 = false;
    this.rn3_1 = false;
    this.sn3_1 = false;
    this.tn3_1 = false;
    this.un3_1 = false;
  }
  pmu(data, version) {
    var flags1 = data.bmg();
    this.cn3_1 = !((flags1 & 128) === 0);
    this.dn3_1 = !((flags1 & 64) === 0);
    this.en3_1 = !((flags1 & 32) === 0);
    this.fn3_1 = !((flags1 & 16) === 0);
    this.gn3_1 = !((flags1 & 8) === 0);
    this.hn3_1 = !((flags1 & 4) === 0);
    this.in3_1 = !((flags1 & 2) === 0);
    this.jn3_1 = !((flags1 & 1) === 0);
    var flags2 = data.bmg();
    this.kn3_1 = !((flags2 & 128) === 0);
    this.ln3_1 = !((flags2 & 64) === 0);
    this.mn3_1 = !((flags2 & 32) === 0);
    this.nn3_1 = !((flags2 & 16) === 0);
    this.on3_1 = !((flags2 & 8) === 0);
    this.pn3_1 = !((flags2 & 4) === 0);
    this.qn3_1 = !((flags2 & 2) === 0);
    this.rn3_1 = !((flags2 & 1) === 0);
    if (version >= 6) {
      var flags3 = data.bmg();
      this.sn3_1 = !((flags3 & 4) === 0);
      this.tn3_1 = !((flags3 & 2) === 0);
      this.un3_1 = !((flags3 & 1) === 0);
      data.bmg();
    }
  }
  toString() {
    // Inline function 'kotlin.collections.arrayListOf' call
    var a = ArrayList.m1();
    if (this.cn3_1) {
      a.f('keyup');
    }
    if (this.dn3_1) {
      a.f('keydown');
    }
    if (this.en3_1) {
      a.f('mouseup');
    }
    if (this.fn3_1) {
      a.f('mousedown');
    }
    if (this.gn3_1) {
      a.f('mousemove');
    }
    if (this.hn3_1) {
      a.f('unload');
    }
    if (this.in3_1) {
      a.f('enterframe');
    }
    if (this.jn3_1) {
      a.f('load');
    }
    if (this.kn3_1) {
      a.f('dragover');
    }
    if (this.ln3_1) {
      a.f('rollout');
    }
    if (this.mn3_1) {
      a.f('rollover');
    }
    if (this.nn3_1) {
      a.f('releaseoutside');
    }
    if (this.on3_1) {
      a.f('release');
    }
    if (this.pn3_1) {
      a.f('press');
    }
    if (this.qn3_1) {
      a.f('initialize');
    }
    if (this.rn3_1) {
      a.f('data');
    }
    if (this.sn3_1) {
      a.f('construct');
    }
    if (this.tn3_1) {
      a.f('keypress');
    }
    if (this.un3_1) {
      a.f('dragout');
    }
    return joinToString(a, ',');
  }
}
class Companion_11 {
  constructor() {
    this.cnb_1 = 0;
    this.dnb_1 = 1;
    this.enb_1 = 2;
    this.fnb_1 = 3;
    this.gnb_1 = 4;
  }
}
class SWFShapeRecordEnd extends SWFShapeRecord {
  constructor() {
    SWFShapeRecordEnd_instance = null;
    super();
    SWFShapeRecordEnd_instance = this;
    this.inb_1 = 1;
  }
  b2n() {
    return this.inb_1;
  }
  toString() {
    return '[SWFShapeRecordEnd]';
  }
  j13() {
    return this;
  }
}
class GradientType extends Enum {}
class StraightEdge {
  constructor(from, to, lineStyleIdx, fillStyleIdx) {
    lineStyleIdx = lineStyleIdx === VOID ? 0 : lineStyleIdx;
    fillStyleIdx = fillStyleIdx === VOID ? 0 : fillStyleIdx;
    this.nn9_1 = from;
    this.on9_1 = to;
    this.pn9_1 = lineStyleIdx;
    this.qn9_1 = fillStyleIdx;
  }
  gn9() {
    return this.nn9_1;
  }
  hn9() {
    return this.on9_1;
  }
  un9() {
    return this.pn9_1;
  }
  zn8() {
    return this.qn9_1;
  }
  vn8(newFillStyleIdx) {
    return new StraightEdge(this.hn9(), this.gn9(), this.un9(), newFillStyleIdx);
  }
  toString() {
    return 'stroke:' + this.un9() + ', fill:' + this.zn8() + ', start:' + this.gn9().toString() + ', end:' + this.hn9().toString();
  }
}
class CurvedEdge extends StraightEdge {
  constructor(aFrom, control, aTo, aLineStyleIdx, aFillStyleIdx) {
    aLineStyleIdx = aLineStyleIdx === VOID ? 0 : aLineStyleIdx;
    aFillStyleIdx = aFillStyleIdx === VOID ? 0 : aFillStyleIdx;
    super(aFrom, aTo, aLineStyleIdx, aFillStyleIdx);
    this.mn9_1 = control;
  }
  vn8(newFillStyleIdx) {
    return new CurvedEdge(this.hn9(), this.mn9_1, this.gn9(), this.un9(), newFillStyleIdx);
  }
  toString() {
    return 'stroke:' + this.un9() + ', fill:' + this.zn8() + ', start:' + this.gn9().toString() + ', control:' + this.mn9_1.toString() + ', end:' + this.hn9().toString();
  }
}
class ShapeExporter {
  yn7() {
    return Unit_instance;
  }
  bn8() {
    return Unit_instance;
  }
  xn8() {
    return Unit_instance;
  }
  cn9(color, alpha) {
    return Unit_instance;
  }
  fn9(color, alpha, $super) {
    alpha = alpha === VOID ? 1.0 : alpha;
    var tmp;
    if ($super === VOID) {
      this.cn9(color, alpha);
      tmp = Unit_instance;
    } else {
      tmp = $super.cn9.call(this, color, alpha);
    }
    return tmp;
  }
  dn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
    return Unit_instance;
  }
  en9(bitmapId, matrix, repeat, smooth) {
    return Unit_instance;
  }
  yn8() {
    return Unit_instance;
  }
  sn9() {
    return Unit_instance;
  }
  tn9() {
    return Unit_instance;
  }
  wn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit) {
    return Unit_instance;
  }
  vn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit, $super) {
    thickness = thickness === VOID ? NaN : thickness;
    color = color === VOID ? 0 : color;
    alpha = alpha === VOID ? 1.0 : alpha;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCaps = startCaps === VOID ? LineCapsStyle_ROUND_getInstance() : startCaps;
    endCaps = endCaps === VOID ? LineCapsStyle_ROUND_getInstance() : endCaps;
    joints = joints === VOID ? null : joints;
    miterLimit = miterLimit === VOID ? 3.0 : miterLimit;
    var tmp;
    if ($super === VOID) {
      this.wn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit);
      tmp = Unit_instance;
    } else {
      tmp = $super.wn9.call(this, thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit);
    }
    return tmp;
  }
  xn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
    return Unit_instance;
  }
  zn9() {
    return Unit_instance;
  }
  b48(x, y) {
    return Unit_instance;
  }
  c48(x, y) {
    return Unit_instance;
  }
  rn9(controlX, controlY, anchorX, anchorY) {
    return Unit_instance;
  }
  yn9() {
    return Unit_instance;
  }
}
class ShapeExporterBoundsBuilder extends ShapeExporter {
  constructor() {
    super();
    this.jnb_1 = new MBoundsBuilder();
    this.knb_1 = 1.0;
    this.lnb_1 = 0.0;
    this.mnb_1 = 0.0;
    this.nnb_1 = Companion_getInstance_8().l2m();
  }
  wn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit) {
    this.knb_1 = thickness;
  }
  xn8() {
    this.knb_1 = 0.0;
  }
  tn9() {
    this.knb_1 = 1.0;
  }
  b48(x, y) {
    addPoint(this, x, y);
    this.lnb_1 = x;
    this.mnb_1 = y;
  }
  c48(x, y) {
    addPoint(this, x, y);
    this.lnb_1 = x;
    this.mnb_1 = y;
  }
  rn9(controlX, controlY, anchorX, anchorY) {
    addPoint(this, controlX, controlY);
    addPoint(this, anchorX, anchorY);
    this.lnb_1 = anchorX;
    this.mnb_1 = anchorY;
  }
  yn9() {
  }
}
class LoggerShapeExporter extends ShapeExporter {
  constructor(parent, logger) {
    var tmp;
    if (logger === VOID) {
      tmp = println$ref();
    } else {
      tmp = logger;
    }
    logger = tmp;
    super();
    this.onb_1 = parent;
    this.pnb_1 = logger;
  }
  qnb(msg) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.LoggerShapeExporter.log.<anonymous>' call
    this.pnb_1(msg);
    return this;
  }
  yn7() {
    return this.qnb('beginShape()').onb_1.yn7();
  }
  bn8() {
    return this.qnb('endShape()').onb_1.bn8();
  }
  xn8() {
    return this.qnb('beginFills()').onb_1.xn8();
  }
  sn9() {
    return this.qnb('endFills()').onb_1.sn9();
  }
  tn9() {
    return this.qnb('beginLines()').onb_1.tn9();
  }
  zn9() {
    return this.qnb('endLines()').onb_1.zn9();
  }
  yn9() {
    return this.qnb('closePath()').onb_1.yn9();
  }
  cn9(color, alpha) {
    return this.qnb('beginFill(' + format('%06X', [color]) + ', ' + alpha + ')').onb_1.cn9(color, alpha);
  }
  dn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
    this.qnb('beginGradientFill(' + type.toString() + ', ' + colors.toString() + ', ' + alphas.toString() + ', ' + ratios.toString() + ', ' + matrix.toString() + ', ' + spreadMethod.toString() + ', ' + interpolationMethod.toString() + ', ' + focalPointRatio + ')').onb_1.dn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio);
  }
  en9(bitmapId, matrix, repeat, smooth) {
    this.qnb('beginBitmapFill(' + bitmapId + ', ' + matrix.toString() + ', ' + repeat + ', ' + smooth + ')').onb_1.en9(bitmapId, matrix, repeat, smooth);
  }
  yn8() {
    return this.qnb('endFill()').onb_1.yn8();
  }
  wn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit) {
    this.qnb('lineStyle(' + thickness + ', ' + color + ', ' + alpha + ', ' + pixelHinting + ', ' + scaleMode.toString() + ', ' + startCaps.toString() + ', ' + endCaps.toString() + ', ' + joints + ', ' + miterLimit + ')').onb_1.wn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit);
  }
  xn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
    this.qnb('lineGradientStyle(' + type.toString() + ', ' + colors.toString() + ', ' + alphas.toString() + ', ' + ratios.toString() + ', ' + matrix.toString() + ', ' + spreadMethod.toString() + ', ' + interpolationMethod.toString() + ', ' + focalPointRatio + ')').onb_1.xn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio);
  }
  b48(x, y) {
    return this.qnb('moveTo(' + x + ', ' + y + ')').onb_1.b48(x, y);
  }
  c48(x, y) {
    return this.qnb('lineTo(' + x + ', ' + y + ')').onb_1.c48(x, y);
  }
  rn9(controlX, controlY, anchorX, anchorY) {
    return this.qnb('curveTo(' + controlX + ', ' + controlY + ', ' + anchorX + ', ' + anchorY + ')').onb_1.rn9(controlX, controlY, anchorX, anchorY);
  }
}
class SWFTagFactory {
  kmo(type) {
    switch (type) {
      case 0:
        return new TagEnd();
      case 1:
        return new TagShowFrame();
      case 2:
        return new TagDefineShape();
      case 4:
        return new TagPlaceObject();
      case 5:
        return new TagRemoveObject();
      case 6:
        return new TagDefineBits();
      case 7:
        return new TagDefineButton();
      case 8:
        return new TagJPEGTables();
      case 9:
        return new TagSetBackgroundColor();
      case 10:
        return new TagDefineFont();
      case 11:
        return new TagDefineText();
      case 12:
        return new TagDoAction();
      case 13:
        return new TagDefineFontInfo();
      case 14:
        return new TagDefineSound();
      case 15:
        return new TagStartSound();
      case 17:
        return new TagDefineButtonSound();
      case 18:
        return new TagSoundStreamHead();
      case 19:
        return new TagSoundStreamBlock();
      case 20:
        return new TagDefineBitsLossless();
      case 21:
        return new TagDefineBitsJPEG2();
      case 22:
        return new TagDefineShape2();
      case 23:
        return new TagDefineButtonCxform();
      case 24:
        return new TagProtect();
      case 25:
        return new TagPathsArePostScript();
      case 26:
        return new TagPlaceObject2();
      case 28:
        return new TagRemoveObject2();
      case 32:
        return new TagDefineShape3();
      case 33:
        return new TagDefineText2();
      case 34:
        return new TagDefineButton2();
      case 35:
        return new TagDefineBitsJPEG3();
      case 36:
        return new TagDefineBitsLossless2();
      case 37:
        return new TagDefineEditText();
      case 39:
        return new TagDefineSprite();
      case 40:
        return new TagNameCharacter();
      case 41:
        return new TagProductInfo();
      case 43:
        return new TagFrameLabel();
      case 45:
        return new TagSoundStreamHead2();
      case 46:
        return new TagDefineMorphShape();
      case 48:
        return new TagDefineFont2();
      case 56:
        return new TagExportAssets();
      case 57:
        return new TagImportAssets();
      case 58:
        return new TagEnableDebugger();
      case 59:
        return new TagDoInitAction();
      case 60:
        return new TagDefineVideoStream();
      case 61:
        return new TagVideoFrame();
      case 62:
        return new TagDefineFontInfo2();
      case 63:
        return new TagDebugID();
      case 64:
        return new TagEnableDebugger2();
      case 65:
        return new TagScriptLimits();
      case 66:
        return new TagSetTabIndex();
      case 69:
        return new TagFileAttributes();
      case 70:
        return new TagPlaceObject3();
      case 71:
        return new TagImportAssets2();
      case 72:
        return new TagDoABCDeprecated();
      case 73:
        return new TagDefineFontAlignZones();
      case 74:
        return new TagCSMTextSettings();
      case 75:
        return new TagDefineFont3();
      case 76:
        return new TagSymbolClass();
      case 77:
        return new TagMetadata();
      case 78:
        return new TagDefineScalingGrid();
      case 82:
        return new TagDoABC();
      case 83:
        return new TagDefineShape4();
      case 84:
        return new TagDefineMorphShape2();
      case 86:
        return new TagDefineSceneAndFrameLabelData();
      case 87:
        return new TagDefineBinaryData();
      case 88:
        return new TagDefineFontName();
      case 89:
        return new TagStartSound2();
      case 90:
        return new TagDefineBitsJPEG4();
      case 91:
        return new TagDefineFont4();
      case 93:
        return new TagEnableTelemetry();
      case 94:
        return new TagPlaceObject4();
      case 253:
        return new TagSWFEncryptActions();
      case 255:
        return new TagSWFEncryptSignature();
      default:
        return new TagUnknown(type);
    }
  }
}
class SWFFilterFactory {
  kmo(id) {
    var tmp;
    switch (id) {
      case 0:
        tmp = new FilterDropShadow(id);
        break;
      case 1:
        tmp = new FilterBlur(id);
        break;
      case 2:
        tmp = new FilterGlow(id);
        break;
      case 3:
        tmp = new FilterBevel(id);
        break;
      case 4:
        tmp = new FilterGradientGlow(id);
        break;
      case 5:
        tmp = new FilterConvolution(id);
        break;
      case 6:
        tmp = new FilterColorMatrix(id);
        break;
      case 7:
        tmp = new FilterGradientBevel(id);
        break;
      default:
        var message = 'Unknown filter ID: ' + id;
        throw IllegalStateException.m5(toString(message));
    }
    return tmp;
  }
}
class SWFActionFactory {
  wn1(code, length, pos) {
    switch (code) {
      case 4:
        return new ActionNextFrame(code, length, pos);
      case 5:
        return new ActionPreviousFrame(code, length, pos);
      case 6:
        return new ActionPlay(code, length, pos);
      case 7:
        return new ActionStop(code, length, pos);
      case 8:
        return new ActionToggleQuality(code, length, pos);
      case 9:
        return new ActionStopSounds(code, length, pos);
      case 10:
        return new ActionAdd(code, length, pos);
      case 11:
        return new ActionSubtract(code, length, pos);
      case 12:
        return new ActionMultiply(code, length, pos);
      case 13:
        return new ActionDivide(code, length, pos);
      case 14:
        return new ActionEquals(code, length, pos);
      case 15:
        return new ActionLess(code, length, pos);
      case 16:
        return new ActionAnd(code, length, pos);
      case 17:
        return new ActionOr(code, length, pos);
      case 18:
        return new ActionNot(code, length, pos);
      case 19:
        return new ActionStringEquals(code, length, pos);
      case 20:
        return new ActionStringLength(code, length, pos);
      case 21:
        return new ActionStringExtract(code, length, pos);
      case 23:
        return new ActionPop(code, length, pos);
      case 24:
        return new ActionToInteger(code, length, pos);
      case 28:
        return new ActionGetVariable(code, length, pos);
      case 29:
        return new ActionSetVariable(code, length, pos);
      case 32:
        return new ActionSetTarget2(code, length, pos);
      case 33:
        return new ActionStringAdd(code, length, pos);
      case 34:
        return new ActionGetProperty(code, length, pos);
      case 35:
        return new ActionSetProperty(code, length, pos);
      case 36:
        return new ActionCloneSprite(code, length, pos);
      case 37:
        return new ActionRemoveSprite(code, length, pos);
      case 38:
        return new ActionTrace(code, length, pos);
      case 39:
        return new ActionStartDrag(code, length, pos);
      case 40:
        return new ActionEndDrag(code, length, pos);
      case 41:
        return new ActionStringLess(code, length, pos);
      case 42:
        return new ActionThrow(code, length, pos);
      case 43:
        return new ActionCastOp(code, length, pos);
      case 44:
        return new ActionImplementsOp(code, length, pos);
      case 48:
        return new ActionRandomNumber(code, length, pos);
      case 49:
        return new ActionMBStringLength(code, length, pos);
      case 50:
        return new ActionCharToAscii(code, length, pos);
      case 51:
        return new ActionAsciiToChar(code, length, pos);
      case 52:
        return new ActionGetTime(code, length, pos);
      case 53:
        return new ActionMBStringExtract(code, length, pos);
      case 54:
        return new ActionMBCharToAscii(code, length, pos);
      case 55:
        return new ActionMBAsciiToChar(code, length, pos);
      case 58:
        return new ActionDelete(code, length, pos);
      case 59:
        return new ActionDelete2(code, length, pos);
      case 60:
        return new ActionDefineLocal(code, length, pos);
      case 61:
        return new ActionCallFunction(code, length, pos);
      case 62:
        return new ActionReturn(code, length, pos);
      case 63:
        return new ActionModulo(code, length, pos);
      case 64:
        return new ActionNewObject(code, length, pos);
      case 65:
        return new ActionDefineLocal2(code, length, pos);
      case 66:
        return new ActionInitArray(code, length, pos);
      case 67:
        return new ActionInitObject(code, length, pos);
      case 68:
        return new ActionTypeOf(code, length, pos);
      case 69:
        return new ActionTargetPath(code, length, pos);
      case 70:
        return new ActionEnumerate(code, length, pos);
      case 71:
        return new ActionAdd2(code, length, pos);
      case 72:
        return new ActionLess2(code, length, pos);
      case 73:
        return new ActionEquals2(code, length, pos);
      case 74:
        return new ActionToNumber(code, length, pos);
      case 75:
        return new ActionToString(code, length, pos);
      case 76:
        return new ActionPushDuplicate(code, length, pos);
      case 77:
        return new ActionStackSwap(code, length, pos);
      case 78:
        return new ActionGetMember(code, length, pos);
      case 79:
        return new ActionSetMember(code, length, pos);
      case 80:
        return new ActionIncrement(code, length, pos);
      case 81:
        return new ActionDecrement(code, length, pos);
      case 82:
        return new ActionCallMethod(code, length, pos);
      case 83:
        return new ActionNewMethod(code, length, pos);
      case 84:
        return new ActionInstanceOf(code, length, pos);
      case 85:
        return new ActionEnumerate2(code, length, pos);
      case 96:
        return new ActionBitAnd(code, length, pos);
      case 97:
        return new ActionBitOr(code, length, pos);
      case 98:
        return new ActionBitXor(code, length, pos);
      case 99:
        return new ActionBitLShift(code, length, pos);
      case 100:
        return new ActionBitRShift(code, length, pos);
      case 101:
        return new ActionBitURShift(code, length, pos);
      case 102:
        return new ActionStrictEquals(code, length, pos);
      case 103:
        return new ActionGreater(code, length, pos);
      case 104:
        return new ActionStringGreater(code, length, pos);
      case 105:
        return new ActionExtends(code, length, pos);
      case 129:
        return new ActionGotoFrame(code, length, pos);
      case 131:
        return new ActionGetURL(code, length, pos);
      case 135:
        return new ActionStoreRegister(code, length, pos);
      case 136:
        return new ActionConstantPool(code, length, pos);
      case 138:
        return new ActionWaitForFrame(code, length, pos);
      case 139:
        return new ActionSetTarget(code, length, pos);
      case 140:
        return new ActionGotoLabel(code, length, pos);
      case 141:
        return new ActionWaitForFrame2(code, length, pos);
      case 142:
        return new ActionDefineFunction2(code, length, pos);
      case 143:
        return new ActionTry(code, length, pos);
      case 148:
        return new ActionWith(code, length, pos);
      case 150:
        return new ActionPush(code, length, pos);
      case 153:
        return new ActionJump(code, length, pos);
      case 154:
        return new ActionGetURL2(code, length, pos);
      case 155:
        return new ActionDefineFunction(code, length, pos);
      case 157:
        return new ActionIf(code, length, pos);
      case 158:
        return new ActionCall(code, length, pos);
      case 159:
        return new ActionGotoFrame2(code, length, pos);
      default:
        return new ActionUnknown(code, length, pos);
    }
  }
}
class Filter {
  constructor(id) {
    this.tne_1 = id;
  }
  lm2(data) {
    throw Error_0.cf('Implement in subclasses!');
  }
  mm2(indent) {
    return '[Filter]';
  }
  toString() {
    return this.mm2(0);
  }
}
class FilterDropShadow extends Filter {
  constructor(id) {
    super(id);
    this.snb_1 = 0;
    this.tnb_1 = 0.0;
    this.unb_1 = 0.0;
    this.vnb_1 = 0.0;
    this.wnb_1 = 0.0;
    this.xnb_1 = 0.0;
    this.ynb_1 = false;
    this.znb_1 = false;
    this.anc_1 = false;
    this.bnc_1 = 0;
  }
  lm2(data) {
    this.snb_1 = data.ems();
    this.tnb_1 = data.umr();
    this.unb_1 = data.umr();
    this.vnb_1 = data.umr();
    this.wnb_1 = data.umr();
    this.xnb_1 = data.mmn();
    var flags = data.bmg();
    this.ynb_1 = !((flags & 128) === 0);
    this.znb_1 = !((flags & 64) === 0);
    this.anc_1 = !((flags & 32) === 0);
    this.bnc_1 = flags & 31;
  }
  mm2(indent) {
    var str = '[DropShadowFilter] DropShadowColor: ' + ColorUtils_instance.lna(this.snb_1) + ', ' + 'BlurX: ' + this.tnb_1 + ', ' + 'BlurY: ' + this.unb_1 + ', ' + 'Angle: ' + this.vnb_1 + ', ' + 'Distance: ' + this.wnb_1 + ', ' + 'Strength: ' + this.xnb_1 + ', ' + 'Passes: ' + this.bnc_1;
    // Inline function 'kotlin.collections.arrayListOf' call
    var flags = ArrayList.m1();
    if (this.ynb_1) {
      flags.f('InnerShadow');
    }
    if (this.znb_1) {
      flags.f('Knockout');
    }
    if (this.anc_1) {
      flags.f('CompositeSource');
    }
    if (flags.j1() > 0)
      str = str + (', Flags: ' + joinToString(flags, ', '));
    return str;
  }
}
class FilterBlur extends Filter {
  constructor(id) {
    super(id);
    this.dnc_1 = 0.0;
    this.enc_1 = 0.0;
    this.fnc_1 = 0;
  }
  lm2(data) {
    this.dnc_1 = data.umr();
    this.enc_1 = data.umr();
    this.fnc_1 = data.bmg() >>> 3 | 0;
  }
  mm2(indent) {
    return '[BlurFilter] BlurX: ' + this.dnc_1 + ', BlurY: ' + this.enc_1 + ', Passes: ' + this.fnc_1;
  }
}
class FilterGlow extends Filter {
  constructor(id) {
    super(id);
    this.hnc_1 = 0;
    this.inc_1 = 0.0;
    this.jnc_1 = 0.0;
    this.knc_1 = 0.0;
    this.lnc_1 = false;
    this.mnc_1 = false;
    this.nnc_1 = false;
    this.onc_1 = 0;
  }
  lm2(data) {
    this.hnc_1 = data.ems();
    this.inc_1 = data.umr();
    this.jnc_1 = data.umr();
    this.knc_1 = data.mmn();
    var flags = data.bmg();
    this.lnc_1 = !((flags & 128) === 0);
    this.mnc_1 = !((flags & 64) === 0);
    this.nnc_1 = !((flags & 32) === 0);
    this.onc_1 = flags & 31;
  }
  mm2(indent) {
    var str = '[GlowFilter] GlowColor: ' + ColorUtils_instance.lna(this.hnc_1) + ', ' + 'BlurX: ' + this.inc_1 + ', ' + 'BlurY: ' + this.jnc_1 + ', ' + 'Strength: ' + this.knc_1 + ', ' + 'Passes: ' + this.onc_1;
    // Inline function 'kotlin.collections.arrayListOf' call
    var flags = ArrayList.m1();
    if (this.lnc_1) {
      flags.f('InnerGlow');
    }
    if (this.mnc_1) {
      flags.f('Knockout');
    }
    if (this.nnc_1) {
      flags.f('CompositeSource');
    }
    if (flags.j1() > 0)
      str = str + (', Flags: ' + joinToString(flags, ', '));
    return str;
  }
}
class FilterBevel extends Filter {
  constructor(id) {
    super(id);
    this.qnc_1 = 0;
    this.rnc_1 = 0;
    this.snc_1 = 0.0;
    this.tnc_1 = 0.0;
    this.unc_1 = 0.0;
    this.vnc_1 = 0.0;
    this.wnc_1 = 0.0;
    this.xnc_1 = false;
    this.ync_1 = false;
    this.znc_1 = false;
    this.and_1 = false;
    this.bnd_1 = 0;
  }
  lm2(data) {
    this.qnc_1 = data.ems();
    this.rnc_1 = data.ems();
    this.snc_1 = data.umr();
    this.tnc_1 = data.umr();
    this.unc_1 = data.umr();
    this.vnc_1 = data.umr();
    this.wnc_1 = data.mmn();
    var flags = data.bmg();
    this.xnc_1 = !((flags & 128) === 0);
    this.ync_1 = !((flags & 64) === 0);
    this.znc_1 = !((flags & 32) === 0);
    this.and_1 = !((flags & 16) === 0);
    this.bnd_1 = flags & 15;
  }
  mm2(indent) {
    var str = '[BevelFilter] ShadowColor: ' + ColorUtils_instance.lna(this.qnc_1) + ', ' + 'HighlightColor: ' + ColorUtils_instance.lna(this.rnc_1) + ', ' + 'BlurX: ' + this.snc_1 + ', ' + 'BlurY: ' + this.tnc_1 + ', ' + 'Angle: ' + this.unc_1 + ', ' + 'Distance: ' + this.vnc_1 + ', ' + 'Strength: ' + this.wnc_1 + ', ' + 'Passes: ' + this.bnd_1;
    // Inline function 'kotlin.collections.arrayListOf' call
    var flags = ArrayList.m1();
    if (this.xnc_1) {
      flags.f('InnerShadow');
    }
    if (this.ync_1) {
      flags.f('Knockout');
    }
    if (this.znc_1) {
      flags.f('CompositeSource');
    }
    if (this.and_1) {
      flags.f('OnTop');
    }
    if (flags.j1() > 0)
      str = str + (', Flags: ' + joinToString(flags, ', '));
    return str;
  }
}
class FilterGradientGlow extends Filter {
  constructor(id) {
    super(id);
    this.dnd_1 = 0;
    this.end_1 = 0.0;
    this.fnd_1 = 0.0;
    this.gnd_1 = 0.0;
    this.hnd_1 = 0.0;
    this.ind_1 = 0.0;
    this.jnd_1 = false;
    this.knd_1 = false;
    this.lnd_1 = false;
    this.mnd_1 = false;
    this.nnd_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ond_1 = ArrayList.m1();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.pnd_1 = ArrayList.m1();
    this.qnd_1 = 'GradientGlowFilter';
  }
  lm2(data) {
    this.dnd_1 = data.bmg();
    var inductionVariable = 0;
    var last = this.dnd_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ond_1.f(data.ems());
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = this.dnd_1;
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.pnd_1.f(data.bmg());
      }
       while (inductionVariable_0 < last_0);
    this.end_1 = data.umr();
    this.fnd_1 = data.umr();
    this.gnd_1 = data.umr();
    this.hnd_1 = data.umr();
    this.ind_1 = data.mmn();
    var flags = data.bmg();
    this.jnd_1 = !((flags & 128) === 0);
    this.knd_1 = !((flags & 64) === 0);
    this.lnd_1 = !((flags & 32) === 0);
    this.mnd_1 = !((flags & 16) === 0);
    this.nnd_1 = flags & 15;
  }
  mm2(indent) {
    var str = '[' + this.rnd() + '] BlurX: ' + this.end_1 + ', BlurY: ' + this.fnd_1 + ', Angle: ' + this.gnd_1 + ', Distance: ' + this.hnd_1 + ', Strength: ' + this.ind_1 + ', Passes: ' + this.nnd_1;
    // Inline function 'kotlin.collections.arrayListOf' call
    var flags = ArrayList.m1();
    if (this.jnd_1) {
      flags.f('InnerShadow');
    }
    if (this.knd_1) {
      flags.f('Knockout');
    }
    if (this.lnd_1) {
      flags.f('CompositeSource');
    }
    if (this.mnd_1) {
      flags.f('OnTop');
    }
    if (flags.j1() > 0)
      str = str + (', Flags: ' + joinToString(flags, ', '));
    if (this.ond_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'GradientColors:');
      var inductionVariable = 0;
      var last = this.ond_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ((i > 0 ? ', ' : ' ') + ColorUtils_instance.lna(this.ond_1.i1(i)));
        }
         while (inductionVariable < last);
    }
    if (this.pnd_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'GradientRatios:');
      var inductionVariable_0 = 0;
      var last_0 = this.pnd_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          str = str + ((i_0 > 0 ? ', ' : ' ') + this.pnd_1.i1(i_0));
        }
         while (inductionVariable_0 < last_0);
    }
    return str;
  }
  rnd() {
    return this.qnd_1;
  }
}
class FilterConvolution extends Filter {
  constructor(id) {
    super(id);
    this.tnd_1 = 0;
    this.und_1 = 0;
    this.vnd_1 = 0.0;
    this.wnd_1 = 0.0;
    this.xnd_1 = 0;
    this.ynd_1 = false;
    this.znd_1 = false;
    this.ane_1 = ArrayList.m1();
  }
  lm2(data) {
    this.tnd_1 = data.bmg();
    this.und_1 = data.bmg();
    this.vnd_1 = data.vmr();
    this.wnd_1 = data.vmr();
    var len = imul(this.tnd_1, this.und_1);
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ane_1.f(data.vmr());
      }
       while (inductionVariable < len);
    this.xnd_1 = data.ems();
    var flags = data.bmg();
    this.ynd_1 = !((flags & 2) === 0);
    this.znd_1 = !((flags & 1) === 0);
  }
  mm2(indent) {
    var str = '[ConvolutionFilter] DefaultColor: ' + ColorUtils_instance.lna(this.xnd_1) + ', ' + 'Divisor: ' + this.vnd_1 + ', ' + 'Bias: ' + this.wnd_1;
    // Inline function 'kotlin.collections.arrayListOf' call
    var flags = ArrayList.m1();
    if (this.ynd_1) {
      flags.f('Clamp');
    }
    if (this.znd_1) {
      flags.f('PreserveAlpha');
    }
    if (flags.j1() > 0)
      str = str + (', Flags: ' + joinToString(flags, ', '));
    if (this.ane_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Matrix:');
      var inductionVariable = 0;
      var last = this.und_1;
      if (inductionVariable < last)
        do {
          var y = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          str = str + ('\n' + repeat(' ', indent + 4 | 0) + '[' + y + ']');
          var inductionVariable_0 = 0;
          var last_0 = this.tnd_1;
          if (inductionVariable_0 < last_0)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              str = str + ((x > 0 ? ', ' : ' ') + this.ane_1.i1(imul(this.tnd_1, y) + x | 0));
            }
             while (inductionVariable_0 < last_0);
        }
         while (inductionVariable < last);
    }
    return str;
  }
}
class FilterColorMatrix extends Filter {
  constructor(id) {
    super(id);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.cne_1 = ArrayList.m1();
  }
  lm2(data) {
    var inductionVariable = 0;
    if (inductionVariable < 20)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.cne_1.f(data.vmr());
      }
       while (inductionVariable < 20);
  }
  mm2(indent) {
    var si = repeat(' ', indent + 2 | 0);
    return '[ColorMatrixFilter]\n' + si + '[R] ' + this.cne_1.i1(0) + ', ' + this.cne_1.i1(1) + ', ' + this.cne_1.i1(2) + ', ' + this.cne_1.i1(3) + ', ' + this.cne_1.i1(4) + '\n' + si + '[G] ' + this.cne_1.i1(5) + ', ' + this.cne_1.i1(6) + ', ' + this.cne_1.i1(7) + ', ' + this.cne_1.i1(8) + ', ' + this.cne_1.i1(9) + '\n' + si + '[B] ' + this.cne_1.i1(10) + ', ' + this.cne_1.i1(11) + ', ' + this.cne_1.i1(12) + ', ' + this.cne_1.i1(13) + ', ' + this.cne_1.i1(14) + '\n' + si + '[A] ' + this.cne_1.i1(15) + ', ' + this.cne_1.i1(16) + ', ' + this.cne_1.i1(17) + ', ' + this.cne_1.i1(18) + ', ' + this.cne_1.i1(19);
  }
}
class FilterGradientBevel extends FilterGradientGlow {
  constructor(id) {
    super(id);
    this.sne_1 = 'GradientBevelFilter';
  }
  rnd() {
    return this.sne_1;
  }
}
class ITag {}
function toString$default(indent, flags, $super) {
  indent = indent === VOID ? 0 : indent;
  flags = flags === VOID ? 0 : flags;
  return $super === VOID ? this.pmn(indent, flags) : $super.pmn.call(this, indent, flags);
}
class _BaseTag {
  constructor(type, name, version, level) {
    level = level === VOID ? 1 : level;
    this.tnf_1 = type;
    this.unf_1 = name;
    this.vnf_1 = version;
    this.wnf_1 = level;
  }
  b2n() {
    return this.tnf_1;
  }
  w3() {
    return this.unf_1;
  }
  s3g() {
    return this.wnf_1;
  }
  lmo(data, length, version, async, $completion) {
    return Unit_instance;
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent);
  }
  toString() {
    return this.pmn(0, 0);
  }
}
class IDefinitionTag {}
class _BaseDefinitionTag extends _BaseTag {
  constructor(type, name, version, level, characterId) {
    level = level === VOID ? 1 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level);
    this.pnf_1 = characterId;
  }
  qnf(_set____db54di) {
    this.pnf_1 = _set____db54di;
  }
  vmo() {
    return this.pnf_1;
  }
}
class TagDefineMorphShape extends _BaseDefinitionTag {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 46 : type;
    name = name === VOID ? 'DefineMorphShape' : name;
    version = version === VOID ? 3 : version;
    level = level === VOID ? 1 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
    this.dnf_1 = new SWFRectangle();
    this.enf_1 = new SWFRectangle();
    this.fnf_1 = ArrayList.m1();
    this.gnf_1 = ArrayList.m1();
  }
  hnf() {
    var tmp = this.zne_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('startBounds');
    }
  }
  inf() {
    var tmp = this.anf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('endBounds');
    }
  }
  jnf() {
    var tmp = this.bnf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('startEdges');
    }
  }
  knf() {
    var tmp = this.cnf_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('endEdges');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.zne_1 = data.lmn();
    this.anf_1 = data.lmn();
    var offset = data.jmn();
    var fillStyleCount = data.bmg();
    if (fillStyleCount === 255)
      fillStyleCount = data.pmf();
    var inductionVariable = 0;
    var last = fillStyleCount;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.fnf_1.f(data.ymz());
      }
       while (inductionVariable < last);
    var lineStyleCount = data.bmg();
    if (lineStyleCount === 255)
      lineStyleCount = data.pmf();
    var inductionVariable_0 = 0;
    var last_0 = lineStyleCount;
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.gnf_1.f(data.on0());
      }
       while (inductionVariable_0 < last_0);
    this.bnf_1 = data.zmt();
    this.cnf_1 = data.zmt();
  }
  rnf(handler, ratio) {
    var j = 0;
    var exportShape = new SWFShape();
    var numEdges = this.jnf().nmt_1.j1();
    try {
      var inductionVariable = 0;
      if (inductionVariable < numEdges)
        $l$loop: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var startRecord = this.jnf().nmt_1.i1(i);
          var tmp;
          if (startRecord.b2n() === 2) {
            tmp = !(startRecord instanceof SWFShapeRecordStyleChange ? startRecord : THROW_CCE()).vn7();
          } else {
            tmp = false;
          }
          if (tmp) {
            exportShape.nmt_1.f(startRecord.j13());
            continue $l$loop;
          }
          var tmp_0 = this.knf().nmt_1;
          var _unary__edvuaz = j;
          j = _unary__edvuaz + 1 | 0;
          var endRecord = tmp_0.i1(_unary__edvuaz);
          var exportRecord = null;
          if (startRecord.b2n() === 4 && endRecord.b2n() === 3) {
            endRecord = this.snf(endRecord instanceof SWFShapeRecordStraightEdge ? endRecord : THROW_CCE());
          } else if (startRecord.b2n() === 3 && endRecord.b2n() === 4) {
            startRecord = this.snf(startRecord instanceof SWFShapeRecordStraightEdge ? startRecord : THROW_CCE());
          }
          switch (startRecord.b2n()) {
            case 2:
              var tmp_1 = startRecord.j13();
              var startStyleChange = tmp_1 instanceof SWFShapeRecordStyleChange ? tmp_1 : THROW_CCE();
              var endStyleChange = endRecord instanceof SWFShapeRecordStyleChange ? endRecord : THROW_CCE();
              startStyleChange.amv_1 = startStyleChange.amv_1 + numberToInt((endStyleChange.amv_1 - startStyleChange.amv_1 | 0) * ratio) | 0;
              startStyleChange.bmv_1 = startStyleChange.bmv_1 + numberToInt((endStyleChange.bmv_1 - startStyleChange.bmv_1 | 0) * ratio) | 0;
              exportRecord = startStyleChange;
              break;
            case 3:
              var tmp_2 = startRecord.j13();
              var startStraightEdge = tmp_2 instanceof SWFShapeRecordStraightEdge ? tmp_2 : THROW_CCE();
              var endStraightEdge = endRecord instanceof SWFShapeRecordStraightEdge ? endRecord : THROW_CCE();
              startStraightEdge.mn8_1 = startStraightEdge.mn8_1 + numberToInt((endStraightEdge.mn8_1 - startStraightEdge.mn8_1 | 0) * ratio) | 0;
              startStraightEdge.ln8_1 = startStraightEdge.ln8_1 + numberToInt((endStraightEdge.ln8_1 - startStraightEdge.ln8_1 | 0) * ratio) | 0;
              if (!(startStraightEdge.mn8_1 === 0) && !(startStraightEdge.ln8_1 === 0)) {
                startStraightEdge.jn8_1 = true;
                startStraightEdge.kn8_1 = false;
              } else {
                startStraightEdge.jn8_1 = false;
                startStraightEdge.kn8_1 = startStraightEdge.mn8_1 === 0;
              }

              exportRecord = startStraightEdge;
              break;
            case 4:
              var tmp_3 = startRecord.j13();
              var startCurvedEdge = tmp_3 instanceof SWFShapeRecordCurvedEdge ? tmp_3 : THROW_CCE();
              var endCurvedEdge = endRecord instanceof SWFShapeRecordCurvedEdge ? endRecord : THROW_CCE();
              startCurvedEdge.qn8_1 = startCurvedEdge.qn8_1 + numberToInt((endCurvedEdge.qn8_1 - startCurvedEdge.qn8_1 | 0) * ratio) | 0;
              startCurvedEdge.rn8_1 = startCurvedEdge.rn8_1 + numberToInt((endCurvedEdge.rn8_1 - startCurvedEdge.rn8_1 | 0) * ratio) | 0;
              startCurvedEdge.sn8_1 = startCurvedEdge.sn8_1 + numberToInt((endCurvedEdge.sn8_1 - startCurvedEdge.sn8_1 | 0) * ratio) | 0;
              startCurvedEdge.tn8_1 = startCurvedEdge.tn8_1 + numberToInt((endCurvedEdge.tn8_1 - startCurvedEdge.tn8_1 | 0) * ratio) | 0;
              exportRecord = startCurvedEdge;
              break;
            case 1:
              exportRecord = startRecord.j13();
              break;
          }
          exportShape.nmt_1.f(ensureNotNull(exportRecord));
        }
         while (inductionVariable < numEdges);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var inductionVariable_0 = 0;
    var last = this.fnf_1.j1();
    if (inductionVariable_0 < last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        exportShape.omt_1.f(this.fnf_1.i1(i_0).sna(ratio));
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.gnf_1.j1();
    if (inductionVariable_1 < last_0)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        exportShape.pmt_1.f(this.gnf_1.i1(i_1).wna(ratio));
      }
       while (inductionVariable_1 < last_0);
    exportShape.wn7(handler);
  }
  snf(straightEdge) {
    var curvedEdge = new SWFShapeRecordCurvedEdge();
    curvedEdge.qn8_1 = straightEdge.mn8_1 / 2 | 0;
    curvedEdge.rn8_1 = straightEdge.ln8_1 / 2 | 0;
    curvedEdge.sn8_1 = straightEdge.mn8_1;
    curvedEdge.tn8_1 = straightEdge.ln8_1;
    return curvedEdge;
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineMorphShape.toString.<anonymous>' call
    var indent2 = repeat(' ', indent + 2 | 0);
    var indent4 = repeat(' ', indent + 4 | 0);
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo());
    this_0.ic('\n' + indent2 + 'Bounds:');
    this_0.ic('\n' + indent4 + 'StartBounds: ' + this.hnf().toString());
    this_0.ic('\n' + indent4 + 'EndBounds: ' + this.inf().toString());
    if (this.fnf_1.j1() > 0) {
      this_0.ic('\n' + indent2 + 'FillStyles:');
      var inductionVariable = 0;
      var last = this.fnf_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + indent4 + '[' + (i + 1 | 0) + '] ' + this.fnf_1.i1(i).toString());
        }
         while (inductionVariable < last);
    }
    if (this.gnf_1.j1() > 0) {
      this_0.ic('\n' + indent2 + 'LineStyles:');
      var inductionVariable_0 = 0;
      var last_0 = this.gnf_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_0.ic('\n' + indent4 + '[' + (i_0 + 1 | 0) + '] ' + this.gnf_1.i1(i_0).toString());
        }
         while (inductionVariable_0 < last_0);
    }
    this_0.ic(this.jnf().mm2(indent + 2 | 0));
    this_0.ic(this.knf().mm2(indent + 2 | 0));
    return this_0.toString();
  }
}
class TagDefineShape extends _BaseDefinitionTag {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 2 : type;
    name = name === VOID ? 'DefineShape' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
  }
  fng() {
    var tmp = this.dng_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shapeBounds');
    }
  }
  gng() {
    var tmp = this.eng_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shapes');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.dng_1 = data.lmn();
    this.eng_1 = data.qmu(this.s3g());
  }
  wn7(handler) {
    this.gng().wn7(handler);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Bounds: ' + this.fng().toString() + this.gng().mm2(indent + 2 | 0);
  }
}
class TagObj {
  constructor(TYPE) {
    this.cmo_1 = TYPE;
  }
}
class Companion_12 extends TagObj {
  constructor() {
    Companion_instance_16 = null;
    super(8);
    Companion_instance_16 = this;
  }
}
class TagJPEGTables extends _BaseTag {
  constructor() {
    Companion_getInstance_33();
    super(Companion_getInstance_33().cmo_1, 'JPEGTables', 1);
    this.lng_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    if (length > 0) {
      this.lng_1 = toFlash(data.h1r(length));
    }
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Length: ' + this.lng_1.a();
  }
}
class Companion_13 extends TagObj {
  constructor() {
    Companion_instance_17 = null;
    super(0);
    Companion_instance_17 = this;
  }
}
class TagEnd extends _BaseTag {
  constructor() {
    Companion_getInstance_34();
    super(Companion_getInstance_34().cmo_1, 'End', 1);
  }
}
class IDisplayListTag {}
class Companion_14 extends TagObj {
  constructor() {
    Companion_instance_18 = null;
    super(43);
    Companion_instance_18 = this;
  }
}
class TagFrameLabel extends _BaseTag {
  constructor() {
    Companion_getInstance_35();
    super(Companion_getInstance_35().cmo_1, 'FrameLabel', 3);
    this.kmp_1 = false;
  }
  lmp() {
    var tmp = this.jmp_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('frameName');
    }
  }
  lmo(data, length, version, async, $completion) {
    var start = data.q1q();
    this.jmp_1 = data.dm0();
    if ((data.q1q() - start | 0) < length) {
      data.bmg();
      this.kmp_1 = true;
    }
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagFrameLabel.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent));
    this_0.ic('Name: ' + this.lmp());
    if (this.kmp_1) {
      this_0.ic(', NamedAnchor = true');
    }
    return this_0.toString();
  }
}
class Companion_15 extends TagObj {
  constructor() {
    Companion_instance_19 = null;
    super(86);
    Companion_instance_19 = this;
  }
}
class TagDefineSceneAndFrameLabelData extends _BaseTag {
  constructor() {
    Companion_getInstance_36();
    super(Companion_getInstance_36().cmo_1, 'DefineSceneAndFrameLabelData', 9);
    this.qmp_1 = ArrayList.m1();
    this.rmp_1 = ArrayList.m1();
  }
  lmo(data, length, version, async, $completion) {
    var sceneCount = data.ymr();
    var inductionVariable = 0;
    if (inductionVariable < sceneCount)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var sceneOffset = data.ymr();
        var sceneName = data.dm0();
        this.qmp_1.f(new SWFScene(sceneOffset, sceneName));
      }
       while (inductionVariable < sceneCount);
    var frameLabelCount = data.ymr();
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < frameLabelCount)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var frameNumber = data.ymr();
        var frameLabel = data.dm0();
        this.rmp_1.f(new SWFFrameLabel(frameNumber, frameLabel));
      }
       while (inductionVariable_0 < frameLabelCount);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineSceneAndFrameLabelData.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent));
    if (this.qmp_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Scenes:');
      var inductionVariable = 0;
      var last = this.qmp_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.qmp_1.i1(i).toString());
        }
         while (inductionVariable < last);
    }
    if (this.rmp_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'FrameLabels:');
      var inductionVariable_0 = 0;
      var last_0 = this.rmp_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i_0 + '] ' + this.rmp_1.i1(i_0).toString());
        }
         while (inductionVariable_0 < last_0);
    }
    return this_0.toString();
  }
}
class Companion_16 extends TagObj {
  constructor() {
    Companion_instance_20 = null;
    super(18);
    Companion_instance_20 = this;
  }
}
class TagSoundStreamHead extends _BaseTag {
  constructor(type, name, version, level) {
    Companion_getInstance_37();
    type = type === VOID ? Companion_getInstance_37().cmo_1 : type;
    name = name === VOID ? 'SoundStreamHead' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.imq_1 = 0;
    this.jmq_1 = 0;
    this.kmq_1 = 0;
    this.lmq_1 = 0;
    this.mmq_1 = 0;
    this.nmq_1 = 0;
    this.omq_1 = 0;
    this.pmq_1 = 0;
    this.qmq_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    data.xmj(4);
    this.imq_1 = data.xmj(2);
    this.jmq_1 = data.xmj(1);
    this.kmq_1 = data.xmj(1);
    this.lmq_1 = data.xmj(4);
    this.mmq_1 = data.xmj(2);
    this.nmq_1 = data.xmj(1);
    this.omq_1 = data.xmj(1);
    this.pmq_1 = data.pmf();
    if (this.lmq_1 === 2)
      this.qmq_1 = data.omj();
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagSoundStreamHead.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent));
    if (this.pmq_1 > 0) {
      this_0.ic('Format: ' + SoundCompression_instance.mm2(this.lmq_1) + ', Rate: ' + SoundRate_instance.mm2(this.mmq_1) + ', Size: ' + SoundSize_instance.mm2(this.nmq_1) + ', Type: ' + SoundType_instance.mm2(this.omq_1) + ', ');
    }
    this_0.ic('Samples: ' + this.pmq_1 + ', ');
    this_0.ic('LatencySeek: ' + this.qmq_1);
    return this_0.toString();
  }
}
class Companion_17 extends TagObj {
  constructor() {
    Companion_instance_21 = null;
    super(45);
    Companion_instance_21 = this;
  }
}
class TagSoundStreamHead2 extends TagSoundStreamHead {
  constructor() {
    Companion_getInstance_38();
    super(Companion_getInstance_38().cmo_1, 'SoundStreamHead2', 3, 2);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagSoundStreamHead2.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent));
    if (this.pmq_1 > 0) {
      this_0.ic('Format: ' + SoundCompression_instance.mm2(this.lmq_1) + ', Rate: ' + SoundRate_instance.mm2(this.mmq_1) + ', Size: ' + SoundSize_instance.mm2(this.nmq_1) + ', Type: ' + SoundType_instance.mm2(this.omq_1) + ', ');
    }
    this_0.ic('Samples: ' + this.pmq_1);
    return this_0.toString();
  }
}
class Companion_18 extends TagObj {
  constructor() {
    Companion_instance_22 = null;
    super(19);
    Companion_instance_22 = this;
  }
}
class TagSoundStreamBlock extends _BaseTag {
  constructor() {
    Companion_getInstance_39();
    super(Companion_getInstance_39().cmo_1, 'SoundStreamBlock', 1);
    this.amq_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    this.amq_1 = toFlash(data.h1r(length));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Length: ' + this.amq_1.a();
  }
}
class Companion_19 extends TagObj {
  constructor() {
    Companion_instance_23 = null;
    super(9);
    Companion_instance_23 = this;
  }
}
class TagSetBackgroundColor extends _BaseTag {
  constructor() {
    Companion_getInstance_40();
    super(Companion_getInstance_40().cmo_1, 'SetBackgroundColor', 1);
    this.vmq_1 = 16777215;
  }
  lmo(data, length, version, async, $completion) {
    this.vmq_1 = data.dms();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Color: ' + ColorUtils_instance.lna(this.vmq_1);
  }
}
class Companion_20 extends TagObj {
  constructor() {
    Companion_instance_24 = null;
    super(1);
    Companion_instance_24 = this;
  }
}
class TagShowFrame extends _BaseTag {
  constructor() {
    Companion_getInstance_41();
    super(Companion_getInstance_41().cmo_1, 'ShowFrame', 1);
  }
}
class Companion_21 extends TagObj {
  constructor() {
    Companion_instance_25 = null;
    super(4);
    Companion_instance_25 = this;
  }
}
class TagPlaceObject extends _BaseTag {
  constructor(type, name, version, level) {
    Companion_getInstance_42();
    type = type === VOID ? Companion_getInstance_42().cmo_1 : type;
    name = name === VOID ? 'PlaceObject' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.dnh_1 = false;
    this.enh_1 = false;
    this.fnh_1 = false;
    this.gnh_1 = false;
    this.hnh_1 = false;
    this.inh_1 = false;
    this.jnh_1 = false;
    this.knh_1 = false;
    this.lnh_1 = false;
    this.mnh_1 = false;
    this.nnh_1 = false;
    this.onh_1 = false;
    this.pnh_1 = false;
    this.qnh_1 = false;
    this.rnh_1 = false;
    this.snh_1 = 0;
    this.tnh_1 = 0;
    this.unh_1 = null;
    this.vnh_1 = null;
    this.wnh_1 = 0;
    this.xnh_1 = null;
    this.ynh_1 = 0;
    this.znh_1 = null;
    this.ani_1 = null;
    this.bni_1 = 0;
    this.cni_1 = 0;
    this.dni_1 = 0;
    this.eni_1 = 0;
    this.fni_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.gni_1 = ArrayList.m1();
  }
  hni() {
    return this.wnh_1 / 65536.0;
  }
  lmo(data, length, version, async, $completion) {
    var pos = data.q1q();
    this.snh_1 = data.pmf();
    this.tnh_1 = data.pmf();
    this.unh_1 = data.fms();
    this.jnh_1 = true;
    this.inh_1 = true;
    if ((data.q1q() - pos | 0) < length) {
      this.vnh_1 = data.pms();
      this.hnh_1 = true;
    }
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagPlaceObject.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Depth: ' + this.tnh_1);
    if (this.jnh_1) {
      this_0.ic(', CharacterID: ' + this.snh_1);
    }
    if (this.inh_1) {
      this_0.ic(', Matrix: ' + toString_0(this.unh_1));
    }
    if (this.hnh_1) {
      this_0.ic(', ColorTransform: ' + toString_0(this.vnh_1));
    }
    return this_0.toString();
  }
}
class Companion_22 extends TagObj {
  constructor() {
    Companion_instance_26 = null;
    super(26);
    Companion_instance_26 = this;
  }
}
class TagPlaceObject2 extends TagPlaceObject {
  constructor(type, name, version, level) {
    Companion_getInstance_43();
    type = type === VOID ? Companion_getInstance_43().cmo_1 : type;
    name = name === VOID ? 'PlaceObject2' : name;
    version = version === VOID ? 3 : version;
    level = level === VOID ? 2 : level;
    super();
  }
  lmo(data, length, version, async, $completion) {
    this.qnj(data);
    this.tnh_1 = data.pmf();
    if (this.jnh_1)
      this.snh_1 = data.pmf();
    if (this.inh_1)
      this.unh_1 = data.fms();
    if (this.hnh_1)
      this.vnh_1 = data.amt();
    if (this.gnh_1)
      this.wnh_1 = data.pmf();
    if (this.fnh_1)
      this.xnh_1 = data.dm0();
    if (this.enh_1)
      this.ynh_1 = data.pmf();
    if (this.dnh_1)
      this.znh_1 = data.tn2(version);
  }
  qnj(data) {
    var flags = data.bmg();
    this.dnh_1 = !((flags & 128) === 0);
    this.enh_1 = !((flags & 64) === 0);
    this.fnh_1 = !((flags & 32) === 0);
    this.gnh_1 = !((flags & 16) === 0);
    this.hnh_1 = !((flags & 8) === 0);
    this.inh_1 = !((flags & 4) === 0);
    this.jnh_1 = !((flags & 2) === 0);
    this.knh_1 = !((flags & 1) === 0);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagPlaceObject2.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Depth: ' + this.tnh_1);
    if (this.jnh_1) {
      this_0.ic(', CharacterID: ' + this.snh_1);
    }
    if (this.inh_1) {
      this_0.ic(', Matrix: ' + toString_0(this.unh_1));
    }
    if (this.hnh_1) {
      this_0.ic(', ColorTransform: ' + toString_0(this.vnh_1));
    }
    if (this.gnh_1) {
      this_0.ic(', Ratio: ' + this.wnh_1);
    }
    if (this.fnh_1) {
      this_0.ic(', Name: ' + this.xnh_1);
    }
    if (this.enh_1) {
      this_0.ic(', ClipDepth: ' + this.ynh_1);
    }
    if (this.dnh_1 && !(this.znh_1 == null)) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + ensureNotNull(this.znh_1).pmn(indent + 2 | 0, flags));
    }
    return this_0.toString();
  }
}
class Companion_23 extends TagObj {
  constructor() {
    Companion_instance_27 = null;
    super(70);
    Companion_instance_27 = this;
  }
}
class TagPlaceObject3 extends TagPlaceObject2 {
  constructor(type, name, version, level) {
    Companion_getInstance_44();
    type = type === VOID ? Companion_getInstance_44().cmo_1 : type;
    name = name === VOID ? 'PlaceObject3' : name;
    version = version === VOID ? 8 : version;
    level = level === VOID ? 3 : level;
    super();
  }
  lmo(data, length, version, async, $completion) {
    this.qnj(data);
    this.znk(data);
    this.tnh_1 = data.pmf();
    if (this.onh_1)
      this.ani_1 = data.dm0();
    if (this.jnh_1)
      this.snh_1 = data.pmf();
    if (this.inh_1)
      this.unh_1 = data.fms();
    if (this.hnh_1)
      this.vnh_1 = data.amt();
    if (this.gnh_1)
      this.wnh_1 = data.pmf();
    if (this.fnh_1)
      this.xnh_1 = data.dm0();
    if (this.enh_1)
      this.ynh_1 = data.pmf();
    if (this.rnh_1) {
      var inductionVariable = 0;
      var last = data.bmg();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.gni_1.f(data.umx());
        }
         while (inductionVariable < last);
    }
    if (this.qnh_1)
      this.bni_1 = data.bmg();
    if (this.pnh_1)
      this.cni_1 = data.bmg();
    if (this.mnh_1)
      this.eni_1 = data.bmg();
    if (this.lnh_1)
      this.dni_1 = data.ems();
    if (this.dnh_1)
      this.znh_1 = data.tn2(version);
  }
  znk(data) {
    var flags2 = data.bmg();
    this.lnh_1 = !((flags2 & 64) === 0);
    this.mnh_1 = !((flags2 & 32) === 0);
    this.nnh_1 = !((flags2 & 16) === 0);
    this.onh_1 = !((flags2 & 8) === 0);
    this.pnh_1 = !((flags2 & 4) === 0);
    this.qnh_1 = !((flags2 & 2) === 0);
    this.rnh_1 = !((flags2 & 1) === 0);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagPlaceObject3.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Depth: ' + this.tnh_1);
    if (this.onh_1) {
      this_0.ic(', ClassName: ' + this.ani_1);
    }
    if (this.jnh_1) {
      this_0.ic(', CharacterID: ' + this.snh_1);
    }
    if (this.inh_1) {
      this_0.ic(', Matrix: ' + toString_0(this.unh_1));
    }
    if (this.hnh_1) {
      this_0.ic(', ColorTransform: ' + toString_0(this.vnh_1));
    }
    if (this.gnh_1) {
      this_0.ic(', Ratio: ' + this.wnh_1);
    }
    if (this.fnh_1) {
      this_0.ic(', Name: ' + this.xnh_1);
    }
    if (this.enh_1) {
      this_0.ic(', ClipDepth: ' + this.ynh_1);
    }
    if (this.qnh_1) {
      this_0.ic(', BlendMode: ' + BlendMode_instance.mm2(this.bni_1));
    }
    if (this.pnh_1) {
      this_0.ic(', CacheAsBitmap: ' + this.cni_1);
    }
    if (this.mnh_1) {
      this_0.ic(', Visible: ' + this.eni_1);
    }
    if (this.lnh_1) {
      this_0.ic(', BackgroundColor: ' + ColorUtils_instance.kna(this.dni_1));
    }
    if (this.rnh_1) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Filters:');
      var inductionVariable = 0;
      var last = this.gni_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.gni_1.i1(i).mm2(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    if (this.dnh_1) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + ensureNotNull(this.znh_1).bnb(indent + 2 | 0));
    }
    return this_0.toString();
  }
}
class Companion_24 extends TagObj {
  constructor() {
    Companion_instance_28 = null;
    super(5);
    Companion_instance_28 = this;
  }
}
class TagRemoveObject extends _BaseTag {
  constructor(type, name, version, level) {
    Companion_getInstance_45();
    type = type === VOID ? Companion_getInstance_45().cmo_1 : type;
    name = name === VOID ? 'RemoveObject' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.enl_1 = 0;
    this.fnl_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.enl_1 = data.pmf();
    this.fnl_1 = data.pmf();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'CharacterID: ' + this.enl_1 + ', Depth: ' + this.fnl_1;
  }
}
class Companion_25 extends TagObj {
  constructor() {
    Companion_instance_29 = null;
    super(28);
    Companion_instance_29 = this;
  }
}
class TagRemoveObject2 extends TagRemoveObject {
  constructor() {
    Companion_getInstance_46();
    super(Companion_getInstance_46().cmo_1, 'RemoveObject2', 3, 2);
  }
  lmo(data, length, version, async, $completion) {
    this.fnl_1 = data.pmf();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Depth: ' + this.fnl_1;
  }
}
class Companion_26 {
  xnf(type, name, indent) {
    return repeat(' ', indent) + '[' + format('%02d', [type]) + ':' + name + '] ';
  }
}
class TagDefineBits extends _BaseDefinitionTag {
  constructor(type, name, version, level) {
    type = type === VOID ? 6 : type;
    name = name === VOID ? 'DefineBits' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.rnl_1 = 1;
    this.snl_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    if (length > 2)
      this.snl_1 = FlashByteArray.tnl(data.h1r(length - 2 | 0));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', BitmapLength: ' + this.snl_1.a();
  }
}
class Companion_27 {
  constructor() {
    this.unl_1 = 'up';
    this.vnl_1 = 'over';
    this.wnl_1 = 'down';
    this.xnl_1 = 'hit';
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.ynl_1 = function_0;
  }
  rj(a, b) {
    return this.ynl_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class TagDefineButton extends _BaseDefinitionTag {
  constructor() {
    super(7, 'DefineButton', 1);
    this.enm_1 = ArrayList.m1();
    this.fnm_1 = ArrayList.m1();
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.gnm_1 = HashMap.c9();
    this.hnm_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    var record;
    $l$loop: while (true) {
      record = data.fmx();
      if (record == null)
        break $l$loop;
      this.enm_1.f(record);
    }
    var action;
    $l$loop_0: while (true) {
      action = data.ymh();
      if (action == null)
        break $l$loop_0;
      this.fnm_1.f(action);
    }
    this.hnm_1 = Companion_instance_6.am2(this.fnm_1);
    this.inm();
  }
  inm() {
    var upState = ArrayList.m1();
    var overState = ArrayList.m1();
    var downState = ArrayList.m1();
    var hitState = ArrayList.m1();
    var inductionVariable = 0;
    var last = this.enm_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var record = this.enm_1.i1(i);
        if (record.ymw_1) {
          upState.f(record);
        }
        if (record.xmw_1) {
          overState.f(record);
        }
        if (record.wmw_1) {
          downState.f(record);
        }
        if (record.vmw_1) {
          hitState.f(record);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.gnm_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = TagDefineButton$processRecords$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var tmp$ret$1 = sortedWith(upState, tmp$ret$0);
    var value = ArrayList.v(tmp$ret$1);
    this_0.r3('up', value);
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.gnm_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = TagDefineButton$processRecords$lambda_0;
    var tmp$ret$2 = new sam$kotlin_Comparator$0(tmp_0);
    var tmp$ret$3 = sortedWith(overState, tmp$ret$2);
    var value_0 = ArrayList.v(tmp$ret$3);
    this_1.r3('over', value_0);
    // Inline function 'kotlin.collections.set' call
    var this_2 = this.gnm_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = TagDefineButton$processRecords$lambda_1;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp_1);
    var tmp$ret$5 = sortedWith(downState, tmp$ret$4);
    var value_1 = ArrayList.v(tmp$ret$5);
    this_2.r3('down', value_1);
    // Inline function 'kotlin.collections.set' call
    var this_3 = this.gnm_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = TagDefineButton$processRecords$lambda_2;
    var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_2);
    var tmp$ret$7 = sortedWith(hitState, tmp$ret$6);
    var value_2 = ArrayList.v(tmp$ret$7);
    this_3.r3('hit', value_2);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineButton.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo());
    if (this.enm_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Characters:');
      var inductionVariable = 0;
      var last = this.enm_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.enm_1.i1(i).mm2(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    if (this.fnm_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Actions:');
      if ((flags & 2) === 0) {
        var inductionVariable_0 = 0;
        var last_0 = this.fnm_1.j1();
        if (inductionVariable_0 < last_0)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i_0 + '] ' + this.fnm_1.i1(i_0).mm2(indent + 4 | 0));
          }
           while (inductionVariable_0 < last_0);
      } else {
        var tmp = this.fnm_1;
        // Inline function 'kotlin.collections.arrayListOf' call
        var tmp$ret$0 = ArrayList.m1();
        var context = new ActionExecutionContext(tmp, tmp$ret$0, this.hnm_1);
        var inductionVariable_1 = 0;
        var last_1 = this.fnm_1.j1();
        if (inductionVariable_1 < last_1)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            this_0.ic('\n' + repeat(' ', indent + 4 | 0) + this.fnm_1.i1(i_1).nm2(indent + 4 | 0, context));
          }
           while (inductionVariable_1 < last_1);
        if (!(context.sm2_1 == null)) {
          this_0.ic('\n' + repeat(' ', indent + 6 | 0) + context.sm2_1 + ':');
        }
      }
    }
    return this_0.toString();
  }
}
class TagDefineFont extends _BaseDefinitionTag {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 10 : type;
    name = name === VOID ? 'DefineFont' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
    this.onm_1 = ArrayList.m1();
    this.pnm_1 = 1.0;
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    var numGlyphs = data.pmf() >>> 1 | 0;
    data.cml((numGlyphs - 1 | 0) << 1);
    var inductionVariable = 0;
    if (inductionVariable < numGlyphs)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.onm_1.f(data.lmt(this.qnm()));
      }
       while (inductionVariable < numGlyphs);
  }
  qnm() {
    return this.pnm_1;
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Glyphs: ' + this.onm_1.j1() + this.rnm(indent);
  }
  rnm(indent) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineFont.toStringCommon.<anonymous>' call
    var inductionVariable = 0;
    var last = this.onm_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.ic('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] GlyphShapes:');
        this_0.ic(this.onm_1.i1(i).mm2(indent + 4 | 0));
      }
       while (inductionVariable < last);
    return this_0.toString();
  }
}
class TagDefineText extends _BaseDefinitionTag {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 11 : type;
    name = name === VOID ? 'DefineText' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
    this.znm_1 = ArrayList.m1();
  }
  ann() {
    var tmp = this.xnm_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('textBounds');
    }
  }
  bnn() {
    var tmp = this.ynm_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('textMatrix');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.xnm_1 = data.lmn();
    this.ynm_1 = data.fms();
    var glyphBits = data.bmg();
    var advanceBits = data.bmg();
    var record = null;
    $l$loop: while (true) {
      record = data.vmx(glyphBits, advanceBits, record, this.s3g());
      if (record == null)
        break $l$loop;
      this.znm_1.f(record);
    }
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineText.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Bounds: ' + this.ann().toString() + ', Matrix: ' + this.bnn().toString());
    if (this.znm_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'TextRecords:');
      var inductionVariable = 0;
      var last = this.znm_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.znm_1.i1(i).mm2(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    return this_0.toString();
  }
}
class TagDoAction extends _BaseTag {
  constructor(type, name, version, level) {
    type = type === VOID ? 12 : type;
    name = name === VOID ? 'DoAction' : name;
    version = version === VOID ? 3 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.gnn_1 = ArrayList.m1();
    this.hnn_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    var action;
    $l$loop: while (true) {
      action = data.ymh();
      if (action == null)
        break $l$loop;
      this.gnn_1.f(action);
    }
    this.hnn_1 = Companion_instance_6.am2(this.gnn_1);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Records: ' + this.gnn_1.j1() + this.inn(indent, flags);
  }
  inn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDoAction.toStringAction.<anonymous>' call
    if ((flags & 2) === 0) {
      var inductionVariable = 0;
      var last = this.gnn_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + this.gnn_1.i1(i).mm2(indent + 2 | 0));
        }
         while (inductionVariable < last);
    } else {
      var tmp = this.gnn_1;
      // Inline function 'kotlin.collections.arrayListOf' call
      var tmp$ret$0 = ArrayList.m1();
      var context = new ActionExecutionContext(tmp, tmp$ret$0, this.hnn_1);
      var inductionVariable_0 = 0;
      var last_0 = this.gnn_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 2 | 0) + this.gnn_1.i1(i_0).nm2(indent + 2 | 0, context));
        }
         while (inductionVariable_0 < last_0);
      if (!(context.sm2_1 == null)) {
        this_0.ic('\n' + repeat(' ', indent + 4 | 0) + context.sm2_1 + ':');
      }
    }
    return this_0.toString();
  }
}
class TagDefineFontInfo extends _BaseTag {
  constructor(type, name, version, level) {
    type = type === VOID ? 13 : type;
    name = name === VOID ? 'DefineFontInfo' : name;
    version = version === VOID ? 1 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.nnn_1 = 0;
    this.pnn_1 = false;
    this.qnn_1 = false;
    this.rnn_1 = false;
    this.snn_1 = false;
    this.tnn_1 = false;
    this.unn_1 = false;
    this.vnn_1 = 0;
    this.wnn_1 = ArrayList.m1();
    this.xnn_1 = 0;
  }
  ynn() {
    var tmp = this.onn_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontName');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.nnn_1 = data.pmf();
    var fontNameLen = data.bmg();
    this.onn_1 = data.an4(fontNameLen);
    var flags = data.bmg();
    this.pnn_1 = !((flags & 32) === 0);
    this.qnn_1 = !((flags & 16) === 0);
    this.rnn_1 = !((flags & 8) === 0);
    this.snn_1 = !((flags & 4) === 0);
    this.tnn_1 = !((flags & 2) === 0);
    this.unn_1 = !((flags & 1) === 0);
    this.znn(data);
    var numGlyphs = ((length - fontNameLen | 0) - this.xnn_1 | 0) - 4 | 0;
    var inductionVariable = 0;
    if (inductionVariable < numGlyphs)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.wnn_1.f(this.unn_1 ? data.pmf() : data.bmg());
      }
       while (inductionVariable < numGlyphs);
  }
  znn(data) {
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'FontID: ' + this.nnn_1 + ', FontName: ' + this.ynn() + ', Italic: ' + this.snn_1 + ', Bold: ' + this.tnn_1 + ', Codes: ' + this.wnn_1.j1();
  }
}
class TagDefineSound extends _BaseDefinitionTag {
  constructor() {
    super(14, 'DefineSound', 1);
    this.fno_1 = 0;
    this.gno_1 = 0;
    this.hno_1 = 0;
    this.ino_1 = 0;
    this.jno_1 = 0;
    this.kno_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.fno_1 = data.xmj(4);
    this.gno_1 = data.xmj(2);
    this.hno_1 = data.xmj(1);
    this.ino_1 = data.xmj(1);
    this.jno_1 = data.jmn();
    this.kno_1 = toFlash(data.h1r(length - 7 | 0));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'SoundID: ' + this.vmo() + ', Format: ' + SoundCompression_instance.mm2(this.fno_1) + ', Rate: ' + SoundRate_instance.mm2(this.gno_1) + ', Size: ' + SoundSize_instance.mm2(this.hno_1) + ', Type: ' + SoundType_instance.mm2(this.ino_1) + ', Samples: ' + this.jno_1;
  }
}
class TagStartSound extends _BaseTag {
  constructor() {
    super(15, 'StartSound', 1, 1);
    this.pno_1 = 0;
  }
  rno() {
    var tmp = this.qno_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('soundInfo');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.pno_1 = data.pmf();
    this.qno_1 = data.dn2();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'SoundID: ' + this.pno_1 + ', SoundInfo: ' + this.rno().toString();
  }
}
class TagDefineButtonSound extends _BaseDefinitionTag {
  constructor() {
    super(17, 'DefineButtonSound', 2);
    this.xno_1 = 0;
    this.yno_1 = 0;
    this.zno_1 = 0;
    this.anp_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.xno_1 = data.pmf();
    if (!(this.xno_1 === 0))
      this.bnp_1 = data.dn2();
    this.yno_1 = data.pmf();
    if (!(this.yno_1 === 0))
      this.cnp_1 = data.dn2();
    this.zno_1 = data.pmf();
    if (!(this.zno_1 === 0))
      this.dnp_1 = data.dn2();
    this.anp_1 = data.pmf();
    if (!(this.anp_1 === 0))
      this.enp_1 = data.dn2();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ButtonID: ' + this.vmo() + ', ButtonSoundChars: ' + this.xno_1 + ',' + this.yno_1 + ',' + this.zno_1 + ',' + this.anp_1;
  }
}
class TagDefineBitsLossless extends _BaseDefinitionTag {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 20 : type;
    name = name === VOID ? 'DefineBitsLossless' : name;
    version = version === VOID ? 2 : version;
    level = level === VOID ? 1 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
    this.knp_1 = false;
    this.lnp_1 = BitmapFormat_UNKNOWN_getInstance();
    this.mnp_1 = 0;
    this.nnp_1 = 0;
    this.onp_1 = 0;
    this.pnp_1 = FlashByteArray.emr();
  }
  qnp() {
    return this.knp_1;
  }
  rnp() {
    return this.onp_1 + 1 | 0;
  }
  n75() {
    var tmp;
    switch (this.lnp_1.v3_1) {
      case 0:
        tmp = 4;
        break;
      case 1:
        tmp = 2;
        break;
      case 2:
        tmp = 1;
        break;
      case 3:
        tmp = 1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  snp() {
    return nextAlignedTo(this.mnp_1, this.n75());
  }
  tnp() {
    return nextAlignedTo(this.nnp_1, this.n75());
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    var rawFormat = data.bmg();
    this.lnp_1 = Companion_getInstance_30().i1(rawFormat);
    this.mnp_1 = data.pmf();
    this.nnp_1 = data.pmf();
    if (this.lnp_1.equals(BitmapFormat_BIT_8_getInstance()))
      this.onp_1 = data.bmg();
    this.pnp_1 = toFlash(data.h1r(length - (this.lnp_1.equals(BitmapFormat_BIT_8_getInstance()) ? 8 : 7) | 0));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Format: ' + this.lnp_1.toString() + ', Size: (' + this.mnp_1 + ',' + this.nnp_1 + ')';
  }
}
class TagDefineBitsJPEG2 extends TagDefineBits {
  constructor(type, name, version, level) {
    type = type === VOID ? 21 : type;
    name = name === VOID ? 'DefineBitsJPEG2' : name;
    version = version === VOID ? 2 : version;
    level = level === VOID ? 2 : level;
    super(type, name, version, level);
  }
  lmo(data, length, version, async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5_0(this, data, length, version, async, $completion), $completion);
  }
  bnq() {
    if (this.snl_1.i1(0) === 255 && (this.snl_1.i1(1) === 216 || this.snl_1.i1(1) === 217))
      this.rnl_1 = 1;
    else if (this.snl_1.i1(0) === 137 && this.snl_1.i1(1) === 80 && this.snl_1.i1(2) === 78 && this.snl_1.i1(3) === 71 && this.snl_1.i1(4) === 13 && this.snl_1.i1(5) === 10 && this.snl_1.i1(6) === 26 && this.snl_1.i1(7) === 10)
      this.rnl_1 = 3;
    else if (this.snl_1.i1(0) === 71 && this.snl_1.i1(1) === 73 && this.snl_1.i1(2) === 70 && this.snl_1.i1(3) === 56 && this.snl_1.i1(4) === 57 && this.snl_1.i1(5) === 97)
      this.rnl_1 = 2;
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Type: ' + BitmapType_instance.mm2(this.rnl_1) + ', BitmapLength: ' + this.snl_1.a();
  }
}
class TagDefineShape2 extends TagDefineShape {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 22 : type;
    name = name === VOID ? 'DefineShape2' : name;
    version = version === VOID ? 2 : version;
    level = level === VOID ? 2 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Bounds: ' + this.fng().toString() + this.gng().mm2(indent + 2 | 0);
  }
}
class TagDefineButtonCxform extends _BaseDefinitionTag {
  constructor() {
    super(23, 'DefineButtonCxform', 2);
  }
  pnq() {
    var tmp = this.onq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('buttonColorTransform');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.onq_1 = data.pms();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', ColorTransform: ' + this.pnq().toString();
  }
}
class TagProtect extends _BaseTag {
  constructor() {
    super(24, 'Protect', 2);
    this.unq_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    if (length > 0) {
      this.unq_1 = toFlash(data.h1r(length));
    }
  }
}
class TagPathsArePostScript extends _BaseTag {
  constructor() {
    super(25, 'PathsArePostScript', 2);
  }
}
class TagDefineShape3 extends TagDefineShape2 {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 32 : type;
    name = name === VOID ? 'DefineShape3' : name;
    version = version === VOID ? 3 : version;
    level = level === VOID ? 3 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Bounds: ' + this.fng().toString() + this.gng().mm2(indent + 2 | 0);
  }
}
class TagDefineText2 extends TagDefineText {
  constructor() {
    super(33, 'DefineText2', 3, 2);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineText2.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Bounds: ' + this.ann().toString() + ', Matrix: ' + this.bnn().toString());
    if (this.znm_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'TextRecords:');
      var inductionVariable = 0;
      var last = this.znm_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + toString(this.znm_1.i1(i)));
        }
         while (inductionVariable < last);
    }
    return this_0.toString();
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.knr_1 = function_0;
  }
  rj(a, b) {
    return this.knr_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class TagDefineButton2 extends _BaseDefinitionTag {
  constructor() {
    super(34, 'DefineButton2', 3, 2);
    this.qnr_1 = false;
    this.rnr_1 = ArrayList.m1();
    this.snr_1 = ArrayList.m1();
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.tnr_1 = HashMap.c9();
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.qnr_1 = !((data.bmg() & 1) === 0);
    var actionOffset = data.pmf();
    var record;
    $l$loop: while (true) {
      record = data.smw(2);
      if (record == null)
        break $l$loop;
      this.rnr_1.f(record);
    }
    if (!(actionOffset === 0)) {
      var condActionSize = 0;
      do {
        condActionSize = data.pmf();
        this.snr_1.f(data.gmx());
      }
       while (!(condActionSize === 0));
    }
    this.inm();
  }
  inm() {
    var upState = ArrayList.m1();
    var overState = ArrayList.m1();
    var downState = ArrayList.m1();
    var hitState = ArrayList.m1();
    var inductionVariable = 0;
    var last = this.rnr_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var record = this.rnr_1.i1(i);
        if (record.ymw_1) {
          upState.f(record);
        }
        if (record.xmw_1) {
          overState.f(record);
        }
        if (record.wmw_1) {
          downState.f(record);
        }
        if (record.vmw_1) {
          hitState.f(record);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.tnr_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = TagDefineButton2$processRecords$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_0(tmp);
    var tmp$ret$1 = sortedWith(upState, tmp$ret$0);
    var value = ArrayList.v(tmp$ret$1);
    this_0.r3('up', value);
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.tnr_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = TagDefineButton2$processRecords$lambda_0;
    var tmp$ret$2 = new sam$kotlin_Comparator$0_0(tmp_0);
    var tmp$ret$3 = sortedWith(overState, tmp$ret$2);
    var value_0 = ArrayList.v(tmp$ret$3);
    this_1.r3('over', value_0);
    // Inline function 'kotlin.collections.set' call
    var this_2 = this.tnr_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = TagDefineButton2$processRecords$lambda_1;
    var tmp$ret$4 = new sam$kotlin_Comparator$0_0(tmp_1);
    var tmp$ret$5 = sortedWith(downState, tmp$ret$4);
    var value_1 = ArrayList.v(tmp$ret$5);
    this_2.r3('down', value_1);
    // Inline function 'kotlin.collections.set' call
    var this_3 = this.tnr_1;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = TagDefineButton2$processRecords$lambda_2;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_2);
    var tmp$ret$7 = sortedWith(hitState, tmp$ret$6);
    var value_2 = ArrayList.v(tmp$ret$7);
    this_3.r3('hit', value_2);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', TrackAsMenu: ' + this.qnr_1);
    if (this.rnr_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Characters:');
      var inductionVariable = 0;
      var last = this.rnr_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.rnr_1.i1(i).mm2(indent + 4 | 0));
        }
         while (inductionVariable < last);
    }
    if (this.snr_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'CondActions:');
      var inductionVariable_0 = 0;
      var last_0 = this.snr_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i_0 + '] ' + this.snr_1.i1(i_0).pmn(indent + 4 | 0, flags));
        }
         while (inductionVariable_0 < last_0);
    }
    return this_0.toString();
  }
}
class TagDefineBitsJPEG3 extends TagDefineBitsJPEG2 {
  constructor(type, name, version, level) {
    type = type === VOID ? 35 : type;
    name = name === VOID ? 'DefineBitsJPEG3' : name;
    version = version === VOID ? 3 : version;
    level = level === VOID ? 0 : level;
    super(type, name, version, level);
    this.bns_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    var alphaDataOffset = data.jmn();
    this.snl_1 = toFlash(data.h1r(alphaDataOffset));
    this.bnq();
    var alphaDataSize = (length - alphaDataOffset | 0) - 6 | 0;
    if (alphaDataSize > 0) {
      this.bns_1 = toFlash(data.h1r(alphaDataSize));
    }
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Type: ' + BitmapType_instance.mm2(this.rnl_1) + ', HasAlphaData: ' + (this.bns_1.a() > 0) + ', ' + (this.bns_1.a() > 0 ? 'BitmapAlphaLength: ' + this.bns_1.a() + ', ' : '') + 'BitmapLength: ' + this.snl_1.a();
  }
}
class TagDefineBitsLossless2 extends TagDefineBitsLossless {
  constructor() {
    super(36, 'DefineBitsLossless2', 3, 2);
    this.nns_1 = true;
  }
  qnp() {
    return this.nns_1;
  }
}
class TagDefineEditText extends _BaseDefinitionTag {
  constructor() {
    super(37, 'DefineEditText', 4);
    this.uns_1 = null;
    this.vns_1 = false;
    this.wns_1 = false;
    this.xns_1 = false;
    this.yns_1 = false;
    this.zns_1 = false;
    this.ant_1 = false;
    this.bnt_1 = false;
    this.cnt_1 = false;
    this.dnt_1 = false;
    this.ent_1 = false;
    this.fnt_1 = false;
    this.gnt_1 = false;
    this.hnt_1 = false;
    this.int_1 = false;
    this.jnt_1 = false;
    this.knt_1 = false;
    this.lnt_1 = 0;
    this.mnt_1 = null;
    this.nnt_1 = 0;
    this.ont_1 = 0;
    this.pnt_1 = 0;
    this.qnt_1 = 0;
    this.rnt_1 = 0;
    this.snt_1 = 0;
    this.tnt_1 = 0;
    this.unt_1 = 0;
    this.vnt_1 = null;
  }
  f6c() {
    var tmp = this.tns_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('bounds');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.tns_1 = data.lmn();
    var flags1 = data.bmg();
    this.vns_1 = !((flags1 & 128) === 0);
    this.wns_1 = !((flags1 & 64) === 0);
    this.xns_1 = !((flags1 & 32) === 0);
    this.yns_1 = !((flags1 & 16) === 0);
    this.zns_1 = !((flags1 & 8) === 0);
    this.ant_1 = !((flags1 & 4) === 0);
    this.bnt_1 = !((flags1 & 2) === 0);
    this.cnt_1 = !((flags1 & 1) === 0);
    var flags2 = data.bmg();
    this.dnt_1 = !((flags2 & 128) === 0);
    this.ent_1 = !((flags2 & 64) === 0);
    this.fnt_1 = !((flags2 & 32) === 0);
    this.gnt_1 = !((flags2 & 16) === 0);
    this.hnt_1 = !((flags2 & 8) === 0);
    this.int_1 = !((flags2 & 4) === 0);
    this.jnt_1 = !((flags2 & 2) === 0);
    this.knt_1 = !((flags2 & 1) === 0);
    if (this.cnt_1)
      this.lnt_1 = data.pmf();
    if (this.dnt_1)
      this.mnt_1 = data.dm0();
    if (this.cnt_1 || this.dnt_1)
      this.nnt_1 = data.pmf();
    if (this.ant_1)
      this.ont_1 = data.ems();
    if (this.bnt_1)
      this.pnt_1 = data.pmf();
    if (this.fnt_1) {
      this.qnt_1 = data.bmg();
      this.rnt_1 = data.pmf();
      this.snt_1 = data.pmf();
      this.tnt_1 = data.pmf();
      this.unt_1 = data.omj();
    }
    this.uns_1 = data.dm0();
    if (this.vns_1) {
      this.vnt_1 = data.dm0();
    }
  }
  pmn(indent, flags) {
    var tmp = Companion_instance_30.xnf(this.b2n(), this.w3(), indent);
    var tmp_0 = this.vmo();
    var tmp_1;
    var tmp_2;
    if (this.vns_1) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = ensureNotNull(this.vnt_1);
      tmp_2 = charSequenceLength(this_0) > 0;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = 'Text: ' + this.vnt_1 + ', ';
    } else {
      tmp_1 = '';
    }
    var tmp_3 = tmp_1;
    var tmp_4;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_1 = ensureNotNull(this.uns_1);
    if (charSequenceLength(this_1) > 0) {
      tmp_4 = 'VariableName: ' + this.uns_1 + ', ';
    } else {
      tmp_4 = '';
    }
    return tmp + 'ID: ' + tmp_0 + ', ' + tmp_3 + tmp_4 + 'Bounds: ' + this.f6c().toString();
  }
}
class TagDefineSprite extends SWFTimelineContainer {
  constructor() {
    super();
    this.onu_1 = new _BaseDefinitionTag(39, 'DefineSprite', 3);
    this.pnu_1 = 0;
  }
  qnf(_set____db54di) {
    this.onu_1.qnf(_set____db54di);
  }
  vmo() {
    return this.onu_1.vmo();
  }
  b2n() {
    return this.onu_1.b2n();
  }
  w3() {
    return this.onu_1.w3();
  }
  lmo(data, length, version, async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5_1(this, data, length, version, async, $completion), $completion);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', FrameCount: ' + this.pnu_1 + super.pmn(indent, flags);
  }
}
class TagNameCharacter extends _BaseTag {
  constructor() {
    super(40, 'NameCharacter', 3);
    this.unu_1 = 0;
    this.vnu_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    this.unu_1 = data.pmf();
    if (length > 2) {
      this.vnu_1 = toFlash(data.h1r(length - 2 | 0));
    }
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagNameCharacter.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.unu_1);
    if (this.vnu_1.a() > 0) {
      this.vnu_1.p1q(0);
      this_0.ic(', Name: ' + this.vnu_1.an4(this.vnu_1.a() - 1 | 0));
      this.vnu_1.p1q(0);
    }
    return this_0.toString();
  }
}
class TagProductInfo extends _BaseTag {
  constructor() {
    super(41, 'ProductInfo', 3);
    this.anv_1 = 0;
    this.bnv_1 = 0;
    this.cnv_1 = 0;
    this.dnv_1 = 0;
    this.env_1 = new Long(0, 0);
    this.fnv_1 = Companion_getInstance_0().c1w_1;
  }
  lmo(data, length, version, async, $completion) {
    this.anv_1 = data.jmn();
    this.bnv_1 = data.jmn();
    this.cnv_1 = data.bmg();
    this.dnv_1 = data.bmg();
    this.env_1 = toLong(data.jmn()).c4(toLong(data.jmn())).k4(32);
    var sec = toLong(data.jmn()).c4(toLong(data.jmn())).k4(32);
    this.fnv_1 = Companion_getInstance_0().e1w(sec);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ProductID: ' + this.anv_1 + ', Edition: ' + this.bnv_1 + ', Version: ' + this.cnv_1 + '.' + this.dnv_1 + ' r' + this.env_1.toString() + ', CompileDate: ' + DateTime__toString_impl_cnueje(this.fnv_1);
  }
}
class TagDefineFont2 extends TagDefineFont {
  constructor(type, name, version, level, characterId) {
    type = type === VOID ? 48 : type;
    name = name === VOID ? 'DefineFont2' : name;
    version = version === VOID ? 3 : version;
    level = level === VOID ? 2 : level;
    characterId = characterId === VOID ? 0 : characterId;
    super(type, name, version, level, characterId);
    this.nnv_1 = false;
    this.onv_1 = false;
    this.pnv_1 = false;
    this.qnv_1 = false;
    this.rnv_1 = false;
    this.snv_1 = false;
    this.tnv_1 = false;
    this.unv_1 = false;
    this.vnv_1 = 0;
    this.xnv_1 = 0;
    this.ynv_1 = 0;
    this.znv_1 = 0;
    this.anw_1 = ArrayList.m1();
    this.bnw_1 = ArrayList.m1();
    this.cnw_1 = ArrayList.m1();
    this.dnw_1 = ArrayList.m1();
  }
  ynn() {
    var tmp = this.wnv_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontName');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    var flags = data.bmg();
    this.nnv_1 = !((flags & 128) === 0);
    this.onv_1 = !((flags & 64) === 0);
    this.pnv_1 = !((flags & 32) === 0);
    this.qnv_1 = !((flags & 16) === 0);
    this.rnv_1 = !((flags & 8) === 0);
    this.snv_1 = !((flags & 4) === 0);
    this.tnv_1 = !((flags & 2) === 0);
    this.unv_1 = !((flags & 1) === 0);
    this.vnv_1 = data.cms();
    var fontNameLen = data.bmg();
    this.wnv_1 = data.an4(fontNameLen);
    var numGlyphs = data.pmf();
    if (numGlyphs > 0) {
      data.cml(numGlyphs << (this.rnv_1 ? 2 : 1));
      var codeTableOffset = this.rnv_1 ? data.jmn() : data.pmf();
      var inductionVariable = 0;
      if (inductionVariable < numGlyphs)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.onm_1.f(data.zmt());
        }
         while (inductionVariable < numGlyphs);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < numGlyphs)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.anw_1.f(this.snv_1 ? data.pmf() : data.bmg());
        }
         while (inductionVariable_0 < numGlyphs);
    }
    if (this.nnv_1) {
      this.xnv_1 = data.pmf();
      this.ynv_1 = data.pmf();
      this.znv_1 = data.omj();
      var inductionVariable_1 = 0;
      if (inductionVariable_1 < numGlyphs)
        do {
          var i_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          this.bnw_1.f(data.omj());
        }
         while (inductionVariable_1 < numGlyphs);
      var inductionVariable_2 = 0;
      if (inductionVariable_2 < numGlyphs)
        do {
          var i_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          this.cnw_1.f(data.lmn());
        }
         while (inductionVariable_2 < numGlyphs);
      var kerningCount = data.pmf();
      var inductionVariable_3 = 0;
      if (inductionVariable_3 < kerningCount)
        do {
          var i_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          this.dnw_1.f(data.vmy(this.snv_1));
        }
         while (inductionVariable_3 < kerningCount);
    }
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', FontName: ' + this.ynn() + ', Italic: ' + this.tnv_1 + ', Bold: ' + this.unv_1 + ', Glyphs: ' + this.onm_1.j1() + this.rnm(indent);
  }
  rnm(indent) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineFont2.toStringCommon.<anonymous>' call
    this_0.ic(super.rnm(indent));
    if (this.nnv_1) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Ascent: ' + this.xnv_1);
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Descent: ' + this.ynv_1);
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Leading: ' + this.znv_1);
    }
    if (this.anw_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'CodeTable:');
      var inductionVariable = 0;
      var last = this.anw_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic((i & 15) === 0 ? '\n' + repeat(' ', indent + 4 | 0) + this.anw_1.i1(i) : ', ' + this.anw_1.i1(i));
        }
         while (inductionVariable < last);
    }
    if (this.bnw_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'FontAdvanceTable:');
      var inductionVariable_0 = 0;
      var last_0 = this.bnw_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_0.ic((i_0 & 7) === 0 ? '\n' + repeat(' ', indent + 4 | 0) + this.bnw_1.i1(i_0) : ', ' + this.bnw_1.i1(i_0));
        }
         while (inductionVariable_0 < last_0);
    }
    if (this.cnw_1.j1() > 0) {
      var hasNonNullBounds = false;
      var inductionVariable_1 = 0;
      var last_1 = this.cnw_1.j1();
      if (inductionVariable_1 < last_1)
        $l$loop: do {
          var i_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var rect = this.cnw_1.i1(i_1);
          if (!(rect.qmn_1 === 0) || !(rect.rmn_1 === 0) || !(rect.smn_1 === 0) || !(rect.tmn_1 === 0)) {
            hasNonNullBounds = true;
            break $l$loop;
          }
        }
         while (inductionVariable_1 < last_1);
      if (hasNonNullBounds) {
        this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'FontBoundsTable:');
        var inductionVariable_2 = 0;
        var last_2 = this.cnw_1.j1();
        if (inductionVariable_2 < last_2)
          do {
            var i_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i_2 + '] ' + this.cnw_1.i1(i_2).toString());
          }
           while (inductionVariable_2 < last_2);
      }
    }
    if (this.dnw_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'KerningTable:');
      var inductionVariable_3 = 0;
      var last_3 = this.dnw_1.j1();
      if (inductionVariable_3 < last_3)
        do {
          var i_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i_3 + '] ' + toString(this.dnw_1.i1(i_3)));
        }
         while (inductionVariable_3 < last_3);
    }
    return this_0.toString();
  }
}
class TagImportExportAssets extends _BaseTag {
  constructor(type, name, version, level) {
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.inw_1 = type;
    this.jnw_1 = name;
    this.knw_1 = version;
    this.lnw_1 = level;
    this.mnw_1 = ArrayList.m1();
  }
  b2n() {
    return this.inw_1;
  }
  w3() {
    return this.jnw_1;
  }
  lmo(data, length, version, async, $completion) {
    var numSymbols = data.pmf();
    var inductionVariable = 0;
    if (inductionVariable < numSymbols)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.mnw_1.f(data.zn1());
      }
       while (inductionVariable < numSymbols);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagImportExportAssets.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent));
    if (this.mnw_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Assets:');
      var inductionVariable = 0;
      var last = this.mnw_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.mnw_1.i1(i).toString());
        }
         while (inductionVariable < last);
    }
    return this_0.toString();
  }
}
class TagExportAssets extends TagImportExportAssets {
  constructor() {
    super(56, 'ExportAssets', 5);
  }
}
class TagImportAssets extends TagImportExportAssets {
  constructor(type, name, version, level) {
    type = type === VOID ? 57 : type;
    name = name === VOID ? 'ImportAssets' : name;
    version = version === VOID ? 5 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
  }
  lmo(data, length, version, async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5_2(this, data, length, version, async, $completion), $completion);
  }
}
class TagEnableDebugger extends _BaseTag {
  constructor(type, name, version, level) {
    type = type === VOID ? 58 : type;
    name = name === VOID ? 'EnableDebugger' : name;
    version = version === VOID ? 5 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
    this.bnx_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    if (length > 0)
      this.bnx_1 = FlashByteArray.tnl(data.h1r(length));
  }
}
class TagDoInitAction extends TagDoAction {
  constructor() {
    super(59, 'DoInitAction', 6);
    this.inx_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.inx_1 = data.pmf();
    $l$loop: while (true) {
      var tmp = this.gnn_1;
      var tmp0_elvis_lhs = data.ymh();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp.f(tmp_0);
    }
    this.hnn_1 = Companion_instance_6.am2(this.gnn_1);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'SpriteID: ' + this.inx_1 + ', Records: ' + this.gnn_1.j1() + this.inn(indent, flags);
  }
}
class TagDefineVideoStream extends _BaseDefinitionTag {
  constructor() {
    super(60, 'DefineVideoStream', 6);
    this.onx_1 = 0;
    this.pnx_1 = 0;
    this.qnx_1 = 0;
    this.rnx_1 = 0;
    this.snx_1 = false;
    this.tnx_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.onx_1 = data.pmf();
    this.pnx_1 = data.pmf();
    this.qnx_1 = data.pmf();
    data.xmj(4);
    this.rnx_1 = data.xmj(3);
    this.snx_1 = data.xmj(1) === 1;
    this.tnx_1 = data.bmg();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Frames: ' + this.onx_1 + ', Width: ' + this.pnx_1 + ', Height: ' + this.qnx_1 + ', Deblocking: ' + VideoDeblockingType_instance.mm2(this.rnx_1) + ', Smoothing: ' + this.snx_1 + ', Codec: ' + VideoCodecID_instance.mm2(this.tnx_1);
  }
}
class TagVideoFrame extends _BaseTag {
  constructor() {
    super(61, 'VideoFrame', 6, 1);
    this.ynx_1 = 0;
    this.znx_1 = 0;
    this.any_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    this.ynx_1 = data.pmf();
    this.znx_1 = data.pmf();
    this.any_1 = toFlash(data.h1r(length - 4 | 0));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'StreamID: ' + this.ynx_1 + ', Frame: ' + this.znx_1;
  }
}
class TagDefineFontInfo2 extends TagDefineFontInfo {
  constructor() {
    super(62, 'DefineFontInfo2', 6, 2);
  }
  znn(data) {
    this.vnn_1 = data.bmg();
    this.xnn_1 = 1;
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'FontID: ' + this.nnn_1 + ', FontName: ' + this.ynn() + ', Italic: ' + this.snn_1 + ', Bold: ' + this.tnn_1 + ', LanguageCode: ' + this.vnn_1 + ', Codes: ' + this.wnn_1.j1();
  }
}
class TagDebugID extends _BaseTag {
  constructor() {
    super(63, 'DebugID', 6, 1);
    this.uny_1 = new Int8Array(0);
  }
  lmo(data, length, version, async, $completion) {
    if (length > 0)
      this.uny_1 = readBytes(data.wmh_1, length);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDebugID.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'UUID: ');
    if (this.uny_1.length === 16) {
      this_0.ic(format('%02x%02x%02x%02x-', [this.uny_1[0], this.uny_1[1], this.uny_1[2], this.uny_1[3]]));
      this_0.ic(format('%02x%02x-', [this.uny_1[4], this.uny_1[5]]));
      this_0.ic(format('%02x%02x-', [this.uny_1[6], this.uny_1[7]]));
      this_0.ic(format('%02x%02x-', [this.uny_1[8], this.uny_1[9]]));
      this_0.ic(format('%02x%02x%02x%02x%02x%02x', [this.uny_1[10], this.uny_1[11], this.uny_1[12], this.uny_1[13], this.uny_1[14], this.uny_1[15]]));
    } else {
      this_0.ic('(invalid length: ' + this.uny_1.length + ')');
    }
    return this_0.toString();
  }
}
class TagEnableDebugger2 extends TagEnableDebugger {
  constructor() {
    super(64, 'EnableDebugger2', 6, 2);
    this.anz_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.anz_1 = data.pmf();
    if (length > 2)
      this.bnx_1 = toFlash(data.h1r(length - 2 | 0));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Password: ' + (this.bnx_1.a() === 0 ? 'null' : this.bnx_1.fn4()) + ', Reserved: 0x' + toString_1(this.anz_1, 16);
  }
}
class TagScriptLimits extends _BaseTag {
  constructor() {
    super(65, 'ScriptLimits', 7, 1);
    this.fnz_1 = 0;
    this.gnz_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.fnz_1 = data.pmf();
    this.gnz_1 = data.pmf();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'MaxRecursionDepth: ' + this.fnz_1 + ', ScriptTimeoutSeconds: ' + this.gnz_1;
  }
}
class TagSetTabIndex extends _BaseTag {
  constructor() {
    super(66, 'SetTabIndex', 7);
    this.lnz_1 = 0;
    this.mnz_1 = 0;
  }
  lmo(data, length, version, async, $completion) {
    this.lnz_1 = data.pmf();
    this.mnz_1 = data.pmf();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Depth: ' + this.lnz_1 + ', TabIndex: ' + this.mnz_1;
  }
}
class TagFileAttributes extends _BaseTag {
  constructor() {
    super(69, 'FileAttributes', 8);
    this.rnz_1 = false;
    this.snz_1 = false;
    this.tnz_1 = false;
    this.unz_1 = true;
    this.vnz_1 = false;
  }
  lmo(data, length, version, async, $completion) {
    var flags = data.bmg();
    this.rnz_1 = !((flags & 64) === 0);
    this.snz_1 = !((flags & 32) === 0);
    this.tnz_1 = !((flags & 16) === 0);
    this.unz_1 = !((flags & 8) === 0);
    this.vnz_1 = !((flags & 1) === 0);
    data.cml(3);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'AS3: ' + this.unz_1 + ', HasMetadata: ' + this.tnz_1 + ', UseDirectBlit: ' + this.rnz_1 + ', UseGPU: ' + this.snz_1 + ', UseNetwork: ' + this.vnz_1;
  }
  toString() {
    return this.pmn(0, 0);
  }
}
class TagImportAssets2 extends TagImportAssets {
  constructor() {
    super(71, 'ImportAssets2', 8, 2);
  }
  lmo(data, length, version, async, $completion) {
    this.wnw_1 = data.dm0();
    data.bmg();
    data.bmg();
    var numSymbols = data.pmf();
    var inductionVariable = 0;
    if (inductionVariable < numSymbols)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.mnw_1.f(data.zn1());
      }
       while (inductionVariable < numSymbols);
  }
}
class Companion_28 {}
class TagDoABCDeprecated extends _BaseTag {
  constructor() {
    super(72, 'DoABCDeprecated', 9);
    this.ko0_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    var pos = data.q1q();
    this.ko0_1 = FlashByteArray.tnl(data.h1r(length - (data.q1q() - pos | 0) | 0));
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'Length: ' + this.ko0_1.a();
  }
}
class TagDefineFontAlignZones extends _BaseTag {
  constructor() {
    super(73, 'DefineFontAlignZones', 8);
    this.po0_1 = 0;
    this.qo0_1 = 0;
    this.ro0_1 = ArrayList.m1();
  }
  lmo(data, length, version, async, $completion) {
    this.po0_1 = data.pmf();
    this.qo0_1 = data.bmg() >>> 6 | 0;
    var recordsEndPos = (data.q1q() + length | 0) - 3 | 0;
    while (data.q1q() < recordsEndPos) {
      this.ro0_1.f(data.nmy());
    }
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineFontAlignZones.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'FontID: ' + this.po0_1 + ', CSMTableHint: ' + CSMTableHint_instance.mm2(this.qo0_1) + ', Records: ' + this.ro0_1.j1());
    var inductionVariable = 0;
    var last = this.ro0_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.ic('\n' + repeat(' ', indent + 2 | 0) + '[' + i + '] ' + toString(this.ro0_1.i1(i)));
      }
       while (inductionVariable < last);
    return this_0.toString();
  }
}
class TagCSMTextSettings extends _BaseTag {
  constructor() {
    super(74, 'CSMTextSettings', 8, 1);
    this.wo0_1 = 0;
    this.xo0_1 = 0;
    this.yo0_1 = 0;
    this.zo0_1 = 0.0;
    this.ao1_1 = 0.0;
  }
  lmo(data, length, version, async, $completion) {
    this.wo0_1 = data.pmf();
    this.xo0_1 = data.xmj(2);
    this.yo0_1 = data.xmj(3);
    data.xmj(3);
    this.zo0_1 = data.umr();
    this.ao1_1 = data.umr();
    data.bmg();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'TextID: ' + this.wo0_1 + ', UseFlashType: ' + this.xo0_1 + ', GridFit: ' + this.yo0_1 + ', Thickness: ' + this.zo0_1 + ', Sharpness: ' + this.ao1_1;
  }
}
class TagDefineFont3 extends TagDefineFont2 {
  constructor() {
    super(75, 'DefineFont3', 8, 2);
    this.zo1_1 = 20.0;
  }
  qnm() {
    return this.zo1_1;
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', FontName: ' + this.ynn() + ', Italic: ' + this.tnv_1 + ', Bold: ' + this.unv_1 + ', Glyphs: ' + this.onm_1.j1() + this.rnm(indent);
  }
}
class TagSymbolClass extends _BaseTag {
  constructor() {
    super(76, 'SymbolClass', 9, 1);
    this.eo2_1 = ArrayList.m1();
  }
  lmo(data, length, version, async, $completion) {
    var inductionVariable = 0;
    var last = data.pmf();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.eo2_1.f(data.zn1());
      }
       while (inductionVariable < last);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagSymbolClass.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent));
    if (this.eo2_1.j1() > 0) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'Symbols:');
      var inductionVariable = 0;
      var last = this.eo2_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + repeat(' ', indent + 4 | 0) + '[' + i + '] ' + this.eo2_1.i1(i).toString());
        }
         while (inductionVariable < last);
    }
    return this_0.toString();
  }
}
class TagMetadata extends _BaseTag {
  constructor() {
    super(77, 'Metadata', 1);
  }
  ko2() {
    var tmp = this.jo2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('xmlString');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.jo2_1 = data.dm0();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + ' ' + this.ko2();
  }
}
class TagDefineScalingGrid extends _BaseDefinitionTag {
  constructor() {
    super(78, 'DefineScalingGrid', 8, 1);
  }
  ro2() {
    var tmp = this.qo2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('splitter');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.qo2_1 = data.lmn();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'CharacterID: ' + this.vmo() + ', Splitter: ' + this.ro2().toString();
  }
}
class Companion_29 {}
class TagDoABC extends _BaseTag {
  constructor() {
    super(82, 'DoABC', 9);
    this.wo2_1 = false;
    this.xo2_1 = '';
    this.yo2_1 = FlashByteArray.emr();
    this.zo2_1 = null;
  }
  ao3() {
    if (this.zo2_1 == null) {
      this.zo2_1 = new ABC();
      var tmp60_safe_receiver = this.zo2_1;
      if (tmp60_safe_receiver == null)
        null;
      else
        tmp60_safe_receiver.ulz(openSync(this.yo2_1.hn4()));
    }
    return ensureNotNull(this.zo2_1);
  }
  lmo(data, length, version, async, $completion) {
    var pos = data.q1q();
    var flags = data.jmn();
    this.wo2_1 = !((flags & 1) === 0);
    this.xo2_1 = data.dm0();
    this.yo2_1 = toFlash(data.h1r(length - (data.q1q() - pos | 0) | 0));
    this.zo2_1 = null;
  }
  pmn(indent, flags) {
    var tmp = Companion_instance_30.xnf(this.b2n(), this.w3(), indent);
    var tmp_0 = this.wo2_1;
    var tmp_1;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.xo2_1;
    if (charSequenceLength(this_0) > 0) {
      tmp_1 = 'Name: ' + this.xo2_1 + ', ';
    } else {
      tmp_1 = '';
    }
    return tmp + 'Lazy: ' + tmp_0 + ', ' + tmp_1 + 'Length: ' + this.yo2_1.a();
  }
}
class TagDefineShape4 extends TagDefineShape3 {
  constructor() {
    super(83, 'DefineShape4', 8, 4);
    this.jo3_1 = false;
    this.ko3_1 = false;
    this.lo3_1 = false;
  }
  mo3() {
    var tmp = this.io3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('edgeBounds');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.dng_1 = data.lmn();
    this.io3_1 = data.lmn();
    var flags = data.bmg();
    this.jo3_1 = !((flags & 4) === 0);
    this.ko3_1 = !((flags & 2) === 0);
    this.lo3_1 = !((flags & 1) === 0);
    this.eng_1 = data.qmu(this.s3g());
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineShape4.toString.<anonymous>' call
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', ');
    if (this.jo3_1) {
      this_0.ic('UsesFillWindingRule, ');
    }
    if (this.ko3_1) {
      this_0.ic('UsesNonScalingStrokes, ');
    }
    if (this.lo3_1) {
      this_0.ic('UsesScalingStrokes, ');
    }
    this_0.ic('ShapeBounds: ' + this.fng().toString() + ', EdgeBounds: ' + this.mo3().toString());
    this_0.ic(this.gng().mm2(indent + 2 | 0));
    return this_0.toString();
  }
}
class TagDefineMorphShape2 extends TagDefineMorphShape {
  constructor() {
    super(84, 'DefineMorphShape2', 8, 2);
    this.ao4_1 = false;
    this.bo4_1 = false;
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    this.zne_1 = data.lmn();
    this.anf_1 = data.lmn();
    this.dnf_1 = data.lmn();
    this.enf_1 = data.lmn();
    var flags = data.bmg();
    this.ao4_1 = !((flags & 2) === 0);
    this.bo4_1 = !((flags & 1) === 0);
    var offset = data.jmn();
    var fillStyleCount = data.bmg();
    if (fillStyleCount === 255) {
      fillStyleCount = data.pmf();
    }
    var inductionVariable = 0;
    var last = fillStyleCount;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.fnf_1.f(data.ymz());
      }
       while (inductionVariable < last);
    var lineStyleCount = data.bmg();
    if (lineStyleCount === 255) {
      lineStyleCount = data.pmf();
    }
    var inductionVariable_0 = 0;
    var last_0 = lineStyleCount;
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.gnf_1.f(data.en1());
      }
       while (inductionVariable_0 < last_0);
    this.bnf_1 = data.zmt();
    this.cnf_1 = data.zmt();
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagDefineMorphShape2.toString.<anonymous>' call
    var indent2 = repeat(' ', indent + 2 | 0);
    var indent4 = repeat(' ', indent + 4 | 0);
    this_0.ic(Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo());
    this_0.ic('\n' + indent2 + 'Bounds:');
    this_0.ic('\n' + indent4 + 'StartBounds: ' + this.hnf().toString());
    this_0.ic('\n' + indent4 + 'EndBounds: ' + this.inf().toString());
    this_0.ic('\n' + indent4 + 'StartEdgeBounds: ' + this.dnf_1.toString());
    this_0.ic('\n' + indent4 + 'EndEdgeBounds: ' + this.enf_1.toString());
    if (this.fnf_1.j1() > 0) {
      this_0.ic('\n' + indent2 + 'FillStyles:');
      var inductionVariable = 0;
      var last = this.fnf_1.j1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.ic('\n' + indent4 + '[' + (i + 1 | 0) + '] ' + this.fnf_1.i1(i).toString());
        }
         while (inductionVariable < last);
    }
    if (this.gnf_1.j1() > 0) {
      this_0.ic('\n' + indent2 + 'LineStyles:');
      var inductionVariable_0 = 0;
      var last_0 = this.gnf_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_0.ic('\n' + indent4 + '[' + (i_0 + 1 | 0) + '] ' + this.gnf_1.i1(i_0).toString());
        }
         while (inductionVariable_0 < last_0);
    }
    this_0.ic(this.jnf().mm2(indent + 2 | 0));
    this_0.ic(this.knf().mm2(indent + 2 | 0));
    return this_0.toString();
  }
}
class TagDefineBinaryData extends _BaseDefinitionTag {
  constructor() {
    super(87, 'DefineBinaryData', 9, 1);
    this.ho4_1 = new Int8Array(0);
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    data.jmn();
    if (length > 6)
      this.ho4_1 = data.h1r(length - 6 | 0);
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Length: ' + this.ho4_1.length;
  }
}
class TagDefineFontName extends _BaseTag {
  constructor() {
    super(88, 'DefineFontName', 9);
    this.mo4_1 = 0;
  }
  ynn() {
    var tmp = this.no4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontName');
    }
  }
  po4() {
    var tmp = this.oo4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontCopyright');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.mo4_1 = data.pmf();
    this.no4_1 = data.dm0();
    this.oo4_1 = data.dm0();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'FontID: ' + this.mo4_1 + ', Name: ' + this.ynn() + ', Copyright: ' + this.po4();
  }
}
class TagStartSound2 extends _BaseTag {
  constructor() {
    super(89, 'StartSound2', 9, 2);
  }
  wo4() {
    var tmp = this.uo4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('soundClassName');
    }
  }
  rno() {
    var tmp = this.vo4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('soundInfo');
    }
  }
  lmo(data, length, version, async, $completion) {
    this.uo4_1 = data.dm0();
    this.vo4_1 = data.dn2();
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'SoundClassName: ' + this.wo4() + ', SoundInfo: ' + this.rno().toString();
  }
}
class TagDefineBitsJPEG4 extends TagDefineBitsJPEG3 {
  constructor() {
    super(90, 'DefineBitsJPEG4', 10, 4);
    this.fo5_1 = 0.0;
  }
  lmo(data, length, version, async, $completion) {
    this.qnf(data.pmf());
    var alphaDataOffset = data.jmn();
    this.fo5_1 = data.mmn();
    this.snl_1 = toFlash(data.h1r(alphaDataOffset));
    this.bnq();
    var alphaDataSize = (length - alphaDataOffset | 0) - 6 | 0;
    if (alphaDataSize > 0) {
      this.bns_1 = toFlash(data.h1r(alphaDataSize));
    }
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', Type: ' + BitmapType_instance.mm2(this.rnl_1) + ', DeblockParam: ' + this.fo5_1 + ', HasAlphaData: ' + (this.bns_1.a() > 0) + ', ' + (this.bns_1.a() > 0 ? 'BitmapAlphaLength: ' + this.bns_1.a() + ', ' : '') + 'BitmapLength: ' + this.snl_1.a();
  }
}
class TagDefineFont4 extends _BaseDefinitionTag {
  constructor() {
    super(91, 'DefineFont4', 10);
    this.lo5_1 = false;
    this.mo5_1 = false;
    this.no5_1 = false;
    this.po5_1 = FlashByteArray.emr();
  }
  ynn() {
    var tmp = this.oo5_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontName');
    }
  }
  lmo(data, length, version, async, $completion) {
    var pos = data.q1q();
    this.qnf(data.pmf());
    var flags = data.bmg();
    this.lo5_1 = !((flags & 4) === 0);
    this.mo5_1 = !((flags & 2) === 0);
    this.no5_1 = !((flags & 1) === 0);
    this.oo5_1 = data.dm0();
    if (this.lo5_1 && length > (data.q1q() - pos | 0)) {
      this.po5_1 = toFlash(data.h1r(length - (data.q1q() - pos | 0) | 0));
    }
  }
  pmn(indent, flags) {
    return Companion_instance_30.xnf(this.b2n(), this.w3(), indent) + 'ID: ' + this.vmo() + ', FontName: ' + this.ynn() + ', HasFontData: ' + this.lo5_1 + ', Italic: ' + this.mo5_1 + ', Bold: ' + this.no5_1;
  }
}
class TagEnableTelemetry extends _BaseTag {
  constructor() {
    super(93, 'EnableTelemetry', 19);
    this.uo5_1 = FlashByteArray.emr();
  }
  lmo(data, length, version, async, $completion) {
    if (length > 2) {
      data.y12();
      data.y12();
      this.uo5_1 = toFlash(data.h1r(length - 2 | 0));
    }
  }
}
class TagPlaceObject4 extends TagPlaceObject3 {
  constructor() {
    super(94, 'PlaceObject4', 19, 4);
  }
  lmo(data, length, version, async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5_3(this, data, length, version, async, $completion), $completion);
  }
  pmn(indent, flags) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.TagPlaceObject4.toString.<anonymous>' call
    this_0.ic(super.pmn(indent, 0));
    if (!(this.fni_1 == null)) {
      this_0.ic('\n' + repeat(' ', indent + 2 | 0) + 'MetaData: yes');
    }
    return this_0.toString();
  }
}
class TagUnknown extends _BaseTag {
  constructor(type, name, version, level) {
    name = name === VOID ? '????' : name;
    version = version === VOID ? 0 : version;
    level = level === VOID ? 1 : level;
    super(type, name, version, level);
  }
  lmo(data, length, version, async, $completion) {
    data.cml(length);
    return Unit_instance;
  }
}
class TagSWFEncryptActions extends TagUnknown {
  constructor() {
    super(253, 'SWFEncryptActions');
  }
}
class TagSWFEncryptSignature extends TagUnknown {
  constructor() {
    super(255, 'SWFEncryptSignature');
  }
}
class Scene {
  constructor(frameNumber, name) {
    this.xmq_1 = frameNumber;
    this.ymq_1 = name;
  }
  mm2(indent) {
    return repeat(' ', indent) + 'Name: ' + this.ymq_1 + ', Frame: ' + this.xmq_1;
  }
}
class Frame {
  constructor(frameNumber, tagIndexStart) {
    frameNumber = frameNumber === VOID ? 0 : frameNumber;
    tagIndexStart = tagIndexStart === VOID ? 0 : tagIndexStart;
    this.wmo_1 = frameNumber;
    this.xmo_1 = tagIndexStart;
    this.ymo_1 = 0;
    this.zmo_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.amp_1 = HashMap.c9();
    this.bmp_1 = null;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.cmp_1 = ArrayList.m1();
  }
  ho7() {
    return (this.ymo_1 - this.xmo_1 | 0) + 1 | 0;
  }
  emp(tagIndex, tag) {
    var frameObject = this.amp_1.k3(tag.tnh_1);
    if (!(frameObject == null)) {
      if (tag.snh_1 === 0) {
        frameObject.mo7_1 = tagIndex;
        frameObject.no7_1 = false;
      } else {
        frameObject.mo7_1 = 0;
        frameObject.lo7_1 = tagIndex;
        frameObject.no7_1 = true;
        if (!(tag.snh_1 === frameObject.jo7_1)) {
          frameObject.jo7_1 = tag.snh_1;
        }
      }
    } else {
      // Inline function 'kotlin.collections.set' call
      var this_0 = this.amp_1;
      var key = tag.tnh_1;
      var value = new FrameObject(tag.tnh_1, tag.snh_1, tag.ani_1, tagIndex, 0, true);
      this_0.r3(key, value);
    }
    this.bmp_1 = null;
  }
  dmp(tag) {
    this.amp_1.s3(tag.fnl_1);
    this.bmp_1 = null;
  }
  j13() {
    var frame = new Frame();
    var _iterator__ex2g4s = this.amp_1.l3().f1();
    while (_iterator__ex2g4s.g1()) {
      var depth = _iterator__ex2g4s.h1();
      // Inline function 'kotlin.collections.set' call
      var this_0 = frame.amp_1;
      var tmp = this.amp_1.k3(depth);
      var value = (tmp instanceof FrameObject ? tmp : THROW_CCE()).po7();
      this_0.r3(depth, value);
    }
    return frame;
  }
  mm2(indent) {
    var str = repeat(' ', indent) + '[' + this.wmo_1 + '] ' + 'Start: ' + this.xmo_1 + ', ' + 'Length: ' + this.ho7();
    if (!(this.zmo_1 == null) && !(this.zmo_1 === '')) {
      str = str + (', Label: ' + this.zmo_1);
    }
    if (this.cmp_1.j1() > 0) {
      str = str + ('\n' + repeat(' ', indent + 2 | 0) + 'Defined CharacterIDs: ' + joinToString(this.cmp_1, ', '));
    }
    var _iterator__ex2g4s = this.amp_1.l3().f1();
    while (_iterator__ex2g4s.g1()) {
      var depth = _iterator__ex2g4s.h1();
      var tmp = str;
      var tmp_0 = this.amp_1.k3(depth);
      str = tmp + (tmp_0 instanceof FrameObject ? tmp_0 : THROW_CCE()).mm2(indent);
    }
    return str;
  }
}
class SoundStream {
  constructor() {
    this.nmo_1 = 0;
    this.omo_1 = 0;
    this.pmo_1 = 0;
    this.qmo_1 = 0;
    this.rmo_1 = 0;
    this.smo_1 = 0;
    this.tmo_1 = 0;
    this.umo_1 = FlashByteArray.emr();
  }
  toString() {
    return '[SoundStream] StartFrame: ' + this.nmo_1 + ', Frames: ' + this.omo_1 + ', Samples: ' + this.pmo_1 + ', Bytes: ' + this.umo_1.a();
  }
}
class FrameObject {
  constructor(depth, characterId, className, placedAtIndex, lastModifiedAtIndex, isKeyframe) {
    lastModifiedAtIndex = lastModifiedAtIndex === VOID ? 0 : lastModifiedAtIndex;
    isKeyframe = isKeyframe === VOID ? false : isKeyframe;
    this.io7_1 = depth;
    this.jo7_1 = characterId;
    this.ko7_1 = className;
    this.lo7_1 = placedAtIndex;
    this.mo7_1 = lastModifiedAtIndex;
    this.no7_1 = isKeyframe;
    this.oo7_1 = -1;
  }
  mm2(indent) {
    var str = '\n' + repeat(' ', indent + 2 | 0) + 'Depth: ' + this.io7_1 + (this.oo7_1 > -1 ? ' (Layer ' + this.oo7_1 + ')' : '') + ', ' + 'CharacterId: ' + this.jo7_1 + ', ';
    if (!(this.ko7_1 == null)) {
      str = str + ('ClassName: ' + this.ko7_1 + ', ');
    }
    str = str + ('PlacedAt: ' + this.lo7_1);
    if (!(this.mo7_1 === 0)) {
      str = str + (', LastModifiedAt: ' + this.mo7_1);
    }
    if (this.no7_1) {
      str = str + ', IsKeyframe';
    }
    return str;
  }
  qo7(depth, characterId, className, placedAtIndex, lastModifiedAtIndex, isKeyframe) {
    return new FrameObject(depth, characterId, className, placedAtIndex, lastModifiedAtIndex, isKeyframe);
  }
  po7(depth, characterId, className, placedAtIndex, lastModifiedAtIndex, isKeyframe, $super) {
    depth = depth === VOID ? this.io7_1 : depth;
    characterId = characterId === VOID ? this.jo7_1 : characterId;
    className = className === VOID ? this.ko7_1 : className;
    placedAtIndex = placedAtIndex === VOID ? this.lo7_1 : placedAtIndex;
    lastModifiedAtIndex = lastModifiedAtIndex === VOID ? this.mo7_1 : lastModifiedAtIndex;
    isKeyframe = isKeyframe === VOID ? this.no7_1 : isKeyframe;
    return $super === VOID ? this.qo7(depth, characterId, className, placedAtIndex, lastModifiedAtIndex, isKeyframe) : $super.qo7.call(this, depth, characterId, className, placedAtIndex, lastModifiedAtIndex, isKeyframe);
  }
  toString() {
    return 'FrameObject(depth=' + this.io7_1 + ', characterId=' + this.jo7_1 + ', className=' + this.ko7_1 + ', placedAtIndex=' + this.lo7_1 + ', lastModifiedAtIndex=' + this.mo7_1 + ', isKeyframe=' + this.no7_1 + ')';
  }
  hashCode() {
    var result = this.io7_1;
    result = imul(result, 31) + this.jo7_1 | 0;
    result = imul(result, 31) + (this.ko7_1 == null ? 0 : getStringHashCode(this.ko7_1)) | 0;
    result = imul(result, 31) + this.lo7_1 | 0;
    result = imul(result, 31) + this.mo7_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.no7_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FrameObject))
      return false;
    var tmp0_other_with_cast = other instanceof FrameObject ? other : THROW_CCE();
    if (!(this.io7_1 === tmp0_other_with_cast.io7_1))
      return false;
    if (!(this.jo7_1 === tmp0_other_with_cast.jo7_1))
      return false;
    if (!(this.ko7_1 == tmp0_other_with_cast.ko7_1))
      return false;
    if (!(this.lo7_1 === tmp0_other_with_cast.lo7_1))
      return false;
    if (!(this.mo7_1 === tmp0_other_with_cast.mo7_1))
      return false;
    if (!(this.no7_1 === tmp0_other_with_cast.no7_1))
      return false;
    return true;
  }
}
class Endian extends Enum {}
class ColorUtils {
  bn9(color) {
    return (color >>> 24 | 0) / 255;
  }
  an9(color) {
    return color & 16777215;
  }
  ro7(color) {
    return ((this.an9(color) >>> 16 | 0) & 255) / 255;
  }
  so7(color) {
    return ((this.an9(color) >>> 8 | 0) & 255) / 255;
  }
  to7(color) {
    return ((this.an9(color) >>> 0 | 0) & 255) / 255;
  }
  tna(color1, color2, ratio) {
    var r1 = this.ro7(color1);
    var g1 = this.so7(color1);
    var b1 = this.to7(color1);
    var alpha1 = this.bn9(color1);
    var ri = numberToInt((r1 + (this.ro7(color2) - r1) * ratio) * 255);
    var gi = numberToInt((g1 + (this.so7(color2) - g1) * ratio) * 255);
    var bi = numberToInt((b1 + (this.to7(color2) - b1) * ratio) * 255);
    var alphai = numberToInt((alpha1 + (this.bn9(color2) - alpha1) * ratio) * 255);
    return bi | gi << 8 | ri << 16 | alphai << 24;
  }
  lna(color) {
    return format('#%06x', [color & 16777215]);
  }
  kna(color) {
    return format('#%06x(%02x)', [color & 16777215, color >>> 24 | 0]);
  }
}
class NumberUtils {
  hn7(pixels) {
    return round(pixels * 100) / 100;
  }
  un7(pixels) {
    return round(pixels * 10000) / 10000;
  }
}
class MatrixUtils {
  una(matrix1, matrix2, ratio) {
    var matrix = new SWFMatrix();
    matrix.gms_1 = matrix1.gms_1 + (matrix2.gms_1 - matrix1.gms_1) * ratio;
    matrix.hms_1 = matrix1.hms_1 + (matrix2.hms_1 - matrix1.hms_1) * ratio;
    matrix.ims_1 = matrix1.ims_1 + (matrix2.ims_1 - matrix1.ims_1) * ratio;
    matrix.jms_1 = matrix1.jms_1 + (matrix2.jms_1 - matrix1.jms_1) * ratio;
    matrix.kms_1 = numberToInt(matrix1.kms_1 + (matrix2.kms_1 - matrix1.kms_1 | 0) * ratio);
    matrix.lms_1 = numberToInt(matrix1.lms_1 + (matrix2.lms_1 - matrix1.lms_1 | 0) * ratio);
    return matrix;
  }
}
class AnBaseShape extends Container {
  static kod(library, symbol) {
    var $this = this.vbw();
    $this.cod_1 = library;
    $this.dod_1 = symbol;
    $this.eod_1 = null;
    $this.fod_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.god_1 = [Vector2D.k2h(0.0, 0.0), Vector2D.k2h(0.25, 0.25), Vector2D.k2h(0.75, 0.75), Vector2D.k2h(1.0, 1.0)];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.hod_1 = [Vector2D.k2h(0.0, 0.0), Vector2D.k2h(0.25, 0.25), Vector2D.k2h(0.75, 0.75), Vector2D.k2h(1.0, 1.0)];
    $this.iod_1 = null;
    $this.jod_1 = null;
    return $this;
  }
  jc7(ctx) {
    if (!this.qcc())
      return Unit_instance;
    if (!(ensureShape(this) == null)) {
      var tmp64_safe_receiver = this.fod_1;
      if (tmp64_safe_receiver == null)
        null;
      else {
        var tmp0_elvis_lhs = this.cod_1.foj_1;
        tmp64_safe_receiver.eh4(tmp0_elvis_lhs == null ? this.boe() : tmp0_elvis_lhs);
      }
      super.jc7(ctx);
      return Unit_instance;
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.ka7_1;
    var this_1 = this_0.ta7_1;
    if (!(this_1.oa7_1 === this_0)) {
      this_1.oa7_1 = this_0;
      this_1.ya8();
    }
    var tmp;
    if (!(this.eod_1 == null)) {
      var np = ensureNotNull(this.eod_1);
      var lm = ensureNotNull(this.w15()).scc();
      var npLeft = np.p2i() - this.yod();
      var npTop = np.r2i() - this.zod();
      var npRight = np.q2i() - this.yod();
      var npBottom = np.s2i() - this.zod();
      var ascaleX = lm.n2m_1;
      var ascaleY = lm.q2m_1;
      this.god_1[1] = Vector2D.k2h(npLeft / this.y5l() / ascaleX, npTop / this.z5l() / ascaleY);
      this.god_1[2] = Vector2D.k2h(1.0 - (this.y5l() - npRight) / this.y5l() / ascaleX, 1.0 - (this.z5l() - npBottom) / this.z5l() / ascaleY);
      this.hod_1[1] = Vector2D.k2h(npLeft / this.y5l(), npTop / this.z5l());
      this.hod_1[2] = Vector2D.k2h(npRight / this.y5l(), npBottom / this.y5l());
      drawNinePatch(this_0, ctx.za8(this.n8p()), this.yod(), this.zod(), this.y5l(), this.z5l(), this.god_1, this.hod_1, get_mutable(this.ybp()), this.coe(), this.wcc(), this.vcc());
      tmp = Unit_instance;
    } else {
      this_0.aa9(ctx.za8(this.n8p()), this.yod(), this.zod(), this.y5l(), this.z5l(), this.ybp(), this.coe(), this.wcc(), this.vcc());
      tmp = Unit_instance;
    }
  }
  bcb() {
    var tmp0_elvis_lhs = this.jod_1;
    return tmp0_elvis_lhs == null ? this.dod_1.pod_1 : tmp0_elvis_lhs;
  }
  gc7() {
    if (!(ensureShape(this) == null)) {
      return super.gc7();
    }
    return Companion_getInstance_8().e2t(this.yod(), this.zod(), this.y5l(), this.z5l());
  }
  toString() {
    return super.toString() + ':symbol=' + this.dod_1.toString();
  }
}
class AnShape extends AnBaseShape {
  static toa(library, shapeSymbol) {
    var $this = this.kod(library, shapeSymbol);
    $this.koa_1 = shapeSymbol;
    $this.loa_1 = $this.koa_1.ood_1.h4e_1;
    $this.moa_1 = $this.koa_1.ood_1.i4e_1;
    var tmp = $this;
    var tmp65_safe_receiver = $this.koa_1.vod_1;
    var tmp0_elvis_lhs = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.oak_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp_0 = get_Bitmaps_transparent();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.noa_1 = tmp_0;
    var tmp_1 = $this;
    var tmp66_safe_receiver = $this.koa_1.wod_1;
    tmp_1.ooa_1 = tmp66_safe_receiver == null ? null : tmp66_safe_receiver();
    var tmp_2 = $this;
    var tmp67_safe_receiver = $this.koa_1.vod_1;
    var tmp0_elvis_lhs_0 = tmp67_safe_receiver == null ? null : tmp67_safe_receiver.qak_1;
    tmp_2.poa_1 = tmp0_elvis_lhs_0 == null ? 1.0 : tmp0_elvis_lhs_0;
    $this.qoa_1 = $this.noa_1.o41_1 / $this.poa_1;
    $this.roa_1 = $this.noa_1.p41_1 / $this.poa_1;
    $this.soa_1 = true;
    return $this;
  }
  yod() {
    return this.loa_1;
  }
  zod() {
    return this.moa_1;
  }
  n8p() {
    return this.noa_1;
  }
  aoe() {
    return this.ooa_1;
  }
  boe() {
    return this.koa_1.xod_1;
  }
  y5l() {
    return this.qoa_1;
  }
  z5l() {
    return this.roa_1;
  }
  coe() {
    return this.soa_1;
  }
}
class AnMovieClip extends Container {
  static qoi(library, symbol) {
    var $this = this.vbw();
    $this.log_1 = library;
    $this.mog_1 = symbol;
    $this.nog_1 = new Result();
    $this.oog_1 = $this.mog_1.joi_1.roi_1;
    $this.pog_1 = $this.mog_1.joi_1.toi_1;
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = $this.oog_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = DummyView.ggn();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.qog_1 = tmp_2;
    var tmp_3 = $this;
    var tmp_4 = 0;
    var tmp_5 = $this.oog_1 + 10 | 0;
    var tmp_6 = new Int32Array(tmp_5);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = -1;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.rog_1 = tmp_6;
    var tmp_7 = $this;
    var tmp_8 = 0;
    var tmp_9 = $this.oog_1 + 10 | 0;
    var tmp_10 = booleanArray(tmp_9);
    while (tmp_8 < tmp_9) {
      tmp_10[tmp_8] = false;
      tmp_8 = tmp_8 + 1 | 0;
    }
    tmp_7.sog_1 = tmp_10;
    var tmp_11 = $this;
    var tmp_12 = 0;
    var tmp_13 = $this.pog_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var info = $this.mog_1.moi_1[tmp_15];
      if (info.voi_1 === $this.mog_1.yoi_1) {
        // Inline function 'kotlin.error' call
        var message = 'Recursive detection';
        throw IllegalStateException.m5(toString(message));
      }
      // Inline function 'kotlin.also' call
      var tmp_16 = $this.log_1.kmo(info.voi_1);
      var this_0 = tmp_16 instanceof View ? tmp_16 : THROW_CCE();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.animate.AnMovieClip.viewUids.<anonymous>' call
      addProps(this_0, info.woi_1);
      tmp_14[tmp_15] = this_0;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.tog_1 = tmp_14;
    $this.uog_1 = true;
    $this.vog_1 = $this.log_1.moj_1;
    $this.wog_1 = $this.mog_1.joi_1.soi_1 <= 1;
    $this.xog_1 = ArrayList.v(toList($this.qog_1));
    $this.yog_1 = new TimelineRunner($this, $this.mog_1);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = $this.qog_1;
    var n = 0;
    while (n < this_1.length) {
      // Inline function 'korlibs.korge.animate.AnMovieClip.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var d = this_1[_unary__edvuaz];
      $this.ubw(d);
    }
    addUpdater($this, AnMovieClip$lambda);
    $this.zog_1 = new MMatrix();
    return $this;
  }
  gc7() {
    if (this.mog_1.yoi_1 === 0) {
      return Companion_getInstance_8().d2t(0, 0, this.log_1.coj_1, this.log_1.doj_1);
    } else {
      return super.gc7();
    }
  }
  jc7(ctx) {
    if (!this.qcc())
      return Unit_instance;
    fill(this.sog_1, false);
    var usedStencil = false;
    var state = 0;
    // Inline function 'korlibs.korge.view.View.forEachChildWithIndex' call
    var tmp339_safe_receiver = this.bca();
    var tmp;
    if (tmp339_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
      var n = 0;
      while (n < tmp339_safe_receiver.j1()) {
        // Inline function 'korlibs.korge.animate.AnMovieClip.renderInternal.<anonymous>' call
        var depth = n;
        var child = tmp339_safe_receiver.i1(n);
        // Inline function 'kotlin.collections.getOrElse' call
        var this_0 = this.rog_1;
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= depth ? depth <= (this_0.length - 1 | 0) : false) {
          tmp_0 = this_0[depth];
        } else {
          // Inline function 'korlibs.korge.animate.AnMovieClip.renderInternal.<anonymous>.<anonymous>' call
          tmp_0 = -1;
        }
        var maskDepth = tmp_0;
        if (maskDepth >= 0) {
          if (0 <= maskDepth ? maskDepth <= (this.sog_1.length - 1 | 0) : false) {
            this.sog_1[maskDepth] = true;
            var _unary__edvuaz = get_stencilIndex(ctx);
            set_stencilIndex(ctx, _unary__edvuaz + 1 | 0);
            usedStencil = true;
            MaskStates_getInstance().ooj_1.toj(ctx, get_stencilIndex(ctx));
            state = 1;
          }
        }
        var tmp_1;
        if (ctx.na7_1) {
          tmp_1 = true;
        } else {
          tmp_1 = true;
        }
        var showChild = tmp_1;
        if (showChild) {
          child.fc7(ctx);
        }
        if (maskDepth >= 0) {
          MaskStates_getInstance().poj_1.toj(ctx, get_stencilIndex(ctx));
          state = 2;
        }
        // Inline function 'kotlin.collections.getOrElse' call
        var this_1 = this.sog_1;
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= depth ? depth <= (this_1.length - 1 | 0) : false) {
          tmp_2 = this_1[depth];
        } else {
          // Inline function 'korlibs.korge.animate.AnMovieClip.renderInternal.<anonymous>.<anonymous>' call
          tmp_2 = false;
        }
        if (tmp_2) {
          MaskStates_getInstance().noj_1.toj(ctx, 0);
          var _unary__edvuaz_0 = get_stencilIndex(ctx);
          set_stencilIndex(ctx, _unary__edvuaz_0 - 1 | 0);
          state = 0;
        }
        n = n + 1 | 0;
      }
      tmp = Unit_instance;
    }
    if (usedStencil && get_stencilIndex(ctx) <= 0) {
      set_stencilIndex(ctx, 0);
      var tmp80_stencil = get_stencilIndex(ctx);
      ctx.eai(VOID, VOID, tmp80_stencil, false, false, true);
    }
  }
  uoj() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.mog_1.loi_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.j1());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.z1().f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.animate.AnMovieClip.<get-stateNames>.<anonymous>' call
      var tmp$ret$1 = item.b2().voj_1;
      destination.f(tmp$ret$1);
    }
    return destination;
  }
  yoj(name) {
    this.yog_1.zoj(name);
    update(this);
  }
  toString() {
    return super.toString() + ':symbol=' + this.mog_1.toString();
  }
}
class AnMorphShape extends AnBaseShape {
  static lon(library, morphSymbol) {
    var $this = this.kod(library, morphSymbol);
    $this.qom_1 = morphSymbol;
    $this.rom_1 = new Result();
    $this.som_1 = null;
    $this.tom_1 = 0.0;
    $this.uom_1 = 0.0;
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    tmp.vom_1 = get_Bitmaps_transparent();
    $this.wom_1 = null;
    $this.xom_1 = $this.qom_1.kon_1;
    $this.yom_1 = 1.0;
    $this.zom_1 = 0.0;
    $this.aon_1 = 0.0;
    $this.bon_1 = true;
    $this.con_1 = Companion_getInstance_10().f10_1;
    updatedRatio($this);
    return $this;
  }
  yod() {
    return this.tom_1;
  }
  zod() {
    return this.uom_1;
  }
  n8p() {
    return this.vom_1;
  }
  aoe() {
    return this.wom_1;
  }
  boe() {
    return this.xom_1;
  }
  y5l() {
    return this.zom_1;
  }
  z5l() {
    return this.aon_1;
  }
  coe() {
    return this.bon_1;
  }
  mon(value) {
    this.con_1 = value;
    updatedRatio(this);
  }
}
class AnEmptyView extends DummyView {
  static pop(library, symbol) {
    symbol = symbol === VOID ? AnSymbolEmpty_getInstance() : symbol;
    var $this = this.ggn();
    $this.nop_1 = library;
    $this.oop_1 = symbol;
    return $this;
  }
}
class AnTextField extends Container {
  static eos(library, symbol) {
    var $this = this.vbw();
    $this.yor_1 = library;
    $this.zor_1 = symbol;
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = Companion_instance_36.fos('', 16.0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.AnTextField.textField.<anonymous>' call
    this_0.gou_1 = $this.yor_1.goj_1;
    this_0.hou_1.u4e($this.zor_1.vou_1);
    this_0.wou($this.zor_1.uou_1);
    this_0.se4();
    tmp.aos_1 = this_0;
    $this.ubw($this.aos_1);
    $this.bos_1 = format$factory($this.aos_1);
    $this.cos_1 = text$factory($this.aos_1);
    $this.dos_1 = html$factory($this.aos_1);
    return $this;
  }
}
class TimelineRunner$eval$slambda {
  constructor(this$0, $action) {
    this.xou_1 = this$0;
    this.you_1 = $action;
  }
  pe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $completion), $completion);
  }
}
class TimelineRunner {
  constructor(view, symbol) {
    this.aoh_1 = view;
    this.boh_1 = symbol;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.coh_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    this.doh_1 = null;
    this.eoh_1 = null;
    this.foh_1 = new Signal();
    this.goh_1 = new Signal();
    this.hoh_1 = new Signal();
    this.ioh_1 = true;
    this.zoj('default');
    this.joh_1 = new RangeResult();
  }
  zou() {
    return this.aoh_1.log_1;
  }
  oov() {
    var tmp;
    if (!(this.eoh_1 == null)) {
      tmp = ensureNotNull(this.eoh_1).koh_1;
    } else {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp;
  }
  pov(value) {
    this.ioh_1 = value;
    if (!value) {
      this.foh_1.x1x(Unit_instance);
    }
  }
  qov(running, name, time) {
    var substate = this.boh_1.loi_1.k3(name);
    if (!(substate == null)) {
      this.doh_1 = substate.voj_1;
      this.eoh_1 = substate.woj_1;
      this.coh_1 = Duration__plus_impl_yu9v8f(substate.xoj_1, time);
      this.pov(running);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$3 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
      this.lh9(tmp$ret$3);
      this.goh_1.x1x(name);
    } else {
      println("Can't find state with name '" + name + "' : " + toString(this.boh_1.loi_1.l3()));
    }
  }
  rov(name, time) {
    return this.qov(true, name, time);
  }
  zoj(name, time, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.rov(name, time);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.rov.call(this, name, new Duration(time));
    }
    return tmp_0;
  }
  lh9(time) {
    if (!this.ioh_1)
      return Unit_instance;
    if (this.eoh_1 == null)
      return Unit_instance;
    var cs = ensureNotNull(this.eoh_1);
    eval_0(this, this.coh_1, min(this.oov(), Duration__plus_impl_yu9v8f(this.coh_1, time)));
    this.coh_1 = Duration__plus_impl_yu9v8f(this.coh_1, time);
    if (Duration__compareTo_impl_pchp0f(this.coh_1, this.oov()) >= 0) {
      var accumulatedTime = Duration__minus_impl_q5cfm7(this.coh_1, this.oov());
      var nextState = cs.noh_1;
      if (nextState == null) {
        this.pov(false);
      } else {
        var tmp = cs.ooh_1;
        // Inline function 'korlibs.time.milliseconds' call
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
        this.qov(tmp, nextState, tmp$ret$1);
        this.coh_1 = Duration__plus_impl_yu9v8f(this.coh_1, accumulatedTime);
        eval_0(this, Duration__minus_impl_q5cfm7(this.coh_1, accumulatedTime), this.coh_1);
      }
    }
  }
}
class Companion_30 {
  vov(views) {
    return new Context(views.yb6_1, views.wb7_1);
  }
}
class Context {
  constructor(coroutineContext, imageFormats) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    this.mov_1 = coroutineContext;
    this.nov_1 = imageFormats;
  }
  toString() {
    return 'Context(coroutineContext=' + toString(this.mov_1) + ', imageFormats=' + this.nov_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.mov_1);
    result = imul(result, 31) + hashCode(this.nov_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Context))
      return false;
    var tmp0_other_with_cast = other instanceof Context ? other : THROW_CCE();
    if (!equals(this.mov_1, tmp0_other_with_cast.mov_1))
      return false;
    if (!equals(this.nov_1, tmp0_other_with_cast.nov_1))
      return false;
    return true;
  }
}
class AnLibrary {
  constructor(context, width, height, fps) {
    this.aoj_1 = new Mixin();
    this.boj_1 = context;
    this.coj_1 = width;
    this.doj_1 = height;
    this.eoj_1 = fps;
    this.foj_1 = null;
    this.goj_1 = new FontsCatalog(null);
    this.hoj_1 = 1000 / this.eoj_1;
    this.ioj_1 = numberToInt(this.hoj_1);
    this.joj_1 = Colors_getInstance().g4r_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.koj_1 = ArrayList.m1();
    this.loj_1 = LinkedHashMap.vc();
    this.moj_1 = true;
  }
  n13(_set____db54di) {
    this.aoj_1.n13(_set____db54di);
  }
  o13() {
    return this.aoj_1.o13();
  }
  wov(symbol) {
    while (this.koj_1.j1() <= symbol.yoi_1) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_0 = this.koj_1;
      var element = AnSymbolEmpty_getInstance();
      this_0.f(element);
    }
    if (symbol.yoi_1 >= 0) {
      this.koj_1.p3(symbol.yoi_1, symbol);
    }
  }
  xov() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.koj_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.korge.animate.AnLibrary.processSymbolNames.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var symbol = this_0.i1(_unary__edvuaz);
      if (!(symbol.zoi_1 == null)) {
        // Inline function 'kotlin.collections.set' call
        var this_1 = this.loj_1;
        var key = ensureNotNull(symbol.zoi_1);
        this_1.r3(key, symbol);
      }
    }
  }
  kmo(id) {
    var tmp;
    if (id < 0) {
      printStackTrace_0('ERROR invalid id=' + id);
      tmp = AnSymbolEmpty_getInstance().yov(this);
    } else {
      // Inline function 'kotlin.collections.getOrElse' call
      var this_0 = this.koj_1;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= id ? id < this_0.j1() : false) {
        tmp_0 = this_0.i1(id);
      } else {
        // Inline function 'korlibs.korge.animate.AnLibrary.create.<anonymous>' call
        tmp_0 = AnSymbolEmpty_getInstance();
      }
      tmp = tmp_0.yov(this);
    }
    return tmp;
  }
  zov(id) {
    var tmp = this.kmo(id);
    return tmp instanceof AnMovieClip ? tmp : THROW_CCE();
  }
  aow() {
    return this.zov(0);
  }
}
class AnSymbol {
  constructor(id, name) {
    id = id === VOID ? -1 : id;
    name = name === VOID ? null : name;
    this.xoi_1 = new Mixin();
    this.yoi_1 = id;
    this.zoi_1 = name;
  }
  n13(_set____db54di) {
    this.xoi_1.n13(_set____db54di);
  }
  o13() {
    return this.xoi_1.o13();
  }
  yov(library) {
    return AnEmptyView.pop(library);
  }
  toString() {
    return 'Symbol(id=' + this.yoi_1 + ', name=' + this.zoi_1 + ')';
  }
}
class AnSymbolMovieClip extends AnSymbol {
  constructor(id, name, limits) {
    super(id, name);
    this.joi_1 = limits;
    this.koi_1 = null;
    this.loi_1 = LinkedHashMap.vc();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.joi_1.toi_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = new AnSymbolUidDef(-1, LinkedHashMap.vc());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.moi_1 = tmp_2;
  }
  yov(library) {
    return AnMovieClip.qoi(library, this);
  }
}
class AnSymbolBaseShape extends AnSymbol {
  constructor(id, name, bounds, path) {
    path = path === VOID ? null : path;
    super(id, name);
    this.ood_1 = bounds;
    this.pod_1 = path;
  }
}
class AnSymbolMorphShape extends AnSymbolBaseShape {
  constructor(id, name, bounds, texturesWithBitmap, path, shapeGen, graphicsRenderer) {
    texturesWithBitmap = texturesWithBitmap === VOID ? new Timed() : texturesWithBitmap;
    path = path === VOID ? null : path;
    shapeGen = shapeGen === VOID ? null : shapeGen;
    graphicsRenderer = graphicsRenderer === VOID ? GraphicsRenderer_GPU_getInstance() : graphicsRenderer;
    super(id, name, bounds, path);
    this.ion_1 = texturesWithBitmap;
    this.jon_1 = shapeGen;
    this.kon_1 = graphicsRenderer;
  }
  yov(library) {
    return AnMorphShape.lon(library, this);
  }
}
class AnSymbolShape extends AnSymbolBaseShape {
  constructor(id, name, bounds, textureWithBitmap, path, shapeGen, graphicsRenderer) {
    path = path === VOID ? null : path;
    shapeGen = shapeGen === VOID ? null : shapeGen;
    graphicsRenderer = graphicsRenderer === VOID ? GraphicsRenderer_GPU_getInstance() : graphicsRenderer;
    super(id, name, bounds, path);
    this.vod_1 = textureWithBitmap;
    this.wod_1 = shapeGen;
    this.xod_1 = graphicsRenderer;
  }
  yov(library) {
    return AnShape.toa(library, this);
  }
}
class Companion_31 {
  poi(view, l, r, ratio) {
    view.rcc(Ratio__toDouble_impl_o7epze(ratio), l.aoi_1.j2t(), r.aoi_1.j2t());
    set_colorTransform(view, get_colorTransform(view).m58(ratio, l.coi_1, r.coi_1));
    if (view instanceof AnMorphShape) {
      view.mon(interpolate(ratio, l.zoh_1, r.zoh_1));
    }
    view.aba_1 = l.boi_1;
    view.jcb(l.doi_1);
    set_filter(view, l.eoi_1);
  }
}
class AnSymbolTimelineFrame {
  constructor(depth, uid, clipDepth, ratio, transform, name, colorTransform, blendMode, filter) {
    depth = depth === VOID ? -1 : depth;
    uid = uid === VOID ? -1 : uid;
    clipDepth = clipDepth === VOID ? -1 : clipDepth;
    ratio = ratio === VOID ? Companion_getInstance_10().f10_1 : ratio;
    transform = transform === VOID ? new MMatrix() : transform;
    name = name === VOID ? null : name;
    var tmp;
    if (colorTransform === VOID) {
      // Inline function 'korlibs.image.color.ColorTransform' call
      var multiply = Colors_getInstance().g4r_1;
      // Inline function 'korlibs.image.color.Companion.invoke' call
      var add = _ColorAdd___init__impl__q78um5(ColorAdd_pack(0, 0, 0, 0));
      tmp = new ColorTransform(_RGBA___get_rf__impl__kvz75k(multiply), _RGBA___get_gf__impl__5gcu1f(multiply), _RGBA___get_bf__impl__1xz5yg(multiply), _RGBA___get_af__impl__vu36qv(multiply), _ColorAdd___get_r__impl__j9xkne(add), _ColorAdd___get_g__impl__itrhk1(add), _ColorAdd___get_b__impl__grv87a(add), _ColorAdd___get_a__impl__c1r8ux(add));
    } else {
      tmp = colorTransform;
    }
    colorTransform = tmp;
    blendMode = blendMode === VOID ? Companion_getInstance_14().sa5_1 : blendMode;
    filter = filter === VOID ? null : filter;
    this.woh_1 = depth;
    this.xoh_1 = uid;
    this.yoh_1 = clipDepth;
    this.zoh_1 = ratio;
    this.aoi_1 = transform;
    this.boi_1 = name;
    this.coi_1 = colorTransform;
    this.doi_1 = blendMode;
    this.eoi_1 = filter;
  }
  foi(view) {
    if (view instanceof AnMorphShape) {
      view.mon(this.zoh_1);
    }
    view.yai(this.aoi_1.j2t());
    view.aba_1 = this.boi_1;
    set_colorTransform(view, this.coi_1);
    view.jcb(this.doi_1);
    set_filter(view, this.eoi_1);
  }
  toString() {
    return 'AnSymbolTimelineFrame(depth=' + this.woh_1 + ', uid=' + this.xoh_1 + ', clipDepth=' + this.yoh_1 + ', ratio=' + Ratio__toString_impl_mfgt3e(this.zoh_1) + ', transform=' + this.aoi_1.toString() + ', name=' + this.boi_1 + ', colorTransform=' + this.coi_1.toString() + ', blendMode=' + this.doi_1.toString() + ', filter=' + toString_0(this.eoi_1) + ')';
  }
  hashCode() {
    var result = this.woh_1;
    result = imul(result, 31) + this.xoh_1 | 0;
    result = imul(result, 31) + this.yoh_1 | 0;
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.zoh_1) | 0;
    result = imul(result, 31) + this.aoi_1.hashCode() | 0;
    result = imul(result, 31) + (this.boi_1 == null ? 0 : getStringHashCode(this.boi_1)) | 0;
    result = imul(result, 31) + this.coi_1.hashCode() | 0;
    result = imul(result, 31) + this.doi_1.hashCode() | 0;
    result = imul(result, 31) + (this.eoi_1 == null ? 0 : hashCode(this.eoi_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnSymbolTimelineFrame))
      return false;
    var tmp0_other_with_cast = other instanceof AnSymbolTimelineFrame ? other : THROW_CCE();
    if (!(this.woh_1 === tmp0_other_with_cast.woh_1))
      return false;
    if (!(this.xoh_1 === tmp0_other_with_cast.xoh_1))
      return false;
    if (!(this.yoh_1 === tmp0_other_with_cast.yoh_1))
      return false;
    if (!equals(this.zoh_1, tmp0_other_with_cast.zoh_1))
      return false;
    if (!this.aoi_1.equals(tmp0_other_with_cast.aoi_1))
      return false;
    if (!(this.boi_1 == tmp0_other_with_cast.boi_1))
      return false;
    if (!this.coi_1.equals(tmp0_other_with_cast.coi_1))
      return false;
    if (!this.doi_1.equals(tmp0_other_with_cast.doi_1))
      return false;
    if (!equals(this.eoi_1, tmp0_other_with_cast.eoi_1))
      return false;
    return true;
  }
}
class AnSymbolEmpty extends AnSymbol {
  constructor() {
    AnSymbolEmpty_instance = null;
    super(-1, '');
    AnSymbolEmpty_instance = this;
  }
}
class AnSymbolSound$getNativeSound$slambda {
  constructor(this$0) {
    this.bow_1 = this$0;
  }
  pe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $completion), $completion);
  }
}
class AnSymbolSound extends AnSymbol {
  constructor(id, name, inputSound, dataBytes) {
    super(id, name);
    this.eov_1 = inputSound;
    this.fov_1 = dataBytes;
    this.gov_1 = new AsyncOnce();
  }
  hov($completion) {
    return this.gov_1.j3p(AnSymbolSound$getNativeSound$slambda_0(this), $completion);
  }
}
class AnTextFieldSymbol extends AnSymbol {
  constructor(id, name, initialHtml, bounds) {
    super(id, name);
    this.uou_1 = initialHtml;
    this.vou_1 = bounds;
  }
  yov(library) {
    return AnTextField.eos(library, this);
  }
}
class AnSymbolBitmap extends AnSymbol {
  constructor(id, name, bmp) {
    super(id, name);
    this.fow_1 = bmp;
  }
}
class AnSymbolUidDef {
  constructor(characterId, extraProps) {
    extraProps = extraProps === VOID ? LinkedHashMap.vc() : extraProps;
    this.voi_1 = characterId;
    this.woi_1 = extraProps;
  }
}
class AnSymbolLimits {
  constructor(totalDepths, totalFrames, totalUids, totalTime) {
    this.roi_1 = totalDepths;
    this.soi_1 = totalFrames;
    this.toi_1 = totalUids;
    this.uoi_1 = totalTime;
  }
}
class AnSymbolMovieClipState {
  constructor(name, subTimeline, startTime) {
    this.voj_1 = name;
    this.woj_1 = subTimeline;
    this.xoj_1 = startTime;
  }
}
class AnSymbolMovieClipSubTimeline {
  constructor(totalDepths) {
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.koh_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_0 = this;
    var tmp_1 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(totalDepths), null);
    while (tmp_1 < totalDepths) {
      var tmp_3 = tmp_1;
      tmp_2[tmp_3] = new AnDepthTimeline(tmp_3);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.loh_1 = tmp_2;
    this.moh_1 = new Timed();
    this.noh_1 = null;
    this.ooh_1 = false;
  }
}
class Timed {
  constructor(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 7 : initialCapacity;
    this.poh_1 = IntArrayList.f31(initialCapacity);
    this.qoh_1 = ArrayList.w(initialCapacity);
  }
  j1() {
    return this.poh_1.j1();
  }
  z1() {
    return zip(this.poh_1, this.qoh_1);
  }
  jow(_this__u8e3s4) {
    // Inline function 'korlibs.time.microsecondsInt' call
    // Inline function 'korlibs.time.microseconds' call
    var tmp$ret$0 = _Duration___get_inWholeNanoseconds__impl__r5x4mr(_this__u8e3s4).t4() / 1000.0;
    return numberToInt(tmp$ret$0);
  }
  kow(time, obj) {
    var time_0 = this.jow(time);
    this.poh_1.l31(time_0);
    this.qoh_1.f(obj);
    var m = this.poh_1.j1() - 2 | 0;
    while (m >= 0 && time_0 < this.poh_1.i1(m)) {
      swap(this, m, m + 1 | 0);
      m = m - 1 | 0;
    }
  }
  low(time) {
    var res = _BSearchResult___get_raw__impl__uyuhf3(binarySearch(this.poh_1, this.jow(time)));
    return res < 0 ? clamp((-res | 0) - 1 | 0, 0, this.poh_1.j1() - 1 | 0) : res;
  }
  iov(startTime, endTime, out) {
    var startIndex = clamp(this.low(startTime) - 1 | 0, 0, this.j1() - 1 | 0);
    var endIndex = clamp(this.low(endTime) + 1 | 0, 0, this.j1() - 1 | 0);
    var min = 2147483647;
    var max = -2147483648;
    var rangeLow = this.jow(startTime);
    var rangeHigh = this.jow(endTime);
    var inductionVariable = startIndex;
    if (inductionVariable <= endIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var time = this.poh_1.i1(n);
        if (rangeLow <= time ? time <= rangeHigh : false) {
          // Inline function 'kotlin.math.min' call
          var a = min;
          var b = n;
          min = Math.min(a, b);
          // Inline function 'kotlin.math.max' call
          var a_0 = max;
          var b_0 = n;
          max = Math.max(a_0, b_0);
        }
      }
       while (!(n === endIndex));
    out.jov_1 = min;
    out.kov_1 = max;
    return out;
  }
  noi(time, out) {
    var tmp$ret$1;
    $l$block_3: {
      // Inline function 'korlibs.korge.animate.Timed.findAndHandle' call
      if (this.qoh_1.a1()) {
        // Inline function 'korlibs.korge.animate.Timed.find.<anonymous>' call
        out.soh_1 = 0;
        out.toh_1 = null;
        out.uoh_1 = null;
        out.voh_1 = 0.0;
        tmp$ret$1 = out;
        break $l$block_3;
      }
      var index = this.low(time);
      var timeInt = this.jow(time);
      var timeAtIndex = this.poh_1.i1(index);
      if (timeInt < timeAtIndex && index <= 0) {
        // Inline function 'korlibs.korge.animate.Timed.find.<anonymous>' call
        var right = this.qoh_1.i1(0);
        out.soh_1 = 0;
        out.toh_1 = null;
        out.uoh_1 = right;
        out.voh_1 = 0.0;
        tmp$ret$1 = out;
        break $l$block_3;
      } else {
        var idx = timeInt < timeAtIndex ? index - 1 | 0 : index;
        var curTimeAtIndex = this.poh_1.i1(idx + 0 | 0);
        if (curTimeAtIndex === timeInt) {
          // Inline function 'korlibs.korge.animate.Timed.find.<anonymous>' call
          var left = this.qoh_1.i1(idx);
          out.soh_1 = idx;
          out.toh_1 = left;
          out.uoh_1 = null;
          out.voh_1 = 0.0;
          tmp$ret$1 = out;
          break $l$block_3;
        } else {
          if (idx >= (this.poh_1.j1() - 1 | 0)) {
            // Inline function 'korlibs.korge.animate.Timed.find.<anonymous>' call
            var index_0 = this.qoh_1.j1();
            var left_0 = this.qoh_1.i1(this.qoh_1.j1() - 1 | 0);
            out.soh_1 = index_0;
            out.toh_1 = left_0;
            out.uoh_1 = null;
            out.voh_1 = 1.0;
            tmp$ret$1 = out;
            break $l$block_3;
          } else {
            var nextTimeAtIndex = this.poh_1.i1(idx + 1 | 0);
            var elapsedTime = timeInt - curTimeAtIndex | 0;
            var totalTime = nextTimeAtIndex - curTimeAtIndex | 0;
            // Inline function 'korlibs.korge.animate.Timed.find.<anonymous>' call
            var left_1 = this.qoh_1.i1(idx);
            var right_0 = this.qoh_1.i1(idx + 1 | 0);
            var ratio = elapsedTime / totalTime;
            out.soh_1 = idx;
            out.toh_1 = left_1;
            out.uoh_1 = right_0;
            out.voh_1 = ratio;
            tmp$ret$1 = out;
            break $l$block_3;
          }
        }
      }
    }
    return tmp$ret$1;
  }
  roh(time, out) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.korge.animate.Timed.findAndHandleWithoutInterpolation' call
      if (this.qoh_1.a1()) {
        // Inline function 'korlibs.korge.animate.Timed.findWithoutInterpolation.<anonymous>' call
        out.soh_1 = 0;
        out.toh_1 = null;
        out.uoh_1 = null;
        out.voh_1 = 0.0;
        tmp$ret$1 = out;
        break $l$block;
      }
      var index = this.low(time);
      var timeInt = this.jow(time);
      var timeAtIndex = this.poh_1.i1(index);
      var tmp;
      if (timeInt < timeAtIndex && index <= 0) {
        // Inline function 'korlibs.korge.animate.Timed.findWithoutInterpolation.<anonymous>' call
        out.soh_1 = 0;
        out.toh_1 = null;
        out.uoh_1 = null;
        out.voh_1 = 0.0;
        tmp = out;
      } else {
        var idx = timeInt < timeAtIndex ? index - 1 | 0 : index;
        var curTimeAtIndex = this.poh_1.i1(idx + 0 | 0);
        var tmp_0;
        if (curTimeAtIndex === timeInt) {
          // Inline function 'korlibs.korge.animate.Timed.findWithoutInterpolation.<anonymous>' call
          var left = this.qoh_1.i1(idx);
          out.soh_1 = idx;
          out.toh_1 = left;
          out.uoh_1 = null;
          out.voh_1 = 0.0;
          tmp_0 = out;
        } else if (idx >= (this.poh_1.j1() - 1 | 0)) {
          // Inline function 'korlibs.korge.animate.Timed.findWithoutInterpolation.<anonymous>' call
          var index_0 = this.qoh_1.j1();
          var left_0 = this.qoh_1.i1(this.qoh_1.j1() - 1 | 0);
          out.soh_1 = index_0;
          out.toh_1 = left_0;
          out.uoh_1 = null;
          out.voh_1 = 0.0;
          tmp_0 = out;
        } else {
          // Inline function 'korlibs.korge.animate.Timed.findWithoutInterpolation.<anonymous>' call
          var left_1 = this.qoh_1.i1(idx);
          out.soh_1 = idx;
          out.toh_1 = left_1;
          out.uoh_1 = null;
          out.voh_1 = 0.0;
          tmp_0 = out;
        }
        tmp = tmp_0;
      }
      tmp$ret$1 = tmp;
    }
    return tmp$ret$1;
  }
  toString() {
    return 'Timed(' + toString(this.z1()) + ')';
  }
}
class AnDepthTimeline extends Timed {
  constructor(depth) {
    super();
    this.iow_1 = depth;
  }
}
class AnPlaySoundAction {
  constructor(soundId) {
    this.aov_1 = soundId;
  }
  toString() {
    return 'AnPlaySoundAction(soundId=' + this.aov_1 + ')';
  }
  hashCode() {
    return this.aov_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnPlaySoundAction))
      return false;
    var tmp0_other_with_cast = other instanceof AnPlaySoundAction ? other : THROW_CCE();
    if (!(this.aov_1 === tmp0_other_with_cast.aov_1))
      return false;
    return true;
  }
}
class AnEventAction {
  constructor(event) {
    this.lov_1 = event;
  }
  toString() {
    return 'AnEventAction(event=' + this.lov_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.lov_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnEventAction))
      return false;
    var tmp0_other_with_cast = other instanceof AnEventAction ? other : THROW_CCE();
    if (!(this.lov_1 === tmp0_other_with_cast.lov_1))
      return false;
    return true;
  }
}
class RangeResult {
  constructor(startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? 0 : endIndex;
    this.jov_1 = startIndex;
    this.kov_1 = endIndex;
  }
  toString() {
    return 'RangeResult(startIndex=' + this.jov_1 + ', endIndex=' + this.kov_1 + ')';
  }
  hashCode() {
    var result = this.jov_1;
    result = imul(result, 31) + this.kov_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RangeResult))
      return false;
    var tmp0_other_with_cast = other instanceof RangeResult ? other : THROW_CCE();
    if (!(this.jov_1 === tmp0_other_with_cast.jov_1))
      return false;
    if (!(this.kov_1 === tmp0_other_with_cast.kov_1))
      return false;
    return true;
  }
}
class Result {
  constructor(index, left, right, ratio) {
    index = index === VOID ? 0 : index;
    left = left === VOID ? null : left;
    right = right === VOID ? null : right;
    ratio = ratio === VOID ? 0.0 : ratio;
    this.soh_1 = index;
    this.toh_1 = left;
    this.uoh_1 = right;
    this.voh_1 = ratio;
  }
  km() {
    return this.soh_1;
  }
  lm() {
    return this.toh_1;
  }
  ks() {
    return this.uoh_1;
  }
  ooi() {
    return this.voh_1;
  }
  toString() {
    return 'Result(index=' + this.soh_1 + ', left=' + toString_0(this.toh_1) + ', right=' + toString_0(this.uoh_1) + ', ratio=' + this.voh_1 + ')';
  }
  hashCode() {
    var result = this.soh_1;
    result = imul(result, 31) + (this.toh_1 == null ? 0 : hashCode(this.toh_1)) | 0;
    result = imul(result, 31) + (this.uoh_1 == null ? 0 : hashCode(this.uoh_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.voh_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!(this.soh_1 === tmp0_other_with_cast.soh_1))
      return false;
    if (!equals(this.toh_1, tmp0_other_with_cast.toh_1))
      return false;
    if (!equals(this.uoh_1, tmp0_other_with_cast.uoh_1))
      return false;
    if (!equals(this.voh_1, tmp0_other_with_cast.voh_1))
      return false;
    return true;
  }
}
class RenderState {
  constructor(stencilRef, stencilOpFunc, colorMask) {
    this.qoj_1 = stencilRef;
    this.roj_1 = stencilOpFunc;
    this.soj_1 = colorMask;
  }
  toj(ctx, referenceValue) {
    ctx.ya8();
    if (ctx.na7_1) {
      ctx.ka7_1.oa8_1 = AGStencilReference__withReferenceValue$default_impl_2trj0v(this.qoj_1, referenceValue);
      ctx.ka7_1.pa8_1 = this.roj_1;
      ctx.ka7_1.qa8_1 = this.soj_1;
    } else {
      ctx.ka7_1.oa8_1 = MaskStates_getInstance().noj_1.qoj_1;
      ctx.ka7_1.pa8_1 = MaskStates_getInstance().noj_1.roj_1;
      ctx.ka7_1.qa8_1 = MaskStates_getInstance().noj_1.soj_1;
    }
  }
}
class MaskStates {
  constructor() {
    MaskStates_instance = this;
    this.noj_1 = new RenderState(Companion_getInstance_15().i8l_1, AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().k8l_1, false), _AGColorMask___init__impl__j38ai8(true, true, true, true));
    this.ooj_1 = new RenderState(AGStencilReference__withReferenceValue$default_impl_2trj0v(AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_15().i8l_1, 0), 255), 0), AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw(AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd(AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().k8l_1, true), Companion_getInstance_17().n8w_1), Companion_getInstance_18().b8x_1), Companion_getInstance_18().b8x_1), Companion_getInstance_18().b8x_1), _AGColorMask___init__impl__j38ai8(false, false, false, false));
    this.poj_1 = new RenderState(AGStencilReference__withReferenceValue$default_impl_2trj0v(AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_15().i8l_1, 255), 0), 0), AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw(AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd(AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_16().k8l_1, true), Companion_getInstance_17().o8w_1), Companion_getInstance_18().a8x_1), Companion_getInstance_18().a8x_1), Companion_getInstance_18().a8x_1), _AGColorMask___init__impl__j38ai8(true, true, true, true));
  }
}
class BitmapWithScale {
  constructor(bitmap, scale, bounds) {
    this.mow_1 = new Mixin();
    this.now_1 = bitmap;
    this.oow_1 = scale;
    this.pow_1 = bounds;
    this.qow_1 = this.now_1.j2y();
    this.row_1 = this.now_1.k2y();
  }
  n13(_set____db54di) {
    this.mow_1.n13(_set____db54di);
  }
  o13() {
    return this.mow_1.o13();
  }
  toString() {
    return 'BitmapWithScale(bitmap=' + toString(this.now_1) + ', scale=' + this.oow_1 + ', bounds=' + this.pow_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.now_1);
    result = imul(result, 31) + getNumberHashCode(this.oow_1) | 0;
    result = imul(result, 31) + this.pow_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapWithScale))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapWithScale ? other : THROW_CCE();
    if (!equals(this.now_1, tmp0_other_with_cast.now_1))
      return false;
    if (!equals(this.oow_1, tmp0_other_with_cast.oow_1))
      return false;
    if (!this.pow_1.equals(tmp0_other_with_cast.pow_1))
      return false;
    return true;
  }
}
class SWFBaseShapeExporter extends ShapeExporter {
  constructor(bitmaps, path, roundDecimalPlaces) {
    path = path === VOID ? new VectorPath() : path;
    roundDecimalPlaces = roundDecimalPlaces === VOID ? -1 : roundDecimalPlaces;
    super();
    this.sow_1 = bitmaps;
    this.tow_1 = path;
    this.uow_1 = roundDecimalPlaces;
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.vow_1 = new CompoundShape(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.wow_1 = ArrayList.m1();
    this.xow_1 = true;
    this.yow_1 = new VectorPath();
    this.zow_1 = NonePaint_instance;
    this.aox_1 = 1.0;
    this.box_1 = LineScaleMode_NORMAL_getInstance();
    this.cox_1 = 1.0;
    this.dox_1 = LineCap_ROUND_getInstance();
    this.eox_1 = null;
    this.fox_1 = 0.0;
    this.gox_1 = new RGBA(Companion_getInstance_4().p5j(Colors_getInstance().h4r_1));
  }
  yn7() {
    this.yow_1 = new VectorPath();
  }
  bn8() {
    this.vow_1 = new CompoundShape(this.wow_1);
  }
  xn8() {
    flush(this);
    this.xow_1 = true;
  }
  sn9() {
    flush(this);
  }
  tn9() {
    flush(this);
    this.xow_1 = false;
  }
  zn9() {
    flush(this);
  }
  woy(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.v3_1) {
      case 0:
        tmp = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        tmp = CycleMethod_REFLECT_getInstance();
        break;
      case 2:
        tmp = CycleMethod_REPEAT_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  cn9(color, alpha) {
    flush(this);
    this.xow_1 = true;
    this.zow_1 = new RGBA(decodeSWFColor(color, alpha));
  }
  dn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
    flush(this);
    this.xow_1 = true;
    this.zow_1 = createGradientPaint(this, type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio);
  }
  en9(bitmapId, matrix, repeat, smooth) {
    flush(this);
    this.xow_1 = true;
    var tmp0_elvis_lhs = this.sow_1.k3(bitmapId);
    var bmp = tmp0_elvis_lhs == null ? Bitmap32.c4p(1, 1) : tmp0_elvis_lhs;
    this.zow_1 = new BitmapPaint(bmp, matrix.j2t(), Companion_getInstance_5().n77(repeat), Companion_getInstance_5().n77(repeat), smooth);
  }
  yn8() {
    flush(this);
  }
  wn9(thickness, color, alpha, pixelHinting, scaleMode, startCaps, endCaps, joints, miterLimit) {
    flush(this);
    this.xow_1 = false;
    this.aox_1 = thickness;
    this.box_1 = scaleMode;
    this.cox_1 = miterLimit;
    this.gox_1 = new RGBA(Companion_getInstance_4().p5j(decodeSWFColor(color, alpha)));
    var tmp = this;
    var tmp_0;
    switch (startCaps.v3_1) {
      case 1:
        tmp_0 = LineCap_BUTT_getInstance();
        break;
      case 0:
        tmp_0 = LineCap_ROUND_getInstance();
        break;
      case 2:
        tmp_0 = LineCap_SQUARE_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.dox_1 = tmp_0;
  }
  xn9(type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
    flush(this);
    this.xow_1 = false;
    this.gox_1 = createGradientPaint(this, type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio);
  }
  b48(x, y) {
    this.yow_1.b48(_get_nice__dax18u(x, this), _get_nice__dax18u(y, this));
    if (this.xow_1) {
      this.tow_1.b48(_get_nice__dax18u(x, this), _get_nice__dax18u(y, this));
    }
  }
  c48(x, y) {
    this.yow_1.c48(_get_nice__dax18u(x, this), _get_nice__dax18u(y, this));
    if (this.xow_1) {
      this.tow_1.c48(_get_nice__dax18u(x, this), _get_nice__dax18u(y, this));
    }
  }
  rn9(controlX, controlY, anchorX, anchorY) {
    this.yow_1.z4a(_get_nice__dax18u(controlX, this), _get_nice__dax18u(controlY, this), _get_nice__dax18u(anchorX, this), _get_nice__dax18u(anchorY, this));
    if (this.xow_1) {
      this.tow_1.z4a(_get_nice__dax18u(controlX, this), _get_nice__dax18u(controlY, this), _get_nice__dax18u(anchorX, this), _get_nice__dax18u(anchorY, this));
    }
  }
  yn9() {
    this.yow_1.u6();
  }
}
class SWFShapeExporter extends SWFBaseShapeExporter {
  constructor(swf, debug, bounds, export_0, rasterizerMethod, antialiasing, requestScale, minSide, maxSide, path, charId, roundDecimalPlaces, graphicsRenderer) {
    requestScale = requestScale === VOID ? 2.0 : requestScale;
    minSide = minSide === VOID ? 16 : minSide;
    maxSide = maxSide === VOID ? 512 : maxSide;
    path = path === VOID ? new VectorPath() : path;
    charId = charId === VOID ? -1 : charId;
    roundDecimalPlaces = roundDecimalPlaces === VOID ? -1 : roundDecimalPlaces;
    graphicsRenderer = graphicsRenderer === VOID ? GraphicsRenderer_SYSTEM_getInstance() : graphicsRenderer;
    super(get_bitmaps(swf), path, roundDecimalPlaces);
    this.wox_1 = swf;
    this.xox_1 = debug;
    this.yox_1 = bounds;
    this.zox_1 = export_0;
    this.aoy_1 = rasterizerMethod;
    this.boy_1 = antialiasing;
    this.coy_1 = requestScale;
    this.doy_1 = minSide;
    this.eoy_1 = maxSide;
    this.foy_1 = charId;
    this.goy_1 = graphicsRenderer;
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var b = toIntCeil(this.yox_1.j4e_1);
    tmp.hoy_1 = Math.max(1, b);
    var tmp_0 = this;
    // Inline function 'kotlin.math.max' call
    var b_0 = toIntCeil(this.yox_1.k4e_1);
    tmp_0.ioy_1 = Math.max(1, b_0);
    this.joy_1 = numberToInt(this.hoy_1 * this.coy_1);
    this.koy_1 = numberToInt(this.ioy_1 * this.coy_1);
    this.loy_1 = clamp(this.joy_1, this.doy_1, this.eoy_1);
    this.moy_1 = clamp(this.koy_1, this.doy_1, this.eoy_1);
    var tmp_1 = this;
    // Inline function 'kotlin.math.min' call
    var a = this.loy_1 / this.hoy_1;
    var b_1 = this.moy_1 / this.ioy_1;
    tmp_1.noy_1 = Math.min(a, b_1);
    this.ooy_1 = numberToInt(this.hoy_1 * this.noy_1);
    this.poy_1 = numberToInt(this.ioy_1 * this.noy_1);
    var tmp_2 = this;
    tmp_2.qoy_1 = lazy(SWFShapeExporter$actualShape$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.roy_1 = lazy(SWFShapeExporter$image$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.soy_1 = lazy(SWFShapeExporter$imageWithScale$delegate$lambda(this));
  }
  toy() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.qoy_1;
    actualShape$factory();
    return this_0.b2();
  }
  uoy() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.roy_1;
    image$factory();
    return this_0.b2();
  }
  voy() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.soy_1;
    imageWithScale$factory();
    return this_0.b2();
  }
}
class SWFExportConfig {
  constructor(debug, mipmaps, antialiasing, rasterizerMethod, exportScale, minShapeSide, maxShapeSide, minMorphShapeSide, maxMorphShapeSide, maxTextureSide, exportPaths, adaptiveScaling, smoothInterpolation, atlasPacking, roundDecimalPlaces, generateTextures, graphicsRenderer) {
    debug = debug === VOID ? false : debug;
    mipmaps = mipmaps === VOID ? true : mipmaps;
    antialiasing = antialiasing === VOID ? true : antialiasing;
    rasterizerMethod = rasterizerMethod === VOID ? ShapeRasterizerMethod_X4_getInstance() : rasterizerMethod;
    exportScale = exportScale === VOID ? 1.0 : exportScale;
    minShapeSide = minShapeSide === VOID ? 64 : minShapeSide;
    maxShapeSide = maxShapeSide === VOID ? 512 : maxShapeSide;
    minMorphShapeSide = minMorphShapeSide === VOID ? 16 : minMorphShapeSide;
    maxMorphShapeSide = maxMorphShapeSide === VOID ? 128 : maxMorphShapeSide;
    maxTextureSide = maxTextureSide === VOID ? 4096 : maxTextureSide;
    exportPaths = exportPaths === VOID ? false : exportPaths;
    adaptiveScaling = adaptiveScaling === VOID ? true : adaptiveScaling;
    smoothInterpolation = smoothInterpolation === VOID ? true : smoothInterpolation;
    atlasPacking = atlasPacking === VOID ? true : atlasPacking;
    roundDecimalPlaces = roundDecimalPlaces === VOID ? -1 : roundDecimalPlaces;
    generateTextures = generateTextures === VOID ? false : generateTextures;
    graphicsRenderer = graphicsRenderer === VOID ? GraphicsRenderer_SYSTEM_getInstance() : graphicsRenderer;
    this.xoy_1 = debug;
    this.yoy_1 = mipmaps;
    this.zoy_1 = antialiasing;
    this.aoz_1 = rasterizerMethod;
    this.boz_1 = exportScale;
    this.coz_1 = minShapeSide;
    this.doz_1 = maxShapeSide;
    this.eoz_1 = minMorphShapeSide;
    this.foz_1 = maxMorphShapeSide;
    this.goz_1 = maxTextureSide;
    this.hoz_1 = exportPaths;
    this.ioz_1 = adaptiveScaling;
    this.joz_1 = smoothInterpolation;
    this.koz_1 = atlasPacking;
    this.loz_1 = roundDecimalPlaces;
    this.moz_1 = generateTextures;
    this.noz_1 = graphicsRenderer;
  }
  ooz(debug, mipmaps, antialiasing, rasterizerMethod, exportScale, minShapeSide, maxShapeSide, minMorphShapeSide, maxMorphShapeSide, maxTextureSide, exportPaths, adaptiveScaling, smoothInterpolation, atlasPacking, roundDecimalPlaces, generateTextures, graphicsRenderer) {
    return new SWFExportConfig(debug, mipmaps, antialiasing, rasterizerMethod, exportScale, minShapeSide, maxShapeSide, minMorphShapeSide, maxMorphShapeSide, maxTextureSide, exportPaths, adaptiveScaling, smoothInterpolation, atlasPacking, roundDecimalPlaces, generateTextures, graphicsRenderer);
  }
  poz(debug, mipmaps, antialiasing, rasterizerMethod, exportScale, minShapeSide, maxShapeSide, minMorphShapeSide, maxMorphShapeSide, maxTextureSide, exportPaths, adaptiveScaling, smoothInterpolation, atlasPacking, roundDecimalPlaces, generateTextures, graphicsRenderer, $super) {
    debug = debug === VOID ? this.xoy_1 : debug;
    mipmaps = mipmaps === VOID ? this.yoy_1 : mipmaps;
    antialiasing = antialiasing === VOID ? this.zoy_1 : antialiasing;
    rasterizerMethod = rasterizerMethod === VOID ? this.aoz_1 : rasterizerMethod;
    exportScale = exportScale === VOID ? this.boz_1 : exportScale;
    minShapeSide = minShapeSide === VOID ? this.coz_1 : minShapeSide;
    maxShapeSide = maxShapeSide === VOID ? this.doz_1 : maxShapeSide;
    minMorphShapeSide = minMorphShapeSide === VOID ? this.eoz_1 : minMorphShapeSide;
    maxMorphShapeSide = maxMorphShapeSide === VOID ? this.foz_1 : maxMorphShapeSide;
    maxTextureSide = maxTextureSide === VOID ? this.goz_1 : maxTextureSide;
    exportPaths = exportPaths === VOID ? this.hoz_1 : exportPaths;
    adaptiveScaling = adaptiveScaling === VOID ? this.ioz_1 : adaptiveScaling;
    smoothInterpolation = smoothInterpolation === VOID ? this.joz_1 : smoothInterpolation;
    atlasPacking = atlasPacking === VOID ? this.koz_1 : atlasPacking;
    roundDecimalPlaces = roundDecimalPlaces === VOID ? this.loz_1 : roundDecimalPlaces;
    generateTextures = generateTextures === VOID ? this.moz_1 : generateTextures;
    graphicsRenderer = graphicsRenderer === VOID ? this.noz_1 : graphicsRenderer;
    return $super === VOID ? this.ooz(debug, mipmaps, antialiasing, rasterizerMethod, exportScale, minShapeSide, maxShapeSide, minMorphShapeSide, maxMorphShapeSide, maxTextureSide, exportPaths, adaptiveScaling, smoothInterpolation, atlasPacking, roundDecimalPlaces, generateTextures, graphicsRenderer) : $super.ooz.call(this, debug, mipmaps, antialiasing, rasterizerMethod, exportScale, minShapeSide, maxShapeSide, minMorphShapeSide, maxMorphShapeSide, maxTextureSide, exportPaths, adaptiveScaling, smoothInterpolation, atlasPacking, roundDecimalPlaces, generateTextures, graphicsRenderer);
  }
  toString() {
    return 'SWFExportConfig(debug=' + this.xoy_1 + ', mipmaps=' + this.yoy_1 + ', antialiasing=' + this.zoy_1 + ', rasterizerMethod=' + this.aoz_1.toString() + ', exportScale=' + this.boz_1 + ', minShapeSide=' + this.coz_1 + ', maxShapeSide=' + this.doz_1 + ', minMorphShapeSide=' + this.eoz_1 + ', maxMorphShapeSide=' + this.foz_1 + ', maxTextureSide=' + this.goz_1 + ', exportPaths=' + this.hoz_1 + ', adaptiveScaling=' + this.ioz_1 + ', smoothInterpolation=' + this.joz_1 + ', atlasPacking=' + this.koz_1 + ', roundDecimalPlaces=' + this.loz_1 + ', generateTextures=' + this.moz_1 + ', graphicsRenderer=' + this.noz_1.toString() + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.xoy_1);
    result = imul(result, 31) + getBooleanHashCode(this.yoy_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zoy_1) | 0;
    result = imul(result, 31) + this.aoz_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.boz_1) | 0;
    result = imul(result, 31) + this.coz_1 | 0;
    result = imul(result, 31) + this.doz_1 | 0;
    result = imul(result, 31) + this.eoz_1 | 0;
    result = imul(result, 31) + this.foz_1 | 0;
    result = imul(result, 31) + this.goz_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hoz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ioz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.joz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.koz_1) | 0;
    result = imul(result, 31) + this.loz_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.moz_1) | 0;
    result = imul(result, 31) + this.noz_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SWFExportConfig))
      return false;
    var tmp0_other_with_cast = other instanceof SWFExportConfig ? other : THROW_CCE();
    if (!(this.xoy_1 === tmp0_other_with_cast.xoy_1))
      return false;
    if (!(this.yoy_1 === tmp0_other_with_cast.yoy_1))
      return false;
    if (!(this.zoy_1 === tmp0_other_with_cast.zoy_1))
      return false;
    if (!this.aoz_1.equals(tmp0_other_with_cast.aoz_1))
      return false;
    if (!equals(this.boz_1, tmp0_other_with_cast.boz_1))
      return false;
    if (!(this.coz_1 === tmp0_other_with_cast.coz_1))
      return false;
    if (!(this.doz_1 === tmp0_other_with_cast.doz_1))
      return false;
    if (!(this.eoz_1 === tmp0_other_with_cast.eoz_1))
      return false;
    if (!(this.foz_1 === tmp0_other_with_cast.foz_1))
      return false;
    if (!(this.goz_1 === tmp0_other_with_cast.goz_1))
      return false;
    if (!(this.hoz_1 === tmp0_other_with_cast.hoz_1))
      return false;
    if (!(this.ioz_1 === tmp0_other_with_cast.ioz_1))
      return false;
    if (!(this.joz_1 === tmp0_other_with_cast.joz_1))
      return false;
    if (!(this.koz_1 === tmp0_other_with_cast.koz_1))
      return false;
    if (!(this.loz_1 === tmp0_other_with_cast.loz_1))
      return false;
    if (!(this.moz_1 === tmp0_other_with_cast.moz_1))
      return false;
    if (!this.noz_1.equals(tmp0_other_with_cast.noz_1))
      return false;
    return true;
  }
}
class MySwfTimeline {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.qoz_1 = ArrayList.m1();
  }
}
class Stop {}
class Play {}
class Goto {
  constructor(frame0) {
    this.roz_1 = frame0;
  }
}
class PlaySound {
  constructor(soundId) {
    this.soz_1 = soundId;
  }
}
class MySwfFrame {
  constructor(index0, maxDepths) {
    this.toz_1 = index0;
    this.uoz_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.voz_1 = ArrayList.m1();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.woz_1 = ArrayList.m1();
  }
  xoz() {
    return this.toz_1 === 0;
  }
  yoz() {
    return this.woz_1.f3(Stop_instance);
  }
  zoz() {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this.woz_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.a1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.korge.ext.swf.MySwfFrame.<get-hasGoto>.<anonymous>' call
        if (element instanceof Goto) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  ap0() {
    return this.yoz() || this.zoz();
  }
  m7w() {
    // Inline function 'kotlin.collections.plusAssign' call
    this.woz_1.f(Stop_instance);
  }
  i85() {
    // Inline function 'kotlin.collections.plusAssign' call
    this.woz_1.f(Play_instance);
  }
  bp0(frame) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.woz_1;
    var element = new Goto(frame);
    this_0.f(element);
  }
  cp0(frame) {
    this.bp0(frame);
    this.m7w();
  }
  dp0(frame) {
    this.bp0(frame);
    this.i85();
  }
  ep0(soundId) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.woz_1;
    var element = new PlaySound(soundId);
    this_0.f(element);
  }
}
class SwfLoaderMethod$generateActualTimelines$Subtimeline {
  constructor(this$0, index, totalFrames, nextState, nextStatePlay) {
    totalFrames = totalFrames === VOID ? 0 : totalFrames;
    nextState = nextState === VOID ? null : nextState;
    nextStatePlay = nextStatePlay === VOID ? true : nextStatePlay;
    this.dp1_1 = this$0;
    this.zp0_1 = index;
    this.ap1_1 = totalFrames;
    this.bp1_1 = nextState;
    this.cp1_1 = nextStatePlay;
  }
  lp1() {
    return this.dp1_1.cp2(this.ap1_1);
  }
  toString() {
    return 'Subtimeline(index=' + this.zp0_1 + ', totalFrames=' + this.ap1_1 + ', nextState=' + this.bp1_1 + ', nextStatePlay=' + this.cp1_1 + ')';
  }
  hashCode() {
    var result = this.zp0_1;
    result = imul(result, 31) + this.ap1_1 | 0;
    result = imul(result, 31) + (this.bp1_1 == null ? 0 : getStringHashCode(this.bp1_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.cp1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwfLoaderMethod$generateActualTimelines$Subtimeline))
      return false;
    var tmp0_other_with_cast = other instanceof SwfLoaderMethod$generateActualTimelines$Subtimeline ? other : THROW_CCE();
    if (!(this.zp0_1 === tmp0_other_with_cast.zp0_1))
      return false;
    if (!(this.ap1_1 === tmp0_other_with_cast.ap1_1))
      return false;
    if (!(this.bp1_1 == tmp0_other_with_cast.bp1_1))
      return false;
    if (!(this.cp1_1 === tmp0_other_with_cast.cp1_1))
      return false;
    return true;
  }
}
class SwfLoaderMethod$generateActualTimelines$FrameInfo {
  constructor(this$0, subtimeline, frameInSubTimeline, stateName, startSubtimeline, startNamedState) {
    this.kp1_1 = this$0;
    this.ep1_1 = subtimeline;
    this.fp1_1 = frameInSubTimeline;
    this.gp1_1 = stateName;
    this.hp1_1 = startSubtimeline;
    this.ip1_1 = startNamedState;
    this.jp1_1 = this$0.cp2(this.fp1_1);
  }
  toString() {
    return 'FrameInfo(subtimeline=' + this.ep1_1.toString() + ', frameInSubTimeline=' + this.fp1_1 + ', stateName=' + this.gp1_1 + ', startSubtimeline=' + this.hp1_1 + ', startNamedState=' + this.ip1_1 + ')';
  }
  hashCode() {
    var result = this.ep1_1.hashCode();
    result = imul(result, 31) + this.fp1_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.gp1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hp1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ip1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwfLoaderMethod$generateActualTimelines$FrameInfo))
      return false;
    var tmp0_other_with_cast = other instanceof SwfLoaderMethod$generateActualTimelines$FrameInfo ? other : THROW_CCE();
    if (!this.ep1_1.equals(tmp0_other_with_cast.ep1_1))
      return false;
    if (!(this.fp1_1 === tmp0_other_with_cast.fp1_1))
      return false;
    if (!(this.gp1_1 === tmp0_other_with_cast.gp1_1))
      return false;
    if (!(this.hp1_1 === tmp0_other_with_cast.hp1_1))
      return false;
    if (!(this.ip1_1 === tmp0_other_with_cast.ip1_1))
      return false;
    return true;
  }
}
class SwfLoaderMethod$parseMovieClipInternal$DepthInfo {
  constructor(depth, uid, charId, clipDepth, name, colorTransform, ratio, matrix, blendMode, filterList) {
    uid = uid === VOID ? -1 : uid;
    charId = charId === VOID ? -1 : charId;
    clipDepth = clipDepth === VOID ? -1 : clipDepth;
    name = name === VOID ? null : name;
    var tmp;
    if (colorTransform === VOID) {
      // Inline function 'korlibs.image.color.ColorTransform' call
      var multiply = Colors_getInstance().g4r_1;
      // Inline function 'korlibs.image.color.Companion.invoke' call
      var add = _ColorAdd___init__impl__q78um5(ColorAdd_pack(0, 0, 0, 0));
      tmp = new ColorTransform(_RGBA___get_rf__impl__kvz75k(multiply), _RGBA___get_gf__impl__5gcu1f(multiply), _RGBA___get_bf__impl__1xz5yg(multiply), _RGBA___get_af__impl__vu36qv(multiply), _ColorAdd___get_r__impl__j9xkne(add), _ColorAdd___get_g__impl__itrhk1(add), _ColorAdd___get_b__impl__grv87a(add), _ColorAdd___get_a__impl__c1r8ux(add));
    } else {
      tmp = colorTransform;
    }
    colorTransform = tmp;
    ratio = ratio === VOID ? Companion_getInstance_10().f10_1 : ratio;
    matrix = matrix === VOID ? new MMatrix() : matrix;
    blendMode = blendMode === VOID ? Companion_getInstance_14().sa5_1 : blendMode;
    filterList = filterList === VOID ? emptyList() : filterList;
    this.dp2_1 = depth;
    this.ep2_1 = uid;
    this.fp2_1 = charId;
    this.gp2_1 = clipDepth;
    this.hp2_1 = name;
    this.ip2_1 = colorTransform;
    this.jp2_1 = ratio;
    this.kp2_1 = matrix;
    this.lp2_1 = blendMode;
    this.mp2_1 = filterList;
  }
  z33() {
    this.ep2_1 = -1;
    this.jp2_1 = Companion_getInstance_10().f10_1;
    this.fp2_1 = -1;
    this.gp2_1 = -1;
    this.ip2_1.a59();
    this.hp2_1 = null;
    this.kp2_1 = new MMatrix();
    this.lp2_1 = Companion_getInstance_14().sa5_1;
  }
  rp2(value, passes) {
    var passesFactor;
    switch (passes) {
      case 1:
        passesFactor = 2.5;
        break;
      case 2:
        passesFactor = 3.0;
        break;
      case 3:
        passesFactor = 8.329042969130445;
        break;
      default:
        passesFactor = 1.0;
        break;
    }
    return value / passesFactor;
  }
  np2() {
    var tmp121_depth = this.dp2_1;
    var tmp122_clipDepth = this.gp2_1;
    var tmp123_uid = this.ep2_1;
    var tmp124_ratio = this.jp2_1;
    var tmp125_name = this.hp2_1;
    var tmp126_transform = this.kp2_1;
    var tmp127_colorTransform = this.ip2_1;
    var tmp128_blendMode = this.lp2_1;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.mp2_1;
    var destination = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.korge.ext.swf.DepthInfo.toFrameElement.<anonymous>' call
      var tmp;
      if (element instanceof FilterBlur) {
        var blurAvg = (element.dnc_1 + element.enc_1) * 0.5;
        var blurAmount = this.rp2(blurAvg, element.fnc_1);
        // Inline function 'korlibs.korge.view.filter.Companion.invoke' call
        var tmp$ret$0 = BlurFilter.chf(numberToDouble(blurAmount), true, false);
        tmp = ComposedFilter.ghg([tmp$ret$0]);
      } else {
        if (element instanceof FilterDropShadow) {
          // Inline function 'korlibs.korge.view.filter.Companion.invoke' call
          Companion_getInstance_13();
          var dropX = element.tnb_1;
          var dropY = element.unb_1;
          var shadowColor = decodeSWFColor(element.snb_1);
          var blurRadius = this.rp2(element.wnb_1, element.bnc_1);
          tmp = new DropshadowFilter(numberToDouble(dropX), numberToDouble(dropY), shadowColor, numberToDouble(blurRadius), true);
        } else {
          println('Unimplemented SWF filter: ' + toString(element));
          tmp = null;
        }
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.f(tmp0_safe_receiver);
      }
    }
    var tmp129_filter = composedOrNull(destination);
    return new AnSymbolTimelineFrame(tmp121_depth, tmp123_uid, tmp122_clipDepth, tmp124_ratio, tmp126_transform, tmp125_name, tmp127_colorTransform, tmp128_blendMode, tmp129_filter);
  }
  toString() {
    return 'DepthInfo(depth=' + this.dp2_1 + ', uid=' + this.ep2_1 + ', charId=' + this.fp2_1 + ', clipDepth=' + this.gp2_1 + ', name=' + this.hp2_1 + ', colorTransform=' + this.ip2_1.toString() + ', ratio=' + Ratio__toString_impl_mfgt3e(this.jp2_1) + ', matrix=' + this.kp2_1.toString() + ', blendMode=' + this.lp2_1.toString() + ', filterList=' + toString(this.mp2_1) + ')';
  }
  hashCode() {
    var result = this.dp2_1;
    result = imul(result, 31) + this.ep2_1 | 0;
    result = imul(result, 31) + this.fp2_1 | 0;
    result = imul(result, 31) + this.gp2_1 | 0;
    result = imul(result, 31) + (this.hp2_1 == null ? 0 : getStringHashCode(this.hp2_1)) | 0;
    result = imul(result, 31) + this.ip2_1.hashCode() | 0;
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.jp2_1) | 0;
    result = imul(result, 31) + this.kp2_1.hashCode() | 0;
    result = imul(result, 31) + this.lp2_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.mp2_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwfLoaderMethod$parseMovieClipInternal$DepthInfo))
      return false;
    var tmp0_other_with_cast = other instanceof SwfLoaderMethod$parseMovieClipInternal$DepthInfo ? other : THROW_CCE();
    if (!(this.dp2_1 === tmp0_other_with_cast.dp2_1))
      return false;
    if (!(this.ep2_1 === tmp0_other_with_cast.ep2_1))
      return false;
    if (!(this.fp2_1 === tmp0_other_with_cast.fp2_1))
      return false;
    if (!(this.gp2_1 === tmp0_other_with_cast.gp2_1))
      return false;
    if (!(this.hp2_1 == tmp0_other_with_cast.hp2_1))
      return false;
    if (!this.ip2_1.equals(tmp0_other_with_cast.ip2_1))
      return false;
    if (!equals(this.jp2_1, tmp0_other_with_cast.jp2_1))
      return false;
    if (!this.kp2_1.equals(tmp0_other_with_cast.kp2_1))
      return false;
    if (!this.lp2_1.equals(tmp0_other_with_cast.lp2_1))
      return false;
    if (!equals(this.mp2_1, tmp0_other_with_cast.mp2_1))
      return false;
    return true;
  }
}
class SwfLoaderMethod {
  constructor(context, config) {
    this.fp0_1 = context;
    this.gp0_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.jp0_1 = HashMap.c9();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.kp0_1 = HashMap.c9();
    this.lp0_1 = LinkedHashMap.vc();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.mp0_1 = ArrayList.m1();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_2.np0_1 = HashMap.c9();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_3.op0_1 = HashMap.c9();
    this.pp0_1 = false;
    var tmp_4 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_4.qp0_1 = ArrayList.m1();
    this.rp0_1 = 0;
    this.sp0_1 = 0;
    var tmp_5 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_5.tp0_1 = HashMap.c9();
  }
  vp0() {
    var tmp = this.hp0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('swf');
    }
  }
  yp0() {
    var tmp = this.ip0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('lib');
    }
  }
  rp1(id) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.op0_1;
    var value = this_0.k3(id);
    var tmp;
    if (value == null) {
      // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.analyzerInfo.<anonymous>' call
      var answer = new SymbolAnalyzeInfo(id);
      this_0.r3(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  up0(data, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_load__qllgda(this, data, $completion), $completion);
  }
  cp2(index0) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = numberToInt(index0 * this.yp0().hoj_1);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
  }
  wp0(tags) {
    var maxDepth = -1;
    var totalFrames = 0;
    // Inline function 'kotlin.collections.hashSetOf' call
    var items = HashSet.xa();
    var _iterator__ex2g4s = tags.f1();
    while (_iterator__ex2g4s.g1()) {
      var it = _iterator__ex2g4s.h1();
      if (it instanceof TagPlaceObject) {
        if (it.jnh_1) {
          // Inline function 'kotlin.collections.plusAssign' call
          // Inline function 'korlibs.korge.ext.swf.depth0' call
          var tmp$ret$1 = it.tnh_1 - 1 | 0;
          var element = to(tmp$ret$1, it.snh_1);
          items.f(element);
        }
        // Inline function 'kotlin.math.max' call
        var a = maxDepth;
        // Inline function 'korlibs.korge.ext.swf.depth0' call
        var b = it.tnh_1 - 1 | 0;
        maxDepth = Math.max(a, b);
        if (it.enh_1) {
          // Inline function 'kotlin.math.max' call
          var a_0 = maxDepth;
          // Inline function 'korlibs.korge.ext.swf.clipDepth0' call
          var b_0 = (it.ynh_1 - 1 | 0) + 1 | 0;
          maxDepth = Math.max(a_0, b_0);
        }
      } else {
        if (it instanceof TagShowFrame) {
          totalFrames = totalFrames + 1 | 0;
        }
      }
    }
    var tmp = maxDepth + 1 | 0;
    var tmp_0 = totalFrames;
    var tmp_1 = items.j1();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = numberToInt(totalFrames * this.yp0().hoj_1);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$7 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    return new AnSymbolLimits(tmp, tmp_0, tmp_1, tmp$ret$7);
  }
  qp2(charId, bmp, name) {
    // Inline function 'kotlin.collections.set' call
    get_bitmaps(this.vp0()).r3(charId, bmp);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.qp0_1;
    var element = new AnSymbolBitmap(charId, name, bmp);
    this_0.f(element);
  }
  xp0(tags, mc, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parseMovieClip__kuikn9(this, tags, mc, $completion), $completion);
  }
}
class SWFShapeRasterizerRequest {
  constructor(swf, tag, config) {
    this.mp1_1 = swf;
    this.np1_1 = tag;
    this.op1_1 = config;
    this.pp1_1 = new VectorPath();
  }
  qp1() {
    return this.np1_1.vmo();
  }
  fng() {
    return this.np1_1.fng().o42();
  }
  bp2(maxScale) {
    return getShapeExporter(this.np1_1, this.mp1_1, this.op1_1, maxScale, this.pp1_1);
  }
}
class SymbolAnalyzeInfo {
  constructor(characterId) {
    this.vp1_1 = characterId;
    this.wp1_1 = false;
    this.xp1_1 = LinkedHashSet.l1();
    this.yp1_1 = new MinMaxDouble();
    var tmp = this;
    tmp.zp1_1 = lazy(SymbolAnalyzeInfo$globalScaleBounds$delegate$lambda(this));
  }
  ap2() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.zp1_1;
    globalScaleBounds$factory();
    return this_0.b2();
  }
  op2(characterId) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.xp1_1.f(characterId);
  }
  up2(scaleX, scaleY) {
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(scaleX, scaleY);
    this.yp1_1.sp2(tmp$ret$0);
  }
  pp2(matrix) {
    // Inline function 'kotlin.math.abs' call
    var x = matrix.a4d_1;
    var tmp = Math.abs(x);
    // Inline function 'kotlin.math.abs' call
    var x_0 = matrix.d4d_1;
    var tmp$ret$1 = Math.abs(x_0);
    this.up2(tmp, tmp$ret$1);
  }
}
class MinMaxDouble {
  constructor(count, min, max) {
    count = count === VOID ? 0 : count;
    min = min === VOID ? 0.0 : min;
    max = max === VOID ? 0.0 : max;
    this.sp1_1 = count;
    this.tp1_1 = min;
    this.up1_1 = max;
  }
  vp2() {
    return this.sp1_1 === 0;
  }
  m4e() {
    return this.sp1_1 > 0;
  }
  sp2(value) {
    if (this.vp2()) {
      this.tp1_1 = value;
      this.up1_1 = value;
    } else {
      var tmp = this;
      // Inline function 'kotlin.math.min' call
      var a = this.tp1_1;
      tmp.tp1_1 = Math.min(a, value);
      var tmp_0 = this;
      // Inline function 'kotlin.math.max' call
      var a_0 = this.up1_1;
      tmp_0.up1_1 = Math.max(a_0, value);
    }
    this.sp1_1 = this.sp1_1 + 1 | 0;
  }
  tp2(value) {
    if (value.m4e()) {
      this.sp2(value.tp1_1);
      this.sp2(value.up1_1);
    }
  }
  toString() {
    return 'MinMaxDouble(count=' + this.sp1_1 + ', min=' + this.tp1_1 + ', max=' + this.up1_1 + ')';
  }
  hashCode() {
    var result = this.sp1_1;
    result = imul(result, 31) + getNumberHashCode(this.tp1_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.up1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MinMaxDouble))
      return false;
    var tmp0_other_with_cast = other instanceof MinMaxDouble ? other : THROW_CCE();
    if (!(this.sp1_1 === tmp0_other_with_cast.sp1_1))
      return false;
    if (!equals(this.tp1_1, tmp0_other_with_cast.tp1_1))
      return false;
    if (!equals(this.up1_1, tmp0_other_with_cast.up1_1))
      return false;
    return true;
  }
}
class FontsCatalog {
  constructor(default_0, context, fonts) {
    context = context === VOID ? null : context;
    var tmp;
    if (fonts === VOID) {
      // Inline function 'kotlin.collections.hashMapOf' call
      tmp = HashMap.c9();
    } else {
      tmp = fonts;
    }
    fonts = tmp;
    this.jp3_1 = default_0;
    this.kp3_1 = context;
    this.lp3_1 = fonts;
  }
  mp3() {
    return get_debugBmpFontSync();
  }
  np3(_this__u8e3s4) {
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = _this__u8e3s4.toLowerCase();
    return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  op3(name, font) {
    var tmp0_elvis_lhs = this.lp3_1.k3(name == null ? null : this.np3(name));
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? font : tmp0_elvis_lhs;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.jp3_1 : tmp1_elvis_lhs;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp138_safe_receiver = this.kp3_1;
      var tmp_0;
      if (tmp138_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.textOld.FontsCatalog.getBitmapFontOrNull.<anonymous>' call
        tmp_0 = new SystemFont(name == null ? 'default' : name, tmp138_safe_receiver);
      }
      tmp = tmp_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  }
  pp3(name, font) {
    var tmp0_elvis_lhs = this.op3(name, font);
    return tmp0_elvis_lhs == null ? this.mp3() : tmp0_elvis_lhs;
  }
  qp3(name, font, $super) {
    font = font === VOID ? null : font;
    return $super === VOID ? this.pp3(name, font) : $super.pp3.call(this, name, font);
  }
  rp3(font) {
    if (!(font == null) ? isInterface(font, BitmapFont) : false)
      return font;
    var tmp140_safe_receiver = font == null ? null : font.w3();
    var fontName = tmp140_safe_receiver == null ? null : this.np3(tmp140_safe_receiver);
    var tmp = this.lp3_1.k3(fontName);
    var tmp141_safe_receiver = (!(tmp == null) ? isInterface(tmp, BitmapFont) : false) ? tmp : null;
    if (tmp141_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp141_safe_receiver;
    }
    var tmp_0 = this.lp3_1;
    var tmp142_safe_receiver = isInterface(tmp_0, KtMutableMap) ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (tmp142_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.getOrPut' call
      var key = '' + fontName + '.$BitmapFont';
      var value = tmp142_safe_receiver.k3(key);
      var tmp_2;
      if (value == null) {
        // Inline function 'korlibs.korge.view.textOld.FontsCatalog.getBitmapFont.<anonymous>' call
        var tmp_3;
        if (font == null) {
          tmp_3 = null;
        } else {
          // Inline function 'korlibs.image.font.toBitmapFont' call
          var chars = Companion_getInstance_7().p5o_1;
          var fontName_0 = font.w3();
          var paint = new RGBA(Colors_getInstance().g4r_1);
          tmp_3 = Companion_instance_1.l5k(font, numberToDouble(32.0), chars, fontName_0, paint, true, null);
        }
        var answer = tmp_3;
        tmp142_safe_receiver.r3(key, answer);
        tmp_2 = answer;
      } else {
        tmp_2 = value;
      }
      tmp_1 = tmp_2;
    }
    var tmp_4 = tmp_1;
    var tmp0_elvis_lhs = (tmp_4 == null ? true : isInterface(tmp_4, BitmapFont)) ? tmp_4 : null;
    return tmp0_elvis_lhs == null ? this.mp3() : tmp0_elvis_lhs;
  }
  sp3(text, format, out) {
    var font = format.tp3();
    getBounds(this.pp3(font == null ? null : font.w3(), font), text, format, out);
  }
}
class Format {
  constructor(parent, color, face, size, letterSpacing, kerning, align) {
    parent = parent === VOID ? null : parent;
    color = color === VOID ? null : color;
    face = face === VOID ? null : face;
    size = size === VOID ? null : size;
    letterSpacing = letterSpacing === VOID ? null : letterSpacing;
    kerning = kerning === VOID ? null : kerning;
    align = align === VOID ? null : align;
    this.wp2_1 = parent;
    this.xp2_1 = color;
    this.yp2_1 = face;
    this.zp2_1 = size;
    this.ap3_1 = letterSpacing;
    this.bp3_1 = kerning;
    this.cp3_1 = align;
    var tmp = this;
    var tmp_0 = face$factory();
    tmp.dp3_1 = new Computed(tmp_0, Html$Format$computedFace$delegate$lambda);
    var tmp_1 = this;
    var tmp_2 = size$factory();
    tmp_1.ep3_1 = new Computed(tmp_2, Html$Format$computedSize$delegate$lambda);
    var tmp_3 = this;
    var tmp_4 = letterSpacing$factory();
    tmp_3.fp3_1 = new Computed(tmp_4, Html$Format$computedLetterSpacing$delegate$lambda);
    var tmp_5 = this;
    var tmp_6 = kerning$factory();
    tmp_5.gp3_1 = new Computed(tmp_6, Html$Format$computedKerning$delegate$lambda);
    var tmp_7 = this;
    var tmp_8 = align$factory();
    tmp_7.hp3_1 = new Computed(tmp_8, Html$Format$computedAlign$delegate$lambda);
  }
  w15() {
    return this.wp2_1;
  }
  up3() {
    var tmp145_safe_receiver = this.wp2_1;
    var tmp0_elvis_lhs = tmp145_safe_receiver == null ? null : tmp145_safe_receiver.up3();
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
      tmp = this.xp2_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
      tmp_1 = Colors_getInstance().g4r_1;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  tp3() {
    return this.dp3_1.c3e(this, computedFace$factory());
  }
  ip3() {
    return this.ep3_1.c3e(this, computedSize$factory());
  }
  vp3() {
    return this.fp3_1.c3e(this, computedLetterSpacing$factory());
  }
  wp3() {
    return this.gp3_1.c3e(this, computedKerning$factory());
  }
  xp3() {
    return this.hp3_1.c3e(this, computedAlign$factory());
  }
  yp3() {
    return new Format(null, this.up3(), this.tp3(), this.ip3(), this.vp3(), this.wp3(), this.xp3());
  }
  toString() {
    var tmp = toString_0(this.wp2_1);
    var tmp_0 = this.xp2_1;
    return 'Format(parent=' + tmp + ', color=' + toString_0(tmp_0 == null ? null : new RGBA(tmp_0)) + ', face=' + toString_0(this.yp2_1) + ', size=' + this.zp2_1 + ', letterSpacing=' + this.ap3_1 + ', kerning=' + this.bp3_1 + ', align=' + toString_0(this.cp3_1) + ')';
  }
  hashCode() {
    var result = this.wp2_1 == null ? 0 : this.wp2_1.hashCode();
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.xp2_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.xp2_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + (this.yp2_1 == null ? 0 : hashCode(this.yp2_1)) | 0;
    result = imul(result, 31) + (this.zp2_1 == null ? 0 : this.zp2_1) | 0;
    result = imul(result, 31) + (this.ap3_1 == null ? 0 : getNumberHashCode(this.ap3_1)) | 0;
    result = imul(result, 31) + (this.bp3_1 == null ? 0 : this.bp3_1) | 0;
    result = imul(result, 31) + (this.cp3_1 == null ? 0 : this.cp3_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Format))
      return false;
    var tmp0_other_with_cast = other instanceof Format ? other : THROW_CCE();
    if (!equals(this.wp2_1, tmp0_other_with_cast.wp2_1))
      return false;
    var tmp = this.xp2_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.xp2_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!equals(this.yp2_1, tmp0_other_with_cast.yp2_1))
      return false;
    if (!(this.zp2_1 == tmp0_other_with_cast.zp2_1))
      return false;
    if (!equals(this.ap3_1, tmp0_other_with_cast.ap3_1))
      return false;
    if (!(this.bp3_1 == tmp0_other_with_cast.bp3_1))
      return false;
    if (!equals(this.cp3_1, tmp0_other_with_cast.cp3_1))
      return false;
    return true;
  }
}
class PositionContext {
  constructor(provider, bounds, x, y) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    this.zp3_1 = provider;
    this.ap4_1 = bounds;
    this.bp4_1 = x;
    this.cp4_1 = y;
  }
  toString() {
    return 'PositionContext(provider=' + toString(this.zp3_1) + ', bounds=' + this.ap4_1.toString() + ', x=' + this.bp4_1 + ', y=' + this.cp4_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.zp3_1);
    result = imul(result, 31) + this.ap4_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.bp4_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.cp4_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PositionContext))
      return false;
    var tmp0_other_with_cast = other instanceof PositionContext ? other : THROW_CCE();
    if (!equals(this.zp3_1, tmp0_other_with_cast.zp3_1))
      return false;
    if (!this.ap4_1.equals(tmp0_other_with_cast.ap4_1))
      return false;
    if (!equals(this.bp4_1, tmp0_other_with_cast.bp4_1))
      return false;
    if (!equals(this.cp4_1, tmp0_other_with_cast.cp4_1))
      return false;
    return true;
  }
}
class Span {
  constructor(format, text) {
    this.dp4_1 = new Mixin();
    this.ep4_1 = format;
    this.fp4_1 = text;
    this.gp4_1 = Companion_getInstance_2().l2m();
  }
  n13(_set____db54di) {
    this.dp4_1.n13(_set____db54di);
  }
  o13() {
    return this.dp4_1.o13();
  }
  hp4(ctx) {
    ctx.zp3_1.sp3(this.fp4_1, this.ep4_1, this.gp4_1);
    var _receiver__tnumb7 = this.gp4_1;
    _receiver__tnumb7.h4e_1 = _receiver__tnumb7.h4e_1 + ctx.bp4_1;
    ctx.bp4_1 = ctx.bp4_1 + this.gp4_1.j4e_1;
  }
  toString() {
    return 'Span(format=' + this.ep4_1.toString() + ', text=' + this.fp4_1 + ')';
  }
  hashCode() {
    var result = this.ep4_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.fp4_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Span))
      return false;
    var tmp0_other_with_cast = other instanceof Span ? other : THROW_CCE();
    if (!this.ep4_1.equals(tmp0_other_with_cast.ep4_1))
      return false;
    if (!(this.fp4_1 === tmp0_other_with_cast.fp4_1))
      return false;
    return true;
  }
}
class Line {
  constructor(spans) {
    var tmp;
    if (spans === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList.m1();
    } else {
      tmp = spans;
    }
    spans = tmp;
    this.ip4_1 = new Mixin();
    this.jp4_1 = spans;
    this.kp4_1 = new Format();
    this.lp4_1 = Companion_getInstance_2().l2m();
  }
  n13(_set____db54di) {
    this.ip4_1.n13(_set____db54di);
  }
  o13() {
    return this.ip4_1.o13();
  }
  mp4() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.jp4_1.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.korge.view.textOld.Line.<get-firstNonEmptySpan>.<anonymous>' call
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_0 = element.fp4_1;
        if (charSequenceLength(this_0) > 0) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    return tmp$ret$2;
  }
  hp4(ctx) {
    ctx.bp4_1 = ctx.ap4_1.h4e_1;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.jp4_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.korge.view.textOld.Line.doPositioning.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.i1(_unary__edvuaz).hp4(ctx);
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.jp4_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.view.textOld.Line.doPositioning.<anonymous>' call
      var tmp$ret$0 = item.gp4_1;
      destination.f(tmp$ret$0);
    }
    bounds(destination, this.lp4_1);
    var restoreY = this.lp4_1.i4e_1;
    this.lp4_1.z4e(this.lp4_1, this.kp4_1.xp3().b5u_1, ctx.ap4_1);
    this.lp4_1.i4e_1 = restoreY;
    var sx = this.lp4_1.h4e_1;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.jp4_1;
    var n_0 = 0;
    while (n_0 < this_2.j1()) {
      // Inline function 'korlibs.korge.view.textOld.Line.doPositioning.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_2.i1(_unary__edvuaz_0);
      v.gp4_1.h4e_1 = sx;
      sx = sx + v.gp4_1.j4e_1;
    }
    ctx.bp4_1 = ctx.ap4_1.h4e_1;
    ctx.cp4_1 = ctx.cp4_1 + this.lp4_1.k4e_1;
  }
  toString() {
    return 'Line(spans=' + this.jp4_1.toString() + ')';
  }
  hashCode() {
    return this.jp4_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!this.jp4_1.equals(tmp0_other_with_cast.jp4_1))
      return false;
    return true;
  }
}
class Paragraph {
  constructor(lines) {
    var tmp;
    if (lines === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList.m1();
    } else {
      tmp = lines;
    }
    lines = tmp;
    this.np4_1 = new Mixin();
    this.op4_1 = lines;
    this.pp4_1 = Companion_getInstance_2().l2m();
  }
  n13(_set____db54di) {
    this.np4_1.n13(_set____db54di);
  }
  o13() {
    return this.np4_1.o13();
  }
  qp4() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.op4_1.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.korge.view.textOld.Paragraph.<get-firstNonEmptyLine>.<anonymous>' call
        if (!(element.mp4() == null)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  hp4(ctx) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.op4_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.korge.view.textOld.Paragraph.doPositioning.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.i1(_unary__edvuaz).hp4(ctx);
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.op4_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.view.textOld.Paragraph.doPositioning.<anonymous>' call
      var tmp$ret$0 = item.lp4_1;
      destination.f(tmp$ret$0);
    }
    bounds(destination, this.pp4_1);
    ctx.bp4_1 = this.pp4_1.p2i();
    ctx.cp4_1 = this.pp4_1.s2i();
  }
  toString() {
    return 'Paragraph(lines=' + this.op4_1.toString() + ')';
  }
  hashCode() {
    return this.op4_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Paragraph))
      return false;
    var tmp0_other_with_cast = other instanceof Paragraph ? other : THROW_CCE();
    if (!this.op4_1.equals(tmp0_other_with_cast.op4_1))
      return false;
    return true;
  }
}
class Document {
  constructor(paragraphs) {
    var tmp;
    if (paragraphs === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList.m1();
    } else {
      tmp = paragraphs;
    }
    paragraphs = tmp;
    this.rp4_1 = new Mixin();
    this.sp4_1 = paragraphs;
    this.tp4_1 = new Format();
    this.up4_1 = Xml('');
    this.vp4_1 = Companion_getInstance_2().l2m();
  }
  n13(_set____db54di) {
    this.rp4_1.n13(_set____db54di);
  }
  o13() {
    return this.rp4_1.o13();
  }
  wp4() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.sp4_1.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.korge.view.textOld.Document.<get-firstNonEmptyParagraph>.<anonymous>' call
        if (!(element.qp4() == null)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  mp4() {
    var tmp146_safe_receiver = this.wp4();
    var tmp147_safe_receiver = tmp146_safe_receiver == null ? null : tmp146_safe_receiver.qp4();
    return tmp147_safe_receiver == null ? null : tmp147_safe_receiver.mp4();
  }
  xp4() {
    var tmp148_safe_receiver = this.mp4();
    var tmp0_elvis_lhs = tmp148_safe_receiver == null ? null : tmp148_safe_receiver.ep4_1;
    return tmp0_elvis_lhs == null ? new Format() : tmp0_elvis_lhs;
  }
  yp4() {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.sp4_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.view.textOld.Document.<get-allSpans>.<anonymous>' call
      var list = element.op4_1;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList.m1();
    var tmp0_iterator_0 = destination.f1();
    while (tmp0_iterator_0.g1()) {
      var element_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.korge.view.textOld.Document.<get-allSpans>.<anonymous>' call
      var list_0 = element_0.jp4_1;
      addAll(destination_0, list_0);
    }
    return destination_0;
  }
  zp4(gp, bounds_0) {
    var ctx = new PositionContext(gp, bounds_0);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.sp4_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.korge.view.textOld.Document.doPositioning.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.i1(_unary__edvuaz).hp4(ctx);
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.sp4_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.view.textOld.Document.doPositioning.<anonymous>' call
      var tmp$ret$0 = item.pp4_1;
      destination.f(tmp$ret$0);
    }
    bounds(destination, this.vp4_1);
  }
  toString() {
    return 'Document(paragraphs=' + this.sp4_1.toString() + ')';
  }
  hashCode() {
    return this.sp4_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Document))
      return false;
    var tmp0_other_with_cast = other instanceof Document ? other : THROW_CCE();
    if (!this.sp4_1.equals(tmp0_other_with_cast.sp4_1))
      return false;
    return true;
  }
}
class HtmlParser {
  constructor(fontsCatalog) {
    this.ap5_1 = fontsCatalog;
    this.bp5_1 = new Document();
    this.cp5_1 = new Line();
    this.dp5_1 = new Paragraph();
  }
  ep5(_this__u8e3s4) {
    return _this__u8e3s4.n2e_1 === 'p' || _this__u8e3s4.n2e_1 === 'div';
  }
  fp5(format, text) {
    if (this.cp5_1.jp4_1.a1()) {
      this.cp5_1.kp4_1 = new Format(format);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.cp5_1.jp4_1;
    var element = new Span(new Format(format), text);
    this_0.f(element);
  }
  gp5(format) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.cp5_1.jp4_1.a1()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_0 = this.dp5_1.op4_1;
      var element = this.cp5_1;
      this_0.f(element);
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.bp5_1.sp4_1;
      var element_0 = this.dp5_1;
      this_1.f(element_0);
      this.dp5_1 = new Paragraph();
      this.cp5_1 = new Line();
    }
  }
  hp5(xml, format) {
    if (get_isText(xml)) {
      this.fp5(format, xml.o2f());
    } else if (!get_isComment(xml))
      if (get_isNode(xml)) {
        var block = this.ep5(xml);
        var tmp = format;
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        switch (xml.y2f('align').toLowerCase()) {
          case 'center':
            tmp.cp3_1 = Companion_getInstance_6().q5s_1;
            break;
          case 'left':
            tmp.cp3_1 = Companion_getInstance_6().p5s_1;
            break;
          case 'right':
            tmp.cp3_1 = Companion_getInstance_6().r5s_1;
            break;
          case 'jusitifed':
            tmp.cp3_1 = Companion_getInstance_6().s5s_1;
            break;
          default:
            tmp.cp3_1 = format.cp3_1;
            break;
        }
        var face = xml.g2g('face');
        var tmp_0 = format;
        var tmp_1;
        if (!(face == null)) {
          var tmp150_safe_receiver = this.ap5_1;
          tmp_1 = tmp150_safe_receiver == null ? null : tmp150_safe_receiver.qp3(face);
        } else {
          tmp_1 = format.yp2_1;
        }
        tmp_0.yp2_1 = tmp_1;
        var tmp_2 = format;
        var tmp0_elvis_lhs = xml.f2g('size');
        tmp_2.zp2_1 = tmp0_elvis_lhs == null ? format.zp2_1 : tmp0_elvis_lhs;
        var tmp_3 = format;
        var tmp1_elvis_lhs = xml.e2g('letterSpacing');
        tmp_3.ap3_1 = tmp1_elvis_lhs == null ? format.ap3_1 : tmp1_elvis_lhs;
        var tmp_4 = format;
        var tmp2_elvis_lhs = xml.f2g('kerning');
        tmp_4.bp3_1 = tmp2_elvis_lhs == null ? format.bp3_1 : tmp2_elvis_lhs;
        var tmp_5 = format;
        var tmp_6 = Colors_getInstance();
        var tmp3_elvis_lhs = xml.g2g('color');
        tmp_5.xp2_1 = tmp_6.r59(tmp3_elvis_lhs == null ? 'white' : tmp3_elvis_lhs);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = xml.q2f();
        var n = 0;
        while (n < this_0.j1()) {
          // Inline function 'korlibs.korge.view.textOld.HtmlParser.parse.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = this_0.i1(_unary__edvuaz);
          this.hp5(child, new Format(format));
        }
        if (block) {
          this.gp5(format);
        }
      }
    return format;
  }
  ip5(html) {
    var xml = Xml(html);
    this.bp5_1.up4_1 = xml;
    var format = this.hp5(xml, this.bp5_1.tp4_1);
    this.gp5(format);
  }
}
class Html {
  constructor() {
    Html_instance = this;
    this.jp5_1 = new FontsCatalog(null, null);
  }
  kp5(html, fontsCatalog) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HtmlParser(fontsCatalog);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.textOld.Html.parse.<anonymous>' call
    this_0.ip5(html);
    return this_0.bp5_1;
  }
}
class Companion_32 {
  lp5(text, textSize, color, font, fontsCatalog) {
    // Inline function 'kotlin.apply' call
    var this_0 = TextOld.mp5();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.textOld.Companion.invoke.<anonymous>' call
    this_0.tov(new Format(VOID, color, font, numberToInt(textSize)));
    if (!(text === '')) {
      this_0.bcg(text);
    }
    var tmp = this_0;
    tmp.gou_1 = fontsCatalog == null ? Html_getInstance().jp5_1 : fontsCatalog;
    return this_0;
  }
  fos(text, textSize, color, font, fontsCatalog, $super) {
    textSize = textSize === VOID ? 16.0 : textSize;
    color = color === VOID ? Colors_getInstance().g4r_1 : color;
    font = font === VOID ? get_debugBmpFontSync() : font;
    fontsCatalog = fontsCatalog === VOID ? null : fontsCatalog;
    return $super === VOID ? this.lp5(text, textSize, color, font, fontsCatalog) : $super.lp5.call(this, text, textSize, new RGBA(color), font, fontsCatalog);
  }
}
class TextOld extends View {
  static mp5() {
    var $this = this.hgn();
    $this.gou_1 = Html_getInstance().jp5_1;
    $this.hou_1 = Companion_getInstance_2().d2t(0, 0, 1024, 1024);
    $this.iou_1 = Companion_getInstance_2().l2m();
    $this.jou_1 = '';
    $this.kou_1 = '';
    $this.lou_1 = null;
    $this.mou_1 = new Format();
    $this.nou_1 = true;
    $this.oou_1 = filtering$factory($this);
    $this.pou_1 = true;
    $this.qou_1 = Colors_getInstance().l4r_1;
    return $this;
  }
  fhf(value) {
    if (!(this.nou_1 === value)) {
      this.nou_1 = value;
      this.hbh();
    }
  }
  tov(value) {
    this.mou_1 = value;
    var tmp168_safe_receiver = this.lou_1;
    if (!value.equals(tmp168_safe_receiver == null ? null : tmp168_safe_receiver.tp4_1)) {
      var tmp166_safe_receiver = this.lou_1;
      var tmp167_safe_receiver = tmp166_safe_receiver == null ? null : tmp166_safe_receiver.tp4_1;
      if (tmp167_safe_receiver == null)
        null;
      else {
        tmp167_safe_receiver.wp2_1 = value;
      }
    }
    recalculateBoundsWhenRequired(this);
  }
  sov() {
    return this.mou_1;
  }
  bcg(value) {
    this.jou_1 = value;
    this.kou_1 = '';
    this.lou_1 = null;
    recalculateBoundsWhenRequired(this);
    this.hbh();
  }
  o2f() {
    var tmp;
    if (!(this.lou_1 == null)) {
      var tmp169_safe_receiver = this.lou_1;
      var tmp170_safe_receiver = tmp169_safe_receiver == null ? null : tmp169_safe_receiver.up4_1;
      var tmp0_elvis_lhs = tmp170_safe_receiver == null ? null : tmp170_safe_receiver.o2f();
      tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    } else {
      tmp = this.jou_1;
    }
    return tmp;
  }
  wou(value) {
    this.lou_1 = Html_getInstance().kp5(value, this.gou_1);
    this.se4();
    ensureNotNull(this.lou_1).tp4_1.wp2_1 = this.sov();
    this.jou_1 = '';
    this.kou_1 = value;
    this.mou_1 = ensureNotNull(this.lou_1).xp4().yp3();
    this.hbh();
  }
  uov() {
    return !(this.lou_1 == null) ? this.kou_1 : this.jou_1;
  }
  se4() {
    var tmp171_safe_receiver = this.lou_1;
    if (tmp171_safe_receiver == null)
      null;
    else {
      tmp171_safe_receiver.zp4(this.gou_1, this.hou_1);
    }
    this.hbh();
  }
  jc7(ctx) {
    if (!this.qcc())
      return Unit_instance;
    var colorMul = this.wcc();
    var m = this.ybp();
    if (!(this.lou_1 == null)) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = ensureNotNull(this.lou_1).yp4();
      var n = 0;
      while (n < this_0.j1()) {
        // Inline function 'korlibs.korge.view.textOld.TextOld.renderInternal.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var span = this_0.i1(_unary__edvuaz);
        var font = this.gou_1.rp3(span.ep4_1.tp3());
        var format = span.ep4_1;
        drawText(font, ctx, format.ip3(), this.o2f(), numberToInt(span.gp4_1.h4e_1), numberToInt(span.gp4_1.i4e_1), m, Companion_getInstance_4().m5j(colorMul, format.up3()), this.vcc(), this.nou_1);
      }
    } else {
      var font_0 = this.sov().tp3();
      var anchor = this.sov().xp3().b5u_1;
      this.gou_1.sp3(this.o2f(), this.sov(), this.iou_1);
      var px = this.hou_1.h4e_1 + (this.hou_1.j4e_1 - this.iou_1.j4e_1) * anchor.y2g_1;
      var py = this.hou_1.i4e_1 + (this.hou_1.k4e_1 - this.iou_1.k4e_1) * anchor.z2g_1;
      if (!(_RGBA___get_a__impl__6msvu7(this.qou_1) === 0)) {
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_1 = ctx.ka7_1;
        var this_2 = this_1.ta7_1;
        if (!(this_2.oa7_1 === this_1)) {
          this_2.oa7_1 = this_1;
          this_2.ya8();
        }
        // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
        var tmp$ret$0 = get_Bitmaps_white();
        this_1.aa9(ctx.za8(tmp$ret$0), this.hou_1.h4e_1, this.hou_1.i4e_1, this.hou_1.j4e_1, this.hou_1.k4e_1, m, false, Companion_getInstance_4().m5j(this.qou_1, this.wcc()), this.vcc());
      }
      drawText(this.gou_1.rp3(font_0), ctx, this.sov().ip3(), this.o2f(), numberToInt(px), numberToInt(py), m, Companion_getInstance_4().m5j(colorMul, this.sov().up3()), this.vcc(), this.nou_1);
    }
  }
  gc7() {
    var out = Companion_getInstance_2().l2m();
    if (!(this.lou_1 == null)) {
      out.u4e(ensureNotNull(this.lou_1).vp4_1);
    } else {
      if (this.pou_1) {
        this.gou_1.sp3(this.o2f(), this.sov(), out);
        out.z4e(out, this.sov().xp3().b5u_1, this.hou_1);
      } else {
        out.u4e(this.hou_1);
      }
    }
    return out.j2t();
  }
}
//endregion
var Companion_instance_3;
function Companion_getInstance_20() {
  if (Companion_instance_3 === VOID)
    new Companion();
  return Companion_instance_3;
}
function ABC$MethodBody$ops$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.MethodBody.ops$delegate.<anonymous>.<anonymous>' call
    var $this$run = openSync(this$0.hlw_1);
    // Inline function 'korlibs.datastructure.mapWhile' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.m1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapWhile.<anonymous>' call
    $l$loop: while (true) {
      // Inline function 'korlibs.korfl.MethodBody.ops$delegate.<anonymous>.<anonymous>.<anonymous>' call
      this_0.j1();
      if (!!get_eof($this$run)) {
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.korfl.MethodBody.ops$delegate.<anonymous>.<anonymous>.<anonymous>' call
      this_0.j1();
      var element = Companion_instance_4.mlw(this$0.ilw_1, $this$run);
      this_0.f(element);
    }
    return this_0;
  };
}
var EmptyMultiname_instance;
function EmptyMultiname_getInstance() {
  return EmptyMultiname_instance;
}
var RTQNameL_instance;
function RTQNameL_getInstance() {
  return RTQNameL_instance;
}
var RTQNameLA_instance;
function RTQNameLA_getInstance() {
  return RTQNameLA_instance;
}
function readTraits$_anonymous_$handleTraitSlot_f8v1zw($s, this$0, name) {
  var slotIndex = readU30($s);
  var type = this$0.glz().i1(readU30($s));
  var valueIndex = readU30($s);
  var tmp;
  if (!(valueIndex === 0)) {
    var valueKind = readU8($s);
    tmp = this$0.hlz(valueKind, valueIndex);
  } else {
    tmp = null;
  }
  var value = tmp;
  return new TraitSlot(name, slotIndex, type, value);
}
function readTraits$_anonymous_$handleTraitMethod_m5u9vd($s, info, name) {
  var dispIndex = readU30($s);
  var methodIndex = readU30($s);
  var isFinal = !((info & 1) === 0);
  var isOverride = !((info & 2) === 0);
  return new TraitMethod(name, dispIndex, methodIndex);
}
function ops$factory() {
  return getPropertyCallableRef('ops', 1, KProperty1, function (receiver) {
    return receiver.p9n();
  }, null);
}
var AMF3_instance;
function AMF3_getInstance() {
  return AMF3_instance;
}
var Companion_instance_4;
function Companion_getInstance_21() {
  return Companion_instance_4;
}
var Kind_BasicOperation_instance;
var Kind_LabelOperation_instance;
var Kind_IntOperation_instance;
var Kind_UIntOperation_instance;
var Kind_NumberOperation_instance;
var Kind_IntIntOperation_instance;
var Kind_IntStringIntIntOperation_instance;
var Kind_StringOperation_instance;
var Kind_MultinameOperation_instance;
var Kind_MultinameIntOperation_instance;
var Kind_ConditionalJumpOperation_instance;
var Kind_JumpOperation_instance;
var Kind_NewClassOperation_instance;
var Kind_LookupSwitchOperation_instance;
var Kind_NamespaceOperation_instance;
var Kind_NewFunctionOperation_instance;
var Kind_MethodOperation_instance;
var Kind_NewCatchOperation_instance;
function AbcOpcode$Kind$_init_$lambda_lyqwcd(_this__u8e3s4) {
  return new AbcBasicOperation(_this__u8e3s4.rm0_1);
}
function AbcOpcode$Kind$lambda(_this__u8e3s4) {
  return new AbcBasicOperation(_this__u8e3s4.rm0_1);
}
function AbcOpcode$Kind$lambda_0(_this__u8e3s4) {
  return new AbcLabelOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.tm0_1.q1q());
}
function AbcOpcode$Kind$lambda_1(_this__u8e3s4) {
  var tmp0 = _this__u8e3s4.rm0_1.v3_1;
  return new AbcIntOperation(_this__u8e3s4.rm0_1, tmp0 === 82 ? readU8(_this__u8e3s4.tm0_1) : tmp0 === 32 ? readS8(_this__u8e3s4.tm0_1) : tmp0 === 33 ? readU30(_this__u8e3s4.tm0_1) << 2 >> 2 : readU30(_this__u8e3s4.tm0_1));
}
function AbcOpcode$Kind$lambda_2(_this__u8e3s4) {
  return new AbcIntOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.qlz().i1(readU30(_this__u8e3s4.tm0_1)));
}
function AbcOpcode$Kind$lambda_3(_this__u8e3s4) {
  return new AbcDoubleOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.rlz().i1(readU30(_this__u8e3s4.tm0_1)));
}
function AbcOpcode$Kind$lambda_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.rm0_1.equals(AbcOpcode_HasNext2_getInstance())) {
    tmp = new AbcIntIntOperation(_this__u8e3s4.rm0_1, readS32LE(_this__u8e3s4.tm0_1), readS32LE(_this__u8e3s4.tm0_1));
  } else {
    tmp = new AbcIntIntOperation(_this__u8e3s4.rm0_1, readU30(_this__u8e3s4.tm0_1), readU30(_this__u8e3s4.tm0_1));
  }
  return tmp;
}
function AbcOpcode$Kind$lambda_5(_this__u8e3s4) {
  return new AbcIntStringIntIntOperation(_this__u8e3s4.rm0_1, readU8(_this__u8e3s4.tm0_1), _this__u8e3s4.slz().i1(readU30(_this__u8e3s4.tm0_1)), readU8(_this__u8e3s4.tm0_1), readU30(_this__u8e3s4.tm0_1));
}
function AbcOpcode$Kind$lambda_6(_this__u8e3s4) {
  return new AbcStringOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.slz().i1(readU30(_this__u8e3s4.tm0_1)));
}
function AbcOpcode$Kind$lambda_7(_this__u8e3s4) {
  return new AbcMultinameOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.glz().i1(readU30(_this__u8e3s4.tm0_1)));
}
function AbcOpcode$Kind$lambda_8(_this__u8e3s4) {
  return new AbcMultinameIntOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.glz().i1(readU30(_this__u8e3s4.tm0_1)), readU30(_this__u8e3s4.tm0_1));
}
function AbcOpcode$Kind$lambda_9(_this__u8e3s4) {
  // Inline function 'kotlin.Long.plus' call
  // Inline function 'kotlin.Long.plus' call
  var this_0 = _this__u8e3s4.tm0_1.q1q().c4(toLong(4));
  var other = readS24LE(_this__u8e3s4.tm0_1);
  var tmp$ret$1 = this_0.c4(toLong(other));
  return new AbcJumpOperation(_this__u8e3s4.rm0_1, tmp$ret$1);
}
function AbcOpcode$Kind$lambda_10(_this__u8e3s4) {
  // Inline function 'kotlin.Long.plus' call
  // Inline function 'kotlin.Long.plus' call
  var this_0 = _this__u8e3s4.tm0_1.q1q().c4(toLong(4));
  var other = readS24LE(_this__u8e3s4.tm0_1);
  var tmp$ret$1 = this_0.c4(toLong(other));
  return new AbcJumpOperation(_this__u8e3s4.rm0_1, tmp$ret$1);
}
function AbcOpcode$Kind$lambda_11(_this__u8e3s4) {
  return new AbcNewClassOperation(_this__u8e3s4.rm0_1, readU30(_this__u8e3s4.tm0_1));
}
function AbcOpcode$Kind$lambda_12(_this__u8e3s4) {
  // Inline function 'kotlin.Long.plus' call
  var this_0 = _this__u8e3s4.tm0_1.q1q();
  var other = readS24LE(_this__u8e3s4.tm0_1);
  var defaultMarker = this_0.c4(toLong(other));
  // Inline function 'kotlin.collections.map' call
  var this_1 = until(0, readU30(_this__u8e3s4.tm0_1) + 1 | 0);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.korfl.Kind.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.Long.plus' call
    var this_2 = _this__u8e3s4.tm0_1.q1q();
    var other_0 = readS24LE(_this__u8e3s4.tm0_1);
    var tmp$ret$2 = this_2.c4(toLong(other_0));
    destination.f(tmp$ret$2);
  }
  var markers = toLongArray(destination);
  return new AbcLookupSwitchOperation(_this__u8e3s4.rm0_1, defaultMarker, markers);
}
function AbcOpcode$Kind$lambda_13(_this__u8e3s4) {
  return new AbcNamespaceOperation(_this__u8e3s4.rm0_1, _this__u8e3s4.tlz().i1(readU30(_this__u8e3s4.tm0_1)));
}
function AbcOpcode$Kind$lambda_14(_this__u8e3s4) {
  return new AbcIntOperation(_this__u8e3s4.rm0_1, readU30(_this__u8e3s4.tm0_1));
}
function AbcOpcode$Kind$lambda_15(_this__u8e3s4) {
  return new AbcIntIntOperation(_this__u8e3s4.rm0_1, readU30(_this__u8e3s4.tm0_1), readU30(_this__u8e3s4.tm0_1));
}
function AbcOpcode$Kind$lambda_16(_this__u8e3s4) {
  return new AbcIntOperation(_this__u8e3s4.rm0_1, readU30(_this__u8e3s4.tm0_1));
}
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_BasicOperation_instance = new Kind('BasicOperation', 0, AbcOpcode$Kind$lambda);
  Kind_LabelOperation_instance = new Kind('LabelOperation', 1, AbcOpcode$Kind$lambda_0);
  Kind_IntOperation_instance = new Kind('IntOperation', 2, AbcOpcode$Kind$lambda_1);
  Kind_UIntOperation_instance = new Kind('UIntOperation', 3, AbcOpcode$Kind$lambda_2);
  Kind_NumberOperation_instance = new Kind('NumberOperation', 4, AbcOpcode$Kind$lambda_3);
  Kind_IntIntOperation_instance = new Kind('IntIntOperation', 5, AbcOpcode$Kind$lambda_4);
  Kind_IntStringIntIntOperation_instance = new Kind('IntStringIntIntOperation', 6, AbcOpcode$Kind$lambda_5);
  Kind_StringOperation_instance = new Kind('StringOperation', 7, AbcOpcode$Kind$lambda_6);
  Kind_MultinameOperation_instance = new Kind('MultinameOperation', 8, AbcOpcode$Kind$lambda_7);
  Kind_MultinameIntOperation_instance = new Kind('MultinameIntOperation', 9, AbcOpcode$Kind$lambda_8);
  Kind_ConditionalJumpOperation_instance = new Kind('ConditionalJumpOperation', 10, AbcOpcode$Kind$lambda_9);
  Kind_JumpOperation_instance = new Kind('JumpOperation', 11, AbcOpcode$Kind$lambda_10);
  Kind_NewClassOperation_instance = new Kind('NewClassOperation', 12, AbcOpcode$Kind$lambda_11);
  Kind_LookupSwitchOperation_instance = new Kind('LookupSwitchOperation', 13, AbcOpcode$Kind$lambda_12);
  Kind_NamespaceOperation_instance = new Kind('NamespaceOperation', 14, AbcOpcode$Kind$lambda_13);
  Kind_NewFunctionOperation_instance = new Kind('NewFunctionOperation', 15, AbcOpcode$Kind$lambda_14);
  Kind_MethodOperation_instance = new Kind('MethodOperation', 16, AbcOpcode$Kind$lambda_15);
  Kind_NewCatchOperation_instance = new Kind('NewCatchOperation', 17, AbcOpcode$Kind$lambda_16);
}
var AbcOpcode_Breakpoint_instance;
var AbcOpcode_Nop_instance;
var AbcOpcode_Throw_instance;
var AbcOpcode_GetSuper_instance;
var AbcOpcode_SetSuper_instance;
var AbcOpcode_DefaultXmlNamespace_instance;
var AbcOpcode_DefaultXmlNamespaceL_instance;
var AbcOpcode_Kill_instance;
var AbcOpcode_Label_instance;
var AbcOpcode_IfNotLessThan_instance;
var AbcOpcode_IfNotLessEqual_instance;
var AbcOpcode_IfNotGreaterThan_instance;
var AbcOpcode_IfNotGreaterEqual_instance;
var AbcOpcode_Jump_instance;
var AbcOpcode_IfTrue_instance;
var AbcOpcode_IfFalse_instance;
var AbcOpcode_IfEqual_instance;
var AbcOpcode_IfNotEqual_instance;
var AbcOpcode_IfLessThan_instance;
var AbcOpcode_IfLessEqual_instance;
var AbcOpcode_IfGreaterThan_instance;
var AbcOpcode_IfGreaterEqual_instance;
var AbcOpcode_IfStrictEqual_instance;
var AbcOpcode_IfStrictNotEqual_instance;
var AbcOpcode_LookupSwitch_instance;
var AbcOpcode_PushWith_instance;
var AbcOpcode_PopScope_instance;
var AbcOpcode_NextName_instance;
var AbcOpcode_HasNext_instance;
var AbcOpcode_PushNull_instance;
var AbcOpcode_PushUndefined_instance;
var AbcOpcode_NextValue_instance;
var AbcOpcode_PushByte_instance;
var AbcOpcode_PushShort_instance;
var AbcOpcode_PushTrue_instance;
var AbcOpcode_PushFalse_instance;
var AbcOpcode_PushNaN_instance;
var AbcOpcode_Pop_instance;
var AbcOpcode_Dup_instance;
var AbcOpcode_Swap_instance;
var AbcOpcode_PushString_instance;
var AbcOpcode_PushInt_instance;
var AbcOpcode_PushUInt_instance;
var AbcOpcode_PushDouble_instance;
var AbcOpcode_PushScope_instance;
var AbcOpcode_PushNamespace_instance;
var AbcOpcode_HasNext2_instance;
var AbcOpcode_PushDecimal_instance;
var AbcOpcode_PushDNaN_instance;
var AbcOpcode_NewFunction_instance;
var AbcOpcode_Call_instance;
var AbcOpcode_Construct_instance;
var AbcOpcode_CallMethod_instance;
var AbcOpcode_CallStatic_instance;
var AbcOpcode_CallSuper_instance;
var AbcOpcode_CallProperty_instance;
var AbcOpcode_ReturnVoid_instance;
var AbcOpcode_ReturnValue_instance;
var AbcOpcode_ConstructSuper_instance;
var AbcOpcode_ConstructProp_instance;
var AbcOpcode_CallSuperId_instance;
var AbcOpcode_CallPropLex_instance;
var AbcOpcode_CallInterface_instance;
var AbcOpcode_CallSuperVoid_instance;
var AbcOpcode_CallPropVoid_instance;
var AbcOpcode_ApplyType_instance;
var AbcOpcode_NewObject_instance;
var AbcOpcode_NewArray_instance;
var AbcOpcode_NewActivation_instance;
var AbcOpcode_NewClass_instance;
var AbcOpcode_GetDescendants_instance;
var AbcOpcode_NewCatch_instance;
var AbcOpcode_FindPropGlobalStrict_instance;
var AbcOpcode_FindPropGlobal_instance;
var AbcOpcode_FindPropStrict_instance;
var AbcOpcode_FindProperty_instance;
var AbcOpcode_FindDef_instance;
var AbcOpcode_GetLex_instance;
var AbcOpcode_SetProperty_instance;
var AbcOpcode_GetLocal_instance;
var AbcOpcode_SetLocal_instance;
var AbcOpcode_GetGlobalScope_instance;
var AbcOpcode_GetScopeObject_instance;
var AbcOpcode_GetProperty_instance;
var AbcOpcode_GetPropertyLate_instance;
var AbcOpcode_InitProperty_instance;
var AbcOpcode_SetPropertyLate_instance;
var AbcOpcode_DeleteProperty_instance;
var AbcOpcode_DeletePropertyLate_instance;
var AbcOpcode_GetSlot_instance;
var AbcOpcode_SetSlot_instance;
var AbcOpcode_GetGlobalSlot_instance;
var AbcOpcode_SetGlobalSlot_instance;
var AbcOpcode_ConvertString_instance;
var AbcOpcode_EscXmlElem_instance;
var AbcOpcode_EscXmlAttr_instance;
var AbcOpcode_ConvertInt_instance;
var AbcOpcode_ConvertUInt_instance;
var AbcOpcode_ConvertDouble_instance;
var AbcOpcode_ConvertBoolean_instance;
var AbcOpcode_ConvertObject_instance;
var AbcOpcode_CheckFilter_instance;
var AbcOpcode_Coerce_instance;
var AbcOpcode_CoerceBoolean_instance;
var AbcOpcode_CoerceAny_instance;
var AbcOpcode_CoerceInt_instance;
var AbcOpcode_CoerceDouble_instance;
var AbcOpcode_CoerceString_instance;
var AbcOpcode_AsType_instance;
var AbcOpcode_AsTypeLate_instance;
var AbcOpcode_CoerceUInt_instance;
var AbcOpcode_CoerceObject_instance;
var AbcOpcode_Negate_instance;
var AbcOpcode_Increment_instance;
var AbcOpcode_IncLocal_instance;
var AbcOpcode_Decrement_instance;
var AbcOpcode_DecLocal_instance;
var AbcOpcode_TypeOf_instance;
var AbcOpcode_Not_instance;
var AbcOpcode_BitNot_instance;
var AbcOpcode_Concat_instance;
var AbcOpcode_AddDouble_instance;
var AbcOpcode_Add_instance;
var AbcOpcode_Subtract_instance;
var AbcOpcode_Multiply_instance;
var AbcOpcode_Divide_instance;
var AbcOpcode_Modulo_instance;
var AbcOpcode_ShiftLeft_instance;
var AbcOpcode_ShiftRight_instance;
var AbcOpcode_ShiftRightUnsigned_instance;
var AbcOpcode_BitAnd_instance;
var AbcOpcode_BitOr_instance;
var AbcOpcode_BitXor_instance;
var AbcOpcode_Equals_instance;
var AbcOpcode_StrictEquals_instance;
var AbcOpcode_LessThan_instance;
var AbcOpcode_LessEquals_instance;
var AbcOpcode_GreaterThan_instance;
var AbcOpcode_GreaterEquals_instance;
var AbcOpcode_InstanceOf_instance;
var AbcOpcode_IsType_instance;
var AbcOpcode_IsTypeLate_instance;
var AbcOpcode_In_instance;
var AbcOpcode_IncrementInt_instance;
var AbcOpcode_DecrementInt_instance;
var AbcOpcode_IncLocalInt_instance;
var AbcOpcode_DecLocalInt_instance;
var AbcOpcode_NegateInt_instance;
var AbcOpcode_AddInt_instance;
var AbcOpcode_SubtractInt_instance;
var AbcOpcode_MultiplyInt_instance;
var AbcOpcode_GetLocal0_instance;
var AbcOpcode_GetLocal1_instance;
var AbcOpcode_GetLocal2_instance;
var AbcOpcode_GetLocal3_instance;
var AbcOpcode_SetLocal0_instance;
var AbcOpcode_SetLocal1_instance;
var AbcOpcode_SetLocal2_instance;
var AbcOpcode_SetLocal3_instance;
var AbcOpcode_Debug_instance;
var AbcOpcode_DebugLine_instance;
var AbcOpcode_DebugFile_instance;
var AbcOpcode_BreakpointLine_instance;
var AbcOpcode_SetByte_instance;
var AbcOpcode_SetShort_instance;
var AbcOpcode_SetInt_instance;
var AbcOpcode_SetFloat_instance;
var AbcOpcode_SetDouble_instance;
var AbcOpcode_GetByte_instance;
var AbcOpcode_GetShort_instance;
var AbcOpcode_GetInt_instance;
var AbcOpcode_GetFloat_instance;
var AbcOpcode_GetDouble_instance;
var AbcOpcode_Sign1_instance;
var AbcOpcode_Sign8_instance;
var AbcOpcode_Sign16_instance;
var Companion_instance_5;
function Companion_getInstance_22() {
  AbcOpcode_initEntries();
  if (Companion_instance_5 === VOID)
    new Companion_1();
  return Companion_instance_5;
}
function values_1() {
  return [AbcOpcode_Breakpoint_getInstance(), AbcOpcode_Nop_getInstance(), AbcOpcode_Throw_getInstance(), AbcOpcode_GetSuper_getInstance(), AbcOpcode_SetSuper_getInstance(), AbcOpcode_DefaultXmlNamespace_getInstance(), AbcOpcode_DefaultXmlNamespaceL_getInstance(), AbcOpcode_Kill_getInstance(), AbcOpcode_Label_getInstance(), AbcOpcode_IfNotLessThan_getInstance(), AbcOpcode_IfNotLessEqual_getInstance(), AbcOpcode_IfNotGreaterThan_getInstance(), AbcOpcode_IfNotGreaterEqual_getInstance(), AbcOpcode_Jump_getInstance(), AbcOpcode_IfTrue_getInstance(), AbcOpcode_IfFalse_getInstance(), AbcOpcode_IfEqual_getInstance(), AbcOpcode_IfNotEqual_getInstance(), AbcOpcode_IfLessThan_getInstance(), AbcOpcode_IfLessEqual_getInstance(), AbcOpcode_IfGreaterThan_getInstance(), AbcOpcode_IfGreaterEqual_getInstance(), AbcOpcode_IfStrictEqual_getInstance(), AbcOpcode_IfStrictNotEqual_getInstance(), AbcOpcode_LookupSwitch_getInstance(), AbcOpcode_PushWith_getInstance(), AbcOpcode_PopScope_getInstance(), AbcOpcode_NextName_getInstance(), AbcOpcode_HasNext_getInstance(), AbcOpcode_PushNull_getInstance(), AbcOpcode_PushUndefined_getInstance(), AbcOpcode_NextValue_getInstance(), AbcOpcode_PushByte_getInstance(), AbcOpcode_PushShort_getInstance(), AbcOpcode_PushTrue_getInstance(), AbcOpcode_PushFalse_getInstance(), AbcOpcode_PushNaN_getInstance(), AbcOpcode_Pop_getInstance(), AbcOpcode_Dup_getInstance(), AbcOpcode_Swap_getInstance(), AbcOpcode_PushString_getInstance(), AbcOpcode_PushInt_getInstance(), AbcOpcode_PushUInt_getInstance(), AbcOpcode_PushDouble_getInstance(), AbcOpcode_PushScope_getInstance(), AbcOpcode_PushNamespace_getInstance(), AbcOpcode_HasNext2_getInstance(), AbcOpcode_PushDecimal_getInstance(), AbcOpcode_PushDNaN_getInstance(), AbcOpcode_NewFunction_getInstance(), AbcOpcode_Call_getInstance(), AbcOpcode_Construct_getInstance(), AbcOpcode_CallMethod_getInstance(), AbcOpcode_CallStatic_getInstance(), AbcOpcode_CallSuper_getInstance(), AbcOpcode_CallProperty_getInstance(), AbcOpcode_ReturnVoid_getInstance(), AbcOpcode_ReturnValue_getInstance(), AbcOpcode_ConstructSuper_getInstance(), AbcOpcode_ConstructProp_getInstance(), AbcOpcode_CallSuperId_getInstance(), AbcOpcode_CallPropLex_getInstance(), AbcOpcode_CallInterface_getInstance(), AbcOpcode_CallSuperVoid_getInstance(), AbcOpcode_CallPropVoid_getInstance(), AbcOpcode_ApplyType_getInstance(), AbcOpcode_NewObject_getInstance(), AbcOpcode_NewArray_getInstance(), AbcOpcode_NewActivation_getInstance(), AbcOpcode_NewClass_getInstance(), AbcOpcode_GetDescendants_getInstance(), AbcOpcode_NewCatch_getInstance(), AbcOpcode_FindPropGlobalStrict_getInstance(), AbcOpcode_FindPropGlobal_getInstance(), AbcOpcode_FindPropStrict_getInstance(), AbcOpcode_FindProperty_getInstance(), AbcOpcode_FindDef_getInstance(), AbcOpcode_GetLex_getInstance(), AbcOpcode_SetProperty_getInstance(), AbcOpcode_GetLocal_getInstance(), AbcOpcode_SetLocal_getInstance(), AbcOpcode_GetGlobalScope_getInstance(), AbcOpcode_GetScopeObject_getInstance(), AbcOpcode_GetProperty_getInstance(), AbcOpcode_GetPropertyLate_getInstance(), AbcOpcode_InitProperty_getInstance(), AbcOpcode_SetPropertyLate_getInstance(), AbcOpcode_DeleteProperty_getInstance(), AbcOpcode_DeletePropertyLate_getInstance(), AbcOpcode_GetSlot_getInstance(), AbcOpcode_SetSlot_getInstance(), AbcOpcode_GetGlobalSlot_getInstance(), AbcOpcode_SetGlobalSlot_getInstance(), AbcOpcode_ConvertString_getInstance(), AbcOpcode_EscXmlElem_getInstance(), AbcOpcode_EscXmlAttr_getInstance(), AbcOpcode_ConvertInt_getInstance(), AbcOpcode_ConvertUInt_getInstance(), AbcOpcode_ConvertDouble_getInstance(), AbcOpcode_ConvertBoolean_getInstance(), AbcOpcode_ConvertObject_getInstance(), AbcOpcode_CheckFilter_getInstance(), AbcOpcode_Coerce_getInstance(), AbcOpcode_CoerceBoolean_getInstance(), AbcOpcode_CoerceAny_getInstance(), AbcOpcode_CoerceInt_getInstance(), AbcOpcode_CoerceDouble_getInstance(), AbcOpcode_CoerceString_getInstance(), AbcOpcode_AsType_getInstance(), AbcOpcode_AsTypeLate_getInstance(), AbcOpcode_CoerceUInt_getInstance(), AbcOpcode_CoerceObject_getInstance(), AbcOpcode_Negate_getInstance(), AbcOpcode_Increment_getInstance(), AbcOpcode_IncLocal_getInstance(), AbcOpcode_Decrement_getInstance(), AbcOpcode_DecLocal_getInstance(), AbcOpcode_TypeOf_getInstance(), AbcOpcode_Not_getInstance(), AbcOpcode_BitNot_getInstance(), AbcOpcode_Concat_getInstance(), AbcOpcode_AddDouble_getInstance(), AbcOpcode_Add_getInstance(), AbcOpcode_Subtract_getInstance(), AbcOpcode_Multiply_getInstance(), AbcOpcode_Divide_getInstance(), AbcOpcode_Modulo_getInstance(), AbcOpcode_ShiftLeft_getInstance(), AbcOpcode_ShiftRight_getInstance(), AbcOpcode_ShiftRightUnsigned_getInstance(), AbcOpcode_BitAnd_getInstance(), AbcOpcode_BitOr_getInstance(), AbcOpcode_BitXor_getInstance(), AbcOpcode_Equals_getInstance(), AbcOpcode_StrictEquals_getInstance(), AbcOpcode_LessThan_getInstance(), AbcOpcode_LessEquals_getInstance(), AbcOpcode_GreaterThan_getInstance(), AbcOpcode_GreaterEquals_getInstance(), AbcOpcode_InstanceOf_getInstance(), AbcOpcode_IsType_getInstance(), AbcOpcode_IsTypeLate_getInstance(), AbcOpcode_In_getInstance(), AbcOpcode_IncrementInt_getInstance(), AbcOpcode_DecrementInt_getInstance(), AbcOpcode_IncLocalInt_getInstance(), AbcOpcode_DecLocalInt_getInstance(), AbcOpcode_NegateInt_getInstance(), AbcOpcode_AddInt_getInstance(), AbcOpcode_SubtractInt_getInstance(), AbcOpcode_MultiplyInt_getInstance(), AbcOpcode_GetLocal0_getInstance(), AbcOpcode_GetLocal1_getInstance(), AbcOpcode_GetLocal2_getInstance(), AbcOpcode_GetLocal3_getInstance(), AbcOpcode_SetLocal0_getInstance(), AbcOpcode_SetLocal1_getInstance(), AbcOpcode_SetLocal2_getInstance(), AbcOpcode_SetLocal3_getInstance(), AbcOpcode_Debug_getInstance(), AbcOpcode_DebugLine_getInstance(), AbcOpcode_DebugFile_getInstance(), AbcOpcode_BreakpointLine_getInstance(), AbcOpcode_SetByte_getInstance(), AbcOpcode_SetShort_getInstance(), AbcOpcode_SetInt_getInstance(), AbcOpcode_SetFloat_getInstance(), AbcOpcode_SetDouble_getInstance(), AbcOpcode_GetByte_getInstance(), AbcOpcode_GetShort_getInstance(), AbcOpcode_GetInt_getInstance(), AbcOpcode_GetFloat_getInstance(), AbcOpcode_GetDouble_getInstance(), AbcOpcode_Sign1_getInstance(), AbcOpcode_Sign8_getInstance(), AbcOpcode_Sign16_getInstance()];
}
var AbcOpcode_entriesInitialized;
function AbcOpcode_initEntries() {
  if (AbcOpcode_entriesInitialized)
    return Unit_instance;
  AbcOpcode_entriesInitialized = true;
  AbcOpcode_Breakpoint_instance = new AbcOpcode('Breakpoint', 0, 1, Kind_BasicOperation_getInstance());
  AbcOpcode_Nop_instance = new AbcOpcode('Nop', 1, 2, Kind_BasicOperation_getInstance());
  AbcOpcode_Throw_instance = new AbcOpcode('Throw', 2, 3, Kind_BasicOperation_getInstance());
  AbcOpcode_GetSuper_instance = new AbcOpcode('GetSuper', 3, 4, Kind_MultinameOperation_getInstance());
  AbcOpcode_SetSuper_instance = new AbcOpcode('SetSuper', 4, 5, Kind_MultinameOperation_getInstance());
  AbcOpcode_DefaultXmlNamespace_instance = new AbcOpcode('DefaultXmlNamespace', 5, 6, Kind_StringOperation_getInstance());
  AbcOpcode_DefaultXmlNamespaceL_instance = new AbcOpcode('DefaultXmlNamespaceL', 6, 7, Kind_BasicOperation_getInstance());
  AbcOpcode_Kill_instance = new AbcOpcode('Kill', 7, 8, Kind_IntOperation_getInstance());
  AbcOpcode_Label_instance = new AbcOpcode('Label', 8, 9, Kind_LabelOperation_getInstance());
  AbcOpcode_IfNotLessThan_instance = new AbcOpcode('IfNotLessThan', 9, 12, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfNotLessEqual_instance = new AbcOpcode('IfNotLessEqual', 10, 13, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfNotGreaterThan_instance = new AbcOpcode('IfNotGreaterThan', 11, 14, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfNotGreaterEqual_instance = new AbcOpcode('IfNotGreaterEqual', 12, 15, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_Jump_instance = new AbcOpcode('Jump', 13, 16, Kind_JumpOperation_getInstance());
  AbcOpcode_IfTrue_instance = new AbcOpcode('IfTrue', 14, 17, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfFalse_instance = new AbcOpcode('IfFalse', 15, 18, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfEqual_instance = new AbcOpcode('IfEqual', 16, 19, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfNotEqual_instance = new AbcOpcode('IfNotEqual', 17, 20, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfLessThan_instance = new AbcOpcode('IfLessThan', 18, 21, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfLessEqual_instance = new AbcOpcode('IfLessEqual', 19, 22, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfGreaterThan_instance = new AbcOpcode('IfGreaterThan', 20, 23, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfGreaterEqual_instance = new AbcOpcode('IfGreaterEqual', 21, 24, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfStrictEqual_instance = new AbcOpcode('IfStrictEqual', 22, 25, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_IfStrictNotEqual_instance = new AbcOpcode('IfStrictNotEqual', 23, 26, Kind_ConditionalJumpOperation_getInstance());
  AbcOpcode_LookupSwitch_instance = new AbcOpcode('LookupSwitch', 24, 27, Kind_LookupSwitchOperation_getInstance());
  AbcOpcode_PushWith_instance = new AbcOpcode('PushWith', 25, 28, Kind_BasicOperation_getInstance());
  AbcOpcode_PopScope_instance = new AbcOpcode('PopScope', 26, 29, Kind_BasicOperation_getInstance());
  AbcOpcode_NextName_instance = new AbcOpcode('NextName', 27, 30, Kind_BasicOperation_getInstance());
  AbcOpcode_HasNext_instance = new AbcOpcode('HasNext', 28, 31, Kind_BasicOperation_getInstance());
  AbcOpcode_PushNull_instance = new AbcOpcode('PushNull', 29, 32, Kind_BasicOperation_getInstance());
  AbcOpcode_PushUndefined_instance = new AbcOpcode('PushUndefined', 30, 33, Kind_BasicOperation_getInstance());
  AbcOpcode_NextValue_instance = new AbcOpcode('NextValue', 31, 35, Kind_BasicOperation_getInstance());
  AbcOpcode_PushByte_instance = new AbcOpcode('PushByte', 32, 36, Kind_IntOperation_getInstance());
  AbcOpcode_PushShort_instance = new AbcOpcode('PushShort', 33, 37, Kind_IntOperation_getInstance());
  AbcOpcode_PushTrue_instance = new AbcOpcode('PushTrue', 34, 38, Kind_BasicOperation_getInstance());
  AbcOpcode_PushFalse_instance = new AbcOpcode('PushFalse', 35, 39, Kind_BasicOperation_getInstance());
  AbcOpcode_PushNaN_instance = new AbcOpcode('PushNaN', 36, 40, Kind_BasicOperation_getInstance());
  AbcOpcode_Pop_instance = new AbcOpcode('Pop', 37, 41, Kind_BasicOperation_getInstance());
  AbcOpcode_Dup_instance = new AbcOpcode('Dup', 38, 42, Kind_BasicOperation_getInstance());
  AbcOpcode_Swap_instance = new AbcOpcode('Swap', 39, 43, Kind_BasicOperation_getInstance());
  AbcOpcode_PushString_instance = new AbcOpcode('PushString', 40, 44, Kind_StringOperation_getInstance());
  AbcOpcode_PushInt_instance = new AbcOpcode('PushInt', 41, 45, Kind_IntOperation_getInstance());
  AbcOpcode_PushUInt_instance = new AbcOpcode('PushUInt', 42, 46, Kind_UIntOperation_getInstance());
  AbcOpcode_PushDouble_instance = new AbcOpcode('PushDouble', 43, 47, Kind_NumberOperation_getInstance());
  AbcOpcode_PushScope_instance = new AbcOpcode('PushScope', 44, 48, Kind_BasicOperation_getInstance());
  AbcOpcode_PushNamespace_instance = new AbcOpcode('PushNamespace', 45, 49, Kind_NamespaceOperation_getInstance());
  AbcOpcode_HasNext2_instance = new AbcOpcode('HasNext2', 46, 50, Kind_IntIntOperation_getInstance());
  AbcOpcode_PushDecimal_instance = new AbcOpcode('PushDecimal', 47, 51, Kind_BasicOperation_getInstance());
  AbcOpcode_PushDNaN_instance = new AbcOpcode('PushDNaN', 48, 52, Kind_BasicOperation_getInstance());
  AbcOpcode_NewFunction_instance = new AbcOpcode('NewFunction', 49, 64, Kind_NewFunctionOperation_getInstance());
  AbcOpcode_Call_instance = new AbcOpcode('Call', 50, 65, Kind_IntOperation_getInstance());
  AbcOpcode_Construct_instance = new AbcOpcode('Construct', 51, 66, Kind_IntOperation_getInstance());
  AbcOpcode_CallMethod_instance = new AbcOpcode('CallMethod', 52, 67, Kind_MethodOperation_getInstance());
  AbcOpcode_CallStatic_instance = new AbcOpcode('CallStatic', 53, 68, Kind_MethodOperation_getInstance());
  AbcOpcode_CallSuper_instance = new AbcOpcode('CallSuper', 54, 69, Kind_MultinameIntOperation_getInstance());
  AbcOpcode_CallProperty_instance = new AbcOpcode('CallProperty', 55, 70, Kind_MultinameIntOperation_getInstance());
  AbcOpcode_ReturnVoid_instance = new AbcOpcode('ReturnVoid', 56, 71, Kind_BasicOperation_getInstance());
  AbcOpcode_ReturnValue_instance = new AbcOpcode('ReturnValue', 57, 72, Kind_BasicOperation_getInstance());
  AbcOpcode_ConstructSuper_instance = new AbcOpcode('ConstructSuper', 58, 73, Kind_IntOperation_getInstance());
  AbcOpcode_ConstructProp_instance = new AbcOpcode('ConstructProp', 59, 74, Kind_MultinameIntOperation_getInstance());
  AbcOpcode_CallSuperId_instance = new AbcOpcode('CallSuperId', 60, 75, Kind_BasicOperation_getInstance());
  AbcOpcode_CallPropLex_instance = new AbcOpcode('CallPropLex', 61, 76, Kind_MultinameIntOperation_getInstance());
  AbcOpcode_CallInterface_instance = new AbcOpcode('CallInterface', 62, 77, Kind_BasicOperation_getInstance());
  AbcOpcode_CallSuperVoid_instance = new AbcOpcode('CallSuperVoid', 63, 78, Kind_MultinameIntOperation_getInstance());
  AbcOpcode_CallPropVoid_instance = new AbcOpcode('CallPropVoid', 64, 79, Kind_MultinameIntOperation_getInstance());
  AbcOpcode_ApplyType_instance = new AbcOpcode('ApplyType', 65, 83, Kind_IntOperation_getInstance());
  AbcOpcode_NewObject_instance = new AbcOpcode('NewObject', 66, 85, Kind_IntOperation_getInstance());
  AbcOpcode_NewArray_instance = new AbcOpcode('NewArray', 67, 86, Kind_IntOperation_getInstance());
  AbcOpcode_NewActivation_instance = new AbcOpcode('NewActivation', 68, 87, Kind_BasicOperation_getInstance());
  AbcOpcode_NewClass_instance = new AbcOpcode('NewClass', 69, 88, Kind_NewClassOperation_getInstance());
  AbcOpcode_GetDescendants_instance = new AbcOpcode('GetDescendants', 70, 89, Kind_MultinameOperation_getInstance());
  AbcOpcode_NewCatch_instance = new AbcOpcode('NewCatch', 71, 90, Kind_NewCatchOperation_getInstance());
  AbcOpcode_FindPropGlobalStrict_instance = new AbcOpcode('FindPropGlobalStrict', 72, 91, Kind_MultinameOperation_getInstance());
  AbcOpcode_FindPropGlobal_instance = new AbcOpcode('FindPropGlobal', 73, 92, Kind_MultinameOperation_getInstance());
  AbcOpcode_FindPropStrict_instance = new AbcOpcode('FindPropStrict', 74, 93, Kind_MultinameOperation_getInstance());
  AbcOpcode_FindProperty_instance = new AbcOpcode('FindProperty', 75, 94, Kind_MultinameOperation_getInstance());
  AbcOpcode_FindDef_instance = new AbcOpcode('FindDef', 76, 95, Kind_MultinameOperation_getInstance());
  AbcOpcode_GetLex_instance = new AbcOpcode('GetLex', 77, 96, Kind_MultinameOperation_getInstance());
  AbcOpcode_SetProperty_instance = new AbcOpcode('SetProperty', 78, 97, Kind_MultinameOperation_getInstance());
  AbcOpcode_GetLocal_instance = new AbcOpcode('GetLocal', 79, 98, Kind_IntOperation_getInstance());
  AbcOpcode_SetLocal_instance = new AbcOpcode('SetLocal', 80, 99, Kind_IntOperation_getInstance());
  AbcOpcode_GetGlobalScope_instance = new AbcOpcode('GetGlobalScope', 81, 100, Kind_BasicOperation_getInstance());
  AbcOpcode_GetScopeObject_instance = new AbcOpcode('GetScopeObject', 82, 101, Kind_IntOperation_getInstance());
  AbcOpcode_GetProperty_instance = new AbcOpcode('GetProperty', 83, 102, Kind_MultinameOperation_getInstance());
  AbcOpcode_GetPropertyLate_instance = new AbcOpcode('GetPropertyLate', 84, 103, Kind_BasicOperation_getInstance());
  AbcOpcode_InitProperty_instance = new AbcOpcode('InitProperty', 85, 104, Kind_MultinameOperation_getInstance());
  AbcOpcode_SetPropertyLate_instance = new AbcOpcode('SetPropertyLate', 86, 105, Kind_BasicOperation_getInstance());
  AbcOpcode_DeleteProperty_instance = new AbcOpcode('DeleteProperty', 87, 106, Kind_MultinameOperation_getInstance());
  AbcOpcode_DeletePropertyLate_instance = new AbcOpcode('DeletePropertyLate', 88, 107, Kind_BasicOperation_getInstance());
  AbcOpcode_GetSlot_instance = new AbcOpcode('GetSlot', 89, 108, Kind_IntOperation_getInstance());
  AbcOpcode_SetSlot_instance = new AbcOpcode('SetSlot', 90, 109, Kind_IntOperation_getInstance());
  AbcOpcode_GetGlobalSlot_instance = new AbcOpcode('GetGlobalSlot', 91, 110, Kind_IntOperation_getInstance());
  AbcOpcode_SetGlobalSlot_instance = new AbcOpcode('SetGlobalSlot', 92, 111, Kind_IntOperation_getInstance());
  AbcOpcode_ConvertString_instance = new AbcOpcode('ConvertString', 93, 112, Kind_BasicOperation_getInstance());
  AbcOpcode_EscXmlElem_instance = new AbcOpcode('EscXmlElem', 94, 113, Kind_BasicOperation_getInstance());
  AbcOpcode_EscXmlAttr_instance = new AbcOpcode('EscXmlAttr', 95, 114, Kind_BasicOperation_getInstance());
  AbcOpcode_ConvertInt_instance = new AbcOpcode('ConvertInt', 96, 115, Kind_BasicOperation_getInstance());
  AbcOpcode_ConvertUInt_instance = new AbcOpcode('ConvertUInt', 97, 116, Kind_BasicOperation_getInstance());
  AbcOpcode_ConvertDouble_instance = new AbcOpcode('ConvertDouble', 98, 117, Kind_BasicOperation_getInstance());
  AbcOpcode_ConvertBoolean_instance = new AbcOpcode('ConvertBoolean', 99, 118, Kind_BasicOperation_getInstance());
  AbcOpcode_ConvertObject_instance = new AbcOpcode('ConvertObject', 100, 119, Kind_BasicOperation_getInstance());
  AbcOpcode_CheckFilter_instance = new AbcOpcode('CheckFilter', 101, 120, Kind_BasicOperation_getInstance());
  AbcOpcode_Coerce_instance = new AbcOpcode('Coerce', 102, 128, Kind_MultinameOperation_getInstance());
  AbcOpcode_CoerceBoolean_instance = new AbcOpcode('CoerceBoolean', 103, 129, Kind_BasicOperation_getInstance());
  AbcOpcode_CoerceAny_instance = new AbcOpcode('CoerceAny', 104, 130, Kind_BasicOperation_getInstance());
  AbcOpcode_CoerceInt_instance = new AbcOpcode('CoerceInt', 105, 131, Kind_BasicOperation_getInstance());
  AbcOpcode_CoerceDouble_instance = new AbcOpcode('CoerceDouble', 106, 132, Kind_BasicOperation_getInstance());
  AbcOpcode_CoerceString_instance = new AbcOpcode('CoerceString', 107, 133, Kind_BasicOperation_getInstance());
  AbcOpcode_AsType_instance = new AbcOpcode('AsType', 108, 134, Kind_MultinameOperation_getInstance());
  AbcOpcode_AsTypeLate_instance = new AbcOpcode('AsTypeLate', 109, 135, Kind_BasicOperation_getInstance());
  AbcOpcode_CoerceUInt_instance = new AbcOpcode('CoerceUInt', 110, 136, Kind_BasicOperation_getInstance());
  AbcOpcode_CoerceObject_instance = new AbcOpcode('CoerceObject', 111, 137, Kind_BasicOperation_getInstance());
  AbcOpcode_Negate_instance = new AbcOpcode('Negate', 112, 144, Kind_BasicOperation_getInstance());
  AbcOpcode_Increment_instance = new AbcOpcode('Increment', 113, 145, Kind_BasicOperation_getInstance());
  AbcOpcode_IncLocal_instance = new AbcOpcode('IncLocal', 114, 146, Kind_IntOperation_getInstance());
  AbcOpcode_Decrement_instance = new AbcOpcode('Decrement', 115, 147, Kind_BasicOperation_getInstance());
  AbcOpcode_DecLocal_instance = new AbcOpcode('DecLocal', 116, 148, Kind_IntOperation_getInstance());
  AbcOpcode_TypeOf_instance = new AbcOpcode('TypeOf', 117, 149, Kind_BasicOperation_getInstance());
  AbcOpcode_Not_instance = new AbcOpcode('Not', 118, 150, Kind_BasicOperation_getInstance());
  AbcOpcode_BitNot_instance = new AbcOpcode('BitNot', 119, 151, Kind_BasicOperation_getInstance());
  AbcOpcode_Concat_instance = new AbcOpcode('Concat', 120, 154, Kind_BasicOperation_getInstance());
  AbcOpcode_AddDouble_instance = new AbcOpcode('AddDouble', 121, 155, Kind_BasicOperation_getInstance());
  AbcOpcode_Add_instance = new AbcOpcode('Add', 122, 160, Kind_BasicOperation_getInstance());
  AbcOpcode_Subtract_instance = new AbcOpcode('Subtract', 123, 161, Kind_BasicOperation_getInstance());
  AbcOpcode_Multiply_instance = new AbcOpcode('Multiply', 124, 162, Kind_BasicOperation_getInstance());
  AbcOpcode_Divide_instance = new AbcOpcode('Divide', 125, 163, Kind_BasicOperation_getInstance());
  AbcOpcode_Modulo_instance = new AbcOpcode('Modulo', 126, 164, Kind_BasicOperation_getInstance());
  AbcOpcode_ShiftLeft_instance = new AbcOpcode('ShiftLeft', 127, 165, Kind_BasicOperation_getInstance());
  AbcOpcode_ShiftRight_instance = new AbcOpcode('ShiftRight', 128, 166, Kind_BasicOperation_getInstance());
  AbcOpcode_ShiftRightUnsigned_instance = new AbcOpcode('ShiftRightUnsigned', 129, 167, Kind_BasicOperation_getInstance());
  AbcOpcode_BitAnd_instance = new AbcOpcode('BitAnd', 130, 168, Kind_BasicOperation_getInstance());
  AbcOpcode_BitOr_instance = new AbcOpcode('BitOr', 131, 169, Kind_BasicOperation_getInstance());
  AbcOpcode_BitXor_instance = new AbcOpcode('BitXor', 132, 170, Kind_BasicOperation_getInstance());
  AbcOpcode_Equals_instance = new AbcOpcode('Equals', 133, 171, Kind_BasicOperation_getInstance());
  AbcOpcode_StrictEquals_instance = new AbcOpcode('StrictEquals', 134, 172, Kind_BasicOperation_getInstance());
  AbcOpcode_LessThan_instance = new AbcOpcode('LessThan', 135, 173, Kind_BasicOperation_getInstance());
  AbcOpcode_LessEquals_instance = new AbcOpcode('LessEquals', 136, 174, Kind_BasicOperation_getInstance());
  AbcOpcode_GreaterThan_instance = new AbcOpcode('GreaterThan', 137, 175, Kind_BasicOperation_getInstance());
  AbcOpcode_GreaterEquals_instance = new AbcOpcode('GreaterEquals', 138, 176, Kind_BasicOperation_getInstance());
  AbcOpcode_InstanceOf_instance = new AbcOpcode('InstanceOf', 139, 177, Kind_BasicOperation_getInstance());
  AbcOpcode_IsType_instance = new AbcOpcode('IsType', 140, 178, Kind_MultinameOperation_getInstance());
  AbcOpcode_IsTypeLate_instance = new AbcOpcode('IsTypeLate', 141, 179, Kind_BasicOperation_getInstance());
  AbcOpcode_In_instance = new AbcOpcode('In', 142, 180, Kind_BasicOperation_getInstance());
  AbcOpcode_IncrementInt_instance = new AbcOpcode('IncrementInt', 143, 192, Kind_BasicOperation_getInstance());
  AbcOpcode_DecrementInt_instance = new AbcOpcode('DecrementInt', 144, 193, Kind_BasicOperation_getInstance());
  AbcOpcode_IncLocalInt_instance = new AbcOpcode('IncLocalInt', 145, 194, Kind_IntOperation_getInstance());
  AbcOpcode_DecLocalInt_instance = new AbcOpcode('DecLocalInt', 146, 195, Kind_IntOperation_getInstance());
  AbcOpcode_NegateInt_instance = new AbcOpcode('NegateInt', 147, 196, Kind_BasicOperation_getInstance());
  AbcOpcode_AddInt_instance = new AbcOpcode('AddInt', 148, 197, Kind_BasicOperation_getInstance());
  AbcOpcode_SubtractInt_instance = new AbcOpcode('SubtractInt', 149, 198, Kind_BasicOperation_getInstance());
  AbcOpcode_MultiplyInt_instance = new AbcOpcode('MultiplyInt', 150, 199, Kind_BasicOperation_getInstance());
  AbcOpcode_GetLocal0_instance = new AbcOpcode('GetLocal0', 151, 208, Kind_BasicOperation_getInstance());
  AbcOpcode_GetLocal1_instance = new AbcOpcode('GetLocal1', 152, 209, Kind_BasicOperation_getInstance());
  AbcOpcode_GetLocal2_instance = new AbcOpcode('GetLocal2', 153, 210, Kind_BasicOperation_getInstance());
  AbcOpcode_GetLocal3_instance = new AbcOpcode('GetLocal3', 154, 211, Kind_BasicOperation_getInstance());
  AbcOpcode_SetLocal0_instance = new AbcOpcode('SetLocal0', 155, 212, Kind_BasicOperation_getInstance());
  AbcOpcode_SetLocal1_instance = new AbcOpcode('SetLocal1', 156, 213, Kind_BasicOperation_getInstance());
  AbcOpcode_SetLocal2_instance = new AbcOpcode('SetLocal2', 157, 214, Kind_BasicOperation_getInstance());
  AbcOpcode_SetLocal3_instance = new AbcOpcode('SetLocal3', 158, 215, Kind_BasicOperation_getInstance());
  AbcOpcode_Debug_instance = new AbcOpcode('Debug', 159, 239, Kind_IntStringIntIntOperation_getInstance());
  AbcOpcode_DebugLine_instance = new AbcOpcode('DebugLine', 160, 240, Kind_IntOperation_getInstance());
  AbcOpcode_DebugFile_instance = new AbcOpcode('DebugFile', 161, 241, Kind_StringOperation_getInstance());
  AbcOpcode_BreakpointLine_instance = new AbcOpcode('BreakpointLine', 162, 242, Kind_BasicOperation_getInstance());
  AbcOpcode_SetByte_instance = new AbcOpcode('SetByte', 163, 58, Kind_BasicOperation_getInstance());
  AbcOpcode_SetShort_instance = new AbcOpcode('SetShort', 164, 59, Kind_BasicOperation_getInstance());
  AbcOpcode_SetInt_instance = new AbcOpcode('SetInt', 165, 60, Kind_BasicOperation_getInstance());
  AbcOpcode_SetFloat_instance = new AbcOpcode('SetFloat', 166, 61, Kind_BasicOperation_getInstance());
  AbcOpcode_SetDouble_instance = new AbcOpcode('SetDouble', 167, 62, Kind_BasicOperation_getInstance());
  AbcOpcode_GetByte_instance = new AbcOpcode('GetByte', 168, 53, Kind_BasicOperation_getInstance());
  AbcOpcode_GetShort_instance = new AbcOpcode('GetShort', 169, 54, Kind_BasicOperation_getInstance());
  AbcOpcode_GetInt_instance = new AbcOpcode('GetInt', 170, 55, Kind_BasicOperation_getInstance());
  AbcOpcode_GetFloat_instance = new AbcOpcode('GetFloat', 171, 56, Kind_BasicOperation_getInstance());
  AbcOpcode_GetDouble_instance = new AbcOpcode('GetDouble', 172, 57, Kind_BasicOperation_getInstance());
  AbcOpcode_Sign1_instance = new AbcOpcode('Sign1', 173, 80, Kind_BasicOperation_getInstance());
  AbcOpcode_Sign8_instance = new AbcOpcode('Sign8', 174, 81, Kind_BasicOperation_getInstance());
  AbcOpcode_Sign16_instance = new AbcOpcode('Sign16', 175, 82, Kind_BasicOperation_getInstance());
  Companion_getInstance_22();
}
function Kind_BasicOperation_getInstance() {
  Kind_initEntries();
  return Kind_BasicOperation_instance;
}
function Kind_LabelOperation_getInstance() {
  Kind_initEntries();
  return Kind_LabelOperation_instance;
}
function Kind_IntOperation_getInstance() {
  Kind_initEntries();
  return Kind_IntOperation_instance;
}
function Kind_UIntOperation_getInstance() {
  Kind_initEntries();
  return Kind_UIntOperation_instance;
}
function Kind_NumberOperation_getInstance() {
  Kind_initEntries();
  return Kind_NumberOperation_instance;
}
function Kind_IntIntOperation_getInstance() {
  Kind_initEntries();
  return Kind_IntIntOperation_instance;
}
function Kind_IntStringIntIntOperation_getInstance() {
  Kind_initEntries();
  return Kind_IntStringIntIntOperation_instance;
}
function Kind_StringOperation_getInstance() {
  Kind_initEntries();
  return Kind_StringOperation_instance;
}
function Kind_MultinameOperation_getInstance() {
  Kind_initEntries();
  return Kind_MultinameOperation_instance;
}
function Kind_MultinameIntOperation_getInstance() {
  Kind_initEntries();
  return Kind_MultinameIntOperation_instance;
}
function Kind_ConditionalJumpOperation_getInstance() {
  Kind_initEntries();
  return Kind_ConditionalJumpOperation_instance;
}
function Kind_JumpOperation_getInstance() {
  Kind_initEntries();
  return Kind_JumpOperation_instance;
}
function Kind_NewClassOperation_getInstance() {
  Kind_initEntries();
  return Kind_NewClassOperation_instance;
}
function Kind_LookupSwitchOperation_getInstance() {
  Kind_initEntries();
  return Kind_LookupSwitchOperation_instance;
}
function Kind_NamespaceOperation_getInstance() {
  Kind_initEntries();
  return Kind_NamespaceOperation_instance;
}
function Kind_NewFunctionOperation_getInstance() {
  Kind_initEntries();
  return Kind_NewFunctionOperation_instance;
}
function Kind_MethodOperation_getInstance() {
  Kind_initEntries();
  return Kind_MethodOperation_instance;
}
function Kind_NewCatchOperation_getInstance() {
  Kind_initEntries();
  return Kind_NewCatchOperation_instance;
}
function AbcOpcode_Breakpoint_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Breakpoint_instance;
}
function AbcOpcode_Nop_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Nop_instance;
}
function AbcOpcode_Throw_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Throw_instance;
}
function AbcOpcode_GetSuper_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetSuper_instance;
}
function AbcOpcode_SetSuper_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetSuper_instance;
}
function AbcOpcode_DefaultXmlNamespace_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DefaultXmlNamespace_instance;
}
function AbcOpcode_DefaultXmlNamespaceL_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DefaultXmlNamespaceL_instance;
}
function AbcOpcode_Kill_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Kill_instance;
}
function AbcOpcode_Label_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Label_instance;
}
function AbcOpcode_IfNotLessThan_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfNotLessThan_instance;
}
function AbcOpcode_IfNotLessEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfNotLessEqual_instance;
}
function AbcOpcode_IfNotGreaterThan_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfNotGreaterThan_instance;
}
function AbcOpcode_IfNotGreaterEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfNotGreaterEqual_instance;
}
function AbcOpcode_Jump_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Jump_instance;
}
function AbcOpcode_IfTrue_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfTrue_instance;
}
function AbcOpcode_IfFalse_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfFalse_instance;
}
function AbcOpcode_IfEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfEqual_instance;
}
function AbcOpcode_IfNotEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfNotEqual_instance;
}
function AbcOpcode_IfLessThan_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfLessThan_instance;
}
function AbcOpcode_IfLessEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfLessEqual_instance;
}
function AbcOpcode_IfGreaterThan_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfGreaterThan_instance;
}
function AbcOpcode_IfGreaterEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfGreaterEqual_instance;
}
function AbcOpcode_IfStrictEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfStrictEqual_instance;
}
function AbcOpcode_IfStrictNotEqual_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IfStrictNotEqual_instance;
}
function AbcOpcode_LookupSwitch_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_LookupSwitch_instance;
}
function AbcOpcode_PushWith_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushWith_instance;
}
function AbcOpcode_PopScope_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PopScope_instance;
}
function AbcOpcode_NextName_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NextName_instance;
}
function AbcOpcode_HasNext_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_HasNext_instance;
}
function AbcOpcode_PushNull_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushNull_instance;
}
function AbcOpcode_PushUndefined_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushUndefined_instance;
}
function AbcOpcode_NextValue_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NextValue_instance;
}
function AbcOpcode_PushByte_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushByte_instance;
}
function AbcOpcode_PushShort_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushShort_instance;
}
function AbcOpcode_PushTrue_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushTrue_instance;
}
function AbcOpcode_PushFalse_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushFalse_instance;
}
function AbcOpcode_PushNaN_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushNaN_instance;
}
function AbcOpcode_Pop_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Pop_instance;
}
function AbcOpcode_Dup_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Dup_instance;
}
function AbcOpcode_Swap_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Swap_instance;
}
function AbcOpcode_PushString_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushString_instance;
}
function AbcOpcode_PushInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushInt_instance;
}
function AbcOpcode_PushUInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushUInt_instance;
}
function AbcOpcode_PushDouble_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushDouble_instance;
}
function AbcOpcode_PushScope_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushScope_instance;
}
function AbcOpcode_PushNamespace_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushNamespace_instance;
}
function AbcOpcode_HasNext2_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_HasNext2_instance;
}
function AbcOpcode_PushDecimal_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushDecimal_instance;
}
function AbcOpcode_PushDNaN_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_PushDNaN_instance;
}
function AbcOpcode_NewFunction_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NewFunction_instance;
}
function AbcOpcode_Call_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Call_instance;
}
function AbcOpcode_Construct_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Construct_instance;
}
function AbcOpcode_CallMethod_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallMethod_instance;
}
function AbcOpcode_CallStatic_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallStatic_instance;
}
function AbcOpcode_CallSuper_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallSuper_instance;
}
function AbcOpcode_CallProperty_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallProperty_instance;
}
function AbcOpcode_ReturnVoid_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ReturnVoid_instance;
}
function AbcOpcode_ReturnValue_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ReturnValue_instance;
}
function AbcOpcode_ConstructSuper_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConstructSuper_instance;
}
function AbcOpcode_ConstructProp_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConstructProp_instance;
}
function AbcOpcode_CallSuperId_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallSuperId_instance;
}
function AbcOpcode_CallPropLex_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallPropLex_instance;
}
function AbcOpcode_CallInterface_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallInterface_instance;
}
function AbcOpcode_CallSuperVoid_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallSuperVoid_instance;
}
function AbcOpcode_CallPropVoid_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CallPropVoid_instance;
}
function AbcOpcode_ApplyType_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ApplyType_instance;
}
function AbcOpcode_NewObject_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NewObject_instance;
}
function AbcOpcode_NewArray_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NewArray_instance;
}
function AbcOpcode_NewActivation_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NewActivation_instance;
}
function AbcOpcode_NewClass_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NewClass_instance;
}
function AbcOpcode_GetDescendants_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetDescendants_instance;
}
function AbcOpcode_NewCatch_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NewCatch_instance;
}
function AbcOpcode_FindPropGlobalStrict_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_FindPropGlobalStrict_instance;
}
function AbcOpcode_FindPropGlobal_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_FindPropGlobal_instance;
}
function AbcOpcode_FindPropStrict_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_FindPropStrict_instance;
}
function AbcOpcode_FindProperty_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_FindProperty_instance;
}
function AbcOpcode_FindDef_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_FindDef_instance;
}
function AbcOpcode_GetLex_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetLex_instance;
}
function AbcOpcode_SetProperty_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetProperty_instance;
}
function AbcOpcode_GetLocal_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetLocal_instance;
}
function AbcOpcode_SetLocal_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetLocal_instance;
}
function AbcOpcode_GetGlobalScope_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetGlobalScope_instance;
}
function AbcOpcode_GetScopeObject_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetScopeObject_instance;
}
function AbcOpcode_GetProperty_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetProperty_instance;
}
function AbcOpcode_GetPropertyLate_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetPropertyLate_instance;
}
function AbcOpcode_InitProperty_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_InitProperty_instance;
}
function AbcOpcode_SetPropertyLate_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetPropertyLate_instance;
}
function AbcOpcode_DeleteProperty_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DeleteProperty_instance;
}
function AbcOpcode_DeletePropertyLate_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DeletePropertyLate_instance;
}
function AbcOpcode_GetSlot_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetSlot_instance;
}
function AbcOpcode_SetSlot_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetSlot_instance;
}
function AbcOpcode_GetGlobalSlot_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetGlobalSlot_instance;
}
function AbcOpcode_SetGlobalSlot_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetGlobalSlot_instance;
}
function AbcOpcode_ConvertString_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConvertString_instance;
}
function AbcOpcode_EscXmlElem_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_EscXmlElem_instance;
}
function AbcOpcode_EscXmlAttr_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_EscXmlAttr_instance;
}
function AbcOpcode_ConvertInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConvertInt_instance;
}
function AbcOpcode_ConvertUInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConvertUInt_instance;
}
function AbcOpcode_ConvertDouble_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConvertDouble_instance;
}
function AbcOpcode_ConvertBoolean_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConvertBoolean_instance;
}
function AbcOpcode_ConvertObject_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ConvertObject_instance;
}
function AbcOpcode_CheckFilter_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CheckFilter_instance;
}
function AbcOpcode_Coerce_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Coerce_instance;
}
function AbcOpcode_CoerceBoolean_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceBoolean_instance;
}
function AbcOpcode_CoerceAny_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceAny_instance;
}
function AbcOpcode_CoerceInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceInt_instance;
}
function AbcOpcode_CoerceDouble_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceDouble_instance;
}
function AbcOpcode_CoerceString_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceString_instance;
}
function AbcOpcode_AsType_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_AsType_instance;
}
function AbcOpcode_AsTypeLate_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_AsTypeLate_instance;
}
function AbcOpcode_CoerceUInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceUInt_instance;
}
function AbcOpcode_CoerceObject_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_CoerceObject_instance;
}
function AbcOpcode_Negate_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Negate_instance;
}
function AbcOpcode_Increment_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Increment_instance;
}
function AbcOpcode_IncLocal_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IncLocal_instance;
}
function AbcOpcode_Decrement_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Decrement_instance;
}
function AbcOpcode_DecLocal_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DecLocal_instance;
}
function AbcOpcode_TypeOf_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_TypeOf_instance;
}
function AbcOpcode_Not_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Not_instance;
}
function AbcOpcode_BitNot_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_BitNot_instance;
}
function AbcOpcode_Concat_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Concat_instance;
}
function AbcOpcode_AddDouble_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_AddDouble_instance;
}
function AbcOpcode_Add_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Add_instance;
}
function AbcOpcode_Subtract_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Subtract_instance;
}
function AbcOpcode_Multiply_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Multiply_instance;
}
function AbcOpcode_Divide_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Divide_instance;
}
function AbcOpcode_Modulo_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Modulo_instance;
}
function AbcOpcode_ShiftLeft_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ShiftLeft_instance;
}
function AbcOpcode_ShiftRight_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ShiftRight_instance;
}
function AbcOpcode_ShiftRightUnsigned_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_ShiftRightUnsigned_instance;
}
function AbcOpcode_BitAnd_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_BitAnd_instance;
}
function AbcOpcode_BitOr_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_BitOr_instance;
}
function AbcOpcode_BitXor_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_BitXor_instance;
}
function AbcOpcode_Equals_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Equals_instance;
}
function AbcOpcode_StrictEquals_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_StrictEquals_instance;
}
function AbcOpcode_LessThan_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_LessThan_instance;
}
function AbcOpcode_LessEquals_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_LessEquals_instance;
}
function AbcOpcode_GreaterThan_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GreaterThan_instance;
}
function AbcOpcode_GreaterEquals_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GreaterEquals_instance;
}
function AbcOpcode_InstanceOf_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_InstanceOf_instance;
}
function AbcOpcode_IsType_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IsType_instance;
}
function AbcOpcode_IsTypeLate_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IsTypeLate_instance;
}
function AbcOpcode_In_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_In_instance;
}
function AbcOpcode_IncrementInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IncrementInt_instance;
}
function AbcOpcode_DecrementInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DecrementInt_instance;
}
function AbcOpcode_IncLocalInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_IncLocalInt_instance;
}
function AbcOpcode_DecLocalInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DecLocalInt_instance;
}
function AbcOpcode_NegateInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_NegateInt_instance;
}
function AbcOpcode_AddInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_AddInt_instance;
}
function AbcOpcode_SubtractInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SubtractInt_instance;
}
function AbcOpcode_MultiplyInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_MultiplyInt_instance;
}
function AbcOpcode_GetLocal0_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetLocal0_instance;
}
function AbcOpcode_GetLocal1_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetLocal1_instance;
}
function AbcOpcode_GetLocal2_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetLocal2_instance;
}
function AbcOpcode_GetLocal3_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetLocal3_instance;
}
function AbcOpcode_SetLocal0_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetLocal0_instance;
}
function AbcOpcode_SetLocal1_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetLocal1_instance;
}
function AbcOpcode_SetLocal2_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetLocal2_instance;
}
function AbcOpcode_SetLocal3_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetLocal3_instance;
}
function AbcOpcode_Debug_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Debug_instance;
}
function AbcOpcode_DebugLine_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DebugLine_instance;
}
function AbcOpcode_DebugFile_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_DebugFile_instance;
}
function AbcOpcode_BreakpointLine_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_BreakpointLine_instance;
}
function AbcOpcode_SetByte_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetByte_instance;
}
function AbcOpcode_SetShort_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetShort_instance;
}
function AbcOpcode_SetInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetInt_instance;
}
function AbcOpcode_SetFloat_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetFloat_instance;
}
function AbcOpcode_SetDouble_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_SetDouble_instance;
}
function AbcOpcode_GetByte_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetByte_instance;
}
function AbcOpcode_GetShort_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetShort_instance;
}
function AbcOpcode_GetInt_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetInt_instance;
}
function AbcOpcode_GetFloat_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetFloat_instance;
}
function AbcOpcode_GetDouble_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_GetDouble_instance;
}
function AbcOpcode_Sign1_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Sign1_instance;
}
function AbcOpcode_Sign8_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Sign8_instance;
}
function AbcOpcode_Sign16_getInstance() {
  AbcOpcode_initEntries();
  return AbcOpcode_Sign16_instance;
}
function readU30(_this__u8e3s4) {
  var result = readU8(_this__u8e3s4);
  if ((result & 128) === 0)
    return result;
  result = result & 127 | readU8(_this__u8e3s4) << 7;
  if ((result & 16384) === 0)
    return result;
  result = result & 16383 | readU8(_this__u8e3s4) << 14;
  if ((result & 2097152) === 0)
    return result;
  result = result & 2097151 | readU8(_this__u8e3s4) << 21;
  if ((result & 268435456) === 0)
    return result;
  result = result & 268435455 | readU8(_this__u8e3s4) << 28;
  return result;
}
var Undefined_instance;
function Undefined_getInstance() {
  return Undefined_instance;
}
function createBox(_this__u8e3s4, scaleX, scaleY, rotation, tx, ty) {
  rotation = rotation === VOID ? 0.0 : rotation;
  tx = tx === VOID ? 0.0 : tx;
  ty = ty === VOID ? 0.0 : ty;
  // Inline function 'kotlin.math.cos' call
  var u = Math.cos(rotation);
  // Inline function 'kotlin.math.sin' call
  var v = Math.sin(rotation);
  _this__u8e3s4.a4d_1 = u * scaleX;
  _this__u8e3s4.b4d_1 = v * scaleY;
  _this__u8e3s4.c4d_1 = -v * scaleX;
  _this__u8e3s4.d4d_1 = u * scaleY;
  _this__u8e3s4.e4d_1 = tx;
  _this__u8e3s4.f4d_1 = ty;
}
var Companion_instance_6;
function Companion_getInstance_23() {
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_24() {
  return Companion_instance_7;
}
function *_generator_loadBytes__jf9vlb($this, bytes, $completion) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korfl.as3swf.SWF.loadBytes.<anonymous>' call
  var ba = toFlash(bytes);
  $this.cmm_1.mmm(0);
  ba.p1q(0);
  ba.nmm($this.cmm_1);
  var tmp = $this.omm($this.cmm_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this;
}
function *_generator_parse__tgo4f5($this, data, $completion) {
  $this.cmm_1 = data;
  var tmp = $this.pmm($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.imn(data, $this.emm_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_parseHeader__o3854c($this, $completion) {
  $this.dmm_1 = '';
  $this.kmm_1 = false;
  $this.lmm_1 = 'zlib';
  $this.cmm_1.p1q(0);
  var signatureByte = $this.cmm_1.bmg();
  var tmp10_subject = numberToChar(signatureByte);
  if (tmp10_subject === _Char___init__impl__6a9atx(67)) {
    $this.kmm_1 = true;
    $this.lmm_1 = 'zlib';
  } else if (tmp10_subject === _Char___init__impl__6a9atx(90)) {
    $this.kmm_1 = true;
    $this.lmm_1 = 'lzma';
  } else if (tmp10_subject === _Char___init__impl__6a9atx(70)) {
    $this.kmm_1 = false;
  } else
    throw Error_0.cf('Not a SWF. First signature byte is 0x' + toString_1(signatureByte, 16) + ' (expected: 0x43 or 0x5A or 0x46)');
  var tmp = $this;
  var tmp_0 = $this.dmm_1;
  var tmp_1 = StringCompanionObject_instance;
  // Inline function 'kotlin.intArrayOf' call
  var tmp$ret$0 = new Int32Array([Char__toInt_impl_vasixd(numberToChar(signatureByte))]);
  tmp.dmm_1 = plus_0(tmp_0, fromIntArray(tmp_1, tmp$ret$0));
  signatureByte = $this.cmm_1.bmg();
  if (!(signatureByte === 87))
    throw Error_0.cf('Not a SWF. Second signature byte is 0x' + toString_1(signatureByte, 16) + ' (expected: 0x57)');
  var tmp_2 = $this;
  var tmp_3 = $this.dmm_1;
  var tmp_4 = StringCompanionObject_instance;
  // Inline function 'kotlin.intArrayOf' call
  var tmp$ret$1 = new Int32Array([Char__toInt_impl_vasixd(numberToChar(signatureByte))]);
  tmp_2.dmm_1 = plus_0(tmp_3, fromIntArray(tmp_4, tmp$ret$1));
  signatureByte = $this.cmm_1.bmg();
  if (!(signatureByte === 83))
    throw Error_0.cf('Not a SWF. Third signature byte is 0x' + toString_1(signatureByte, 16) + ' (expected: 0x53)');
  var tmp_5 = $this;
  var tmp_6 = $this.dmm_1;
  var tmp_7 = StringCompanionObject_instance;
  // Inline function 'kotlin.intArrayOf' call
  var tmp$ret$2 = new Int32Array([Char__toInt_impl_vasixd(numberToChar(signatureByte))]);
  tmp_5.dmm_1 = plus_0(tmp_6, fromIntArray(tmp_7, tmp$ret$2));
  $this.emm_1 = $this.cmm_1.bmg();
  $this.fmm_1 = $this.cmm_1.jmn();
  $this.gmm_1 = $this.cmm_1.a();
  if ($this.fmm_1 >= imul($this.gmm_1, 4)) {
    invalidOp('something went wrong! fileLength >= fileLengthCompressed * 4 : ' + $this.fmm_1 + ' >= ' + $this.gmm_1 + ' * 4');
  }
  if ($this.kmm_1) {
    var tmp_8 = $this.cmm_1.kmn($this.lmm_1, $this.fmm_1, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  }
  $this.hmm_1 = $this.cmm_1.lmn();
  $this.imm_1 = $this.cmm_1.mmn();
  $this.jmm_1 = $this.cmm_1.pmf();
  return Unit_instance;
}
var Companion_instance_8;
function Companion_getInstance_25() {
  return Companion_instance_8;
}
function *_generator_parseTags__eki1u0($this, data, version, $completion) {
  parseTagsInit($this, data, version);
  $l$loop_0: while (data.bmo() > 0) {
    dispatchProgress($this, ensureNotNull($this.bmn_1).q1q(), ensureNotNull($this.bmn_1).a());
    var tmp = $this.xmn(ensureNotNull($this.bmn_1), true, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      break $l$loop_0;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tag = tmp_0;
    if (tag.b2n() === Companion_getInstance_34().cmo_1)
      break $l$loop_0;
  }
  parseTagsFinalize($this);
  return Unit_instance;
}
function dispatchProgress($this, position, length) {
}
function parseTagsInit($this, data, version) {
  $this.qmm_1.o3();
  $this.umm_1.o3();
  $this.vmm_1.o3();
  var tmp = $this;
  // Inline function 'kotlin.collections.hashMapOf' call
  tmp.smm_1 = HashMap.c9();
  $this.xmm_1 = new Frame();
  var tmp_0 = $this;
  // Inline function 'kotlin.collections.hashMapOf' call
  tmp_0.ymm_1 = HashMap.c9();
  $this.zmm_1 = false;
  $this.bmn_1 = data;
  $this.cmn_1 = version;
}
function *_generator_parseTag__51w741($this, data, async, $completion) {
  var pos = data.q1q();
  $this.amn_1 = pos >= data.a();
  if ($this.amn_1) {
    println('WARNING: end of file encountered, no end tag.');
    return null;
  }
  var tagRaw = data.dmo();
  var tagHeader = tagRaw.gmo();
  var tag = $this.emn_1.kmo(tagHeader.hmo_1);
  try {
    if (tag instanceof SWFTimelineContainer) {
      var timelineContainer = tag;
      timelineContainer.emn_1 = $this.emn_1;
      timelineContainer.fmn_1 = $this;
    }
    var tmp = tag.lmo(data, tagHeader.imo_1, $this.cmn_1, async, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      println('ERROR: parse error: ' + e.message + ', Tag: ' + tag.w3() + ', Index: ' + $this.qmm_1.j1());
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  $this.qmm_1.f(tag);
  $this.rmm_1.f(tagRaw);
  processTag($this, tag);
  if (!(data.q1q() === (pos + tagHeader.mmo() | 0))) {
    var index = $this.qmm_1.j1() - 1 | 0;
    var excessBytes = data.q1q() - (pos + tagHeader.mmo() | 0) | 0;
    if (equals($this.fmn_1, $this)) {
      println('WARNING: excess bytes: ' + excessBytes + ', ' + 'Tag: ' + tag.w3() + ', ' + 'Index: ' + index);
    } else {
      println('WARNING: excess bytes: ' + excessBytes + ', ' + 'Tag: ' + tag.w3() + ', ' + 'Index: ' + index + ', ' + 'IndexRoot: ' + $this.fmn_1.qmm_1.j1());
    }
    data.p1q(pos + tagHeader.mmo() | 0);
  }
  return tag;
}
function parseTagsFinalize($this) {
  var soundStream = $this.wmm_1;
  if (!(soundStream == null) && soundStream.umo_1.a() === 0)
    $this.wmm_1 = null;
}
function processTag($this, tag) {
  var currentTagIndex = $this.qmm_1.j1() - 1 | 0;
  if (isInterface(tag, IDefinitionTag)) {
    processDefinitionTag($this, tag, currentTagIndex);
    return Unit_instance;
  } else {
    if (isInterface(tag, IDisplayListTag)) {
      processDisplayListTag($this, tag, currentTagIndex);
      return Unit_instance;
    }
  }
  var tmp13_subject = tag.b2n();
  if (tmp13_subject === Companion_getInstance_35().cmo_1 || tmp13_subject === Companion_getInstance_36().cmo_1) {
    processFrameLabelTag($this, tag, currentTagIndex);
  } else if (tmp13_subject === Companion_getInstance_37().cmo_1 || (tmp13_subject === Companion_getInstance_38().cmo_1 || tmp13_subject === Companion_getInstance_39().cmo_1)) {
    if (Companion_instance_8.amo_1) {
      processSoundStreamTag($this, tag, currentTagIndex);
    }
  } else if (tmp13_subject === Companion_getInstance_40().cmo_1) {
    $this.ymn(tag instanceof TagSetBackgroundColor ? tag : THROW_CCE(), currentTagIndex);
  } else if (tmp13_subject === Companion_getInstance_33().cmo_1) {
    $this.zmn(tag instanceof TagJPEGTables ? tag : THROW_CCE(), currentTagIndex);
  }
}
function processDefinitionTag($this, tag, currentTagIndex) {
  if (tag.vmo() > 0) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = $this.smm_1;
    var key = tag.vmo();
    this_0.r3(key, currentTagIndex);
    $this.wmn().cmp_1.f(tag.vmo());
  }
}
function processDisplayListTag($this, tag, currentTagIndex) {
  var tmp14_subject = tag.b2n();
  if (tmp14_subject === Companion_getInstance_41().cmo_1) {
    $this.wmn().ymo_1 = currentTagIndex;
    var tmp;
    if ($this.wmn().zmo_1 == null) {
      // Inline function 'kotlin.collections.contains' call
      var this_0 = $this.ymm_1;
      // Inline function 'kotlin.collections.containsKey' call
      var key = $this.wmn().wmo_1;
      tmp = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).i3(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.wmn().zmo_1 = $this.ymm_1.k3($this.wmn().wmo_1);
    }
    $this.umm_1.f($this.wmn());
    $this.xmm_1 = $this.wmn().j13();
    $this.wmn().wmo_1 = $this.umm_1.j1();
    $this.wmn().xmo_1 = currentTagIndex + 1 | 0;
  } else if (tmp14_subject === Companion_getInstance_42().cmo_1 || (tmp14_subject === Companion_getInstance_43().cmo_1 || tmp14_subject === Companion_getInstance_44().cmo_1)) {
    var tmp_0 = $this.wmn();
    tmp_0.emp(currentTagIndex, tag instanceof TagPlaceObject ? tag : THROW_CCE());
  } else if (tmp14_subject === Companion_getInstance_45().cmo_1 || tmp14_subject === Companion_getInstance_46().cmo_1) {
    var tmp_1 = $this.wmn();
    tmp_1.dmp(tag instanceof TagRemoveObject ? tag : THROW_CCE());
  }
}
function processFrameLabelTag($this, tag, currentTagIndex) {
  var tmp15_subject = tag.b2n();
  if (tmp15_subject === Companion_getInstance_36().cmo_1) {
    var tagSceneAndFrameLabelData = tag instanceof TagDefineSceneAndFrameLabelData ? tag : THROW_CCE();
    var inductionVariable = 0;
    var last = tagSceneAndFrameLabelData.rmp_1.j1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var frameLabel = tagSceneAndFrameLabelData.rmp_1.i1(i);
        // Inline function 'kotlin.collections.set' call
        var this_0 = $this.ymm_1;
        var key = frameLabel.smp_1;
        var value = frameLabel.tmp_1;
        this_0.r3(key, value);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = tagSceneAndFrameLabelData.qmp_1.j1();
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var scene = tagSceneAndFrameLabelData.qmp_1.i1(i_0);
        $this.tmm_1.f(new Scene(scene.ump_1, scene.vmp_1));
      }
       while (inductionVariable_0 < last_0);
  } else if (tmp15_subject === Companion_getInstance_35().cmo_1) {
    var tagFrameLabel = tag instanceof TagFrameLabel ? tag : THROW_CCE();
    $this.wmn().zmo_1 = tagFrameLabel.lmp();
  }
}
function processSoundStreamTag($this, tag, currentTagIndex) {
  var tmp16_subject = tag.b2n();
  if (tmp16_subject === Companion_getInstance_37().cmo_1 || tmp16_subject === Companion_getInstance_38().cmo_1) {
    var tagSoundStreamHead = tag instanceof TagSoundStreamHead ? tag : THROW_CCE();
    $this.wmm_1 = new SoundStream();
    var soundStream = ensureNotNull($this.wmm_1);
    soundStream.qmo_1 = tagSoundStreamHead.lmq_1;
    soundStream.rmo_1 = tagSoundStreamHead.mmq_1;
    soundStream.smo_1 = tagSoundStreamHead.nmq_1;
    soundStream.tmo_1 = tagSoundStreamHead.omq_1;
    soundStream.omo_1 = 0;
    soundStream.pmo_1 = 0;
  } else if (tmp16_subject === Companion_getInstance_39().cmo_1) {
    if (!($this.wmm_1 == null)) {
      var soundStream_0 = ensureNotNull($this.wmm_1);
      if (!$this.zmm_1) {
        $this.zmm_1 = true;
        soundStream_0.nmo_1 = $this.wmn().wmo_1;
      }
      var tagSoundStreamBlock = tag instanceof TagSoundStreamBlock ? tag : THROW_CCE();
      var soundData = tagSoundStreamBlock.amq_1;
      soundData.xmh_1 = Endian_LITTLE_ENDIAN_getInstance();
      soundData.p1q(0);
      var tmp17_subject = soundStream_0.qmo_1;
      if (tmp17_subject !== 1)
        if (tmp17_subject === 2) {
          var numSamples = soundData.bmq();
          var seekSamples = soundData.cmq();
          if (numSamples > 0) {
            soundStream_0.pmo_1 = soundStream_0.pmo_1 + numSamples | 0;
            soundStream_0.umo_1.dmq(soundData, 4);
          }
        }
      soundStream_0.omo_1 = soundStream_0.omo_1 + 1 | 0;
    }
  }
}
var Companion_instance_9;
function Companion_getInstance_26() {
  return Companion_instance_9;
}
function *_generator_swfUncompress__isrgon($this, compressionMethod, uncompressedLength, $completion) {
  var pos = $this.q1q();
  var ba = FlashByteArray.emr();
  switch (compressionMethod) {
    case 'zlib':
      $this.nmm(ba);
      ba.p1q(0);
      var tmp = ba.fmr(VOID, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      break;
    case 'lzma':
      var inductionVariable = 0;
      if (inductionVariable < 5)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          ba.gmr($this.i1(i + 12 | 0));
        }
         while (inductionVariable < 5);
      ba.xmh_1 = Endian_LITTLE_ENDIAN_getInstance();
      ba.hmr(uncompressedLength - 8 | 0);
      ba.hmr(0);
      $this.p1q(17);
      ba.p1q(13);
      ba.imr($this.h1r($this.bmo()));
      ba.p1q(13);
      ba.p1q(0);
      var tmp_0 = ba.jmr(compressionMethod, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Unknown compression method: ' + compressionMethod;
      throw IllegalStateException.m5(toString(message));
  }
  $this.mmm(pos);
  $this.p1q(pos);
  $this.dmq(ba);
  $this.p1q(pos);
  return Unit_instance;
}
var SoundCompression_instance;
function SoundCompression_getInstance() {
  return SoundCompression_instance;
}
var SoundRate_instance;
function SoundRate_getInstance() {
  return SoundRate_instance;
}
var SoundSize_instance;
function SoundSize_getInstance() {
  return SoundSize_instance;
}
var SoundType_instance;
function SoundType_getInstance() {
  return SoundType_instance;
}
var BlendMode_instance;
function BlendMode_getInstance() {
  return BlendMode_instance;
}
var GradientSpreadMode_PAD_instance;
var GradientSpreadMode_REFLECT_instance;
var GradientSpreadMode_REPEAT_instance;
var Companion_instance_10;
function Companion_getInstance_27() {
  GradientSpreadMode_initEntries();
  if (Companion_instance_10 === VOID)
    new Companion_6();
  return Companion_instance_10;
}
function values_2() {
  return [GradientSpreadMode_PAD_getInstance(), GradientSpreadMode_REFLECT_getInstance(), GradientSpreadMode_REPEAT_getInstance()];
}
var GradientSpreadMode_entriesInitialized;
function GradientSpreadMode_initEntries() {
  if (GradientSpreadMode_entriesInitialized)
    return Unit_instance;
  GradientSpreadMode_entriesInitialized = true;
  GradientSpreadMode_PAD_instance = new GradientSpreadMode('PAD', 0, 0);
  GradientSpreadMode_REFLECT_instance = new GradientSpreadMode('REFLECT', 1, 1);
  GradientSpreadMode_REPEAT_instance = new GradientSpreadMode('REPEAT', 2, 2);
  Companion_getInstance_27();
}
var GradientInterpolationMode_NORMAL_instance;
var GradientInterpolationMode_LINEAR_instance;
var Companion_instance_11;
function Companion_getInstance_28() {
  GradientInterpolationMode_initEntries();
  if (Companion_instance_11 === VOID)
    new Companion_7();
  return Companion_instance_11;
}
function values_3() {
  return [GradientInterpolationMode_NORMAL_getInstance(), GradientInterpolationMode_LINEAR_getInstance()];
}
var GradientInterpolationMode_entriesInitialized;
function GradientInterpolationMode_initEntries() {
  if (GradientInterpolationMode_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMode_entriesInitialized = true;
  GradientInterpolationMode_NORMAL_instance = new GradientInterpolationMode('NORMAL', 0, 0);
  GradientInterpolationMode_LINEAR_instance = new GradientInterpolationMode('LINEAR', 1, 1);
  Companion_getInstance_28();
}
var LineCapsStyle_ROUND_instance;
var LineCapsStyle_NO_instance;
var LineCapsStyle_SQUARE_instance;
var Companion_instance_12;
function Companion_getInstance_29() {
  LineCapsStyle_initEntries();
  if (Companion_instance_12 === VOID)
    new Companion_8();
  return Companion_instance_12;
}
function values_4() {
  return [LineCapsStyle_ROUND_getInstance(), LineCapsStyle_NO_getInstance(), LineCapsStyle_SQUARE_getInstance()];
}
var LineCapsStyle_entriesInitialized;
function LineCapsStyle_initEntries() {
  if (LineCapsStyle_entriesInitialized)
    return Unit_instance;
  LineCapsStyle_entriesInitialized = true;
  LineCapsStyle_ROUND_instance = new LineCapsStyle('ROUND', 0, 0);
  LineCapsStyle_NO_instance = new LineCapsStyle('NO', 1, 1);
  LineCapsStyle_SQUARE_instance = new LineCapsStyle('SQUARE', 2, 2);
  Companion_getInstance_29();
}
var LineJointStyle_instance;
function LineJointStyle_getInstance() {
  return LineJointStyle_instance;
}
var ActionValueType_instance;
function ActionValueType_getInstance() {
  return ActionValueType_instance;
}
var BitmapFormat_BIT_8_instance;
var BitmapFormat_BIT_15_instance;
var BitmapFormat_BIT_24_32_instance;
var BitmapFormat_UNKNOWN_instance;
var Companion_instance_13;
function Companion_getInstance_30() {
  BitmapFormat_initEntries();
  if (Companion_instance_13 === VOID)
    new Companion_9();
  return Companion_instance_13;
}
function values_5() {
  return [BitmapFormat_BIT_8_getInstance(), BitmapFormat_BIT_15_getInstance(), BitmapFormat_BIT_24_32_getInstance(), BitmapFormat_UNKNOWN_getInstance()];
}
var BitmapFormat_entriesInitialized;
function BitmapFormat_initEntries() {
  if (BitmapFormat_entriesInitialized)
    return Unit_instance;
  BitmapFormat_entriesInitialized = true;
  BitmapFormat_BIT_8_instance = new BitmapFormat('BIT_8', 0, 3);
  BitmapFormat_BIT_15_instance = new BitmapFormat('BIT_15', 1, 4);
  BitmapFormat_BIT_24_32_instance = new BitmapFormat('BIT_24_32', 2, 5);
  BitmapFormat_UNKNOWN_instance = new BitmapFormat('UNKNOWN', 3, -1);
  Companion_getInstance_30();
}
var BitmapType_instance;
function BitmapType_getInstance() {
  return BitmapType_instance;
}
var VideoDeblockingType_instance;
function VideoDeblockingType_getInstance() {
  return VideoDeblockingType_instance;
}
var VideoCodecID_instance;
function VideoCodecID_getInstance() {
  return VideoCodecID_instance;
}
var CSMTableHint_instance;
function CSMTableHint_getInstance() {
  return CSMTableHint_instance;
}
function GradientSpreadMode_PAD_getInstance() {
  GradientSpreadMode_initEntries();
  return GradientSpreadMode_PAD_instance;
}
function GradientSpreadMode_REFLECT_getInstance() {
  GradientSpreadMode_initEntries();
  return GradientSpreadMode_REFLECT_instance;
}
function GradientSpreadMode_REPEAT_getInstance() {
  GradientSpreadMode_initEntries();
  return GradientSpreadMode_REPEAT_instance;
}
function GradientInterpolationMode_NORMAL_getInstance() {
  GradientInterpolationMode_initEntries();
  return GradientInterpolationMode_NORMAL_instance;
}
function GradientInterpolationMode_LINEAR_getInstance() {
  GradientInterpolationMode_initEntries();
  return GradientInterpolationMode_LINEAR_instance;
}
function LineCapsStyle_ROUND_getInstance() {
  LineCapsStyle_initEntries();
  return LineCapsStyle_ROUND_instance;
}
function LineCapsStyle_NO_getInstance() {
  LineCapsStyle_initEntries();
  return LineCapsStyle_NO_instance;
}
function LineCapsStyle_SQUARE_getInstance() {
  LineCapsStyle_initEntries();
  return LineCapsStyle_SQUARE_instance;
}
function BitmapFormat_BIT_8_getInstance() {
  BitmapFormat_initEntries();
  return BitmapFormat_BIT_8_instance;
}
function BitmapFormat_BIT_15_getInstance() {
  BitmapFormat_initEntries();
  return BitmapFormat_BIT_15_instance;
}
function BitmapFormat_BIT_24_32_getInstance() {
  BitmapFormat_initEntries();
  return BitmapFormat_BIT_24_32_instance;
}
function BitmapFormat_UNKNOWN_getInstance() {
  BitmapFormat_initEntries();
  return BitmapFormat_UNKNOWN_instance;
}
function get_SWFActionValue_ba() {
  _init_properties_data_kt__4ud8ly();
  return SWFActionValue_ba;
}
var SWFActionValue_ba;
function _get_ba__ndbxv0($this) {
  return get_SWFActionValue_ba();
}
var Companion_instance_14;
function Companion_getInstance_31() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_32() {
  return Companion_instance_15;
}
var SWFShapeRecordEnd_instance;
function SWFShapeRecordEnd_getInstance() {
  if (SWFShapeRecordEnd_instance === VOID)
    new SWFShapeRecordEnd();
  return SWFShapeRecordEnd_instance;
}
var GradientType_LINEAR_instance;
var GradientType_RADIAL_instance;
var GradientType_entriesInitialized;
function GradientType_initEntries() {
  if (GradientType_entriesInitialized)
    return Unit_instance;
  GradientType_entriesInitialized = true;
  GradientType_LINEAR_instance = new GradientType('LINEAR', 0);
  GradientType_RADIAL_instance = new GradientType('RADIAL', 1);
}
function GradientType_LINEAR_getInstance() {
  GradientType_initEntries();
  return GradientType_LINEAR_instance;
}
function GradientType_RADIAL_getInstance() {
  GradientType_initEntries();
  return GradientType_RADIAL_instance;
}
var properties_initialized_data_kt_o36vg;
function _init_properties_data_kt__4ud8ly() {
  if (!properties_initialized_data_kt_o36vg) {
    properties_initialized_data_kt_o36vg = true;
    // Inline function 'kotlin.also' call
    var this_0 = FlashByteArray.emr();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korfl.as3swf.SWFActionValue_ba.<anonymous>' call
    this_0.xmh_1 = Endian_LITTLE_ENDIAN_getInstance();
    this_0.mmm(8);
    SWFActionValue_ba = this_0;
  }
}
function addPoint($this, x, y) {
  $this.jnb_1.r3e(x - $this.knb_1, y - $this.knb_1);
  $this.jnb_1.r3e(x + $this.knb_1, y + $this.knb_1);
}
function println$ref() {
  var l = function (p0) {
    println(p0);
    return Unit_instance;
  };
  l.callableName = 'println';
  return l;
}
var SWFFilterFactory_instance;
function SWFFilterFactory_getInstance() {
  return SWFFilterFactory_instance;
}
var SWFActionFactory_instance;
function SWFActionFactory_getInstance() {
  return SWFActionFactory_instance;
}
var Companion_instance_16;
function Companion_getInstance_33() {
  if (Companion_instance_16 === VOID)
    new Companion_12();
  return Companion_instance_16;
}
var Companion_instance_17;
function Companion_getInstance_34() {
  if (Companion_instance_17 === VOID)
    new Companion_13();
  return Companion_instance_17;
}
var Companion_instance_18;
function Companion_getInstance_35() {
  if (Companion_instance_18 === VOID)
    new Companion_14();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_36() {
  if (Companion_instance_19 === VOID)
    new Companion_15();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_37() {
  if (Companion_instance_20 === VOID)
    new Companion_16();
  return Companion_instance_20;
}
var Companion_instance_21;
function Companion_getInstance_38() {
  if (Companion_instance_21 === VOID)
    new Companion_17();
  return Companion_instance_21;
}
var Companion_instance_22;
function Companion_getInstance_39() {
  if (Companion_instance_22 === VOID)
    new Companion_18();
  return Companion_instance_22;
}
var Companion_instance_23;
function Companion_getInstance_40() {
  if (Companion_instance_23 === VOID)
    new Companion_19();
  return Companion_instance_23;
}
var Companion_instance_24;
function Companion_getInstance_41() {
  if (Companion_instance_24 === VOID)
    new Companion_20();
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_42() {
  if (Companion_instance_25 === VOID)
    new Companion_21();
  return Companion_instance_25;
}
var Companion_instance_26;
function Companion_getInstance_43() {
  if (Companion_instance_26 === VOID)
    new Companion_22();
  return Companion_instance_26;
}
var Companion_instance_27;
function Companion_getInstance_44() {
  if (Companion_instance_27 === VOID)
    new Companion_23();
  return Companion_instance_27;
}
var Companion_instance_28;
function Companion_getInstance_45() {
  if (Companion_instance_28 === VOID)
    new Companion_24();
  return Companion_instance_28;
}
var Companion_instance_29;
function Companion_getInstance_46() {
  if (Companion_instance_29 === VOID)
    new Companion_25();
  return Companion_instance_29;
}
var Companion_instance_30;
function Companion_getInstance_47() {
  return Companion_instance_30;
}
var Companion_instance_31;
function Companion_getInstance_48() {
  return Companion_instance_31;
}
function TagDefineButton$processRecords$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function TagDefineButton$processRecords$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function TagDefineButton$processRecords$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function TagDefineButton$processRecords$lambda_2(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_parse__tgo4f5_0($this, data, length, version, async, $completion) {
  var tmp = protoOf(TagDefineBits).lmo.call($this, data, length, version, async, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.bnq();
  return Unit_instance;
}
function TagDefineButton2$processRecords$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function TagDefineButton2$processRecords$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function TagDefineButton2$processRecords$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function TagDefineButton2$processRecords$lambda_2(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp = a.amx_1;
  // Inline function 'korlibs.korfl.as3swf.TagDefineButton2.processRecords.<anonymous>' call
  var tmp$ret$1 = b.amx_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_parse__tgo4f5_1($this, data, length, version, async, $completion) {
  $this.qnf(data.pmf());
  $this.pnu_1 = data.pmf();
  var tmp = $this.imn(data, version, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_parse__tgo4f5_2($this, data, length, version, async, $completion) {
  $this.wnw_1 = data.dm0();
  var tmp = protoOf(TagImportExportAssets).lmo.call($this, data, length, version, async, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_32;
function Companion_getInstance_49() {
  return Companion_instance_32;
}
var Companion_instance_33;
function Companion_getInstance_50() {
  return Companion_instance_33;
}
function *_generator_parse__tgo4f5_3($this, data, length, version, async, $completion) {
  var tmp = protoOf(TagPlaceObject3).lmo.call($this, data, length, version, async, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (data.bmo() > 0) {
    $this.fni_1 = data.bm0();
  }
  return Unit_instance;
}
function ensureIndex($this, index) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korfl.as3swf.FlashByteArray.ensureIndex.<anonymous>' call
  var tmp = $this.vmh_1.c1s_1;
  // Inline function 'kotlin.math.max' call
  var a = $this.vmh_1.c1s_1.j1();
  var b = index + 1 | 0;
  var tmp$ret$0 = Math.max(a, b);
  tmp.nv(tmp$ret$0);
  return $this;
}
function getCompressionMethod($this, method) {
  var tmp;
  switch (method) {
    case 'gzip':
      tmp = Companion_getInstance_11();
      break;
    case 'zlib':
      tmp = Companion_getInstance_12();
      break;
    case 'deflate':
      tmp = get_Deflate();
      break;
    case 'lzma':
      tmp = Lzma_instance;
      break;
    default:
      var reason = 'Unsupported compression method ' + method;
      throw NotImplementedError.oe('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function _uncompress($this, data, method) {
  return uncompress(data, getCompressionMethod($this, method));
}
var Endian_LITTLE_ENDIAN_instance;
var Endian_BIG_ENDIAN_instance;
var Endian_entriesInitialized;
function Endian_initEntries() {
  if (Endian_entriesInitialized)
    return Unit_instance;
  Endian_entriesInitialized = true;
  Endian_LITTLE_ENDIAN_instance = new Endian('LITTLE_ENDIAN', 0);
  Endian_BIG_ENDIAN_instance = new Endian('BIG_ENDIAN', 1);
}
function toFlash(_this__u8e3s4) {
  return FlashByteArray.tnl(_this__u8e3s4);
}
var ColorUtils_instance;
function ColorUtils_getInstance() {
  return ColorUtils_instance;
}
var NumberUtils_instance;
function NumberUtils_getInstance() {
  return NumberUtils_instance;
}
var MatrixUtils_instance;
function MatrixUtils_getInstance() {
  return MatrixUtils_instance;
}
function Endian_LITTLE_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_LITTLE_ENDIAN_instance;
}
function Endian_BIG_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_BIG_ENDIAN_instance;
}
function set_stencilIndex(_this__u8e3s4, _set____db54di) {
  _init_properties_Animate_kt__k9vufl();
  var this_0 = stencilIndex$delegate;
  var property = stencilIndex$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_stencilIndex(_this__u8e3s4) {
  _init_properties_Animate_kt__k9vufl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = stencilIndex$delegate;
    var property = stencilIndex$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var stencilIndex$delegate;
function replaceDepth($this, depth, view) {
  var result = replaceWith($this.xog_1.i1(depth), view);
  $this.xog_1.p3(depth, view);
  return result;
}
function update($this) {
  var inductionVariable = 0;
  var last = $this.oog_1;
  if (inductionVariable < last)
    $l$loop_0: do {
      var depth = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp81_safe_receiver = $this.yog_1.eoh_1;
      var tmp0_elvis_lhs = tmp81_safe_receiver == null ? null : tmp81_safe_receiver.loh_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var timelines = tmp;
      var timeline = timelines[depth];
      if (timeline.j1() <= 0)
        continue $l$loop_0;
      var hasMultipleFrames = timeline.j1() > 1;
      if ($this.vog_1) {
        var _destruct__k2r9zo = timeline.noi($this.yog_1.coh_1, $this.nog_1);
        var index = _destruct__k2r9zo.km();
        var left = _destruct__k2r9zo.lm();
        var right = _destruct__k2r9zo.ks();
        var ratio = _destruct__k2r9zo.ooi();
        if (!(left == null)) {
          $this.rog_1[left.woh_1] = left.yoh_1;
        }
        var view = !(left == null) && left.xoh_1 >= 0 ? $this.tog_1[left.xoh_1] : $this.qog_1[depth];
        var placed = replaceDepth($this, depth, view);
        if (placed || hasMultipleFrames) {
          if (!(left == null) && !(right == null) && left.xoh_1 === right.xoh_1) {
            Companion_instance_35.poi(view, left, right, toRatio(ratio));
          } else {
            if (left == null)
              null;
            else {
              left.foi(view);
            }
          }
          var tmp_0;
          if (!($this.mog_1.koi_1 == null)) {
            tmp_0 = view instanceof AnBaseShape;
          } else {
            tmp_0 = false;
          }
          if (tmp_0)
            view.eod_1 = $this.mog_1.koi_1;
        }
      } else {
        var _destruct__k2r9zo_0 = timeline.roh($this.yog_1.coh_1, $this.nog_1);
        var index_0 = _destruct__k2r9zo_0.km();
        var left_0 = _destruct__k2r9zo_0.lm();
        if (!(left_0 == null)) {
          $this.rog_1[left_0.woh_1] = left_0.yoh_1;
        }
        var view_0 = !(left_0 == null) && left_0.xoh_1 >= 0 ? $this.tog_1[left_0.xoh_1] : $this.qog_1[depth];
        var placed_0 = replaceDepth($this, depth, view_0);
        if (placed_0 || hasMultipleFrames) {
          if (left_0 == null)
            null;
          else {
            left_0.foi(view_0);
          }
          var tmp_1;
          if (!($this.mog_1.koi_1 == null)) {
            tmp_1 = view_0 instanceof AnBaseShape;
          } else {
            tmp_1 = false;
          }
          if (tmp_1)
            view_0.eod_1 = $this.mog_1.koi_1;
        }
      }
    }
     while (inductionVariable < last);
}
function updateInternal($this, dt) {
  if ($this.yog_1.ioh_1 && ($this.uog_1 || !$this.wog_1)) {
    $this.uog_1 = false;
    $this.yog_1.lh9(dt);
    update($this);
  }
}
function AnMovieClip$lambda($this$addUpdater, it) {
  updateInternal($this$addUpdater, it.hk_1);
  return Unit_instance;
}
function updatedRatio($this) {
  if (!($this.qom_1.jon_1 == null)) {
    $this.wom_1 = ensureNotNull($this.qom_1.jon_1)(Ratio__toDouble_impl_o7epze($this.con_1));
    return Unit_instance;
  }
  var tmp = $this.qom_1.ion_1;
  // Inline function 'korlibs.time.seconds' call
  var this_0 = Ratio__toDouble_impl_o7epze($this.con_1);
  var tmp$ret$0 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
  var result = tmp.noi(tmp$ret$0, $this.rom_1);
  var tmp_0 = $this;
  var tmp0_elvis_lhs = result.toh_1;
  tmp_0.som_1 = tmp0_elvis_lhs == null ? result.uoh_1 : tmp0_elvis_lhs;
  var tmp_1 = $this;
  var tmp68_safe_receiver = $this.som_1;
  var tmp69_safe_receiver = tmp68_safe_receiver == null ? null : tmp68_safe_receiver.rak_1;
  var tmp70_safe_receiver = tmp69_safe_receiver == null ? null : tmp69_safe_receiver.i2i_1;
  var tmp1_elvis_lhs = tmp70_safe_receiver == null ? null : tmp70_safe_receiver;
  tmp_1.tom_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp_2 = $this;
  var tmp71_safe_receiver = $this.som_1;
  var tmp72_safe_receiver = tmp71_safe_receiver == null ? null : tmp71_safe_receiver.rak_1;
  var tmp73_safe_receiver = tmp72_safe_receiver == null ? null : tmp72_safe_receiver.j2i_1;
  var tmp2_elvis_lhs = tmp73_safe_receiver == null ? null : tmp73_safe_receiver;
  tmp_2.uom_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  var tmp_3 = $this;
  var tmp74_safe_receiver = $this.som_1;
  var tmp3_elvis_lhs = tmp74_safe_receiver == null ? null : tmp74_safe_receiver.oak_1;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    tmp_4 = get_Bitmaps_transparent();
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  tmp_3.vom_1 = tmp_4;
  var tmp_5 = $this;
  var tmp75_safe_receiver = $this.som_1;
  var tmp4_elvis_lhs = tmp75_safe_receiver == null ? null : tmp75_safe_receiver.qak_1;
  tmp_5.yom_1 = tmp4_elvis_lhs == null ? 1.0 : tmp4_elvis_lhs;
  $this.zom_1 = $this.vom_1.o41_1 / $this.yom_1;
  $this.aon_1 = $this.vom_1.p41_1 / $this.yom_1;
  $this.bon_1 = true;
}
function ensureShape($this) {
  if (!($this.aoe() == null)) {
    if ($this.fod_1 == null) {
      var tmp = $this;
      // Inline function 'korlibs.korge.view.graphics' call
      var tmp0_elvis_lhs = $this.cod_1.foj_1;
      var renderer = tmp0_elvis_lhs == null ? $this.boe() : tmp0_elvis_lhs;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = Graphics.zh3(EmptyShape_instance, renderer);
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
      tmp.fod_1 = addTo(this_0, $this);
    }
    if (!($this.iod_1 === $this.aoe())) {
      $this.iod_1 = $this.aoe();
      var tmp63_safe_receiver = $this.fod_1;
      if (tmp63_safe_receiver == null)
        null;
      else {
        tmp63_safe_receiver.xh3(ensureNotNull($this.aoe()));
      }
    }
  }
  return $this.aoe();
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.xou_1.zou().koj_1.i1($this.you_1.aov_1);
  var tmp78_safe_receiver = tmp instanceof AnSymbolSound ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp78_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp78_safe_receiver.hov($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp79_safe_receiver = tmp_0;
  if (tmp79_safe_receiver == null)
    null;
  else {
    var tmp_2 = tmp79_safe_receiver.w7z(VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function eval_0($this, prev, current) {
  if (Duration__compareTo_impl_pchp0f(prev, current) >= 0)
    return Unit_instance;
  var tmp76_safe_receiver = $this.eoh_1;
  var tmp0_elvis_lhs = tmp76_safe_receiver == null ? null : tmp76_safe_receiver.moh_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var actionsTimeline = tmp;
  // Inline function 'korlibs.time.microseconds' call
  // Inline function 'korlibs.time.microseconds' call
  var tmp$ret$1 = toDuration(1, DurationUnit_MICROSECONDS_getInstance());
  var result = actionsTimeline.iov(prev, Duration__minus_impl_q5cfm7(current, tmp$ret$1), $this.joh_1);
  var inductionVariable = result.jov_1;
  var last = result.kov_1;
  if (inductionVariable <= last)
    execution: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var action = actionsTimeline.qoh_1.i1(n);
      if (action instanceof AnPlaySoundAction) {
        var tmp_0 = $this.zou().boj_1.mov_1;
        launchImmediately(tmp_0, TimelineRunner$eval$slambda_0($this, action));
      } else {
        if (action instanceof AnEventAction) {
          $this.hoh_1.x1x(action.lov_1);
        }
      }
    }
     while (!(n === last));
}
function TimelineRunner$eval$slambda_0(this$0, $action) {
  var i = new TimelineRunner$eval$slambda(this$0, $action);
  var l = function ($completion) {
    return i.pe($completion);
  };
  l.$arity = 0;
  return l;
}
function drawNinePatch(_this__u8e3s4, tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, blendMode, program) {
  m = m === VOID ? new MMatrix() : m;
  filtering = filtering === VOID ? true : filtering;
  colorMul = colorMul === VOID ? Colors_getInstance().g4r_1 : colorMul;
  blendMode = blendMode === VOID ? Companion_getInstance_14().ra5_1 : blendMode;
  program = program === VOID ? null : program;
  _init_properties_Animate_kt__k9vufl();
  _this__u8e3s4.faf(tex.o33(), filtering, blendMode, program, 54, 16);
  var texIndex = 0;
  var ptt1 = Companion_getInstance_3().l2m();
  var ptt2 = Companion_getInstance_3().l2m();
  var pt1 = Companion_getInstance_3().l2m();
  var pt2 = Companion_getInstance_3().l2m();
  var pt3 = Companion_getInstance_3().l2m();
  var pt4 = Companion_getInstance_3().l2m();
  var pt5 = Companion_getInstance_3().l2m();
  var pt6 = Companion_getInstance_3().l2m();
  var pt7 = Companion_getInstance_3().l2m();
  var pt8 = Companion_getInstance_3().l2m();
  var p_o = pt1.y4c(m, ptt1.x4c(x, y));
  var p_dU = pt2.h4d(ptt1.y4c(m, ptt1.x4c(x + width, y)), p_o);
  var p_dV = pt3.h4d(ptt1.y4c(m, ptt1.x4c(x, y + height)), p_o);
  var t_o = pt4.x4c(tex.b43(), tex.c43());
  var t_dU = pt5.h4d(ptt1.x4c(tex.d43(), tex.e43()), t_o);
  var t_dV = pt6.h4d(ptt1.x4c(tex.h43(), tex.i43()), t_o);
  var start = _this__u8e3s4.kae();
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var cy = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var posCutY = posCuts[cy].j2h_1;
      var texCutY = texCuts[cy].j2h_1;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < 4)
        do {
          var cx = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var posCutX = posCuts[cx].i2h_1;
          var texCutX = texCuts[cx].i2h_1;
          var p = pt7.g4d(p_o, ptt1.g4d(ptt1.i4d(p_dU, posCutX), ptt2.i4d(p_dV, posCutY)));
          var t = pt8.g4d(t_o, ptt1.g4d(ptt1.i4d(t_dU, texCutX), ptt2.i4d(t_dV, texCutY)));
          _this__u8e3s4.nae(p.p4c_1, p.q4c_1, t.p4c_1, t.q4c_1, colorMul, texIndex);
        }
         while (inductionVariable_0 < 4);
    }
     while (inductionVariable < 4);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < 3)
    do {
      var cy_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var inductionVariable_2 = 0;
      if (inductionVariable_2 < 3)
        do {
          var cx_0 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var v0 = (start + imul(cy_0, 4) | 0) + cx_0 | 0;
          var v1 = v0 + 1 | 0;
          var v2 = v0 + 4 | 0;
          var v3 = v0 + 5 | 0;
          // Inline function 'korlibs.korge.render.BatchBuilder2D.addIndex' call
          var _unary__edvuaz = _this__u8e3s4.ha8_1;
          _this__u8e3s4.ha8_1 = _unary__edvuaz + 1 | 0;
          Uint16Buffer__set_impl_g0kliu(_this__u8e3s4.ea8_1, _unary__edvuaz, v0);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.addIndex' call
          var _unary__edvuaz_0 = _this__u8e3s4.ha8_1;
          _this__u8e3s4.ha8_1 = _unary__edvuaz_0 + 1 | 0;
          Uint16Buffer__set_impl_g0kliu(_this__u8e3s4.ea8_1, _unary__edvuaz_0, v1);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.addIndex' call
          var _unary__edvuaz_1 = _this__u8e3s4.ha8_1;
          _this__u8e3s4.ha8_1 = _unary__edvuaz_1 + 1 | 0;
          Uint16Buffer__set_impl_g0kliu(_this__u8e3s4.ea8_1, _unary__edvuaz_1, v2);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.addIndex' call
          var _unary__edvuaz_2 = _this__u8e3s4.ha8_1;
          _this__u8e3s4.ha8_1 = _unary__edvuaz_2 + 1 | 0;
          Uint16Buffer__set_impl_g0kliu(_this__u8e3s4.ea8_1, _unary__edvuaz_2, v2);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.addIndex' call
          var _unary__edvuaz_3 = _this__u8e3s4.ha8_1;
          _this__u8e3s4.ha8_1 = _unary__edvuaz_3 + 1 | 0;
          Uint16Buffer__set_impl_g0kliu(_this__u8e3s4.ea8_1, _unary__edvuaz_3, v1);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.addIndex' call
          var _unary__edvuaz_4 = _this__u8e3s4.ha8_1;
          _this__u8e3s4.ha8_1 = _unary__edvuaz_4 + 1 | 0;
          Uint16Buffer__set_impl_g0kliu(_this__u8e3s4.ea8_1, _unary__edvuaz_4, v3);
        }
         while (inductionVariable_2 < 3);
    }
     while (inductionVariable_1 < 3);
}
function stencilIndex$delegate$lambda() {
  _init_properties_Animate_kt__k9vufl();
  return 0;
}
function stencilIndex$factory() {
  return getPropertyCallableRef('stencilIndex', 1, KMutableProperty1, function (receiver) {
    return get_stencilIndex(receiver);
  }, function (receiver, value) {
    return set_stencilIndex(receiver, value);
  });
}
function stencilIndex$factory_0() {
  return getPropertyCallableRef('stencilIndex', 1, KMutableProperty1, function (receiver) {
    return get_stencilIndex(receiver);
  }, function (receiver, value) {
    return set_stencilIndex(receiver, value);
  });
}
function format$factory($b0) {
  return getPropertyCallableRef('format', 0, KMutableProperty0, function () {
    return $b0.sov();
  }, function (value) {
    return $b0.tov(value);
  });
}
function text$factory($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.o2f();
  }, function (value) {
    return $b0.bcg(value);
  });
}
function html$factory($b0) {
  return getPropertyCallableRef('html', 0, KMutableProperty0, function () {
    return $b0.uov();
  }, function (value) {
    return $b0.wou(value);
  });
}
var properties_initialized_Animate_kt_any8dt;
function _init_properties_Animate_kt__k9vufl() {
  if (!properties_initialized_Animate_kt_any8dt) {
    properties_initialized_Animate_kt_any8dt = true;
    stencilIndex$delegate = new Property(VOID, stencilIndex$delegate$lambda);
  }
}
var Companion_instance_34;
function Companion_getInstance_51() {
  return Companion_instance_34;
}
var Companion_instance_35;
function Companion_getInstance_52() {
  return Companion_instance_35;
}
var AnSymbolEmpty_instance;
function AnSymbolEmpty_getInstance() {
  if (AnSymbolEmpty_instance === VOID)
    new AnSymbolEmpty();
  return AnSymbolEmpty_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  if ($this.bow_1.eov_1 == null) {
    var tmp = $this.bow_1;
    var tmp_0;
    try {
      var tmp_1 = get_nativeSoundProvider();
      var tmp0_elvis_lhs = $this.bow_1.fov_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.byteArrayOf' call
        tmp_2 = new Int8Array([]);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var tmp_3 = tmp_1.z7y(tmp_2, VOID, VOID, VOID, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_0 = tmp_3;
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var e = $p;
        if (e instanceof CancellationException)
          throw e;
        var tmp_5 = get_nativeSoundProvider().d7z(Companion_getInstance_19().s7v(), VOID, VOID, VOID, $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_4 = tmp_5;
      } else {
        throw $p;
      }
      tmp_0 = tmp_4;
    }
    tmp.eov_1 = tmp_0;
  }
  return ensureNotNull($this.bow_1.eov_1);
}
function AnSymbolSound$getNativeSound$slambda_0(this$0) {
  var i = new AnSymbolSound$getNativeSound$slambda(this$0);
  var l = function ($completion) {
    return i.pe($completion);
  };
  l.$arity = 0;
  return l;
}
function swap($this, a, b) {
  var tempTime = $this.poh_1.i1(b);
  var tempObject = $this.qoh_1.i1(b);
  $this.poh_1.t31(b, $this.poh_1.i1(a));
  $this.qoh_1.p3(b, $this.qoh_1.i1(a));
  $this.poh_1.t31(a, tempTime);
  $this.qoh_1.p3(a, tempObject);
}
function set_colorTransform(_this__u8e3s4, value) {
  _this__u8e3s4.m59(value.x58());
}
function get_colorTransform(_this__u8e3s4) {
  // Inline function 'korlibs.image.color.ColorTransform' call
  var multiply = _this__u8e3s4.x58();
  // Inline function 'korlibs.image.color.Companion.NEUTRAL' call
  var add = get_ColorAdd_NEUTRAL();
  return new ColorTransform(_RGBA___get_rf__impl__kvz75k(multiply), _RGBA___get_gf__impl__5gcu1f(multiply), _RGBA___get_bf__impl__1xz5yg(multiply), _RGBA___get_af__impl__vu36qv(multiply), _ColorAdd___get_r__impl__j9xkne(add), _ColorAdd___get_g__impl__itrhk1(add), _ColorAdd___get_b__impl__grv87a(add), _ColorAdd___get_a__impl__c1r8ux(add));
}
function get__props(_this__u8e3s4) {
  _init_properties_ViewPropsExt_kt__ctded2();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = _props$delegate;
    var property = _props$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _props$delegate;
function addProps(_this__u8e3s4, values) {
  _init_properties_ViewPropsExt_kt__ctded2();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = values.z1().f1();
  while (_iterator__ex2g4s.g1()) {
    var pair = _iterator__ex2g4s.h1();
    addProp(_this__u8e3s4, pair.a2(), pair.b2());
  }
}
function addProp(_this__u8e3s4, key, value) {
  _init_properties_ViewPropsExt_kt__ctded2();
  // Inline function 'kotlin.collections.set' call
  get__props(_this__u8e3s4).r3(key, value);
}
function _props$delegate$lambda($this$PropertyThis) {
  _init_properties_ViewPropsExt_kt__ctded2();
  // Inline function 'kotlin.collections.linkedMapOf' call
  return LinkedHashMap.vc();
}
function _props$factory() {
  return getPropertyCallableRef('_props', 1, KProperty1, function (receiver) {
    return get__props(receiver);
  }, null);
}
var properties_initialized_ViewPropsExt_kt_s1u2fs;
function _init_properties_ViewPropsExt_kt__ctded2() {
  if (!properties_initialized_ViewPropsExt_kt_s1u2fs) {
    properties_initialized_ViewPropsExt_kt_s1u2fs = true;
    _props$delegate = new PropertyThis(VOID, _props$delegate$lambda);
  }
}
var MaskStates_instance;
function MaskStates_getInstance() {
  if (MaskStates_instance === VOID)
    new MaskStates();
  return MaskStates_instance;
}
function toAtlas(_this__u8e3s4, context, maxTextureSide, mipmaps, atlasPacking, $completion) {
  if (atlasPacking) {
    var tmp = AtlasPacker_instance;
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList_0(_this__u8e3s4.z1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.ext.swf.toAtlas.<anonymous>' call
      var tmp$ret$0 = to(item, slice(item.b2().now_1));
      destination.f(tmp$ret$0);
    }
    var atlas = tmp.v4p(destination, maxTextureSide);
    var out = LinkedHashMap.vc();
    var _iterator__ex2g4s = atlas.k4o_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var at = _iterator__ex2g4s.h1();
      var texture = slice(at.g4o_1);
      var _iterator__ex2g4s_0 = at.i4o_1.f1();
      while (_iterator__ex2g4s_0.g1()) {
        var item_0 = _iterator__ex2g4s_0.h1();
        var ibmp = item_0.b4o_1.b2();
        var rect2 = item_0.f4o_1;
        // Inline function 'kotlin.collections.set' call
        var key = item_0.b4o_1.a2();
        var value = new TextureWithBitmapSlice(texture.x42(rect2.q2()), item_0.d4o_1, ibmp.oow_1, ibmp.pow_1.j2t());
        out.r3(key, value);
      }
    }
    return out;
  } else {
    // Inline function 'kotlin.collections.associate' call
    var this_1 = _this__u8e3s4.z1();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.wc(capacity);
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element = tmp0_iterator_0.h1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.korge.ext.swf.toAtlas.<anonymous>' call
      var pair = to(element.a2(), new TextureWithBitmapSlice(slice(element.b2().now_1), slice(element.b2().now_1), element.b2().oow_1, element.b2().pow_1.j2t()));
      destination_0.r3(pair.im_1, pair.jm_1);
    }
    return destination_0;
  }
}
function encodeSWFColor(color) {
  return insert8(insert8(insert8(0, _RGBA___get_r__impl__duz7mo(color), 16), _RGBA___get_g__impl__o8pukr(color), 8), _RGBA___get_b__impl__m6tl80(color), 0);
}
function export_0(_this__u8e3s4, bitmaps) {
  var exporter = new SWFBaseShapeExporter(bitmaps);
  _this__u8e3s4.wn7(exporter);
  return exporter.vow_1;
}
function export_1(_this__u8e3s4, bitmaps, ratio) {
  var exporter = new SWFBaseShapeExporter(bitmaps);
  _this__u8e3s4.rnf(exporter, ratio);
  return exporter.vow_1;
}
function SWFShapeExporter$actualShape$delegate$lambda(this$0) {
  return function () {
    this$0.zox_1(this$0.xox_1 ? new LoggerShapeExporter(this$0) : this$0);
    return this$0.vow_1;
  };
}
function SWFShapeExporter$image$delegate$lambda(this$0) {
  return function () {
    return BitmapVector.c75(this$0.toy(), this$0.yox_1.j2t(), this$0.noy_1, this$0.aoy_1, this$0.boy_1, this$0.ooy_1, this$0.poy_1, true, !this$0.goy_1.equals(GraphicsRenderer_CPU_getInstance()));
  };
}
function SWFShapeExporter$imageWithScale$delegate$lambda(this$0) {
  return function () {
    return new BitmapWithScale(this$0.uoy(), this$0.noy_1, this$0.yox_1);
  };
}
function decodeSWFColor(color, alpha) {
  alpha = alpha === VOID ? 1.0 : alpha;
  var tmp = Companion_getInstance_4();
  // Inline function 'korlibs.memory.extract8' call
  var tmp_0 = (color >>> 16 | 0) & 255;
  // Inline function 'korlibs.memory.extract8' call
  var tmp_1 = (color >>> 8 | 0) & 255;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$2 = (color >>> 0 | 0) & 255;
  return tmp.a57(tmp_0, tmp_1, tmp$ret$2, clamp(numberToInt(alpha * 255), 0, 255));
}
function toColorTransform(_this__u8e3s4) {
  // Inline function 'korlibs.image.color.ColorTransform' call
  var mR = _this__u8e3s4.jn7();
  var mG = _this__u8e3s4.kn7();
  var mB = _this__u8e3s4.ln7();
  var mA = _this__u8e3s4.mn7();
  var aR = _this__u8e3s4.nn7();
  var aG = _this__u8e3s4.on7();
  var aB = _this__u8e3s4.pn7();
  var aA = _this__u8e3s4.qn7();
  return new ColorTransform(numberToDouble(mR), numberToDouble(mG), numberToDouble(mB), numberToDouble(mA), numberToInt(aR), numberToInt(aG), numberToInt(aB), numberToInt(aA));
}
function createGradientPaint($this, type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
  // Inline function 'korlibs.datastructure.mapDouble' call
  // Inline function 'kotlin.also' call
  var this_0 = DoubleArrayList.c32();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
  var _iterator__ex2g4s = ratios.f1();
  while (_iterator__ex2g4s.g1()) {
    var v = _iterator__ex2g4s.h1();
    // Inline function 'korlibs.korge.ext.swf.SWFBaseShapeExporter.createGradientPaint.<anonymous>' call
    var tmp$ret$0 = v / 255.0;
    this_0.t2d(tmp$ret$0);
  }
  var aratios = this_0;
  var acolors = IntArrayList.f31(colors.j1());
  var inductionVariable = 0;
  var last = colors.j1() - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      acolors.l31(_RGBA___get_value__impl__hhco8v(decodeSWFColor(colors.i1(n), alphas.i1(n))));
    }
     while (inductionVariable <= last);
  var m2 = new MMatrix();
  m2.r4d(matrix);
  m2.t4d(-0.5, -0.5);
  m2.s4d(1638.4 / 2.0, 1638.4 / 2.0);
  var tmp;
  switch (interpolationMethod.v3_1) {
    case 0:
      tmp = GradientInterpolationMethod_NORMAL_getInstance();
      break;
    case 1:
      tmp = GradientInterpolationMethod_LINEAR_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var imethod = tmp;
  var tmp_0;
  switch (type.v3_1) {
    case 0:
      tmp_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), -1.0, 0.0, 0.0, +1.0, 0.0, 0.0, aratios, acolors, $this.woy(spreadMethod), m2.j2t(), imethod);
      break;
    case 1:
      tmp_0 = new GradientPaint(GradientKind_RADIAL_getInstance(), focalPointRatio, 0.0, 0.0, 0.0, 0.0, 1.0, aratios, acolors, $this.woy(spreadMethod), m2.j2t(), imethod);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
}
function __flushFill($this) {
  if ($this.yow_1.a1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var this_0 = $this.wow_1;
  var element = new FillShape($this.yow_1, null, $this.zow_1, Companion_getInstance_9().i2m_1);
  this_0.f(element);
  $this.yow_1 = new VectorPath();
}
function __flushStroke($this) {
  if ($this.yow_1.a1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var this_0 = $this.wow_1;
  var element = new PolylineShape($this.yow_1, null, $this.gox_1, Companion_getInstance_9().i2m_1, new StrokeInfo($this.aox_1, true, $this.box_1, $this.dox_1, $this.dox_1, LineJoin_MITER_getInstance(), $this.cox_1, $this.eox_1, $this.fox_1));
  this_0.f(element);
  $this.yow_1 = new VectorPath();
}
function flush($this) {
  if ($this.xow_1) {
    __flushFill($this);
  } else {
    __flushStroke($this);
  }
}
function _get_nice__dax18u(_this__u8e3s4, $this) {
  return $this.uow_1 < 0 ? _this__u8e3s4 : roundDecimalPlaces(_this__u8e3s4, $this.uow_1);
}
function actualShape$factory() {
  return getPropertyCallableRef('actualShape', 1, KProperty1, function (receiver) {
    return receiver.toy();
  }, null);
}
function image$factory() {
  return getPropertyCallableRef('image', 1, KProperty1, function (receiver) {
    return receiver.uoy();
  }, null);
}
function imageWithScale$factory() {
  return getPropertyCallableRef('imageWithScale', 1, KProperty1, function (receiver) {
    return receiver.voy();
  }, null);
}
var swfExportConfig$delegate;
var ShapeRasterizerMethodValues;
var GraphicsRendererValues;
function get_bitmaps(_this__u8e3s4) {
  _init_properties_Swf_kt__178u9c();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = bitmaps$delegate;
    var property = bitmaps$factory();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var bitmaps$delegate;
function get_swfTimeline(_this__u8e3s4) {
  _init_properties_Swf_kt__178u9c();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = swfTimeline$delegate;
    var property = swfTimeline$factory();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var swfTimeline$delegate;
function get_labelsToFrame0(_this__u8e3s4) {
  _init_properties_Swf_kt__178u9c();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = labelsToFrame0$delegate;
    var property = labelsToFrame0$factory();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var labelsToFrame0$delegate;
function set_tagDefineMorphShape(_this__u8e3s4, _set____db54di) {
  _init_properties_Swf_kt__178u9c();
  var this_0 = tagDefineMorphShape$delegate;
  var property = tagDefineMorphShape$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_tagDefineMorphShape(_this__u8e3s4) {
  _init_properties_Swf_kt__178u9c();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = tagDefineMorphShape$delegate;
    var property = tagDefineMorphShape$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var tagDefineMorphShape$delegate;
function set_tagDefineShape(_this__u8e3s4, _set____db54di) {
  _init_properties_Swf_kt__178u9c();
  var this_0 = tagDefineShape$delegate;
  var property = tagDefineShape$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_tagDefineShape(_this__u8e3s4) {
  _init_properties_Swf_kt__178u9c();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = tagDefineShape$delegate;
    var property = tagDefineShape$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var tagDefineShape$delegate;
var Stop_instance;
function Stop_getInstance() {
  return Stop_instance;
}
var Play_instance;
function Play_getInstance() {
  return Play_instance;
}
function readSWF(_this__u8e3s4, views, defaultConfig, atlasPacking, $completion) {
  defaultConfig = defaultConfig === VOID ? new SWFExportConfig() : defaultConfig;
  atlasPacking = atlasPacking === VOID ? null : atlasPacking;
  var tmp = Companion_instance_34.vov(views);
  return readSWF_0(_this__u8e3s4, tmp, defaultConfig.poz(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, atlasPacking == null ? defaultConfig.koz_1 : atlasPacking), VOID, $completion);
}
function *_generator_readSWF__9pepwo(_this__u8e3s4, context, config, content, $completion) {
  content = content === VOID ? null : content;
  var tmp = new SwfLoaderMethod(context, config);
  var tmp_0;
  if (content == null) {
    var tmp_1 = _this__u8e3s4.v22($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    tmp_0 = content;
  }
  var tmp_2 = tmp.up0(tmp_0, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function readSWF_0(_this__u8e3s4, context, config, content, $completion) {
  content = content === VOID ? null : content;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readSWF__9pepwo(_this__u8e3s4, context, config, content, $completion), $completion);
}
function swfExportConfig$delegate$lambda() {
  _init_properties_Swf_kt__178u9c();
  return new SWFExportConfig();
}
function bitmaps$delegate$lambda() {
  _init_properties_Swf_kt__178u9c();
  // Inline function 'kotlin.collections.hashMapOf' call
  return HashMap.c9();
}
function swfTimeline$delegate$lambda() {
  _init_properties_Swf_kt__178u9c();
  return new MySwfTimeline();
}
function labelsToFrame0$delegate$lambda() {
  _init_properties_Swf_kt__178u9c();
  // Inline function 'kotlin.collections.hashMapOf' call
  return HashMap.c9();
}
function tagDefineMorphShape$delegate$lambda() {
  _init_properties_Swf_kt__178u9c();
  return null;
}
function tagDefineShape$delegate$lambda() {
  _init_properties_Swf_kt__178u9c();
  return null;
}
function bitmaps$factory() {
  return getPropertyCallableRef('bitmaps', 1, KProperty1, function (receiver) {
    return get_bitmaps(receiver);
  }, null);
}
function swfTimeline$factory() {
  return getPropertyCallableRef('swfTimeline', 1, KProperty1, function (receiver) {
    return get_swfTimeline(receiver);
  }, null);
}
function labelsToFrame0$factory() {
  return getPropertyCallableRef('labelsToFrame0', 1, KProperty1, function (receiver) {
    return get_labelsToFrame0(receiver);
  }, null);
}
function tagDefineMorphShape$factory() {
  return getPropertyCallableRef('tagDefineMorphShape', 1, KMutableProperty1, function (receiver) {
    return get_tagDefineMorphShape(receiver);
  }, function (receiver, value) {
    return set_tagDefineMorphShape(receiver, value);
  });
}
function tagDefineMorphShape$factory_0() {
  return getPropertyCallableRef('tagDefineMorphShape', 1, KMutableProperty1, function (receiver) {
    return get_tagDefineMorphShape(receiver);
  }, function (receiver, value) {
    return set_tagDefineMorphShape(receiver, value);
  });
}
function tagDefineShape$factory() {
  return getPropertyCallableRef('tagDefineShape', 1, KMutableProperty1, function (receiver) {
    return get_tagDefineShape(receiver);
  }, function (receiver, value) {
    return set_tagDefineShape(receiver, value);
  });
}
function tagDefineShape$factory_0() {
  return getPropertyCallableRef('tagDefineShape', 1, KMutableProperty1, function (receiver) {
    return get_tagDefineShape(receiver);
  }, function (receiver, value) {
    return set_tagDefineShape(receiver, value);
  });
}
var properties_initialized_Swf_kt_sx2s0e;
function _init_properties_Swf_kt__178u9c() {
  if (!properties_initialized_Swf_kt_sx2s0e) {
    properties_initialized_Swf_kt_sx2s0e = true;
    swfExportConfig$delegate = new Property(VOID, swfExportConfig$delegate$lambda);
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.ext.swf.ShapeRasterizerMethodValues.<anonymous>' call
      var tmp$ret$0 = element.u3_1;
      destination.r3(tmp$ret$0, element);
    }
    ShapeRasterizerMethodValues = destination;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = values_0();
    var capacity_0 = coerceAtLeast(mapCapacity(this_1.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.wc(capacity_0);
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'korlibs.korge.ext.swf.GraphicsRendererValues.<anonymous>' call
      var tmp$ret$0_0 = element_0.u3_1;
      destination_0.r3(tmp$ret$0_0, element_0);
    }
    GraphicsRendererValues = destination_0;
    bitmaps$delegate = new Property(VOID, bitmaps$delegate$lambda);
    swfTimeline$delegate = new Property(VOID, swfTimeline$delegate$lambda);
    labelsToFrame0$delegate = new Property(VOID, labelsToFrame0$delegate$lambda);
    tagDefineMorphShape$delegate = new Property(VOID, tagDefineMorphShape$delegate$lambda);
    tagDefineShape$delegate = new Property(VOID, tagDefineShape$delegate$lambda);
  }
}
function *_generator_load__qllgda($this, data, $completion) {
  var tmp = $this;
  var tmp_0 = (new SWF()).omn(data, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.hp0_1 = tmp_0;
  var bounds = $this.vp0().hmm_1.o42();
  $this.ip0_1 = new AnLibrary($this.fp0_1, numberToInt(bounds.j4e_1), numberToInt(bounds.k4e_1), $this.vp0().imm_1);
  var tmp_1 = $this.xp0($this.vp0().qmm_1, new AnSymbolMovieClip(0, 'MainTimeLine', $this.wp0($this.vp0().qmm_1)), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var _iterator__ex2g4s = $this.qp0_1.f1();
  while (_iterator__ex2g4s.g1()) {
    var symbol = _iterator__ex2g4s.h1();
    $this.yp0().wov(symbol);
  }
  try {
    processAs3Actions($this);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  var tmp_2 = generateActualTimelines($this, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.yp0().xov();
  if ($this.gp0_1.moz_1) {
    var tmp_3 = generateTextures($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    generateShapes($this);
  }
  finalProcessing($this);
  return $this.yp0();
}
function finalProcessing($this) {
}
function generateActualTimelines($this, $completion) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_0 = $this.yp0().koj_1;
  var destination = ArrayList.m1();
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    if (element instanceof AnSymbolMovieClip) {
      destination.f(element);
    }
  }
  var _iterator__ex2g4s = destination.f1();
  while (_iterator__ex2g4s.g1()) {
    var symbol = _iterator__ex2g4s.h1();
    var swfTimeline = get_swfTimeline(symbol);
    var justAfterStopOrStart = true;
    var stateStartFrame = 0;
    var frameInfos = ArrayList.w(swfTimeline.qoz_1.j1());
    // Inline function 'kotlin.collections.hashSetOf' call
    var referencedFrames = HashSet.xa();
    var _iterator__ex2g4s_0 = swfTimeline.qoz_1.f1();
    while (_iterator__ex2g4s_0.g1()) {
      var frame = _iterator__ex2g4s_0.h1();
      if (frame.zoz()) {
        // Inline function 'kotlin.collections.filterIsInstance' call
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var this_1 = frame.woz_1;
        var destination_0 = ArrayList.m1();
        var tmp0_iterator_0 = this_1.f1();
        while (tmp0_iterator_0.g1()) {
          var element_0 = tmp0_iterator_0.h1();
          if (element_0 instanceof Goto) {
            destination_0.f(element_0);
          }
        }
        var goto = first(destination_0);
        // Inline function 'kotlin.collections.plusAssign' call
        var element_1 = goto.roz_1;
        referencedFrames.f(element_1);
      }
    }
    var flow = true;
    var stateName = 'default';
    var frameIndex = 0;
    var subtimelineIndex = -1;
    // Inline function 'kotlin.collections.arrayListOf' call
    var subtimelines = ArrayList.m1();
    var _iterator__ex2g4s_1 = swfTimeline.qoz_1.f1();
    while (_iterator__ex2g4s_1.g1()) {
      var frame_0 = _iterator__ex2g4s_1.h1();
      var startNamedState = false;
      var startSubtimeline = false;
      if (flow) {
        stateName = frame_0.xoz() ? 'default' : !(frame_0.uoz_1 == null) ? ensureNotNull(frame_0.uoz_1) : 'frame' + frame_0.toz_1;
        frameIndex = 0;
        subtimelineIndex = subtimelineIndex + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_2 = new SwfLoaderMethod$generateActualTimelines$Subtimeline($this, subtimelineIndex);
        subtimelines.f(element_2);
        startNamedState = true;
        startSubtimeline = true;
      }
      if (!(frame_0.uoz_1 == null)) {
        stateName = ensureNotNull(frame_0.uoz_1);
        startNamedState = true;
      } else if (referencedFrames.f3(frame_0.toz_1)) {
        stateName = 'frame' + frame_0.toz_1;
        startNamedState = true;
      }
      var subtimeline = subtimelines.i1(subtimelineIndex);
      subtimeline.ap1_1 = subtimeline.ap1_1 + 1 | 0;
      flow = frame_0.ap0();
      // Inline function 'kotlin.collections.plusAssign' call
      var element_3 = new SwfLoaderMethod$generateActualTimelines$FrameInfo($this, subtimeline, frameIndex, stateName, startSubtimeline, startNamedState);
      frameInfos.f(element_3);
      frameIndex = frameIndex + 1 | 0;
    }
    var _iterator__ex2g4s_2 = swfTimeline.qoz_1.f1();
    while (_iterator__ex2g4s_2.g1()) {
      var frame_1 = _iterator__ex2g4s_2.h1();
      var info = frameInfos.i1(frame_1.toz_1);
      var isLast = frame_1.toz_1 === last(swfTimeline.qoz_1).toz_1;
      if (frame_1.ap0()) {
        var _iterator__ex2g4s_3 = frame_1.woz_1.f1();
        while (_iterator__ex2g4s_3.g1()) {
          var action = _iterator__ex2g4s_3.h1();
          if (action instanceof Goto) {
            if (action.roz_1 >= frameInfos.j1()) {
              println('ERROR: action.frame0 >= frameInfos.size :: ' + action.roz_1 + ' >= ' + frameInfos.j1());
            }
            var tmp = info.ep1_1;
            var tmp113_safe_receiver = getOrNull(frameInfos, action.roz_1);
            tmp.bp1_1 = tmp113_safe_receiver == null ? null : tmp113_safe_receiver.gp1_1;
          } else {
            if (action instanceof Stop) {
              info.ep1_1.cp1_1 = false;
            } else {
              if (action instanceof Play) {
                info.ep1_1.cp1_1 = true;
              }
            }
          }
        }
      } else {
        if (isLast) {
          info.ep1_1.bp1_1 = 'default';
          info.ep1_1.cp1_1 = true;
        }
      }
    }
    var totalDepths = symbol.joi_1.roi_1;
    var currentSubTimeline = new AnSymbolMovieClipSubTimeline(totalDepths);
    // Inline function 'kotlin.arrayOfNulls' call
    var lastDepths = fillArrayVal(Array(totalDepths), null);
    var _iterator__ex2g4s_4 = swfTimeline.qoz_1.f1();
    while (_iterator__ex2g4s_4.g1()) {
      var frame_2 = _iterator__ex2g4s_4.h1();
      var info_0 = frameInfos.i1(frame_2.toz_1);
      var currentTime = info_0.jp1_1;
      if (info_0.hp1_1) {
        currentSubTimeline = new AnSymbolMovieClipSubTimeline(totalDepths);
        fill_0(lastDepths, null);
        var subtimeline_0 = info_0.ep1_1;
        currentSubTimeline.koh_1 = subtimeline_0.lp1();
        currentSubTimeline.noh_1 = subtimeline_0.bp1_1;
        currentSubTimeline.ooh_1 = subtimeline_0.cp1_1;
        if (frame_2.xoz()) {
          // Inline function 'kotlin.collections.set' call
          var this_2 = symbol.loi_1;
          var tmp_0 = currentSubTimeline;
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$8 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
          var value = new AnSymbolMovieClipState('default', tmp_0, tmp$ret$8);
          this_2.r3('default', value);
          // Inline function 'kotlin.collections.set' call
          var this_3 = symbol.loi_1;
          var tmp_1 = currentSubTimeline;
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$10 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
          var value_0 = new AnSymbolMovieClipState('frame0', tmp_1, tmp$ret$10);
          this_3.r3('frame0', value_0);
        }
      }
      if (info_0.ip1_1) {
        currentSubTimeline.moh_1.kow(info_0.jp1_1, new AnEventAction(info_0.gp1_1));
        // Inline function 'kotlin.collections.set' call
        var this_4 = symbol.loi_1;
        var key = info_0.gp1_1;
        var value_1 = new AnSymbolMovieClipState(info_0.gp1_1, currentSubTimeline, info_0.jp1_1);
        this_4.r3(key, value_1);
      }
      var _iterator__ex2g4s_5 = frame_2.voz_1.f1();
      while (_iterator__ex2g4s_5.g1()) {
        var depth = _iterator__ex2g4s_5.h1();
        var n = depth.woh_1;
        var lastDepth = lastDepths[n];
        if (!depth.equals(lastDepth)) {
          currentSubTimeline.loh_1[depth.woh_1].kow(info_0.jp1_1, depth);
          lastDepths[n] = depth;
        }
      }
      var _iterator__ex2g4s_6 = frame_2.woz_1.f1();
      while (_iterator__ex2g4s_6.g1()) {
        var it = _iterator__ex2g4s_6.h1();
        if (it instanceof PlaySound) {
          currentSubTimeline.moh_1.kow(currentTime, new AnPlaySoundAction(it.soz_1));
        }
      }
    }
  }
}
function processAs3Actions($this) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = $this.kp0_1.z1().f1();
  $l$loop_0: while (_iterator__ex2g4s.g1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.h1();
    // Inline function 'kotlin.collections.component1' call
    var className = _destruct__k2r9zo.a2();
    // Inline function 'kotlin.collections.component2' call
    var tagId = _destruct__k2r9zo.b2();
    $this.yp0().koj_1.i1(tagId).zoi_1 = className;
    var tmp0_elvis_lhs = $this.jp0_1.k3(className);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var type = tmp;
    var tmp_0 = $this.yp0().koj_1.i1(tagId);
    var tmp1_elvis_lhs = tmp_0 instanceof AnSymbolMovieClip ? tmp_0 : null;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var symbol = tmp_1;
    var abc = type.sly_1;
    var labelsToFrame0 = get_labelsToFrame0(symbol);
    var _iterator__ex2g4s_0 = type.vly().f1();
    $l$loop_3: while (_iterator__ex2g4s_0.g1()) {
      var trait = _iterator__ex2g4s_0.h1();
      var simpleName = trait.w3().xf();
      if (startsWith(simpleName, 'frame')) {
        // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
        var tmp_2;
        try {
          // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.processAs3Actions.<anonymous>' call
          tmp_2 = toInt(substr(simpleName, 5));
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var e = $p;
            if (false) {
              printStackTrace(e);
            }
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp2_elvis_lhs = tmp_2;
        var tmp_4;
        if (tmp2_elvis_lhs == null) {
          continue $l$loop_3;
        } else {
          tmp_4 = tmp2_elvis_lhs;
        }
        var frame = tmp_4;
        var frame0 = frame - 1 | 0;
        var tmp3_elvis_lhs = trait instanceof TraitMethod ? trait : THROW_CCE();
        var tmp_5;
        if (tmp3_elvis_lhs == null) {
          continue $l$loop_3;
        } else {
          tmp_5 = tmp3_elvis_lhs;
        }
        var traitMethod = tmp_5;
        var methodDesc = abc.yly_1.i1(traitMethod.ely_1);
        var tmp4_elvis_lhs = methodDesc.slx_1;
        var tmp_6;
        if (tmp4_elvis_lhs == null) {
          continue $l$loop_3;
        } else {
          tmp_6 = tmp4_elvis_lhs;
        }
        var body = tmp_6;
        var lastValue = null;
        var _iterator__ex2g4s_1 = body.p9n().f1();
        while (_iterator__ex2g4s_1.g1()) {
          var op = _iterator__ex2g4s_1.h1();
          switch (op.vm0().v3_1) {
            case 32:
              lastValue = (op instanceof AbcIntOperation ? op : THROW_CCE()).zm0_1;
              break;
            case 33:
              lastValue = (op instanceof AbcIntOperation ? op : THROW_CCE()).zm0_1;
              break;
            case 41:
              lastValue = (op instanceof AbcIntOperation ? op : THROW_CCE()).zm0_1;
              break;
            case 42:
              lastValue = (op instanceof AbcIntOperation ? op : THROW_CCE()).zm0_1;
              break;
            case 40:
              lastValue = (op instanceof AbcStringOperation ? op : THROW_CCE()).lm1_1;
              break;
            case 64:
              var call = op instanceof AbcMultinameIntOperation ? op : THROW_CCE();
              var callMethodName = call.pm1_1.xf();
              var frameData = get_swfTimeline(symbol).qoz_1.i1(frame0);
              switch (callMethodName) {
                case 'gotoAndPlay':
                case 'gotoAndStop':
                  var tmp117_subject = lastValue;
                  var tmp_7;
                  if (!(tmp117_subject == null) ? typeof tmp117_subject === 'string' : false) {
                    var tmp5_elvis_lhs = labelsToFrame0.k3(lastValue);
                    tmp_7 = tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs;
                  } else {
                    if (!(tmp117_subject == null) ? typeof tmp117_subject === 'number' : false) {
                      tmp_7 = lastValue - 1 | 0;
                    } else {
                      tmp_7 = 0;
                    }
                  }

                  var gotoFrame0 = tmp_7;
                  if (callMethodName === 'gotoAndStop') {
                    frameData.cp0(gotoFrame0);
                  } else {
                    frameData.dp0(gotoFrame0);
                  }

                  break;
                case 'play':
                  frameData.i85();
                  break;
                case 'stop':
                  frameData.m7w();
                  break;
                default:
                  break;
              }

              lastValue = null;
              break;
            default:
              break;
          }
        }
      }
    }
  }
}
function generateShapes($this) {
  var _iterator__ex2g4s = $this.lp0_1.l3().f1();
  while (_iterator__ex2g4s.g1()) {
    var shape = _iterator__ex2g4s.h1();
    var tag = ensureNotNull(get_tagDefineShape(shape));
    var tmp = shape;
    tmp.wod_1 = memoize(SwfLoaderMethod$generateShapes$lambda(tag, $this));
    shape.xod_1 = $this.gp0_1.noz_1;
  }
  var _iterator__ex2g4s_0 = $this.mp0_1.f1();
  while (_iterator__ex2g4s_0.g1()) {
    var morph = _iterator__ex2g4s_0.h1();
    var tag_0 = ensureNotNull(get_tagDefineMorphShape(morph));
    var tmp_0 = morph;
    tmp_0.jon_1 = SwfLoaderMethod$generateShapes$lambda_0(tag_0, $this);
  }
}
function *_generator_generateTextures__8nuue3($this, $completion) {
  var itemsInAtlas = LinkedHashMap.vc();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = $this.lp0_1.z1().f1();
  while (_iterator__ex2g4s.g1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.h1();
    // Inline function 'kotlin.collections.component1' call
    var shape = _destruct__k2r9zo.a2();
    // Inline function 'kotlin.collections.component2' call
    var rasterizerRequest = _destruct__k2r9zo.b2();
    var info = $this.rp1(rasterizerRequest.qp1());
    var rasterizer = rasterizerRequest.bp2(info.ap2().up1_1);
    itemsInAtlas.r3(SwfLoaderMethod$generateTextures$lambda(shape), rasterizer.voy());
  }
  var _iterator__ex2g4s_0 = $this.mp0_1.f1();
  while (_iterator__ex2g4s_0.g1()) {
    var morph = _iterator__ex2g4s_0.h1();
    var tag = ensureNotNull(get_tagDefineMorphShape(morph));
    var tmp0_elvis_lhs = $this.np0_1.k3(tag.vmo());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.setOf' call
      tmp = emptySet();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ratios = sorted(tmp);
    var MAX_RATIOS = 24;
    var tmp_0;
    if (ratios.j1() > MAX_RATIOS) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, MAX_RATIOS);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.generateTextures.<anonymous>' call
        var tmp$ret$4 = item / (MAX_RATIOS - 1 | 0);
        destination.f(tmp$ret$4);
      }
      tmp_0 = destination;
    } else {
      tmp_0 = ratios;
    }
    var aratios = tmp_0;
    var _iterator__ex2g4s_1 = aratios.f1();
    while (_iterator__ex2g4s_1.g1()) {
      var ratio = _iterator__ex2g4s_1.h1();
      var bb = new ShapeExporterBoundsBuilder();
      try {
        tag.rnf(bb, ratio);
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var bounds = bb.jnb_1.o4i();
      var tmp_1 = $this.vp0();
      var rasterizer_0 = new SWFShapeExporter(tmp_1, $this.gp0_1.xoy_1, bounds, SwfLoaderMethod$generateTextures$lambda_0(tag, ratio), $this.gp0_1.aoz_1, $this.gp0_1.zoy_1, $this.gp0_1.boz_1, $this.gp0_1.eoz_1, $this.gp0_1.foz_1, VOID, morph.yoi_1, VOID, $this.gp0_1.noz_1);
      itemsInAtlas.r3(SwfLoaderMethod$generateTextures$lambda_1(morph, ratio), rasterizer_0.voy());
    }
  }
  // Inline function 'kotlin.collections.iterator' call
  var tmp_2 = toAtlas(itemsInAtlas, $this.fp0_1, $this.gp0_1.goz_1, $this.gp0_1.yoy_1, $this.gp0_1.koz_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var _iterator__ex2g4s_2 = tmp_2.z1().f1();
  while (_iterator__ex2g4s_2.g1()) {
    var _destruct__k2r9zo_0 = _iterator__ex2g4s_2.h1();
    // Inline function 'kotlin.collections.component1' call
    var processor = _destruct__k2r9zo_0.a2();
    // Inline function 'kotlin.collections.component2' call
    var texture = _destruct__k2r9zo_0.b2();
    processor(texture);
  }
  return Unit_instance;
}
function generateTextures($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_generateTextures__8nuue3($this, $completion), $completion);
}
function *_generator_parseMovieClip__kuikn9($this, tags, mc, $completion) {
  try {
    var tmp = parseMovieClipInternal($this, tags, mc, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_parseMovieClipInternal__hv03m($this, tags, mc, $completion) {
  // Inline function 'kotlin.collections.plusAssign' call
  $this.qp0_1.f(mc);
  var swfTimeline = get_swfTimeline(mc);
  var labelsToFrame0 = get_labelsToFrame0(mc);
  // Inline function 'kotlin.collections.hashMapOf' call
  var uniqueIds = HashMap.c9();
  var tmp = 0;
  var tmp_0 = mc.joi_1.roi_1;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = fillArrayVal(Array(tmp_0), null);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = new SwfLoaderMethod$parseMovieClipInternal$DepthInfo(tmp_2);
    tmp = tmp + 1 | 0;
  }
  var depths = tmp_1;
  var totalShowFramesInMc = 0;
  var _iterator__ex2g4s = tags.f1();
  while (_iterator__ex2g4s.g1()) {
    var it = _iterator__ex2g4s.h1();
    var currentFrame = swfTimeline.qoz_1.j1();
    if (it instanceof TagDefineSceneAndFrameLabelData) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_0 = get_labelsToFrame0(mc);
      // Inline function 'kotlin.collections.map' call
      var this_1 = it.rmp_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
        var tmp$ret$3 = to(item.tmp_1, item.smp_1 - 1 | 0);
        destination.f(tmp$ret$3);
      }
      putAll(this_0, destination);
    } else {
      if (it instanceof TagFrameLabel) {
        // Inline function 'kotlin.collections.set' call
        var this_2 = get_labelsToFrame0(mc);
        var key = it.lmp();
        this_2.r3(key, currentFrame);
      } else {
        if (it instanceof TagShowFrame) {
          // Inline function 'kotlin.collections.plusAssign' call
          var this_3 = swfTimeline.qoz_1;
          var element = new MySwfFrame(currentFrame, mc.joi_1.roi_1);
          this_3.f(element);
          totalShowFramesInMc = totalShowFramesInMc + 1 | 0;
        }
      }
    }
  }
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = get_labelsToFrame0(mc).z1().f1();
  while (_iterator__ex2g4s_0.g1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_0.h1();
    // Inline function 'kotlin.collections.component1' call
    var name = _destruct__k2r9zo.a2();
    // Inline function 'kotlin.collections.component2' call
    var index = _destruct__k2r9zo.b2();
    swfTimeline.qoz_1.i1(index).uoz_1 = name;
  }
  var depthsChanged = new BitSet(depths.length);
  var currentFrame_0 = {_v: 0};
  var _iterator__ex2g4s_1 = tags.f1();
  while (_iterator__ex2g4s_1.g1()) {
    var it_0 = _iterator__ex2g4s_1.h1();
    var currentTime = $this.cp2(currentFrame_0._v);
    var swfCurrentFrame$delegate = lazy(SwfLoaderMethod$parseMovieClipInternal$lambda(mc, currentFrame_0));
    if (!(it_0 instanceof TagDefineSceneAndFrameLabelData)) {
      if (!(it_0 instanceof TagFrameLabel)) {
        if (!(it_0 instanceof TagFileAttributes)) {
          if (it_0 instanceof TagSetBackgroundColor) {
            $this.yp0().joj_1 = decodeSWFColor(it_0.vmq_1);
          } else {
            if (!(it_0 instanceof TagProtect)) {
              if (!(it_0 instanceof TagDefineFont)) {
                if (!(it_0 instanceof TagDefineFontName)) {
                  if (!(it_0 instanceof TagDefineFontAlignZones)) {
                    if (it_0 instanceof TagDefineEditText) {
                      // Inline function 'kotlin.collections.plusAssign' call
                      var this_4 = $this.qp0_1;
                      var tmp_3 = it_0.vmo();
                      var tmp0_elvis_lhs = it_0.vnt_1;
                      var element_0 = new AnTextFieldSymbol(tmp_3, null, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, it_0.f6c().o42());
                      this_4.f(element_0);
                    } else {
                      if (!(it_0 instanceof TagCSMTextSettings)) {
                        if (it_0 instanceof TagDoAction) {
                          var _iterator__ex2g4s_2 = it_0.gnn_1.f1();
                          while (_iterator__ex2g4s_2.g1()) {
                            var action = _iterator__ex2g4s_2.h1();
                            if (action instanceof ActionStop) {
                              parseMovieClipInternal$lambda(swfCurrentFrame$delegate).m7w();
                            } else {
                              if (action instanceof ActionPlay) {
                                parseMovieClipInternal$lambda(swfCurrentFrame$delegate).i85();
                              } else {
                                if (action instanceof ActionGotoFrame) {
                                  parseMovieClipInternal$lambda(swfCurrentFrame$delegate).bp0(action.kmf_1);
                                }
                              }
                            }
                          }
                        } else {
                          if (it_0 instanceof TagDefineSound) {
                            var soundBytes = it_0.kno_1.hn4();
                            // Inline function 'kotlin.collections.plusAssign' call
                            var this_5 = $this.qp0_1;
                            var element_1 = new AnSymbolSound(it_0.vmo(), null, null, soundBytes);
                            this_5.f(element_1);
                          } else {
                            if (it_0 instanceof TagStartSound) {
                              parseMovieClipInternal$lambda(swfCurrentFrame$delegate).ep0(it_0.pno_1);
                            } else {
                              if (it_0 instanceof TagJPEGTables) {
                                println('Unhandled tag: ' + it_0.toString());
                              } else {
                                if (it_0 instanceof TagSoundStreamHead) {
                                  println('Unhandled tag: ' + it_0.toString());
                                } else {
                                  if (!(it_0 instanceof TagSoundStreamBlock)) {
                                    if (it_0 instanceof TagDefineText) {
                                      println('Unhandled tag: TagDefineText');
                                    } else {
                                      if (it_0 instanceof TagDefineButton) {
                                        println('Unhandled tag: TagDefineButton');
                                      } else {
                                        var tmp_4;
                                        if (it_0 instanceof TagDefineBits) {
                                          tmp_4 = true;
                                        } else {
                                          tmp_4 = it_0 instanceof TagDefineBitsLossless;
                                        }
                                        if (tmp_4) {
                                          var fbmp = Bitmap32.c4p(1, 1, VOID, false);
                                          if (!isInterface(it_0, IDefinitionTag))
                                            THROW_CCE();
                                          if (it_0 instanceof TagDefineBits) {
                                            var bitsData = it_0.snl_1.hn4();
                                            var tmp_5;
                                            try {
                                              if (bitsData.length >= 4 && get_hexLower(sliceArray(bitsData, until(0, 4))) === 'ffd9ffd8') {
                                                bitsData = sliceArray(bitsData, until(4, bitsData.length));
                                              }
                                              var tmp_6 = readBitmap(openAsync(bitsData), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.fp0_1.nov_1), $completion);
                                              if (tmp_6 === get_COROUTINE_SUSPENDED())
                                                tmp_6 = yield tmp_6;
                                              tmp_5 = tmp_6;
                                            } catch ($p) {
                                              var tmp_7;
                                              if ($p instanceof Error) {
                                                var e = $p;
                                                printStackTrace(e);
                                                tmp_7 = Bitmap32.c4p(1, 1);
                                              } else {
                                                throw $p;
                                              }
                                              tmp_5 = tmp_7;
                                            }
                                            var nativeBitmap = tmp_5;
                                            var bmp = nativeBitmap.o4q();
                                            fbmp = bmp;
                                            if (it_0 instanceof TagDefineBitsJPEG3) {
                                              var fmaskinfo = it_0.bns_1.gn4();
                                              var tmp_8 = fmaskinfo.jmr('zlib', $completion);
                                              if (tmp_8 === get_COROUTINE_SUSPENDED())
                                                tmp_8 = yield tmp_8;
                                              var maskinfo = fmaskinfo.hn4();
                                              bmp.i50(BitmapChannel_ALPHA_getInstance(), Bitmap8.f51(bmp.j2y(), bmp.k2y(), maskinfo));
                                            }
                                          } else {
                                            if (it_0 instanceof TagDefineBitsLossless) {
                                              var funcompressedData = it_0.pnp_1.gn4();
                                              var tmp_9 = funcompressedData.jmr('zlib', $completion);
                                              if (tmp_9 === get_COROUTINE_SUSPENDED())
                                                tmp_9 = yield tmp_9;
                                              var uncompressedData = funcompressedData.hn4();
                                              switch (it_0.lnp_1.v3_1) {
                                                case 0:
                                                  var ncolors = it_0.rnp();
                                                  var s = new FastByteArrayInputStream(uncompressedData);
                                                  var tmp_10;
                                                  if (it_0.qnp()) {
                                                    // Inline function 'kotlin.collections.map' call
                                                    var this_6 = until(0, ncolors);
                                                    // Inline function 'kotlin.collections.mapTo' call
                                                    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_6, 10));
                                                    var tmp0_iterator_0 = this_6.f1();
                                                    while (tmp0_iterator_0.g1()) {
                                                      var item_0 = tmp0_iterator_0.h1();
                                                      // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                      var tmp$ret$9 = s.e1r();
                                                      destination_0.f(tmp$ret$9);
                                                    }
                                                    tmp_10 = toIntArray(destination_0);
                                                  } else {
                                                    // Inline function 'kotlin.collections.map' call
                                                    var this_7 = until(0, ncolors);
                                                    // Inline function 'kotlin.collections.mapTo' call
                                                    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_7, 10));
                                                    var tmp0_iterator_1 = this_7.f1();
                                                    while (tmp0_iterator_1.g1()) {
                                                      var item_1 = tmp0_iterator_1.h1();
                                                      // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                      var tmp$ret$12 = -16777216 | s.c1r();
                                                      destination_1.f(tmp$ret$12);
                                                    }
                                                    tmp_10 = toIntArray(destination_1);
                                                  }

                                                  var clut = tmp_10;
                                                  var nbytes = imul(it_0.snp(), it_0.tnp());
                                                  var rpixels = new Int8Array(nbytes);
                                                  s.k12(rpixels, 0, nbytes);
                                                  var bmp_0 = Bitmap8.f51(it_0.snp(), it_0.tnp(), rpixels, _RgbaArray___init__impl__oib4y4(clut));
                                                  fbmp = bmp_0;
                                                  break;
                                                case 1:
                                                  fbmp = Bitmap32.q4z(it_0.snp(), it_0.tnp(), decode(BGRA_5551_getInstance(), uncompressedData));
                                                  break;
                                                case 2:
                                                  var components = uncompressedData.length / imul(it_0.mnp_1, it_0.nnp_1) | 0;
                                                  var colorFormat = BGRA_getInstance();
                                                  var bmp_1 = Bitmap32.q4z(it_0.mnp_1, it_0.nnp_1, decode(colorFormat, uncompressedData, VOID, VOID, false));
                                                  fbmp = bmp_1;
                                                  if (!it_0.qnp()) {
                                                    var inductionVariable = 0;
                                                    var last = fbmp.z4o_1.length;
                                                    if (inductionVariable < last)
                                                      do {
                                                        var n = inductionVariable;
                                                        inductionVariable = inductionVariable + 1 | 0;
                                                        bmp_1.v4z(n, Companion_getInstance_4().o5j(_RGBA___get_rgb__impl__tijaqt(bmp_1.i4y(n)), 255));
                                                      }
                                                       while (inductionVariable < last);
                                                  }

                                                  break;
                                                default:
                                                  break;
                                              }
                                            }
                                          }
                                          $this.qp2(it_0.vmo(), fbmp, null);
                                        } else {
                                          if (it_0 instanceof TagDefineShape) {
                                            var tag = it_0;
                                            var rasterizerRequest = new SWFShapeRasterizerRequest($this.vp0(), tag, $this.gp0_1);
                                            var symbol = new AnSymbolShape(it_0.vmo(), null, rasterizerRequest.fng(), null, rasterizerRequest.pp1_1);
                                            set_tagDefineShape(symbol, it_0);
                                            // Inline function 'kotlin.collections.plusAssign' call
                                            $this.qp0_1.f(symbol);
                                            // Inline function 'kotlin.collections.plusAssign' call
                                            var this_8 = $this.lp0_1;
                                            var pair = to(symbol, rasterizerRequest);
                                            this_8.r3(pair.im_1, pair.jm_1);
                                          } else {
                                            if (it_0 instanceof TagDefineMorphShape) {
                                              var startBounds = it_0.hnf().o42();
                                              var endBounds = it_0.inf().o42();
                                              // Inline function 'korlibs.math.geom.MBoundsBuilder.add' call
                                              // Inline function 'korlibs.math.geom.MBoundsBuilder.add' call
                                              // Inline function 'korlibs.math.geom.MBoundsBuilder.add' call
                                              // Inline function 'korlibs.math.geom.MBoundsBuilder.add' call
                                              var this_9 = new MBoundsBuilder();
                                              if (startBounds == null)
                                                null;
                                              else {
                                                // Inline function 'kotlin.let' call
                                                // Inline function 'kotlin.contracts.contract' call
                                                // Inline function 'korlibs.math.geom.MBoundsBuilder.add.<anonymous>' call
                                                this_9.k4i(startBounds);
                                              }
                                              if (endBounds == null)
                                                null;
                                              else {
                                                // Inline function 'kotlin.let' call
                                                // Inline function 'kotlin.contracts.contract' call
                                                // Inline function 'korlibs.math.geom.MBoundsBuilder.add.<anonymous>' call
                                                this_9.k4i(endBounds);
                                              }
                                              var rect = it_0.dnf_1.o42();
                                              if (rect == null)
                                                null;
                                              else {
                                                // Inline function 'kotlin.let' call
                                                // Inline function 'kotlin.contracts.contract' call
                                                // Inline function 'korlibs.math.geom.MBoundsBuilder.add.<anonymous>' call
                                                this_9.k4i(rect);
                                              }
                                              var rect_0 = it_0.enf_1.o42();
                                              if (rect_0 == null)
                                                null;
                                              else {
                                                // Inline function 'kotlin.let' call
                                                // Inline function 'kotlin.contracts.contract' call
                                                // Inline function 'korlibs.math.geom.MBoundsBuilder.add.<anonymous>' call
                                                this_9.k4i(rect_0);
                                              }
                                              var bounds = this_9.o4i();
                                              var bounds2 = bounds.e4f(VOID, VOID, bounds.j4e_1 + 100, bounds.k4e_1 + 100);
                                              var symbol_0 = new AnSymbolMorphShape(it_0.vmo(), null, bounds2);
                                              set_tagDefineMorphShape(symbol_0, it_0);
                                              // Inline function 'kotlin.collections.plusAssign' call
                                              $this.qp0_1.f(symbol_0);
                                              // Inline function 'kotlin.collections.plusAssign' call
                                              $this.mp0_1.f(symbol_0);
                                            } else {
                                              if (it_0 instanceof TagDoABC) {
                                                // Inline function 'kotlin.collections.plusAssign' call
                                                var this_10 = $this.jp0_1;
                                                // Inline function 'kotlin.collections.map' call
                                                var this_11 = it_0.ao3().blz_1;
                                                // Inline function 'kotlin.collections.mapTo' call
                                                var destination_2 = ArrayList.w(collectionSizeOrDefault(this_11, 10));
                                                var tmp0_iterator_2 = this_11.f1();
                                                while (tmp0_iterator_2.g1()) {
                                                  var item_2 = tmp0_iterator_2.h1();
                                                  // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                  var tmp$ret$27 = to(item_2.w3().toString(), item_2);
                                                  destination_2.f(tmp$ret$27);
                                                }
                                                var map = toMap(destination_2);
                                                this_10.t3(map);
                                              } else {
                                                if (it_0 instanceof TagSymbolClass) {
                                                  // Inline function 'kotlin.collections.plusAssign' call
                                                  var this_12 = $this.kp0_1;
                                                  // Inline function 'kotlin.collections.map' call
                                                  // Inline function 'kotlin.collections.filter' call
                                                  // Inline function 'kotlin.collections.filterTo' call
                                                  var this_13 = it_0.eo2_1;
                                                  var destination_3 = ArrayList.m1();
                                                  var tmp0_iterator_3 = this_13.f1();
                                                  while (tmp0_iterator_3.g1()) {
                                                    var element_2 = tmp0_iterator_3.h1();
                                                    // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                    if (!(element_2.bn2_1 == null)) {
                                                      destination_3.f(element_2);
                                                    }
                                                  }
                                                  // Inline function 'kotlin.collections.mapTo' call
                                                  var destination_4 = ArrayList.w(collectionSizeOrDefault(destination_3, 10));
                                                  var tmp0_iterator_4 = destination_3.f1();
                                                  while (tmp0_iterator_4.g1()) {
                                                    var item_3 = tmp0_iterator_4.h1();
                                                    // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                    var tmp$ret$33 = to(ensureNotNull(item_3.bn2_1), item_3.an2_1);
                                                    destination_4.f(tmp$ret$33);
                                                  }
                                                  var map_0 = toMap(destination_4);
                                                  this_12.t3(map_0);
                                                } else {
                                                  if (it_0 instanceof TagDefineSprite) {
                                                    var childMc = new AnSymbolMovieClip(it_0.vmo(), null, $this.wp0(it_0.qmm_1));
                                                    // Inline function 'kotlin.collections.set' call
                                                    var this_14 = $this.tp0_1;
                                                    var key_0 = it_0.vmo();
                                                    this_14.r3(key_0, childMc);
                                                    var tmp_11 = $this.xp0(it_0.qmm_1, childMc, $completion);
                                                    if (tmp_11 === get_COROUTINE_SUSPENDED())
                                                      tmp_11 = yield tmp_11;
                                                  } else {
                                                    if (it_0 instanceof TagDefineScalingGrid) {
                                                      var childMc_0 = $this.tp0_1.k3(it_0.vmo());
                                                      if (!(childMc_0 == null)) {
                                                        childMc_0.koi_1 = it_0.ro2().o42();
                                                      }
                                                      $this.rp1(it_0.vmo()).wp1_1 = true;
                                                    } else {
                                                      if (it_0 instanceof TagPlaceObject) {
                                                        $this.rp0_1 = $this.rp0_1 + 1 | 0;
                                                        // Inline function 'korlibs.korge.ext.swf.depth0' call
                                                        var depthId = it_0.tnh_1 - 1 | 0;
                                                        var tmp_12;
                                                        if (it_0.enh_1) {
                                                          // Inline function 'korlibs.korge.ext.swf.clipDepth0' call
                                                          tmp_12 = (it_0.ynh_1 - 1 | 0) - 1 | 0;
                                                        } else {
                                                          tmp_12 = -1;
                                                        }
                                                        var clipDepthId = tmp_12;
                                                        var depth = depths[depthId];
                                                        if (it_0.jnh_1)
                                                          depth.fp2_1 = it_0.snh_1;
                                                        if (it_0.enh_1)
                                                          depth.gp2_1 = clipDepthId;
                                                        if (it_0.fnh_1)
                                                          depth.hp2_1 = it_0.xnh_1;
                                                        if (it_0.hnh_1) {
                                                          var ct = toColorTransform(ensureNotNull(it_0.vnh_1));
                                                          depth.ip2_1 = ct;
                                                        } else {
                                                          var tmp_13 = depth;
                                                          // Inline function 'korlibs.image.color.ColorTransform' call
                                                          var multiply = Colors_getInstance().g4r_1;
                                                          // Inline function 'korlibs.image.color.Companion.invoke' call
                                                          var add = _ColorAdd___init__impl__q78um5(ColorAdd_pack(0, 0, 0, 0));
                                                          tmp_13.ip2_1 = new ColorTransform(_RGBA___get_rf__impl__kvz75k(multiply), _RGBA___get_gf__impl__5gcu1f(multiply), _RGBA___get_bf__impl__1xz5yg(multiply), _RGBA___get_af__impl__vu36qv(multiply), _ColorAdd___get_r__impl__j9xkne(add), _ColorAdd___get_g__impl__itrhk1(add), _ColorAdd___get_b__impl__grv87a(add), _ColorAdd___get_a__impl__c1r8ux(add));
                                                        }
                                                        if (it_0.inh_1) {
                                                          var m = ensureNotNull(it_0.unh_1).gl6();
                                                          depth.kp2_1 = m;
                                                        }
                                                        if (it_0.qnh_1) {
                                                          var tmp_14 = depth;
                                                          switch (it_0.bni_1) {
                                                            case 0:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ra5_1;
                                                              break;
                                                            case 1:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ra5_1;
                                                              break;
                                                            case 2:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().sa5_1;
                                                              break;
                                                            case 3:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().va5_1;
                                                              break;
                                                            case 4:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().wa5_1;
                                                              break;
                                                            case 5:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ca6_1;
                                                              break;
                                                            case 6:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().da6_1;
                                                              break;
                                                            case 7:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ea6_1;
                                                              break;
                                                            case 8:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ua5_1;
                                                              break;
                                                            case 9:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().aa6_1;
                                                              break;
                                                            case 10:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ba6_1;
                                                              break;
                                                            case 11:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().fa6_1;
                                                              break;
                                                            case 12:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().xa5_1;
                                                              break;
                                                            case 13:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().sa5_1;
                                                              break;
                                                            case 14:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().ga6_1;
                                                              break;
                                                            default:
                                                              tmp_14.lp2_1 = Companion_getInstance_14().sa5_1;
                                                              break;
                                                          }
                                                        }
                                                        depth.mp2_1 = it_0.rnh_1 ? toList_0(it_0.gni_1) : emptyList();
                                                        var uid = parseMovieClipInternal$getUid(depths, uniqueIds, mc, depthId);
                                                        var metaData = it_0.fni_1;
                                                        var tmp_15;
                                                        var tmp_16;
                                                        if (!(metaData == null)) {
                                                          tmp_16 = !(metaData == null) ? isInterface(metaData, KtMap) : false;
                                                        } else {
                                                          tmp_16 = false;
                                                        }
                                                        if (tmp_16) {
                                                          // Inline function 'kotlin.collections.contains' call
                                                          // Inline function 'kotlin.collections.containsKey' call
                                                          tmp_15 = (isInterface(metaData, KtMap) ? metaData : THROW_CCE()).i3('props');
                                                        } else {
                                                          tmp_15 = false;
                                                        }
                                                        if (tmp_15) {
                                                          var uidInfo = mc.moi_1[uid];
                                                          // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
                                                          var tmp_17;
                                                          try {
                                                            // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                            var tmp_18 = Companion_getInstance_1();
                                                            // Inline function 'kotlin.collections.get' call
                                                            var tmp$ret$42 = (isInterface(metaData, KtMap) ? metaData : THROW_CCE()).k3('props');
                                                            var tmp_19 = tmp_18.i2d(toString_0(tmp$ret$42));
                                                            tmp_17 = (!(tmp_19 == null) ? isInterface(tmp_19, KtMap) : false) ? tmp_19 : THROW_CCE();
                                                          } catch ($p) {
                                                            var tmp_20;
                                                            if ($p instanceof Error) {
                                                              var e_0 = $p;
                                                              if (false) {
                                                                printStackTrace(e_0);
                                                              }
                                                              tmp_20 = null;
                                                            } else {
                                                              throw $p;
                                                            }
                                                            tmp_17 = tmp_20;
                                                          }
                                                          var eprops = tmp_17;
                                                          if (!(eprops == null)) {
                                                            // Inline function 'kotlin.collections.plusAssign' call
                                                            uidInfo.woi_1.t3(eprops);
                                                          }
                                                        }
                                                        if (it_0.gnh_1) {
                                                          depth.jp2_1 = toRatio(it_0.hni());
                                                          // Inline function 'kotlin.collections.getOrPut' call
                                                          var this_15 = $this.np0_1;
                                                          var key_1 = depth.fp2_1;
                                                          var value = this_15.k3(key_1);
                                                          var tmp_21;
                                                          if (value == null) {
                                                            // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.<anonymous>' call
                                                            // Inline function 'kotlin.collections.hashSetOf' call
                                                            var answer = HashSet.xa();
                                                            this_15.r3(key_1, answer);
                                                            tmp_21 = answer;
                                                          } else {
                                                            tmp_21 = value;
                                                          }
                                                          var ratios = tmp_21;
                                                          // Inline function 'kotlin.collections.plusAssign' call
                                                          var element_3 = it_0.hni();
                                                          ratios.f(element_3);
                                                        }
                                                        $this.rp1(depth.fp2_1).op2($this.rp1(mc.yoi_1));
                                                        $this.rp1(depth.fp2_1).pp2(depth.kp2_1);
                                                        depth.ep2_1 = uid;
                                                        depthsChanged.e34(depthId, true);
                                                      } else {
                                                        if (it_0 instanceof TagRemoveObject) {
                                                          // Inline function 'korlibs.korge.ext.swf.depth0' call
                                                          depths[it_0.fnl_1 - 1 | 0].z33();
                                                          // Inline function 'korlibs.korge.ext.swf.depth0' call
                                                          var tmp$ret$49 = it_0.fnl_1 - 1 | 0;
                                                          depthsChanged.e34(tmp$ret$49, true);
                                                        } else {
                                                          if (it_0 instanceof TagShowFrame) {
                                                            $this.sp0_1 = $this.sp0_1 + 1 | 0;
                                                            var inductionVariable_0 = 0;
                                                            var last_0 = depths.length;
                                                            while (inductionVariable_0 < last_0) {
                                                              var depth_0 = depths[inductionVariable_0];
                                                              inductionVariable_0 = inductionVariable_0 + 1 | 0;
                                                              // Inline function 'kotlin.collections.plusAssign' call
                                                              var this_16 = parseMovieClipInternal$lambda(swfCurrentFrame$delegate).voz_1;
                                                              var element_4 = depth_0.np2();
                                                              this_16.f(element_4);
                                                            }
                                                            depthsChanged.o3();
                                                            currentFrame_0._v = currentFrame_0._v + 1 | 0;
                                                          } else {
                                                            if (!(it_0 instanceof TagEnd)) {
                                                              if (isInterface(it_0, IDefinitionTag)) {
                                                                println('Unhandled tag ' + toString(it_0) + " - Can't continue without handling th define tag " + toString(it_0));
                                                              } else {
                                                                println('Unhandled tag ' + toString(it_0));
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return Unit_instance;
}
function parseMovieClipInternal($this, tags, mc, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_parseMovieClipInternal__hv03m($this, tags, mc, $completion), $completion);
}
function parseMovieClipInternal$getUid(depths, uniqueIds, $mc, depth) {
  var charId = depths[depth].fp2_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var key = to(depth, charId);
  var value = uniqueIds.k3(key);
  var tmp;
  if (value == null) {
    // Inline function 'korlibs.korge.ext.swf.SwfLoaderMethod.parseMovieClipInternal.getUid.<anonymous>' call
    var uid = uniqueIds.j1();
    $mc.moi_1[uid] = new AnSymbolUidDef(charId);
    var answer = uid;
    uniqueIds.r3(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function parseMovieClipInternal$lambda($swfCurrentFrame$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('swfCurrentFrame', KProperty0, false, function () {
    return THROW_ISE();
  });
  return $swfCurrentFrame$delegate.b2();
}
function SwfLoaderMethod$generateShapes$lambda($tag, this$0) {
  return function () {
    return export_0($tag, get_bitmaps(this$0.vp0()));
  };
}
function SwfLoaderMethod$generateShapes$lambda_0($tag, this$0) {
  return function (ratio) {
    return export_1($tag, get_bitmaps(this$0.vp0()), ratio);
  };
}
function SwfLoaderMethod$generateTextures$lambda($shape) {
  return function (texture) {
    $shape.vod_1 = texture;
    return Unit_instance;
  };
}
function SwfLoaderMethod$generateTextures$lambda_0($tag, $ratio) {
  return function (it) {
    var tmp;
    try {
      $tag.rnf(it, $ratio);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (e instanceof CancellationException)
          throw e;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function SwfLoaderMethod$generateTextures$lambda_1($morph, $ratio) {
  return function (texture) {
    var tmp = $morph.ion_1;
    // Inline function 'korlibs.time.seconds' call
    var this_0 = $ratio;
    var tmp$ret$0 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
    tmp.kow(tmp$ret$0, texture);
    return Unit_instance;
  };
}
function SwfLoaderMethod$parseMovieClipInternal$lambda($mc, $currentFrame) {
  return function () {
    return get_swfTimeline($mc).qoz_1.i1($currentFrame._v);
  };
}
function SymbolAnalyzeInfo$globalScaleBounds$delegate$lambda(this$0) {
  return function () {
    var out = new MinMaxDouble();
    var tmp;
    if (this$0.xp1_1.a1()) {
      var tmp_0;
      if (this$0.yp1_1.m4e()) {
        out.tp2(this$0.yp1_1);
        tmp_0 = Unit_instance;
      } else {
        out.sp2(1.0);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } else {
      var _iterator__ex2g4s = this$0.xp1_1.f1();
      $l$loop: while (_iterator__ex2g4s.g1()) {
        var parent = _iterator__ex2g4s.h1();
        if (parent.wp1_1)
          continue $l$loop;
        out.sp2(this$0.yp1_1.tp1_1 * parent.ap2().tp1_1);
        out.sp2(this$0.yp1_1.up1_1 * parent.ap2().up1_1);
      }
      tmp = Unit_instance;
    }
    return out;
  };
}
function getShapeExporter(_this__u8e3s4, swf, config, maxScale, path) {
  path = path === VOID ? new VectorPath() : path;
  var adaptiveScaling = config.ioz_1 ? maxScale : 1.0;
  var tmp = _this__u8e3s4.fng().o42();
  return new SWFShapeExporter(swf, config.xoy_1, tmp, getShapeExporter$lambda(_this__u8e3s4), config.aoz_1, config.zoy_1, config.boz_1 * adaptiveScaling, config.coz_1, config.doz_1, path, _this__u8e3s4.vmo(), config.loz_1, config.noz_1);
}
function getShapeExporter$lambda($this_getShapeExporter) {
  return function (it) {
    $this_getShapeExporter.wn7(it);
    return Unit_instance;
  };
}
function globalScaleBounds$factory() {
  return getPropertyCallableRef('globalScaleBounds', 1, KProperty1, function (receiver) {
    return receiver.ap2();
  }, null);
}
function getBounds(_this__u8e3s4, text, format, out) {
  out = out === VOID ? Companion_getInstance_2().l2m() : out;
  var font = _this__u8e3s4;
  var textSize = format.ip3();
  var width = 0.0;
  var height = 0.0;
  var dy = 0.0;
  var dx = 0.0;
  var glyph = new GlyphMetrics();
  var fmetrics = font.m5k(textSize);
  var inductionVariable = 0;
  var last = text.length;
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(text, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + fmetrics.d5l();
        // Inline function 'kotlin.math.max' call
        var a = height;
        var b = dy;
        height = Math.max(a, b);
        continue $l$loop;
      }
      var c2 = 32;
      if ((n + 1 | 0) < text.length)
        c2 = Char__toInt_impl_vasixd(charSequenceGet(text, n + 1 | 0));
      var kerningOffset = font.t5n(textSize, c1, c2);
      var glyph_0 = font.o5k(textSize, c1, glyph);
      dx = dx + (glyph_0.t5k_1 + kerningOffset);
      // Inline function 'kotlin.math.max' call
      var a_0 = width;
      var b_0 = dx;
      width = Math.max(a_0, b_0);
    }
     while (inductionVariable < last);
  height = height + fmetrics.d5l();
  out.c4e(0.0, 0.0, width, height);
  return out;
}
var debugBmpFontOrNull;
var _DefaultFontsCatalog;
function Html$Format$computedFace$delegate$lambda() {
  return null;
}
function Html$Format$computedSize$delegate$lambda() {
  return 16;
}
function Html$Format$computedLetterSpacing$delegate$lambda() {
  return 0.0;
}
function Html$Format$computedKerning$delegate$lambda() {
  return 0;
}
function Html$Format$computedAlign$delegate$lambda() {
  return Companion_getInstance_6().p5s_1;
}
var Html_instance;
function Html_getInstance() {
  if (Html_instance === VOID)
    new Html();
  return Html_instance;
}
function get_debugBmpFontSync() {
  if (debugBmpFontOrNull == null) {
    debugBmpFontOrNull = debugBmpFont(slice(PNG_getInstance().o6k(get_DEBUG_FONT_BYTES())));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.wc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.korge.view.textOld.debugBmpFont.<anonymous>' call
    var x = element % 16 | 0;
    var y = element / 16 | 0;
    var tmp$ret$0 = new Glyph(fntHeight, element, tex.v42(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
    result.r3(element, tmp$ret$0);
  }
  var glyphs = toIntMap(result);
  var kernings = IntMap.t37();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
function face$factory() {
  return getPropertyCallableRef('face', 1, KMutableProperty1, function (receiver) {
    return receiver.yp2_1;
  }, function (receiver, value) {
    receiver.yp2_1 = value;
    return Unit_instance;
  });
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KMutableProperty1, function (receiver) {
    return receiver.zp2_1;
  }, function (receiver, value) {
    receiver.zp2_1 = value;
    return Unit_instance;
  });
}
function letterSpacing$factory() {
  return getPropertyCallableRef('letterSpacing', 1, KMutableProperty1, function (receiver) {
    return receiver.ap3_1;
  }, function (receiver, value) {
    receiver.ap3_1 = value;
    return Unit_instance;
  });
}
function kerning$factory() {
  return getPropertyCallableRef('kerning', 1, KMutableProperty1, function (receiver) {
    return receiver.bp3_1;
  }, function (receiver, value) {
    receiver.bp3_1 = value;
    return Unit_instance;
  });
}
function align$factory() {
  return getPropertyCallableRef('align', 1, KMutableProperty1, function (receiver) {
    return receiver.cp3_1;
  }, function (receiver, value) {
    receiver.cp3_1 = value;
    return Unit_instance;
  });
}
function computedFace$factory() {
  return getPropertyCallableRef('computedFace', 1, KProperty1, function (receiver) {
    return receiver.tp3();
  }, null);
}
function computedSize$factory() {
  return getPropertyCallableRef('computedSize', 1, KProperty1, function (receiver) {
    return receiver.ip3();
  }, null);
}
function computedLetterSpacing$factory() {
  return getPropertyCallableRef('computedLetterSpacing', 1, KProperty1, function (receiver) {
    return receiver.vp3();
  }, null);
}
function computedKerning$factory() {
  return getPropertyCallableRef('computedKerning', 1, KProperty1, function (receiver) {
    return receiver.wp3();
  }, null);
}
function computedAlign$factory() {
  return getPropertyCallableRef('computedAlign', 1, KProperty1, function (receiver) {
    return receiver.xp3();
  }, null);
}
var Companion_instance_36;
function Companion_getInstance_53() {
  return Companion_instance_36;
}
function recalculateBounds($this) {
  $this.gou_1.sp3($this.o2f(), $this.sov(), $this.hou_1);
}
function recalculateBoundsWhenRequired($this) {
  if ($this.pou_1) {
    recalculateBounds($this);
  }
}
function filtering$factory($b0) {
  return getPropertyCallableRef('filtering', 0, KMutableProperty0, function () {
    return $b0.nou_1;
  }, function (value) {
    return $b0.fhf(value);
  });
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Namespace, 'Namespace');
initMetadataForObject(EmptyMultiname, 'EmptyMultiname');
initMetadataForClass(ABCQName, 'ABCQName');
initMetadataForClass(QNameA, 'QNameA');
initMetadataForClass(RTQName, 'RTQName');
initMetadataForClass(RTQNameA, 'RTQNameA');
initMetadataForObject(RTQNameL, 'RTQNameL');
initMetadataForObject(RTQNameLA, 'RTQNameLA');
initMetadataForClass(Multiname, 'Multiname');
initMetadataForClass(MultinameA, 'MultinameA');
initMetadataForClass(MultinameL, 'MultinameL');
initMetadataForClass(MultinameLA, 'MultinameLA');
initMetadataForClass(TypeName, 'TypeName');
initMetadataForClass(Metadata, 'Metadata');
initMetadataForClass(MethodBody, 'MethodBody');
initMetadataForClass(ExceptionInfo, 'ExceptionInfo');
initMetadataForClass(TraitSlot, 'TraitSlot');
initMetadataForClass(TraitMethod, 'TraitMethod');
initMetadataForClass(TraitClass, 'TraitClass');
initMetadataForClass(TraitFunction, 'TraitFunction');
initMetadataForClass(InstanceInfo, 'InstanceInfo');
initMetadataForClass(ClassInfo, 'ClassInfo');
initMetadataForClass(TypeInfo, 'TypeInfo');
initMetadataForClass(ScriptInfo, 'ScriptInfo');
initMetadataForClass(MethodDesc, 'MethodDesc');
initMetadataForClass(ABC, 'ABC', ABC);
initMetadataForClass(Reader, 'Reader');
initMetadataForObject(AMF3, 'AMF3');
initMetadataForClass(AbcConstantPool, 'AbcConstantPool', AbcConstantPool);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KindContext, 'KindContext');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_1);
initMetadataForClass(AbcOpcode, 'AbcOpcode');
initMetadataForClass(AbcBasicOperation, 'AbcBasicOperation');
initMetadataForClass(AbcLabelOperation, 'AbcLabelOperation');
initMetadataForClass(AbcIntOperation, 'AbcIntOperation');
initMetadataForClass(AbcDoubleOperation, 'AbcDoubleOperation');
initMetadataForClass(AbcIntIntOperation, 'AbcIntIntOperation');
initMetadataForClass(AbcIntStringIntIntOperation, 'AbcIntStringIntIntOperation');
initMetadataForClass(AbcStringOperation, 'AbcStringOperation');
initMetadataForClass(AbcMultinameOperation, 'AbcMultinameOperation');
initMetadataForClass(AbcMultinameIntOperation, 'AbcMultinameIntOperation');
initMetadataForClass(AbcJumpOperation, 'AbcJumpOperation');
initMetadataForClass(AbcNewClassOperation, 'AbcNewClassOperation');
initMetadataForClass(AbcLookupSwitchOperation, 'AbcLookupSwitchOperation');
initMetadataForClass(AbcNamespaceOperation, 'AbcNamespaceOperation');
initMetadataForObject(Undefined, 'Undefined');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Action, 'Action');
initMetadataForClass(ActionExecutionContext, 'ActionExecutionContext');
initMetadataForClass(ActionNextFrame, 'ActionNextFrame');
initMetadataForClass(ActionPreviousFrame, 'ActionPreviousFrame');
initMetadataForClass(ActionPlay, 'ActionPlay');
initMetadataForClass(ActionStop, 'ActionStop');
initMetadataForClass(ActionToggleQuality, 'ActionToggleQuality');
initMetadataForClass(ActionStopSounds, 'ActionStopSounds');
initMetadataForClass(ActionAdd, 'ActionAdd');
initMetadataForClass(ActionSubtract, 'ActionSubtract');
initMetadataForClass(ActionMultiply, 'ActionMultiply');
initMetadataForClass(ActionDivide, 'ActionDivide');
initMetadataForClass(ActionEquals, 'ActionEquals');
initMetadataForClass(ActionLess, 'ActionLess');
initMetadataForClass(ActionAnd, 'ActionAnd');
initMetadataForClass(ActionOr, 'ActionOr');
initMetadataForClass(ActionNot, 'ActionNot');
initMetadataForClass(ActionStringEquals, 'ActionStringEquals');
initMetadataForClass(ActionStringLength, 'ActionStringLength');
initMetadataForClass(ActionStringExtract, 'ActionStringExtract');
initMetadataForClass(ActionPop, 'ActionPop');
initMetadataForClass(ActionToInteger, 'ActionToInteger');
initMetadataForClass(ActionGetVariable, 'ActionGetVariable');
initMetadataForClass(ActionSetVariable, 'ActionSetVariable');
initMetadataForClass(ActionSetTarget2, 'ActionSetTarget2');
initMetadataForClass(ActionStringAdd, 'ActionStringAdd');
initMetadataForClass(ActionGetProperty, 'ActionGetProperty');
initMetadataForClass(ActionSetProperty, 'ActionSetProperty');
initMetadataForClass(ActionCloneSprite, 'ActionCloneSprite');
initMetadataForClass(ActionRemoveSprite, 'ActionRemoveSprite');
initMetadataForClass(ActionTrace, 'ActionTrace');
initMetadataForClass(ActionStartDrag, 'ActionStartDrag');
initMetadataForClass(ActionEndDrag, 'ActionEndDrag');
initMetadataForClass(ActionStringLess, 'ActionStringLess');
initMetadataForClass(ActionThrow, 'ActionThrow');
initMetadataForClass(ActionCastOp, 'ActionCastOp');
initMetadataForClass(ActionImplementsOp, 'ActionImplementsOp');
initMetadataForClass(ActionRandomNumber, 'ActionRandomNumber');
initMetadataForClass(ActionMBStringLength, 'ActionMBStringLength');
initMetadataForClass(ActionCharToAscii, 'ActionCharToAscii');
initMetadataForClass(ActionAsciiToChar, 'ActionAsciiToChar');
initMetadataForClass(ActionGetTime, 'ActionGetTime');
initMetadataForClass(ActionMBStringExtract, 'ActionMBStringExtract');
initMetadataForClass(ActionMBCharToAscii, 'ActionMBCharToAscii');
initMetadataForClass(ActionMBAsciiToChar, 'ActionMBAsciiToChar');
initMetadataForClass(ActionDelete, 'ActionDelete');
initMetadataForClass(ActionDelete2, 'ActionDelete2');
initMetadataForClass(ActionDefineLocal, 'ActionDefineLocal');
initMetadataForClass(ActionCallFunction, 'ActionCallFunction');
initMetadataForClass(ActionReturn, 'ActionReturn');
initMetadataForClass(ActionModulo, 'ActionModulo');
initMetadataForClass(ActionNewObject, 'ActionNewObject');
initMetadataForClass(ActionDefineLocal2, 'ActionDefineLocal2');
initMetadataForClass(ActionInitArray, 'ActionInitArray');
initMetadataForClass(ActionInitObject, 'ActionInitObject');
initMetadataForClass(ActionTypeOf, 'ActionTypeOf');
initMetadataForClass(ActionTargetPath, 'ActionTargetPath');
initMetadataForClass(ActionEnumerate, 'ActionEnumerate');
initMetadataForClass(ActionAdd2, 'ActionAdd2');
initMetadataForClass(ActionLess2, 'ActionLess2');
initMetadataForClass(ActionEquals2, 'ActionEquals2');
initMetadataForClass(ActionToNumber, 'ActionToNumber');
initMetadataForClass(ActionToString, 'ActionToString');
initMetadataForClass(ActionPushDuplicate, 'ActionPushDuplicate');
initMetadataForClass(ActionStackSwap, 'ActionStackSwap');
initMetadataForClass(ActionGetMember, 'ActionGetMember');
initMetadataForClass(ActionSetMember, 'ActionSetMember');
initMetadataForClass(ActionIncrement, 'ActionIncrement');
initMetadataForClass(ActionDecrement, 'ActionDecrement');
initMetadataForClass(ActionCallMethod, 'ActionCallMethod');
initMetadataForClass(ActionNewMethod, 'ActionNewMethod');
initMetadataForClass(ActionInstanceOf, 'ActionInstanceOf');
initMetadataForClass(ActionEnumerate2, 'ActionEnumerate2');
initMetadataForClass(ActionBitAnd, 'ActionBitAnd');
initMetadataForClass(ActionBitOr, 'ActionBitOr');
initMetadataForClass(ActionBitXor, 'ActionBitXor');
initMetadataForClass(ActionBitLShift, 'ActionBitLShift');
initMetadataForClass(ActionBitRShift, 'ActionBitRShift');
initMetadataForClass(ActionBitURShift, 'ActionBitURShift');
initMetadataForClass(ActionStrictEquals, 'ActionStrictEquals');
initMetadataForClass(ActionGreater, 'ActionGreater');
initMetadataForClass(ActionStringGreater, 'ActionStringGreater');
initMetadataForClass(ActionExtends, 'ActionExtends');
initMetadataForClass(ActionGotoFrame, 'ActionGotoFrame');
initMetadataForClass(ActionGetURL, 'ActionGetURL');
initMetadataForClass(ActionStoreRegister, 'ActionStoreRegister');
initMetadataForClass(ActionConstantPool, 'ActionConstantPool');
initMetadataForClass(ActionWaitForFrame, 'ActionWaitForFrame');
initMetadataForClass(ActionSetTarget, 'ActionSetTarget');
initMetadataForClass(ActionGotoLabel, 'ActionGotoLabel');
initMetadataForClass(ActionWaitForFrame2, 'ActionWaitForFrame2');
initMetadataForClass(ActionDefineFunction2, 'ActionDefineFunction2');
initMetadataForClass(ActionTry, 'ActionTry');
initMetadataForClass(ActionWith, 'ActionWith');
initMetadataForClass(ActionPush, 'ActionPush');
initMetadataForInterface(IActionBranch, 'IActionBranch');
initMetadataForClass(ActionJump, 'ActionJump', VOID, VOID, [Action, IActionBranch]);
initMetadataForClass(ActionGetURL2, 'ActionGetURL2');
initMetadataForClass(ActionDefineFunction, 'ActionDefineFunction');
initMetadataForClass(ActionIf, 'ActionIf', VOID, VOID, [Action, IActionBranch]);
initMetadataForClass(ActionCall, 'ActionCall');
initMetadataForClass(ActionGotoFrame2, 'ActionGotoFrame2');
initMetadataForClass(ActionUnknown, 'ActionUnknown');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SWFTimelineContainer, 'SWFTimelineContainer', SWFTimelineContainer, VOID, VOID, [2]);
initMetadataForClass(SWF, 'SWF', SWF, VOID, VOID, [1, 0, 2]);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(FlashByteArray, 'FlashByteArray', FlashByteArray.emr, VOID, VOID, [1]);
initMetadataForClass(BitArray, 'BitArray', BitArray.omr, VOID, VOID, [1]);
initMetadataForClass(SWFData, 'SWFData', SWFData.nmn, VOID, VOID, [2, 1]);
initMetadataForObject(SoundCompression, 'SoundCompression');
initMetadataForObject(SoundRate, 'SoundRate');
initMetadataForObject(SoundSize, 'SoundSize');
initMetadataForObject(SoundType, 'SoundType');
initMetadataForObject(BlendMode, 'BlendMode');
initMetadataForCompanion(Companion_6);
initMetadataForClass(GradientSpreadMode, 'GradientSpreadMode');
initMetadataForCompanion(Companion_7);
initMetadataForClass(GradientInterpolationMode, 'GradientInterpolationMode');
initMetadataForCompanion(Companion_8);
initMetadataForClass(LineCapsStyle, 'LineCapsStyle');
initMetadataForObject(LineJointStyle, 'LineJointStyle');
initMetadataForObject(ActionValueType, 'ActionValueType');
initMetadataForCompanion(Companion_9);
initMetadataForClass(BitmapFormat, 'BitmapFormat');
initMetadataForObject(BitmapType, 'BitmapType');
initMetadataForObject(VideoDeblockingType, 'VideoDeblockingType');
initMetadataForObject(VideoCodecID, 'VideoCodecID');
initMetadataForObject(CSMTableHint, 'CSMTableHint');
initMetadataForClass(SWFRectangle, 'SWFRectangle', SWFRectangle);
initMetadataForClass(SWFRawTag, 'SWFRawTag', SWFRawTag);
initMetadataForClass(SWFRecordHeader, 'SWFRecordHeader');
initMetadataForClass(SWFFrameLabel, 'SWFFrameLabel');
initMetadataForClass(SWFScene, 'SWFScene');
initMetadataForClass(SWFMatrix, 'SWFMatrix', SWFMatrix);
initMetadataForClass(SWFColorTransform, 'SWFColorTransform', SWFColorTransform);
initMetadataForClass(SWFColorTransformWithAlpha, 'SWFColorTransformWithAlpha', SWFColorTransformWithAlpha);
initMetadataForClass(SWFShape, 'SWFShape', SWFShape);
initMetadataForClass(SWFShapeWithStyle, 'SWFShapeWithStyle', SWFShapeWithStyle);
initMetadataForClass(SWFShapeRecord, 'SWFShapeRecord', SWFShapeRecord);
initMetadataForClass(SWFShapeRecordStraightEdge, 'SWFShapeRecordStraightEdge', SWFShapeRecordStraightEdge);
initMetadataForClass(SWFShapeRecordCurvedEdge, 'SWFShapeRecordCurvedEdge', SWFShapeRecordCurvedEdge);
initMetadataForClass(SWFShapeRecordStyleChange, 'SWFShapeRecordStyleChange', SWFShapeRecordStyleChange);
initMetadataForClass(SWFFillStyle, 'SWFFillStyle', SWFFillStyle);
initMetadataForClass(SWFLineStyle, 'SWFLineStyle', SWFLineStyle);
initMetadataForClass(SWFLineStyle2, 'SWFLineStyle2', SWFLineStyle2);
initMetadataForClass(SWFButtonRecord, 'SWFButtonRecord', SWFButtonRecord);
initMetadataForClass(SWFButtonCondAction, 'SWFButtonCondAction', SWFButtonCondAction);
initMetadataForClass(SWFTextRecord, 'SWFTextRecord', SWFTextRecord);
initMetadataForClass(SWFGlyphEntry, 'SWFGlyphEntry', SWFGlyphEntry);
initMetadataForClass(SWFZoneRecord, 'SWFZoneRecord');
initMetadataForClass(SWFZoneData, 'SWFZoneData');
initMetadataForClass(SWFKerningRecord, 'SWFKerningRecord', SWFKerningRecord);
initMetadataForClass(SWFGradient, 'SWFGradient', SWFGradient);
initMetadataForClass(SWFFocalGradient, 'SWFFocalGradient', SWFFocalGradient);
initMetadataForClass(SWFGradientRecord, 'SWFGradientRecord', SWFGradientRecord);
initMetadataForClass(SWFMorphFillStyle, 'SWFMorphFillStyle', SWFMorphFillStyle);
initMetadataForClass(SWFMorphLineStyle, 'SWFMorphLineStyle', SWFMorphLineStyle);
initMetadataForClass(SWFMorphLineStyle2, 'SWFMorphLineStyle2', SWFMorphLineStyle2);
initMetadataForClass(SWFMorphGradient, 'SWFMorphGradient', SWFMorphGradient);
initMetadataForClass(SWFMorphFocalGradient, 'SWFMorphFocalGradient', SWFMorphFocalGradient);
initMetadataForClass(SWFMorphGradientRecord, 'SWFMorphGradientRecord', SWFMorphGradientRecord);
initMetadataForCompanion(Companion_10);
initMetadataForClass(SWFActionValue, 'SWFActionValue', SWFActionValue);
initMetadataForClass(SWFRegisterParam, 'SWFRegisterParam', SWFRegisterParam);
initMetadataForClass(SWFSymbol, 'SWFSymbol', SWFSymbol.yna);
initMetadataForClass(SWFSoundInfo, 'SWFSoundInfo', SWFSoundInfo);
initMetadataForClass(SWFSoundEnvelope, 'SWFSoundEnvelope', SWFSoundEnvelope.zna);
initMetadataForClass(SWFClipActions, 'SWFClipActions', SWFClipActions);
initMetadataForClass(SWFClipActionRecord, 'SWFClipActionRecord', SWFClipActionRecord);
initMetadataForClass(SWFClipEventFlags, 'SWFClipEventFlags', SWFClipEventFlags);
initMetadataForCompanion(Companion_11);
initMetadataForObject(SWFShapeRecordEnd, 'SWFShapeRecordEnd');
initMetadataForClass(GradientType, 'GradientType');
initMetadataForClass(StraightEdge, 'StraightEdge');
initMetadataForClass(CurvedEdge, 'CurvedEdge');
initMetadataForClass(ShapeExporter, 'ShapeExporter', ShapeExporter);
initMetadataForClass(ShapeExporterBoundsBuilder, 'ShapeExporterBoundsBuilder', ShapeExporterBoundsBuilder);
initMetadataForClass(LoggerShapeExporter, 'LoggerShapeExporter');
initMetadataForClass(SWFTagFactory, 'SWFTagFactory', SWFTagFactory);
initMetadataForObject(SWFFilterFactory, 'SWFFilterFactory');
initMetadataForObject(SWFActionFactory, 'SWFActionFactory');
initMetadataForClass(Filter, 'Filter');
initMetadataForClass(FilterDropShadow, 'FilterDropShadow');
initMetadataForClass(FilterBlur, 'FilterBlur');
initMetadataForClass(FilterGlow, 'FilterGlow');
initMetadataForClass(FilterBevel, 'FilterBevel');
initMetadataForClass(FilterGradientGlow, 'FilterGradientGlow');
initMetadataForClass(FilterConvolution, 'FilterConvolution');
initMetadataForClass(FilterColorMatrix, 'FilterColorMatrix');
initMetadataForClass(FilterGradientBevel, 'FilterGradientBevel');
initMetadataForInterface(ITag, 'ITag', VOID, VOID, VOID, [4]);
protoOf(_BaseTag).wmq = toString$default;
initMetadataForClass(_BaseTag, '_BaseTag', VOID, VOID, [ITag], [4]);
initMetadataForInterface(IDefinitionTag, 'IDefinitionTag', VOID, VOID, [ITag], [4]);
initMetadataForClass(_BaseDefinitionTag, '_BaseDefinitionTag', VOID, VOID, [_BaseTag, IDefinitionTag], [4]);
initMetadataForClass(TagDefineMorphShape, 'TagDefineMorphShape', TagDefineMorphShape, VOID, VOID, [4]);
initMetadataForClass(TagDefineShape, 'TagDefineShape', TagDefineShape, VOID, VOID, [4]);
initMetadataForClass(TagObj, 'TagObj');
initMetadataForCompanion(Companion_12);
initMetadataForClass(TagJPEGTables, 'TagJPEGTables', TagJPEGTables, VOID, VOID, [4]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(TagEnd, 'TagEnd', TagEnd, VOID, VOID, [4]);
initMetadataForInterface(IDisplayListTag, 'IDisplayListTag', VOID, VOID, [ITag], [4]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(TagFrameLabel, 'TagFrameLabel', TagFrameLabel, VOID, VOID, [4]);
initMetadataForCompanion(Companion_15);
initMetadataForClass(TagDefineSceneAndFrameLabelData, 'TagDefineSceneAndFrameLabelData', TagDefineSceneAndFrameLabelData, VOID, VOID, [4]);
initMetadataForCompanion(Companion_16);
initMetadataForClass(TagSoundStreamHead, 'TagSoundStreamHead', TagSoundStreamHead, VOID, VOID, [4]);
initMetadataForCompanion(Companion_17);
initMetadataForClass(TagSoundStreamHead2, 'TagSoundStreamHead2', TagSoundStreamHead2, VOID, VOID, [4]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(TagSoundStreamBlock, 'TagSoundStreamBlock', TagSoundStreamBlock, VOID, VOID, [4]);
initMetadataForCompanion(Companion_19);
initMetadataForClass(TagSetBackgroundColor, 'TagSetBackgroundColor', TagSetBackgroundColor, VOID, VOID, [4]);
initMetadataForCompanion(Companion_20);
initMetadataForClass(TagShowFrame, 'TagShowFrame', TagShowFrame, VOID, [_BaseTag, IDisplayListTag], [4]);
initMetadataForCompanion(Companion_21);
initMetadataForClass(TagPlaceObject, 'TagPlaceObject', TagPlaceObject, VOID, [_BaseTag, IDisplayListTag], [4]);
initMetadataForCompanion(Companion_22);
initMetadataForClass(TagPlaceObject2, 'TagPlaceObject2', TagPlaceObject2, VOID, [TagPlaceObject, IDisplayListTag], [4]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(TagPlaceObject3, 'TagPlaceObject3', TagPlaceObject3, VOID, [TagPlaceObject2, IDisplayListTag], [4]);
initMetadataForCompanion(Companion_24);
initMetadataForClass(TagRemoveObject, 'TagRemoveObject', TagRemoveObject, VOID, [_BaseTag, IDisplayListTag], [4]);
initMetadataForCompanion(Companion_25);
initMetadataForClass(TagRemoveObject2, 'TagRemoveObject2', TagRemoveObject2, VOID, [TagRemoveObject, IDisplayListTag], [4]);
initMetadataForCompanion(Companion_26);
initMetadataForClass(TagDefineBits, 'TagDefineBits', TagDefineBits, VOID, VOID, [4]);
initMetadataForCompanion(Companion_27);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(TagDefineButton, 'TagDefineButton', TagDefineButton, VOID, VOID, [4]);
initMetadataForClass(TagDefineFont, 'TagDefineFont', TagDefineFont, VOID, VOID, [4]);
initMetadataForClass(TagDefineText, 'TagDefineText', TagDefineText, VOID, VOID, [4]);
initMetadataForClass(TagDoAction, 'TagDoAction', TagDoAction, VOID, VOID, [4]);
initMetadataForClass(TagDefineFontInfo, 'TagDefineFontInfo', TagDefineFontInfo, VOID, VOID, [4]);
initMetadataForClass(TagDefineSound, 'TagDefineSound', TagDefineSound, VOID, VOID, [4]);
initMetadataForClass(TagStartSound, 'TagStartSound', TagStartSound, VOID, VOID, [4]);
initMetadataForClass(TagDefineButtonSound, 'TagDefineButtonSound', TagDefineButtonSound, VOID, VOID, [4]);
initMetadataForClass(TagDefineBitsLossless, 'TagDefineBitsLossless', TagDefineBitsLossless, VOID, VOID, [4]);
initMetadataForClass(TagDefineBitsJPEG2, 'TagDefineBitsJPEG2', TagDefineBitsJPEG2, VOID, VOID, [4]);
initMetadataForClass(TagDefineShape2, 'TagDefineShape2', TagDefineShape2, VOID, VOID, [4]);
initMetadataForClass(TagDefineButtonCxform, 'TagDefineButtonCxform', TagDefineButtonCxform, VOID, VOID, [4]);
initMetadataForClass(TagProtect, 'TagProtect', TagProtect, VOID, VOID, [4]);
initMetadataForClass(TagPathsArePostScript, 'TagPathsArePostScript', TagPathsArePostScript, VOID, VOID, [4]);
initMetadataForClass(TagDefineShape3, 'TagDefineShape3', TagDefineShape3, VOID, VOID, [4]);
initMetadataForClass(TagDefineText2, 'TagDefineText2', TagDefineText2, VOID, VOID, [4]);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(TagDefineButton2, 'TagDefineButton2', TagDefineButton2, VOID, VOID, [4]);
initMetadataForClass(TagDefineBitsJPEG3, 'TagDefineBitsJPEG3', TagDefineBitsJPEG3, VOID, VOID, [4]);
initMetadataForClass(TagDefineBitsLossless2, 'TagDefineBitsLossless2', TagDefineBitsLossless2, VOID, VOID, [4]);
initMetadataForClass(TagDefineEditText, 'TagDefineEditText', TagDefineEditText, VOID, VOID, [4]);
initMetadataForClass(TagDefineSprite, 'TagDefineSprite', TagDefineSprite, VOID, [SWFTimelineContainer, IDefinitionTag], [4, 2]);
initMetadataForClass(TagNameCharacter, 'TagNameCharacter', TagNameCharacter, VOID, VOID, [4]);
initMetadataForClass(TagProductInfo, 'TagProductInfo', TagProductInfo, VOID, VOID, [4]);
initMetadataForClass(TagDefineFont2, 'TagDefineFont2', TagDefineFont2, VOID, VOID, [4]);
initMetadataForClass(TagImportExportAssets, 'TagImportExportAssets', VOID, VOID, VOID, [4]);
initMetadataForClass(TagExportAssets, 'TagExportAssets', TagExportAssets, VOID, VOID, [4]);
initMetadataForClass(TagImportAssets, 'TagImportAssets', TagImportAssets, VOID, VOID, [4]);
initMetadataForClass(TagEnableDebugger, 'TagEnableDebugger', TagEnableDebugger, VOID, VOID, [4]);
initMetadataForClass(TagDoInitAction, 'TagDoInitAction', TagDoInitAction, VOID, VOID, [4]);
initMetadataForClass(TagDefineVideoStream, 'TagDefineVideoStream', TagDefineVideoStream, VOID, VOID, [4]);
initMetadataForClass(TagVideoFrame, 'TagVideoFrame', TagVideoFrame, VOID, VOID, [4]);
initMetadataForClass(TagDefineFontInfo2, 'TagDefineFontInfo2', TagDefineFontInfo2, VOID, VOID, [4]);
initMetadataForClass(TagDebugID, 'TagDebugID', TagDebugID, VOID, VOID, [4]);
initMetadataForClass(TagEnableDebugger2, 'TagEnableDebugger2', TagEnableDebugger2, VOID, VOID, [4]);
initMetadataForClass(TagScriptLimits, 'TagScriptLimits', TagScriptLimits, VOID, VOID, [4]);
initMetadataForClass(TagSetTabIndex, 'TagSetTabIndex', TagSetTabIndex, VOID, VOID, [4]);
initMetadataForClass(TagFileAttributes, 'TagFileAttributes', TagFileAttributes, VOID, VOID, [4]);
initMetadataForClass(TagImportAssets2, 'TagImportAssets2', TagImportAssets2, VOID, VOID, [4]);
initMetadataForCompanion(Companion_28);
initMetadataForClass(TagDoABCDeprecated, 'TagDoABCDeprecated', TagDoABCDeprecated, VOID, VOID, [4]);
initMetadataForClass(TagDefineFontAlignZones, 'TagDefineFontAlignZones', TagDefineFontAlignZones, VOID, VOID, [4]);
initMetadataForClass(TagCSMTextSettings, 'TagCSMTextSettings', TagCSMTextSettings, VOID, VOID, [4]);
initMetadataForClass(TagDefineFont3, 'TagDefineFont3', TagDefineFont3, VOID, VOID, [4]);
initMetadataForClass(TagSymbolClass, 'TagSymbolClass', TagSymbolClass, VOID, VOID, [4]);
initMetadataForClass(TagMetadata, 'TagMetadata', TagMetadata, VOID, VOID, [4]);
initMetadataForClass(TagDefineScalingGrid, 'TagDefineScalingGrid', TagDefineScalingGrid, VOID, VOID, [4]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(TagDoABC, 'TagDoABC', TagDoABC, VOID, VOID, [4]);
initMetadataForClass(TagDefineShape4, 'TagDefineShape4', TagDefineShape4, VOID, VOID, [4]);
initMetadataForClass(TagDefineMorphShape2, 'TagDefineMorphShape2', TagDefineMorphShape2, VOID, VOID, [4]);
initMetadataForClass(TagDefineBinaryData, 'TagDefineBinaryData', TagDefineBinaryData, VOID, VOID, [4]);
initMetadataForClass(TagDefineFontName, 'TagDefineFontName', TagDefineFontName, VOID, VOID, [4]);
initMetadataForClass(TagStartSound2, 'TagStartSound2', TagStartSound2, VOID, VOID, [4]);
initMetadataForClass(TagDefineBitsJPEG4, 'TagDefineBitsJPEG4', TagDefineBitsJPEG4, VOID, VOID, [4]);
initMetadataForClass(TagDefineFont4, 'TagDefineFont4', TagDefineFont4, VOID, VOID, [4]);
initMetadataForClass(TagEnableTelemetry, 'TagEnableTelemetry', TagEnableTelemetry, VOID, VOID, [4]);
initMetadataForClass(TagPlaceObject4, 'TagPlaceObject4', TagPlaceObject4, VOID, [TagPlaceObject3, IDisplayListTag], [4]);
initMetadataForClass(TagUnknown, 'TagUnknown', VOID, VOID, VOID, [4]);
initMetadataForClass(TagSWFEncryptActions, 'TagSWFEncryptActions', TagSWFEncryptActions, VOID, VOID, [4]);
initMetadataForClass(TagSWFEncryptSignature, 'TagSWFEncryptSignature', TagSWFEncryptSignature, VOID, VOID, [4]);
initMetadataForClass(Scene, 'Scene');
initMetadataForClass(Frame, 'Frame', Frame);
initMetadataForClass(SoundStream, 'SoundStream', SoundStream);
initMetadataForClass(FrameObject, 'FrameObject');
initMetadataForClass(Endian, 'Endian');
initMetadataForObject(ColorUtils, 'ColorUtils');
initMetadataForObject(NumberUtils, 'NumberUtils');
initMetadataForObject(MatrixUtils, 'MatrixUtils');
initMetadataForClass(AnBaseShape, 'AnBaseShape');
initMetadataForClass(AnShape, 'AnShape');
initMetadataForClass(AnMovieClip, 'AnMovieClip', VOID, VOID, VOID, [1, 2, 0]);
initMetadataForClass(AnMorphShape, 'AnMorphShape');
initMetadataForClass(AnEmptyView, 'AnEmptyView');
initMetadataForClass(AnTextField, 'AnTextField');
initMetadataForLambda(TimelineRunner$eval$slambda, VOID, VOID, [0]);
initMetadataForClass(TimelineRunner, 'TimelineRunner');
initMetadataForCompanion(Companion_30);
initMetadataForClass(Context, 'Context', Context);
initMetadataForClass(AnLibrary, 'AnLibrary');
initMetadataForClass(AnSymbol, 'AnSymbol', AnSymbol);
initMetadataForClass(AnSymbolMovieClip, 'AnSymbolMovieClip');
initMetadataForClass(AnSymbolBaseShape, 'AnSymbolBaseShape');
initMetadataForClass(AnSymbolMorphShape, 'AnSymbolMorphShape');
initMetadataForClass(AnSymbolShape, 'AnSymbolShape');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AnSymbolTimelineFrame, 'AnSymbolTimelineFrame', AnSymbolTimelineFrame);
initMetadataForObject(AnSymbolEmpty, 'AnSymbolEmpty');
initMetadataForLambda(AnSymbolSound$getNativeSound$slambda, VOID, VOID, [0]);
initMetadataForClass(AnSymbolSound, 'AnSymbolSound', VOID, VOID, VOID, [0]);
initMetadataForClass(AnTextFieldSymbol, 'AnTextFieldSymbol');
initMetadataForClass(AnSymbolBitmap, 'AnSymbolBitmap');
initMetadataForClass(AnSymbolUidDef, 'AnSymbolUidDef');
initMetadataForClass(AnSymbolLimits, 'AnSymbolLimits');
initMetadataForClass(AnSymbolMovieClipState, 'AnSymbolMovieClipState');
initMetadataForClass(AnSymbolMovieClipSubTimeline, 'AnSymbolMovieClipSubTimeline');
initMetadataForClass(Timed, 'Timed', Timed);
initMetadataForClass(AnDepthTimeline, 'AnDepthTimeline');
initMetadataForClass(AnPlaySoundAction, 'AnPlaySoundAction');
initMetadataForClass(AnEventAction, 'AnEventAction');
initMetadataForClass(RangeResult, 'RangeResult', RangeResult);
initMetadataForClass(Result, 'Result', Result);
initMetadataForClass(RenderState, 'RenderState');
initMetadataForObject(MaskStates, 'MaskStates');
initMetadataForClass(BitmapWithScale, 'BitmapWithScale');
initMetadataForClass(SWFBaseShapeExporter, 'SWFBaseShapeExporter');
initMetadataForClass(SWFShapeExporter, 'SWFShapeExporter');
initMetadataForClass(SWFExportConfig, 'SWFExportConfig', SWFExportConfig);
initMetadataForClass(MySwfTimeline, 'MySwfTimeline', MySwfTimeline);
initMetadataForObject(Stop, 'Stop');
initMetadataForObject(Play, 'Play');
initMetadataForClass(Goto, 'Goto');
initMetadataForClass(PlaySound, 'PlaySound');
initMetadataForClass(MySwfFrame, 'MySwfFrame');
initMetadataForClass(SwfLoaderMethod$generateActualTimelines$Subtimeline, 'Subtimeline');
initMetadataForClass(SwfLoaderMethod$generateActualTimelines$FrameInfo, 'FrameInfo');
initMetadataForClass(SwfLoaderMethod$parseMovieClipInternal$DepthInfo, 'DepthInfo');
initMetadataForClass(SwfLoaderMethod, 'SwfLoaderMethod', VOID, VOID, VOID, [1, 0, 2]);
initMetadataForClass(SWFShapeRasterizerRequest, 'SWFShapeRasterizerRequest');
initMetadataForClass(SymbolAnalyzeInfo, 'SymbolAnalyzeInfo');
initMetadataForClass(MinMaxDouble, 'MinMaxDouble', MinMaxDouble);
initMetadataForClass(FontsCatalog, 'FontsCatalog');
initMetadataForClass(Format, 'Format', Format);
initMetadataForClass(PositionContext, 'PositionContext');
initMetadataForClass(Span, 'Span');
initMetadataForClass(Line, 'Line', Line);
initMetadataForClass(Paragraph, 'Paragraph', Paragraph);
initMetadataForClass(Document, 'Document', Document);
initMetadataForClass(HtmlParser, 'HtmlParser');
initMetadataForObject(Html, 'Html', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_32);
initMetadataForClass(TextOld, 'TextOld', TextOld.mp5);
//endregion
//region block: init
EmptyMultiname_instance = new EmptyMultiname();
RTQNameL_instance = new RTQNameL();
RTQNameLA_instance = new RTQNameLA();
AMF3_instance = new AMF3();
Companion_instance_4 = new Companion_0();
Undefined_instance = new Undefined();
Companion_instance_6 = new Companion_2();
Companion_instance_7 = new Companion_3();
Companion_instance_8 = new Companion_4();
Companion_instance_9 = new Companion_5();
SoundCompression_instance = new SoundCompression();
SoundRate_instance = new SoundRate();
SoundSize_instance = new SoundSize();
SoundType_instance = new SoundType();
BlendMode_instance = new BlendMode();
LineJointStyle_instance = new LineJointStyle();
ActionValueType_instance = new ActionValueType();
BitmapType_instance = new BitmapType();
VideoDeblockingType_instance = new VideoDeblockingType();
VideoCodecID_instance = new VideoCodecID();
CSMTableHint_instance = new CSMTableHint();
Companion_instance_14 = new Companion_10();
Companion_instance_15 = new Companion_11();
SWFFilterFactory_instance = new SWFFilterFactory();
SWFActionFactory_instance = new SWFActionFactory();
Companion_instance_30 = new Companion_26();
Companion_instance_31 = new Companion_27();
Companion_instance_32 = new Companion_28();
Companion_instance_33 = new Companion_29();
ColorUtils_instance = new ColorUtils();
NumberUtils_instance = new NumberUtils();
MatrixUtils_instance = new MatrixUtils();
Companion_instance_34 = new Companion_30();
Companion_instance_35 = new Companion_31();
Stop_instance = new Stop();
Play_instance = new Play();
debugBmpFontOrNull = null;
_DefaultFontsCatalog = null;
Companion_instance_36 = new Companion_32();
//endregion
//region block: exports
export {
  readSWF as readSWF2zr5p57ipe5bt,
  SWFExportConfig as SWFExportConfig2djnbvfub7nz1,
};
//endregion
